import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: number;
  Currency: string;
  Date: Date;
  DateTime: Date;
  Long: number;
  UUID: any;
  Url: any;
};

export type Account = IdBase & {
  __typename?: 'Account';
  accessUntil?: Maybe<Scalars['Date']>;
  client: Client;
  colorIndex: Scalars['Int'];
  consentExpired: Scalars['Boolean'];
  creationTimestamp: Scalars['DateTime'];
  currency: Scalars['String'];
  iban: Scalars['String'];
  id: Scalars['ID'];
  institution: Institution;
  name: Scalars['String'];
  synchronizationMethod: AccountInformationSynchronizationMethod;
  transactionsRange?: Maybe<Array<DateRange>>;
  type?: Maybe<Scalars['String']>;
  updateTimestamp: Scalars['DateTime'];
};

export enum AccountInformationSynchronizationMethod {
  AispNordigen = 'AISP_NORDIGEN',
  Manual = 'MANUAL'
}

export type AccountPage = {
  __typename?: 'AccountPage';
  items: Array<Account>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type AggregateBalanceFilter = {
  accountIds?: Array<FilterOperatorValue>;
  referenceDates?: Array<FilterOperatorValue>;
};

export type ApplicantAlimonyIncome = {
  __typename?: 'ApplicantAlimonyIncome';
  monthlyIncome: Money;
};

export type ApplicantAlimonyIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantAlimonyLiability = {
  __typename?: 'ApplicantAlimonyLiability';
  monthlyInstallment: Money;
};

export type ApplicantAlimonyLiabilityInput = {
  monthlyInstallment: MoneyInput;
};

export type ApplicantConsumerLoanLiability = {
  __typename?: 'ApplicantConsumerLoanLiability';
  balance: Money;
  monthlyInstallment: Money;
};

export type ApplicantConsumerLoanLiabilityInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type ApplicantCreditCardLiability = {
  __typename?: 'ApplicantCreditCardLiability';
  limit: Money;
};

export type ApplicantCreditCardLiabilityInput = {
  limit: MoneyInput;
};

export type ApplicantDisabilityPensionIncome = {
  __typename?: 'ApplicantDisabilityPensionIncome';
  monthlyIncome: Money;
};

export type ApplicantDisabilityPensionIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantDoctoralScholarshipIncome = {
  __typename?: 'ApplicantDoctoralScholarshipIncome';
  monthlyIncome: Money;
};

export type ApplicantDoctoralScholarshipIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantEntrepreneurshipIncome = {
  __typename?: 'ApplicantEntrepreneurshipIncome';
  establishmentDate?: Maybe<Scalars['Date']>;
  expenseType?: Maybe<EntrepreneurshipExpenseType>;
  monthlyIncome?: Maybe<Money>;
  taxBase?: Maybe<Money>;
  taxPayed?: Maybe<Money>;
  yearlyRevenues?: Maybe<Money>;
};

export type ApplicantEntrepreneurshipIncomeInput = {
  establishmentDate?: InputMaybe<Scalars['Date']>;
  expenseType?: InputMaybe<EntrepreneurshipExpenseType>;
  monthlyIncome?: InputMaybe<MoneyInput>;
  taxBase?: InputMaybe<MoneyInput>;
  taxPayed?: InputMaybe<MoneyInput>;
  yearlyRevenues?: InputMaybe<MoneyInput>;
};

export type ApplicantLeaseLiability = {
  __typename?: 'ApplicantLeaseLiability';
  balance: Money;
  monthlyInstallment: Money;
};

export type ApplicantLeaseLiabilityInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type ApplicantLifeInsuranceLiability = {
  __typename?: 'ApplicantLifeInsuranceLiability';
  balance: Money;
  monthlyInstallment: Money;
};

export type ApplicantLifeInsuranceLiabilityInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type ApplicantLtdIncome = {
  __typename?: 'ApplicantLtdIncome';
  ceoCompensation?: Maybe<Money>;
  equityShares?: Maybe<Scalars['BigDecimal']>;
  monthlyIncome?: Maybe<Money>;
  yearlyProfit?: Maybe<Money>;
  yearlyRevenues?: Maybe<Money>;
};

export type ApplicantLtdIncomeInput = {
  ceoCompensation?: InputMaybe<MoneyInput>;
  equityShares?: InputMaybe<Scalars['BigDecimal']>;
  monthlyIncome?: InputMaybe<MoneyInput>;
  yearlyProfit?: InputMaybe<MoneyInput>;
  yearlyRevenues?: InputMaybe<MoneyInput>;
};

export type ApplicantMaternityLeaveIncome = {
  __typename?: 'ApplicantMaternityLeaveIncome';
  monthlyIncome: Money;
};

export type ApplicantMaternityLeaveIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantMortgageLiability = {
  __typename?: 'ApplicantMortgageLiability';
  balance: Money;
  monthlyInstallment: Money;
};

export type ApplicantMortgageLiabilityInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type ApplicantOldAgePensionIncome = {
  __typename?: 'ApplicantOldAgePensionIncome';
  monthlyIncome: Money;
};

export type ApplicantOldAgePensionIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantOrphanPensionIncome = {
  __typename?: 'ApplicantOrphanPensionIncome';
  monthlyIncome: Money;
};

export type ApplicantOrphanPensionIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantOtherIncome = {
  __typename?: 'ApplicantOtherIncome';
  description?: Maybe<Scalars['String']>;
  monthlyIncome: Money;
};

export type ApplicantOtherIncomeInput = {
  description?: InputMaybe<Scalars['String']>;
  monthlyIncome: MoneyInput;
};

export type ApplicantOtherLoanLiability = {
  __typename?: 'ApplicantOtherLoanLiability';
  balance: Money;
  monthlyInstallment: Money;
};

export type ApplicantOtherLoanLiabilityInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type ApplicantOverdraftLiability = {
  __typename?: 'ApplicantOverdraftLiability';
  limit: Money;
};

export type ApplicantOverdraftLiabilityInput = {
  limit: MoneyInput;
};

export type ApplicantParentalAllowanceIncome = {
  __typename?: 'ApplicantParentalAllowanceIncome';
  monthlyIncome: Money;
};

export type ApplicantParentalAllowanceIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantRealEstateRentalIncome = {
  __typename?: 'ApplicantRealEstateRentalIncome';
  contractSignatureDate: Scalars['Date'];
  monthlyIncome: Money;
};

export type ApplicantRealEstateRentalIncomeInput = {
  contractSignatureDate: Scalars['Date'];
  monthlyIncome: MoneyInput;
};

export type ApplicantReconstructionLoanLiability = {
  __typename?: 'ApplicantReconstructionLoanLiability';
  balance: Money;
  monthlyInstallment: Money;
};

export type ApplicantReconstructionLoanLiabilityInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type ApplicantRetirementPensionIncome = {
  __typename?: 'ApplicantRetirementPensionIncome';
  monthlyIncome: Money;
};

export type ApplicantRetirementPensionIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantSalaryIncome = {
  __typename?: 'ApplicantSalaryIncome';
  contractSignatureDate?: Maybe<Scalars['Date']>;
  monthlyIncome: Money;
};

export type ApplicantSalaryIncomeInput = {
  contractSignatureDate?: InputMaybe<Scalars['Date']>;
  monthlyIncome: MoneyInput;
};

export type ApplicantTravelCompensationIncome = {
  __typename?: 'ApplicantTravelCompensationIncome';
  monthlyIncome: Money;
};

export type ApplicantTravelCompensationIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantUnemploymentBenefitIncome = {
  __typename?: 'ApplicantUnemploymentBenefitIncome';
  monthlyIncome: Money;
};

export type ApplicantUnemploymentBenefitIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantWidowPensionIncome = {
  __typename?: 'ApplicantWidowPensionIncome';
  monthlyIncome: Money;
};

export type ApplicantWidowPensionIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type ApplicantWorkAgreementIncome = {
  __typename?: 'ApplicantWorkAgreementIncome';
  monthlyIncome: Money;
};

export type ApplicantWorkAgreementIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type Avatar = IdBase & {
  __typename?: 'Avatar';
  creationTimestamp: Scalars['DateTime'];
  fullSize?: Maybe<File>;
  id: Scalars['ID'];
  thumbnail?: Maybe<File>;
  updateTimestamp: Scalars['DateTime'];
};

export enum BalanceAttribute {
  Account = 'ACCOUNT',
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type BalanceKey = Account | DateKey;

export type BalanceResult = {
  __typename?: 'BalanceResult';
  baseCurrency: Scalars['Currency'];
  resultData: Array<BalanceValue>;
};

export type BalanceValue = {
  __typename?: 'BalanceValue';
  balance: Money;
  key: Array<BalanceKey>;
};

export type BuildingSavingsProduct = ProductBase & {
  __typename?: 'BuildingSavingsProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type BuildingSavingsProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type BuildingSavingsProductPage = {
  __typename?: 'BuildingSavingsProductPage';
  items: Array<BuildingSavingsProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CalendarEvent = IdBase & {
  __typename?: 'CalendarEvent';
  amount?: Maybe<Money>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  productType?: Maybe<FinancialProductType>;
  recurrenceRule?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
  type: CalendarEventType;
};

export type CalendarEventInput = {
  name: Scalars['String'];
  recurrenceRule?: InputMaybe<Scalars['String']>;
  startDate: Scalars['Date'];
};

export type CalendarEventInstance = IdBase & {
  __typename?: 'CalendarEventInstance';
  amount?: Maybe<Money>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalEventId: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  productType?: Maybe<FinancialProductType>;
  type: CalendarEventType;
};

export type CalendarEventNotificationDetails = {
  __typename?: 'CalendarEventNotificationDetails';
  calendarEvent: CalendarEvent;
};

export enum CalendarEventType {
  General = 'GENERAL',
  ProductExpiration = 'PRODUCT_EXPIRATION',
  ProductPayment = 'PRODUCT_PAYMENT',
  UserDefined = 'USER_DEFINED'
}

export type CashFlowAdjustment = IdBase & {
  __typename?: 'CashFlowAdjustment';
  client?: Maybe<Client>;
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  period: TransactionPeriod;
  text?: Maybe<Scalars['String']>;
  updateTimestamp: Scalars['DateTime'];
};

export type CashFlowAdjustmentInput = {
  period: TransactionPeriodInput;
  text?: InputMaybe<Scalars['String']>;
};

export type CashFlowAdjustmentPage = {
  __typename?: 'CashFlowAdjustmentPage';
  items: Array<CashFlowAdjustment>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Client = {
  __typename?: 'Client';
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  status: ClientStatus;
  updateTimestamp: Scalars['DateTime'];
  user?: Maybe<User>;
};

export type ClientInput = {
  status: ClientStatus;
};

export type ClientNote = IdBase & {
  __typename?: 'ClientNote';
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  text: Scalars['String'];
  updateTimestamp: Scalars['DateTime'];
};

export type ClientNoteInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};

export type ClientNotePage = {
  __typename?: 'ClientNotePage';
  items: Array<ClientNote>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ClientPage = {
  __typename?: 'ClientPage';
  items: Array<Client>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ClientProfile = IdBase & {
  __typename?: 'ClientProfile';
  birthYear: Scalars['Int'];
  childrenNumber: Scalars['Int'];
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  partner: Scalars['Boolean'];
  partnerBirthYear?: Maybe<Scalars['Int']>;
  preferredServiceLocation: ServiceLocation;
  updateTimestamp: Scalars['DateTime'];
  youngestChildBirthYear?: Maybe<Scalars['Int']>;
};

export type ClientProfileInput = {
  birthYear: Scalars['Int'];
  childrenNumber: Scalars['Int'];
  partner: Scalars['Boolean'];
  partnerBirthYear?: InputMaybe<Scalars['Int']>;
  preferredServiceLocationId: Scalars['ID'];
  youngestChildBirthYear?: InputMaybe<Scalars['Int']>;
};

export enum ClientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CollisionInsuranceProduct = ProductBase & {
  __typename?: 'CollisionInsuranceProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  insuranceRisks?: Maybe<Array<CollisionInsuranceRisk>>;
  insuringPerson?: Maybe<InsuringPerson>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  vehicleInfo?: Maybe<VehicleInfo>;
};

export type CollisionInsuranceProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  insuranceRisks?: InputMaybe<Array<CollisionInsuranceRiskInput>>;
  insuringPerson?: InputMaybe<InsuringPersonInput>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  vehicleInfo?: InputMaybe<VehicleInfoInput>;
};

export type CollisionInsuranceProductPage = {
  __typename?: 'CollisionInsuranceProductPage';
  items: Array<CollisionInsuranceProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CollisionInsuranceRisk = {
  __typename?: 'CollisionInsuranceRisk';
  annualCost?: Maybe<Money>;
  id: Scalars['ID'];
  insuredSum?: Maybe<Money>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<CollisionInsuranceRiskType>;
};

export type CollisionInsuranceRiskInput = {
  annualCost?: InputMaybe<MoneyInput>;
  insuredSum?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CollisionInsuranceRiskType>;
};

export enum CollisionInsuranceRiskType {
  Accident = 'ACCIDENT',
  NaturalDisaster = 'NATURAL_DISASTER',
  Other = 'OTHER',
  Theft = 'THEFT',
  Vandalism = 'VANDALISM'
}

export type CreditCardProduct = ProductBase & {
  __typename?: 'CreditCardProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  limitAmount?: Maybe<Money>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  owedAmountPaidByMaturity?: Maybe<Scalars['Boolean']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  regularUsage?: Maybe<Scalars['Boolean']>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type CreditCardProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  limitAmount?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  owedAmountPaidByMaturity?: InputMaybe<Scalars['Boolean']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  regularUsage?: InputMaybe<Scalars['Boolean']>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type CreditCardProductPage = {
  __typename?: 'CreditCardProductPage';
  items: Array<CreditCardProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum DateGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type DateKey = {
  __typename?: 'DateKey';
  granularity: DateGranularity;
  startDate: Scalars['Date'];
};

export type DateRange = {
  __typename?: 'DateRange';
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export enum DisabilityPensionType {
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

export type Document = IdBase & {
  __typename?: 'Document';
  files: Array<File>;
  id: Scalars['ID'];
  type: DocumentType;
};

export type DocumentInput = {
  type: DocumentType;
};

export enum DocumentType {
  BuildingSavingsContract = 'BUILDING_SAVINGS_CONTRACT',
  CollisionInsuranceContract = 'COLLISION_INSURANCE_CONTRACT',
  CreditCardContract = 'CREDIT_CARD_CONTRACT',
  GenericContract = 'GENERIC_CONTRACT',
  GenericInsuranceContract = 'GENERIC_INSURANCE_CONTRACT',
  InvestmentContract = 'INVESTMENT_CONTRACT',
  LifeInsuranceContract = 'LIFE_INSURANCE_CONTRACT',
  LoanContract = 'LOAN_CONTRACT',
  MortgageContract = 'MORTGAGE_CONTRACT',
  MotorLiabilityInsuranceContract = 'MOTOR_LIABILITY_INSURANCE_CONTRACT',
  PropertyInsuranceContract = 'PROPERTY_INSURANCE_CONTRACT',
  RetirementPensionSavingsContract = 'RETIREMENT_PENSION_SAVINGS_CONTRACT',
  SavingsContract = 'SAVINGS_CONTRACT',
  SupplementaryPensionSavingsContract = 'SUPPLEMENTARY_PENSION_SAVINGS_CONTRACT'
}

export enum EntrepreneurshipExpenseType {
  FlatRate = 'FLAT_RATE',
  Real = 'REAL'
}

export enum FamilyStatus {
  CohabitingPartnership = 'COHABITING_PARTNERSHIP',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  MarriedSplitOwnership = 'MARRIED_SPLIT_OWNERSHIP',
  Single = 'SINGLE',
  Widow = 'WIDOW'
}

export type File = IdBase & {
  __typename?: 'File';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Long']>;
};

export type FilterConditionInput = {
  fieldPath?: InputMaybe<Scalars['String']>;
  operator: FilterOperator;
  values?: Array<Scalars['String']>;
};

export type FilterInput = {
  arguments: Array<FilterInputWrapper>;
  operator?: LogicalOperator;
};

export type FilterInputWrapper = {
  filter?: InputMaybe<FilterInput>;
  filterCondition?: InputMaybe<FilterConditionInput>;
};

export enum FilterOperator {
  Contains = 'CONTAINS',
  Equal = 'EQUAL',
  FulltextSearch = 'FULLTEXT_SEARCH',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  Ilike = 'ILIKE',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN',
  UnaccentedIlike = 'UNACCENTED_ILIKE',
  UnaccentedLike = 'UNACCENTED_LIKE'
}

export type FilterOperatorValue = {
  operator: FilterOperator;
  value: Scalars['String'];
};

export type FinancialAdvisorTask = IdBase & {
  __typename?: 'FinancialAdvisorTask';
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  details?: Maybe<FinancialAdvisorTaskDetails>;
  doneDate?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  stage?: Maybe<Scalars['Int']>;
  subtitle: Scalars['String'];
  text: Scalars['String'];
  title: Scalars['String'];
  type: FinancialAdvisorTaskType;
};

export type FinancialAdvisorTaskDetails = LifeInsuranceCalculatorFinancialAdvisorTaskDetails | MortgageCalculatorFinancialAdvisorTaskDetails | ProductFinancialAdvisorTaskDetails;

export type FinancialAdvisorTaskInput = {
  dueDate: Scalars['DateTime'];
  subtitle: Scalars['String'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type FinancialAdvisorTaskPage = {
  __typename?: 'FinancialAdvisorTaskPage';
  items: Array<FinancialAdvisorTask>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum FinancialAdvisorTaskType {
  CollisionInsuranceProductExpiration = 'COLLISION_INSURANCE_PRODUCT_EXPIRATION',
  CollisionInsuranceProductPayment = 'COLLISION_INSURANCE_PRODUCT_PAYMENT',
  FinancialAdvisorDefined = 'FINANCIAL_ADVISOR_DEFINED',
  GenericProductExpiration = 'GENERIC_PRODUCT_EXPIRATION',
  LifeInsuranceAnnualUpdate = 'LIFE_INSURANCE_ANNUAL_UPDATE',
  LifeInsuranceCalculatorContact = 'LIFE_INSURANCE_CALCULATOR_CONTACT',
  MortgageCalculatorContact = 'MORTGAGE_CALCULATOR_CONTACT',
  MortgageProductFixationEnd = 'MORTGAGE_PRODUCT_FIXATION_END',
  MotorLiabilityInsuranceProductExpiration = 'MOTOR_LIABILITY_INSURANCE_PRODUCT_EXPIRATION',
  MotorLiabilityInsuranceProductPayment = 'MOTOR_LIABILITY_INSURANCE_PRODUCT_PAYMENT',
  ProductWaitingForSubmission = 'PRODUCT_WAITING_FOR_SUBMISSION',
  PropertyInsuranceProductExpiration = 'PROPERTY_INSURANCE_PRODUCT_EXPIRATION',
  PropertyInsuranceProductPayment = 'PROPERTY_INSURANCE_PRODUCT_PAYMENT'
}

export enum FinancialProductType {
  BuildingSavings = 'BUILDING_SAVINGS',
  CollisionInsurance = 'COLLISION_INSURANCE',
  CreditCard = 'CREDIT_CARD',
  Generic = 'GENERIC',
  GenericInsurance = 'GENERIC_INSURANCE',
  Investment = 'INVESTMENT',
  LifeInsurance = 'LIFE_INSURANCE',
  Loan = 'LOAN',
  Mortgage = 'MORTGAGE',
  MotorLiabilityInsurance = 'MOTOR_LIABILITY_INSURANCE',
  PropertyInsurance = 'PROPERTY_INSURANCE',
  RetirementPensionSavings = 'RETIREMENT_PENSION_SAVINGS',
  Savings = 'SAVINGS',
  SupplementaryPensionSavings = 'SUPPLEMENTARY_PENSION_SAVINGS'
}

export type FinancialReserve = IdBase & {
  __typename?: 'FinancialReserve';
  amount: Money;
  client?: Maybe<Client>;
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updateTimestamp: Scalars['DateTime'];
};

export type FinancialReserveInput = {
  amount?: InputMaybe<MoneyInput>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type FinancialReservePage = {
  __typename?: 'FinancialReservePage';
  items: Array<FinancialReserve>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type GenericInsuranceProduct = ProductBase & {
  __typename?: 'GenericInsuranceProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type GenericInsuranceProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type GenericInsuranceProductPage = {
  __typename?: 'GenericInsuranceProductPage';
  items: Array<GenericInsuranceProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type GenericProduct = ProductBase & {
  __typename?: 'GenericProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type GenericProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type GenericProductPage = {
  __typename?: 'GenericProductPage';
  items: Array<GenericProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type IdBase = {
  id: Scalars['ID'];
};

export type Institution = IdBase & {
  __typename?: 'Institution';
  abbreviation: Scalars['String'];
  bic?: Maybe<Scalars['String']>;
  financialProductTypes: Array<FinancialProductType>;
  id: Scalars['ID'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  possibleAispNordigenConnection: Scalars['Boolean'];
  possibleUploadAccountStatements: Scalars['Boolean'];
  smallLogoUrl: Scalars['String'];
  wideLogoUrl?: Maybe<Scalars['String']>;
};

export type InstitutionPage = {
  __typename?: 'InstitutionPage';
  items: Array<Institution>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type InsuringPerson = {
  __typename?: 'InsuringPerson';
  name?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  type?: Maybe<InsuringPersonType>;
};

export type InsuringPersonInput = {
  name?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<InsuringPersonType>;
};

export enum InsuringPersonType {
  Legal = 'LEGAL',
  Natural = 'NATURAL'
}

export type IntInterval = {
  __typename?: 'IntInterval';
  lower?: Maybe<Scalars['Int']>;
  upper?: Maybe<Scalars['Int']>;
};

export type IntIntervalInput = {
  lower?: InputMaybe<Scalars['Int']>;
  upper?: InputMaybe<Scalars['Int']>;
};

export type InvestmentProduct = ProductBase & {
  __typename?: 'InvestmentProduct';
  amountInvested?: Maybe<Money>;
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  currentMarketValue?: Maybe<Money>;
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  financialInstrument?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type InvestmentProductInput = {
  amountInvested?: InputMaybe<MoneyInput>;
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  currentMarketValue?: InputMaybe<MoneyInput>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  financialInstrument?: InputMaybe<Scalars['String']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type InvestmentProductPage = {
  __typename?: 'InvestmentProductPage';
  items: Array<InvestmentProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type JobStatus = {
  __typename?: 'JobStatus';
  errorMessage?: Maybe<Scalars['String']>;
  status: JobStatusType;
};

export enum JobStatusType {
  Done = 'DONE',
  Error = 'ERROR',
  NonExistent = 'NON_EXISTENT',
  Running = 'RUNNING'
}

export enum LeadContext {
  LiAudit = 'LI_AUDIT',
  LiPurchase = 'LI_PURCHASE',
  LiScoreCalc = 'LI_SCORE_CALC',
  MortgageMaxCalc = 'MORTGAGE_MAX_CALC',
  MortgagePurchase = 'MORTGAGE_PURCHASE',
  MortgageRefinance = 'MORTGAGE_REFINANCE'
}

export type LifeInsuranceAdultProposal = IdBase & {
  __typename?: 'LifeInsuranceAdultProposal';
  applicant: LifeInsuranceApplicant;
  criticalIllnesses: Money;
  deathInsurance: Money;
  disability: Money;
  id: Scalars['ID'];
  permanentInjuryConsequences: Money;
};

export type LifeInsuranceApplicant = IdBase & {
  __typename?: 'LifeInsuranceApplicant';
  dateOfBirth?: Maybe<Scalars['Date']>;
  expenses?: Maybe<LifeInsuranceExpenses>;
  hasSharedExpenses?: Maybe<Scalars['Boolean']>;
  hasSharedLiabilities?: Maybe<Scalars['Boolean']>;
  healthCondition?: Maybe<LifeInsuranceHealthCondition>;
  id: Scalars['ID'];
  incomes: Array<LifeInsuranceIncome>;
  insurance?: Maybe<LifeInsuranceInsurance>;
  isHealthConditionSkipped?: Maybe<Scalars['Boolean']>;
  isInsured: Scalars['Boolean'];
  isInsuring: Scalars['Boolean'];
  liabilities: Array<LifeInsuranceLiability>;
  name: Scalars['String'];
  occupationName?: Maybe<Scalars['String']>;
  practicedSports: Array<LifeInsuranceSport>;
  surname: Scalars['String'];
};

export type LifeInsuranceApplicantInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  expenses?: InputMaybe<LifeInsuranceExpensesInput>;
  hasSharedExpenses?: InputMaybe<Scalars['Boolean']>;
  hasSharedLiabilities?: InputMaybe<Scalars['Boolean']>;
  healthCondition?: InputMaybe<LifeInsuranceHealthConditionInput>;
  incomes?: Array<LifeInsuranceIncomeInput>;
  insurance?: InputMaybe<LifeInsuranceInsuranceInput>;
  isHealthConditionSkipped?: InputMaybe<Scalars['Boolean']>;
  isInsured: Scalars['Boolean'];
  isInsuring: Scalars['Boolean'];
  liabilities?: Array<LifeInsuranceLiabilityInput>;
  name: Scalars['String'];
  occupationName?: InputMaybe<Scalars['String']>;
  practicedSports?: Array<LifeInsuranceSportInput>;
  surname: Scalars['String'];
};

export type LifeInsuranceAuditProcess = IdBase & {
  __typename?: 'LifeInsuranceAuditProcess';
  client?: Maybe<Client>;
  creationTimestamp?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<Document>>;
  id: Scalars['ID'];
  inquiry?: Maybe<LifeInsuranceInquiry>;
  locked?: Maybe<Scalars['Boolean']>;
  updateTimestamp?: Maybe<Scalars['DateTime']>;
};

export type LifeInsuranceAuditProcessPage = {
  __typename?: 'LifeInsuranceAuditProcessPage';
  items: Array<LifeInsuranceAuditProcess>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type LifeInsuranceCalculatorCalculation = IdBase & {
  __typename?: 'LifeInsuranceCalculatorCalculation';
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  inquiry: LifeInsuranceCalculatorInquiry;
  result: LifeInsuranceCalculatorResult;
};

export type LifeInsuranceCalculatorCalculationsPage = {
  __typename?: 'LifeInsuranceCalculatorCalculationsPage';
  items: Array<LifeInsuranceCalculatorCalculation>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum LifeInsuranceCalculatorDomain {
  Driving = 'DRIVING',
  Employment = 'EMPLOYMENT',
  FinancialReserve = 'FINANCIAL_RESERVE',
  Health = 'HEALTH',
  Liabilities = 'LIABILITIES',
  Sport = 'SPORT'
}

export enum LifeInsuranceCalculatorDrivingMileage {
  From_5000To_20000Km = 'FROM_5000_TO_20000_KM',
  Over_20000Km = 'OVER_20000_KM',
  Under_5000Km = 'UNDER_5000_KM'
}

export enum LifeInsuranceCalculatorEmploymentRisk {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type LifeInsuranceCalculatorFinancialAdvisorTaskDetails = {
  __typename?: 'LifeInsuranceCalculatorFinancialAdvisorTaskDetails';
  lifeInsuranceCalculatorCalculation: LifeInsuranceCalculatorCalculation;
};

export enum LifeInsuranceCalculatorFinancialReserveRisk {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type LifeInsuranceCalculatorInquiry = {
  __typename?: 'LifeInsuranceCalculatorInquiry';
  drivingMileage: LifeInsuranceCalculatorDrivingMileage;
  employmentRisk: LifeInsuranceCalculatorEmploymentRisk;
  financialReserveRisk: LifeInsuranceCalculatorFinancialReserveRisk;
  healthRisk: Scalars['Boolean'];
  liabilitiesSum: LifeInsuranceCalculatorLiabilitiesSum;
  sportRisk: Scalars['Boolean'];
};

export type LifeInsuranceCalculatorInquiryInput = {
  drivingMileage: LifeInsuranceCalculatorDrivingMileage;
  employmentRisk: LifeInsuranceCalculatorEmploymentRisk;
  financialReserveRisk: LifeInsuranceCalculatorFinancialReserveRisk;
  healthRisk: Scalars['Boolean'];
  liabilitiesSum: LifeInsuranceCalculatorLiabilitiesSum;
  sportRisk: Scalars['Boolean'];
};

export enum LifeInsuranceCalculatorLiabilitiesSum {
  From_50000To_100000Eur = 'FROM_50000_TO_100000_EUR',
  From_100000To_150000Eur = 'FROM_100000_TO_150000_EUR',
  NoLiabilities = 'NO_LIABILITIES',
  Over_150000Eur = 'OVER_150000_EUR',
  Under_50000Eur = 'UNDER_50000_EUR'
}

export enum LifeInsuranceCalculatorNecessity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type LifeInsuranceCalculatorResult = {
  __typename?: 'LifeInsuranceCalculatorResult';
  maximalScore: Scalars['Int'];
  necessity: LifeInsuranceCalculatorNecessity;
  score: Scalars['BigDecimal'];
  significantDomains: Array<LifeInsuranceCalculatorDomain>;
  similarUserRatio: Scalars['BigDecimal'];
};

export type LifeInsuranceChildProposal = IdBase & {
  __typename?: 'LifeInsuranceChildProposal';
  applicant: LifeInsuranceApplicant;
  criticalIllnesses: Money;
  hospitalization: Money;
  id: Scalars['ID'];
  minorInjuries: Money;
  permanentInjuryConsequences: Money;
};

export type LifeInsuranceDisease = {
  __typename?: 'LifeInsuranceDisease';
  description: Scalars['String'];
};

export type LifeInsuranceDiseaseInput = {
  description: Scalars['String'];
};

export type LifeInsuranceExpenses = {
  __typename?: 'LifeInsuranceExpenses';
  monthlyClothingExpenses: Money;
  monthlyFamilyExpenses: Money;
  monthlyGroceriesExpenses: Money;
  monthlyInsuranceExpenses: Money;
  monthlyTransportExpenses: Money;
  monthlyUtilitiesExpenses: Money;
};

export type LifeInsuranceExpensesInput = {
  monthlyClothingExpenses: MoneyInput;
  monthlyFamilyExpenses: MoneyInput;
  monthlyGroceriesExpenses: MoneyInput;
  monthlyInsuranceExpenses: MoneyInput;
  monthlyTransportExpenses: MoneyInput;
  monthlyUtilitiesExpenses: MoneyInput;
};

export type LifeInsuranceHealthCondition = {
  __typename?: 'LifeInsuranceHealthCondition';
  disabilityPension: DisabilityPensionType;
  diseases?: Maybe<Array<LifeInsuranceDisease>>;
  hasPermanentInjuryConsequences: Scalars['Boolean'];
  hasPlannedMedicalProcedure: Scalars['Boolean'];
  isOnRegularMedication: Scalars['Boolean'];
  isOnSickLeave: Scalars['Boolean'];
  isTreatedForDisease: Scalars['Boolean'];
  permanentInjuryConsequencesDescription: Scalars['String'];
  plannedMedicalProcedures?: Maybe<Array<LifeInsuranceMedicalProcedure>>;
  regularMedication: Scalars['String'];
};

export type LifeInsuranceHealthConditionInput = {
  disabilityPension: DisabilityPensionType;
  diseases?: InputMaybe<Array<LifeInsuranceDiseaseInput>>;
  hasPermanentInjuryConsequences: Scalars['Boolean'];
  hasPlannedMedicalProcedure: Scalars['Boolean'];
  isOnRegularMedication: Scalars['Boolean'];
  isOnSickLeave: Scalars['Boolean'];
  isTreatedForDisease: Scalars['Boolean'];
  permanentInjuryConsequencesDescription: Scalars['String'];
  plannedMedicalProcedures?: InputMaybe<Array<LifeInsuranceMedicalProcedureInput>>;
  regularMedication: Scalars['String'];
};

export type LifeInsuranceIncome = ApplicantAlimonyIncome | ApplicantEntrepreneurshipIncome | ApplicantLtdIncome | ApplicantMaternityLeaveIncome | ApplicantOtherIncome | ApplicantParentalAllowanceIncome | ApplicantSalaryIncome | ApplicantUnemploymentBenefitIncome | ApplicantWorkAgreementIncome;

export type LifeInsuranceIncomeInput = {
  alimonyIncome?: InputMaybe<ApplicantAlimonyIncomeInput>;
  entrepreneurshipIncome?: InputMaybe<ApplicantEntrepreneurshipIncomeInput>;
  ltdIncome?: InputMaybe<ApplicantLtdIncomeInput>;
  maternityLeaveIncome?: InputMaybe<ApplicantMaternityLeaveIncomeInput>;
  otherIncome?: InputMaybe<ApplicantOtherIncomeInput>;
  parentalAllowanceIncome?: InputMaybe<ApplicantParentalAllowanceIncomeInput>;
  salaryIncome?: InputMaybe<ApplicantSalaryIncomeInput>;
  unemploymentBenefitIncome?: InputMaybe<ApplicantUnemploymentBenefitIncomeInput>;
  workAgreementIncome?: InputMaybe<ApplicantWorkAgreementIncomeInput>;
};

export type LifeInsuranceInquiry = IdBase & {
  __typename?: 'LifeInsuranceInquiry';
  applicants?: Maybe<Array<LifeInsuranceApplicant>>;
  id: Scalars['ID'];
  inquiryCurrentStepUrl?: Maybe<Scalars['String']>;
  inquiryProgress?: Maybe<Scalars['Float']>;
};

export type LifeInsuranceInquiryInput = {
  applicants?: InputMaybe<Array<LifeInsuranceApplicantInput>>;
  inquiryCurrentStepUrl?: InputMaybe<Scalars['String']>;
  inquiryProgress?: InputMaybe<Scalars['Float']>;
};

export type LifeInsuranceInsurance = {
  __typename?: 'LifeInsuranceInsurance';
  id: Scalars['ID'];
  insuranceRisks: Array<LifeInsuranceInsuranceRisk>;
};

export type LifeInsuranceInsuranceInput = {
  insuranceRisks: Array<LifeInsuranceInsuranceRiskInput>;
};

export type LifeInsuranceInsuranceRisk = {
  __typename?: 'LifeInsuranceInsuranceRisk';
  annualCost?: Maybe<Money>;
  id: Scalars['ID'];
  insuredSum?: Maybe<Money>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<LifeInsuranceInsuranceRiskType>;
};

export type LifeInsuranceInsuranceRiskInput = {
  annualCost?: InputMaybe<MoneyInput>;
  insuredSum?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<LifeInsuranceInsuranceRiskType>;
};

export enum LifeInsuranceInsuranceRiskType {
  CriticalIllnesses = 'CRITICAL_ILLNESSES',
  DailyCompensation = 'DAILY_COMPENSATION',
  Death = 'DEATH',
  Disability = 'DISABILITY',
  Hospitalization = 'HOSPITALIZATION',
  Other = 'OTHER',
  PermanentInjuryConsequences = 'PERMANENT_INJURY_CONSEQUENCES',
  SicknessAbsence = 'SICKNESS_ABSENCE'
}

export type LifeInsuranceLiability = ApplicantAlimonyLiability | ApplicantConsumerLoanLiability | ApplicantLeaseLiability | ApplicantMortgageLiability | ApplicantOtherLoanLiability | ApplicantReconstructionLoanLiability;

export type LifeInsuranceLiabilityInput = {
  alimonyLiability?: InputMaybe<ApplicantAlimonyLiabilityInput>;
  consumerLoanLiability?: InputMaybe<ApplicantConsumerLoanLiabilityInput>;
  leaseLiability?: InputMaybe<ApplicantLeaseLiabilityInput>;
  mortgageLiability?: InputMaybe<ApplicantMortgageLiabilityInput>;
  otherLoanLiability?: InputMaybe<ApplicantOtherLoanLiabilityInput>;
  reconstructionLoanLiability?: InputMaybe<ApplicantReconstructionLoanLiabilityInput>;
};

export type LifeInsuranceMedicalProcedure = {
  __typename?: 'LifeInsuranceMedicalProcedure';
  description: Scalars['String'];
  scheduledFor: Scalars['String'];
};

export type LifeInsuranceMedicalProcedureInput = {
  description: Scalars['String'];
  scheduledFor: Scalars['String'];
};

export type LifeInsuranceProduct = ProductBase & {
  __typename?: 'LifeInsuranceProduct';
  applicants: Array<LifeInsuranceApplicant>;
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  savings?: Maybe<LifeInsuranceSavings>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  surrenderValue?: Maybe<Money>;
};

export type LifeInsuranceProductInput = {
  applicants?: InputMaybe<Array<LifeInsuranceApplicantInput>>;
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  savings?: InputMaybe<LifeInsuranceSavingsInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  surrenderValue?: InputMaybe<MoneyInput>;
};

export type LifeInsuranceProductPage = {
  __typename?: 'LifeInsuranceProductPage';
  items: Array<LifeInsuranceProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type LifeInsuranceProposal = LifeInsuranceAdultProposal | LifeInsuranceChildProposal;

export type LifeInsurancePurchaseProcess = IdBase & {
  __typename?: 'LifeInsurancePurchaseProcess';
  client?: Maybe<Client>;
  creationTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inquiry?: Maybe<LifeInsuranceInquiry>;
  locked?: Maybe<Scalars['Boolean']>;
  updateTimestamp?: Maybe<Scalars['DateTime']>;
};

export type LifeInsurancePurchaseProcessPage = {
  __typename?: 'LifeInsurancePurchaseProcessPage';
  items: Array<LifeInsurancePurchaseProcess>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type LifeInsuranceResult = IdBase & {
  __typename?: 'LifeInsuranceResult';
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  proposals: Array<LifeInsuranceProposal>;
};

export type LifeInsuranceSavings = {
  __typename?: 'LifeInsuranceSavings';
  amount?: Maybe<Money>;
  insuredSum?: Maybe<Money>;
};

export type LifeInsuranceSavingsInput = {
  amount?: InputMaybe<MoneyInput>;
  insuredSum?: InputMaybe<MoneyInput>;
};

export type LifeInsuranceSport = {
  __typename?: 'LifeInsuranceSport';
  name: Scalars['String'];
  wayOfPracticing: LifeInsuranceWayOfPracticingSportType;
};

export type LifeInsuranceSportInput = {
  name: Scalars['String'];
  wayOfPracticing: LifeInsuranceWayOfPracticingSportType;
};

export enum LifeInsuranceWayOfPracticingSportType {
  Organized = 'ORGANIZED',
  Professional = 'PROFESSIONAL',
  Recreational = 'RECREATIONAL'
}

export type LoanProduct = ProductBase & {
  __typename?: 'LoanProduct';
  amount?: Maybe<Money>;
  annualPercentageRate?: Maybe<Scalars['BigDecimal']>;
  balance?: Maybe<Money>;
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['BigDecimal']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type LoanProductInput = {
  amount?: InputMaybe<MoneyInput>;
  annualPercentageRate?: InputMaybe<Scalars['BigDecimal']>;
  balance?: InputMaybe<MoneyInput>;
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  interestRate?: InputMaybe<Scalars['BigDecimal']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type LoanProductPage = {
  __typename?: 'LoanProductPage';
  items: Array<LoanProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['BigDecimal'];
  currency: Scalars['Currency'];
};

export type MoneyInput = {
  amount: Scalars['BigDecimal'];
  currency: Scalars['Currency'];
};

export type MortgageCalculatorCalculation = IdBase & {
  __typename?: 'MortgageCalculatorCalculation';
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  inquiry: MortgageCalculatorInquiry;
  result: MortgageCalculatorResult;
};

export type MortgageCalculatorCalculationsPage = {
  __typename?: 'MortgageCalculatorCalculationsPage';
  items: Array<MortgageCalculatorCalculation>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MortgageCalculatorEntrepreneurshipIncome = {
  __typename?: 'MortgageCalculatorEntrepreneurshipIncome';
  taxBase: Money;
  taxPayed: Money;
  yearlyRevenues: Money;
};

export type MortgageCalculatorEntrepreneurshipIncomeInput = {
  taxBase: MoneyInput;
  taxPayed: MoneyInput;
  yearlyRevenues: MoneyInput;
};

export type MortgageCalculatorFinancialAdvisorTaskDetails = {
  __typename?: 'MortgageCalculatorFinancialAdvisorTaskDetails';
  mortgageCalculatorCalculation: MortgageCalculatorCalculation;
};

export type MortgageCalculatorInquiry = {
  __typename?: 'MortgageCalculatorInquiry';
  ageOldestApplicant: Scalars['Int'];
  entrepreneurshipIncome?: Maybe<MortgageCalculatorEntrepreneurshipIncome>;
  liabilities: MortgageCalculatorLiabilities;
  ltdIncome?: Maybe<MortgageCalculatorLtdIncome>;
  numberOfApplicants: Scalars['Int'];
  numberOfDependents: Scalars['Int'];
  salaryIncome?: Maybe<MortgageCalculatorSalaryIncome>;
};

export type MortgageCalculatorInquiryInput = {
  ageOldestApplicant: Scalars['Int'];
  entrepreneurshipIncome?: InputMaybe<MortgageCalculatorEntrepreneurshipIncomeInput>;
  liabilities: MortgageCalculatorLiabilitiesInput;
  ltdIncome?: InputMaybe<MortgageCalculatorLtdIncomeInput>;
  numberOfApplicants: Scalars['Int'];
  numberOfDependents: Scalars['Int'];
  salaryIncome?: InputMaybe<MortgageCalculatorSalaryIncomeInput>;
};

export type MortgageCalculatorLiabilities = {
  __typename?: 'MortgageCalculatorLiabilities';
  balance: Money;
  monthlyInstallment: Money;
};

export type MortgageCalculatorLiabilitiesInput = {
  balance: MoneyInput;
  monthlyInstallment: MoneyInput;
};

export type MortgageCalculatorLtdIncome = {
  __typename?: 'MortgageCalculatorLtdIncome';
  ceoCompensation: Money;
  equityShares: Scalars['BigDecimal'];
  yearlyProfit: Money;
  yearlyRevenues: Money;
};

export type MortgageCalculatorLtdIncomeInput = {
  ceoCompensation: MoneyInput;
  equityShares: Scalars['BigDecimal'];
  yearlyProfit: MoneyInput;
  yearlyRevenues: MoneyInput;
};

export type MortgageCalculatorResult = {
  __typename?: 'MortgageCalculatorResult';
  maxMortgageAmount: Money;
};

export type MortgageCalculatorSalaryIncome = {
  __typename?: 'MortgageCalculatorSalaryIncome';
  monthlyIncome: Money;
};

export type MortgageCalculatorSalaryIncomeInput = {
  monthlyIncome: MoneyInput;
};

export type MortgageCollateral = {
  __typename?: 'MortgageCollateral';
  address?: Maybe<Scalars['String']>;
  isInConstruction?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  sameAsPurchasedProperty?: Maybe<Scalars['Boolean']>;
  type?: Maybe<MortgageCollateralType>;
  value?: Maybe<Money>;
};

export type MortgageCollateralInput = {
  address?: InputMaybe<Scalars['String']>;
  isInConstruction?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  sameAsPurchasedProperty?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<MortgageCollateralType>;
  value?: InputMaybe<MoneyInput>;
};

export enum MortgageCollateralType {
  Flat = 'FLAT',
  House = 'HOUSE'
}

export type MortgageCurrentSetup = {
  __typename?: 'MortgageCurrentSetup';
  balance?: Maybe<Money>;
  collaterals?: Maybe<Array<MortgageCollateral>>;
  fixationEndDate?: Maybe<Scalars['Date']>;
  fixationLength?: Maybe<Scalars['Int']>;
  installment?: Maybe<Money>;
  institution?: Maybe<Institution>;
  interestRate?: Maybe<Scalars['BigDecimal']>;
  isNewFixationProposed?: Maybe<Scalars['Boolean']>;
  newProposedFixation?: Maybe<NewProposedFixation>;
  numberOfCollaterals?: Maybe<Scalars['Int']>;
};

export type MortgageCurrentSetupInput = {
  balance?: InputMaybe<MoneyInput>;
  collaterals?: InputMaybe<Array<MortgageCollateralInput>>;
  fixationEndDate?: InputMaybe<Scalars['Date']>;
  fixationLength?: InputMaybe<Scalars['Int']>;
  installment?: InputMaybe<MoneyInput>;
  institutionId: Scalars['ID'];
  interestRate?: InputMaybe<Scalars['BigDecimal']>;
  isNewFixationProposed?: InputMaybe<Scalars['Boolean']>;
  newProposedFixation?: InputMaybe<NewProposedFixationInput>;
  numberOfCollaterals?: InputMaybe<Scalars['Int']>;
};

export type MortgageIncome = ApplicantAlimonyIncome | ApplicantDisabilityPensionIncome | ApplicantDoctoralScholarshipIncome | ApplicantEntrepreneurshipIncome | ApplicantLtdIncome | ApplicantMaternityLeaveIncome | ApplicantOldAgePensionIncome | ApplicantOrphanPensionIncome | ApplicantOtherIncome | ApplicantParentalAllowanceIncome | ApplicantRealEstateRentalIncome | ApplicantRetirementPensionIncome | ApplicantSalaryIncome | ApplicantTravelCompensationIncome | ApplicantWidowPensionIncome | ApplicantWorkAgreementIncome;

export type MortgageIncomeInput = {
  alimonyIncome?: InputMaybe<ApplicantAlimonyIncomeInput>;
  disabilityPensionIncome?: InputMaybe<ApplicantDisabilityPensionIncomeInput>;
  doctoralScholarshipIncome?: InputMaybe<ApplicantDoctoralScholarshipIncomeInput>;
  entrepreneurshipIncome?: InputMaybe<ApplicantEntrepreneurshipIncomeInput>;
  ltdIncome?: InputMaybe<ApplicantLtdIncomeInput>;
  maternityLeaveIncome?: InputMaybe<ApplicantMaternityLeaveIncomeInput>;
  oldAgePensionIncome?: InputMaybe<ApplicantOldAgePensionIncomeInput>;
  orphanPensionIncome?: InputMaybe<ApplicantOrphanPensionIncomeInput>;
  parentalAllowanceIncome?: InputMaybe<ApplicantParentalAllowanceIncomeInput>;
  realEstateRentalIncome?: InputMaybe<ApplicantRealEstateRentalIncomeInput>;
  retirementPensionIncome?: InputMaybe<ApplicantRetirementPensionIncomeInput>;
  salaryIncome?: InputMaybe<ApplicantSalaryIncomeInput>;
  travelCompensationIncome?: InputMaybe<ApplicantTravelCompensationIncomeInput>;
  widowPensionIncome?: InputMaybe<ApplicantWidowPensionIncomeInput>;
  workAgreementIncome?: InputMaybe<ApplicantWorkAgreementIncomeInput>;
};

export enum MortgageIncomeType {
  Entrepreneurship = 'ENTREPRENEURSHIP',
  Ltd = 'LTD',
  Other = 'OTHER',
  Salary = 'SALARY'
}

export type MortgageLiability = ApplicantAlimonyLiability | ApplicantConsumerLoanLiability | ApplicantCreditCardLiability | ApplicantLeaseLiability | ApplicantMortgageLiability | ApplicantOtherLoanLiability | ApplicantOverdraftLiability | ApplicantReconstructionLoanLiability;

export type MortgageLiabilityInput = {
  alimonyLiability?: InputMaybe<ApplicantAlimonyLiabilityInput>;
  consumerLoanLiability?: InputMaybe<ApplicantConsumerLoanLiabilityInput>;
  creditCardLiability?: InputMaybe<ApplicantCreditCardLiabilityInput>;
  leaseLiability?: InputMaybe<ApplicantLeaseLiabilityInput>;
  mortgageLiability?: InputMaybe<ApplicantMortgageLiabilityInput>;
  otherLoanLiability?: InputMaybe<ApplicantOtherLoanLiabilityInput>;
  overdraftLiability?: InputMaybe<ApplicantOverdraftLiabilityInput>;
  reconstructionLoanLiability?: InputMaybe<ApplicantReconstructionLoanLiabilityInput>;
};

export type MortgageParticipant = {
  __typename?: 'MortgageParticipant';
  name?: Maybe<Scalars['String']>;
};

export type MortgageParticipantInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type MortgageProduct = ProductBase & {
  __typename?: 'MortgageProduct';
  amount?: Maybe<Money>;
  annualPercentageRate?: Maybe<Scalars['BigDecimal']>;
  balance?: Maybe<Money>;
  client?: Maybe<Client>;
  collaterals: Array<MortgageCollateral>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  fixationEndDate?: Maybe<Scalars['Date']>;
  fixationLength?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['BigDecimal']>;
  isNewFixationProposed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  newProposedFixation?: Maybe<NewProposedFixation>;
  note?: Maybe<Scalars['String']>;
  numberOfCollaterals?: Maybe<Scalars['Int']>;
  participants: Array<MortgageParticipant>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  purchasedProperty?: Maybe<MortgageProperty>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type MortgageProductInput = {
  amount?: InputMaybe<MoneyInput>;
  annualPercentageRate?: InputMaybe<Scalars['BigDecimal']>;
  balance?: InputMaybe<MoneyInput>;
  collaterals?: InputMaybe<Array<MortgageCollateralInput>>;
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  fixationEndDate?: InputMaybe<Scalars['Date']>;
  fixationLength?: InputMaybe<Scalars['Int']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  interestRate?: InputMaybe<Scalars['BigDecimal']>;
  isNewFixationProposed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  newProposedFixation?: InputMaybe<NewProposedFixationInput>;
  note?: InputMaybe<Scalars['String']>;
  numberOfCollaterals?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<Array<MortgageParticipantInput>>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  purchasedProperty?: InputMaybe<MortgagePropertyInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type MortgageProductPage = {
  __typename?: 'MortgageProductPage';
  items: Array<MortgageProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MortgageProperty = {
  __typename?: 'MortgageProperty';
  address?: Maybe<Scalars['String']>;
  energyCertificateClassA?: Maybe<Scalars['Boolean']>;
  isChosen?: Maybe<Scalars['Boolean']>;
  isDeveloperProject?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Money>;
  size?: Maybe<MortgagePropertySize>;
  sizeInterval?: Maybe<IntInterval>;
  type?: Maybe<MortgagePropertyType>;
};

export type MortgagePropertyInput = {
  address?: InputMaybe<Scalars['String']>;
  energyCertificateClassA?: InputMaybe<Scalars['Boolean']>;
  isChosen?: InputMaybe<Scalars['Boolean']>;
  isDeveloperProject?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<MoneyInput>;
  size?: InputMaybe<MortgagePropertySize>;
  sizeInterval?: InputMaybe<IntIntervalInput>;
  type?: InputMaybe<MortgagePropertyType>;
};

export enum MortgagePropertySize {
  Over_150M2 = 'OVER_150_M2',
  Under_150M2 = 'UNDER_150_M2'
}

export enum MortgagePropertyType {
  Flat = 'FLAT',
  House = 'HOUSE',
  Land = 'LAND',
  Other = 'OTHER'
}

export type MortgageProposal = IdBase & {
  __typename?: 'MortgageProposal';
  amount: Money;
  capitalBalanceAfterFixation?: Maybe<Money>;
  fees?: Maybe<MortgageProposalFees>;
  fixationLength: Scalars['Int'];
  id: Scalars['ID'];
  incomeVerification?: Maybe<Scalars['Boolean']>;
  installment: Money;
  installmentChange?: Maybe<Money>;
  institutionAbbreviation: Scalars['String'];
  interestRate: Scalars['BigDecimal'];
  maturity: Scalars['Int'];
  overpaymentInFixationPeriod: Money;
};

export type MortgageProposalFees = {
  __typename?: 'MortgageProposalFees';
  annualPropertyInsurance: Money;
  monthlyAccountManagement: Money;
  monthlyMortgageInsurance: Money;
  prepaymentOrChangeOfConditions: Money;
  provision: Money;
};

export type MortgagePurchaseApplicant = IdBase & {
  __typename?: 'MortgagePurchaseApplicant';
  citizenship?: Maybe<Scalars['String']>;
  dateOfBirth: Scalars['Date'];
  familyStatus?: Maybe<FamilyStatus>;
  id: Scalars['ID'];
  incomes?: Maybe<Array<MortgageIncome>>;
  liabilities?: Maybe<Array<MortgageLiability>>;
  name: Scalars['String'];
  numberOfDependents?: Maybe<Scalars['Int']>;
};

export type MortgagePurchaseApplicantInput = {
  citizenship?: InputMaybe<Scalars['String']>;
  dateOfBirth: Scalars['Date'];
  familyStatus?: InputMaybe<FamilyStatus>;
  incomes?: InputMaybe<Array<MortgageIncomeInput>>;
  liabilities?: InputMaybe<Array<MortgageLiabilityInput>>;
  name: Scalars['String'];
  numberOfDependents?: InputMaybe<Scalars['Int']>;
};

export type MortgagePurchaseInquiry = IdBase & {
  __typename?: 'MortgagePurchaseInquiry';
  applicants?: Maybe<Array<MortgagePurchaseApplicant>>;
  collaterals?: Maybe<Array<MortgageCollateral>>;
  id: Scalars['ID'];
  inquiryCurrentStepUrl?: Maybe<Scalars['String']>;
  inquiryProgress?: Maybe<Scalars['Float']>;
  numberOfApplicants?: Maybe<Scalars['Int']>;
  numberOfCollaterals?: Maybe<Scalars['Int']>;
  purpose?: Maybe<MortgagePurpose>;
};

export type MortgagePurchaseInquiryInput = {
  applicants?: InputMaybe<Array<MortgagePurchaseApplicantInput>>;
  collaterals?: InputMaybe<Array<MortgageCollateralInput>>;
  inquiryCurrentStepUrl?: InputMaybe<Scalars['String']>;
  inquiryProgress?: InputMaybe<Scalars['Float']>;
  numberOfApplicants?: InputMaybe<Scalars['Int']>;
  numberOfCollaterals?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<MortgagePurposeInput>;
};

export type MortgagePurchaseProcess = IdBase & {
  __typename?: 'MortgagePurchaseProcess';
  acceptanceType?: Maybe<MortgagePurchaseProcessAcceptanceType>;
  acceptedProposal?: Maybe<MortgageProposal>;
  acceptedTimestamp?: Maybe<Scalars['DateTime']>;
  client?: Maybe<Client>;
  creationTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inquiry?: Maybe<MortgagePurchaseInquiry>;
  locked?: Maybe<Scalars['Boolean']>;
  updateTimestamp?: Maybe<Scalars['DateTime']>;
};

export enum MortgagePurchaseProcessAcceptanceType {
  Future = 'FUTURE',
  Immediate = 'IMMEDIATE'
}

export type MortgagePurchaseProcessPage = {
  __typename?: 'MortgagePurchaseProcessPage';
  items: Array<MortgagePurchaseProcess>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MortgagePurchaseResult = IdBase & {
  __typename?: 'MortgagePurchaseResult';
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  proposals: Array<MortgageProposal>;
};

export type MortgagePurchaseResultConstraints = {
  __typename?: 'MortgagePurchaseResultConstraints';
  fixationLength: Scalars['Int'];
  installment: Money;
  maturity: Scalars['Int'];
  maxMortgageAmount: Money;
  maxPropertyPrice: Money;
  minInterestRate: Scalars['BigDecimal'];
};

export type MortgagePurchaseTuningInput = {
  amount: MoneyInput;
  fixationLengthInYears: Scalars['Int'];
  maturityInYears: Scalars['Int'];
};

export type MortgagePurchaseTuningLimits = {
  __typename?: 'MortgagePurchaseTuningLimits';
  amountDefault: Money;
  amountRange: PairMoney;
  fixationDefault: Scalars['Int'];
  fixationOptions?: Maybe<Array<Scalars['Int']>>;
  maturityInYearsDefault: Scalars['Int'];
  maturityInYearsRange: IntInterval;
};

export type MortgagePurpose = {
  __typename?: 'MortgagePurpose';
  mortgageAmount?: Maybe<Money>;
  property?: Maybe<MortgageProperty>;
  type?: Maybe<MortgagePurposeType>;
  typeOtherDescription?: Maybe<Scalars['String']>;
};

export type MortgagePurposeInput = {
  mortgageAmount?: InputMaybe<MoneyInput>;
  property?: InputMaybe<MortgagePropertyInput>;
  type?: InputMaybe<MortgagePurposeType>;
  typeOtherDescription?: InputMaybe<Scalars['String']>;
};

export enum MortgagePurposeType {
  Completion = 'COMPLETION',
  Consolidation = 'CONSOLIDATION',
  Construction = 'CONSTRUCTION',
  InheritanceSettlement = 'INHERITANCE_SETTLEMENT',
  Other = 'OTHER',
  OtherPropertyRelated = 'OTHER_PROPERTY_RELATED',
  OwnershipSettlement = 'OWNERSHIP_SETTLEMENT',
  PurchasePriceRefund = 'PURCHASE_PRICE_REFUND',
  PurchaseProperty = 'PURCHASE_PROPERTY',
  ReconstructionNotRequiringBuildingPermit = 'RECONSTRUCTION_NOT_REQUIRING_BUILDING_PERMIT',
  ReconstructionRequiringBuildingPermit = 'RECONSTRUCTION_REQUIRING_BUILDING_PERMIT',
  Refinance = 'REFINANCE'
}

export type MortgageRefinanceApplicant = IdBase & {
  __typename?: 'MortgageRefinanceApplicant';
  dateOfBirth: Scalars['Date'];
  id: Scalars['ID'];
  incomeCommencementDate?: Maybe<Scalars['Date']>;
  incomeType: MortgageIncomeType;
  name: Scalars['String'];
};

export type MortgageRefinanceApplicantInput = {
  dateOfBirth: Scalars['Date'];
  incomeCommencementDate?: InputMaybe<Scalars['Date']>;
  incomeType: MortgageIncomeType;
  name: Scalars['String'];
};

export type MortgageRefinanceInquiry = IdBase & {
  __typename?: 'MortgageRefinanceInquiry';
  applicants?: Maybe<Array<MortgageRefinanceApplicant>>;
  currentSetup?: Maybe<MortgageCurrentSetup>;
  id: Scalars['ID'];
  inquiryCurrentStepUrl?: Maybe<Scalars['String']>;
  inquiryProgress?: Maybe<Scalars['Float']>;
  numberOfApplicants?: Maybe<Scalars['Int']>;
};

export type MortgageRefinanceInquiryInput = {
  applicants?: InputMaybe<Array<MortgageRefinanceApplicantInput>>;
  currentSetup?: InputMaybe<MortgageCurrentSetupInput>;
  inquiryCurrentStepUrl?: InputMaybe<Scalars['String']>;
  inquiryProgress?: InputMaybe<Scalars['Float']>;
  numberOfApplicants?: InputMaybe<Scalars['Int']>;
};

export type MortgageRefinanceProcess = IdBase & {
  __typename?: 'MortgageRefinanceProcess';
  acceptedProposal?: Maybe<MortgageProposal>;
  acceptedTimestamp?: Maybe<Scalars['DateTime']>;
  client?: Maybe<Client>;
  creationTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inquiry?: Maybe<MortgageRefinanceInquiry>;
  updateTimestamp?: Maybe<Scalars['DateTime']>;
};

export type MortgageRefinanceProcessPage = {
  __typename?: 'MortgageRefinanceProcessPage';
  items: Array<MortgageRefinanceProcess>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type MortgageRefinanceResult = IdBase & {
  __typename?: 'MortgageRefinanceResult';
  creationTimestamp: Scalars['DateTime'];
  currentMortgageInFixationPeriod?: Maybe<MortgageProposal>;
  customStrategyResult: MortgageRefinanceStrategyResult;
  id: Scalars['ID'];
  minimizingOverpaymentResult: MortgageRefinanceStrategyResult;
  preservingCurrentInstallmentResult: MortgageRefinanceStrategyResult;
};

export type MortgageRefinanceStrategyResult = IdBase & {
  __typename?: 'MortgageRefinanceStrategyResult';
  changeInOverpayment?: Maybe<Money>;
  currentMortgageAfterFixationPeriod?: Maybe<MortgageProposal>;
  id: Scalars['ID'];
  proposals: Array<MortgageProposal>;
};

export type MortgageRefinanceTuningInput = {
  fixationLengthInYears: Scalars['Int'];
  maturityInYears: Scalars['Int'];
};

export type MortgageRefinanceTuningLimits = {
  __typename?: 'MortgageRefinanceTuningLimits';
  fixationDefault: Scalars['Int'];
  fixationOptions?: Maybe<Array<Scalars['Int']>>;
  maturityInYearsDefault: Scalars['Int'];
  maturityInYearsRange: IntInterval;
};

export type MotorLiabilityInsuranceProduct = ProductBase & {
  __typename?: 'MotorLiabilityInsuranceProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  insuringPerson?: Maybe<InsuringPerson>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  vehicleInfo?: Maybe<VehicleInfo>;
};

export type MotorLiabilityInsuranceProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  insuringPerson?: InputMaybe<InsuringPersonInput>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  vehicleInfo?: InputMaybe<VehicleInfoInput>;
};

export type MotorLiabilityInsuranceProductPage = {
  __typename?: 'MotorLiabilityInsuranceProductPage';
  items: Array<MotorLiabilityInsuranceProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptLifeInsuranceAuditResult: LifeInsuranceAuditProcess;
  acceptLifeInsurancePurchaseResult: LifeInsurancePurchaseProcess;
  acceptMortgagePurchaseProposal: MortgagePurchaseProcess;
  acceptMortgageRefinanceProposal: MortgageRefinanceProcess;
  addTagsToTransactionGroup: TransactionGroup;
  addTagsToTransactions: Array<Transaction>;
  adminCreateBuildingSavingsProduct: BuildingSavingsProduct;
  adminCreateBuildingSavingsProductDocument: Document;
  adminCreateCashFlowAdjustment: CashFlowAdjustment;
  adminCreateClientNote: ClientNote;
  adminCreateCollisionInsuranceProduct: CollisionInsuranceProduct;
  adminCreateCollisionInsuranceProductDocument: Document;
  adminCreateCreditCardProduct: CreditCardProduct;
  adminCreateCreditCardProductDocument: Document;
  adminCreateFinancialAdvisorTask: FinancialAdvisorTask;
  adminCreateFinancialReserve: FinancialReserve;
  adminCreateGenericInsuranceProduct: GenericInsuranceProduct;
  adminCreateGenericInsuranceProductDocument: Document;
  adminCreateGenericProduct: GenericProduct;
  adminCreateGenericProductDocument: Document;
  adminCreateInvestmentProduct: InvestmentProduct;
  adminCreateInvestmentProductDocument: Document;
  adminCreateLifeInsuranceProduct: LifeInsuranceProduct;
  adminCreateLifeInsuranceProductDocument: Document;
  adminCreateLoanProduct: LoanProduct;
  adminCreateLoanProductDocument: Document;
  adminCreateMortgageProduct: MortgageProduct;
  adminCreateMortgageProductDocument: Document;
  adminCreateMotorLiabilityInsuranceProduct: MotorLiabilityInsuranceProduct;
  adminCreateMotorLiabilityInsuranceProductDocument: Document;
  adminCreatePropertyInsuranceProduct: PropertyInsuranceProduct;
  adminCreatePropertyInsuranceProductDocument: Document;
  adminCreateReport: Report;
  adminCreateRetirementPensionSavingsProduct: RetirementPensionSavingsProduct;
  adminCreateRetirementPensionSavingsProductDocument: Document;
  adminCreateSavingsProduct: SavingsProduct;
  adminCreateSavingsProductDocument: Document;
  adminCreateSupplementaryPensionSavingsProduct: SupplementaryPensionSavingsProduct;
  adminCreateSupplementaryPensionSavingsProductDocument: Document;
  adminCreateUser: User;
  adminCreateUserInvitation: UserInvitation;
  adminCreateUserRelation: UserRelation;
  adminDeactivateFinancialAdvisorTask: Scalars['ID'];
  adminDeleteBuildingSavingsProduct: Scalars['ID'];
  adminDeleteBuildingSavingsProducts: Array<Scalars['ID']>;
  adminDeleteCashFlowAdjustment: Scalars['ID'];
  adminDeleteCashFlowAdjustments: Array<Scalars['ID']>;
  adminDeleteClientNote: Scalars['ID'];
  adminDeleteClientNotes: Array<Scalars['ID']>;
  adminDeleteCollisionInsuranceProduct: Scalars['ID'];
  adminDeleteCollisionInsuranceProducts: Array<Scalars['ID']>;
  adminDeleteCreditCardProduct: Scalars['ID'];
  adminDeleteCreditCardProducts: Array<Scalars['ID']>;
  adminDeleteFinancialReserve: Scalars['ID'];
  adminDeleteFinancialReserves: Array<Scalars['ID']>;
  adminDeleteGenericInsuranceProduct: Scalars['ID'];
  adminDeleteGenericInsuranceProducts: Array<Scalars['ID']>;
  adminDeleteGenericProduct: Scalars['ID'];
  adminDeleteGenericProducts: Array<Scalars['ID']>;
  adminDeleteInvestmentProduct: Scalars['ID'];
  adminDeleteInvestmentProducts: Array<Scalars['ID']>;
  adminDeleteLifeInsuranceAuditProcess: Scalars['ID'];
  adminDeleteLifeInsuranceAuditProcesses: Array<Scalars['ID']>;
  adminDeleteLifeInsuranceProduct: Scalars['ID'];
  adminDeleteLifeInsuranceProducts: Array<Scalars['ID']>;
  adminDeleteLifeInsurancePurchaseProcess: Scalars['ID'];
  adminDeleteLifeInsurancePurchaseProcesses: Array<Scalars['ID']>;
  adminDeleteLoanProduct: Scalars['ID'];
  adminDeleteLoanProducts: Array<Scalars['ID']>;
  adminDeleteMortgageProduct: Scalars['ID'];
  adminDeleteMortgageProducts: Array<Scalars['ID']>;
  adminDeleteMortgagePurchaseProcess: Scalars['ID'];
  adminDeleteMortgagePurchaseProcesses: Array<Scalars['ID']>;
  adminDeleteMortgageRefinanceProcess: Scalars['ID'];
  adminDeleteMortgageRefinanceProcesses: Array<Scalars['ID']>;
  adminDeleteMotorLiabilityInsuranceProduct: Scalars['ID'];
  adminDeleteMotorLiabilityInsuranceProducts: Array<Scalars['ID']>;
  adminDeletePropertyInsuranceProduct: Scalars['ID'];
  adminDeletePropertyInsuranceProducts: Array<Scalars['ID']>;
  adminDeleteReport: Scalars['ID'];
  adminDeleteReports: Array<Scalars['ID']>;
  adminDeleteRetirementPensionSavingsProduct: Scalars['ID'];
  adminDeleteRetirementPensionSavingsProducts: Array<Scalars['ID']>;
  adminDeleteSavingsProduct: Scalars['ID'];
  adminDeleteSavingsProducts: Array<Scalars['ID']>;
  adminDeleteSupplementaryPensionSavingsProduct: Scalars['ID'];
  adminDeleteSupplementaryPensionSavingsProducts: Array<Scalars['ID']>;
  adminDeleteUser: Scalars['ID'];
  adminDeleteUserInvitation: Scalars['ID'];
  adminDeleteUserInvitations: Array<Scalars['ID']>;
  adminDeleteUserRelation: Scalars['ID'];
  adminDeleteUserRelations: Array<Scalars['ID']>;
  adminDeleteUsers: Array<Scalars['ID']>;
  adminMarkFinancialAdvisorTaskAsDone: FinancialAdvisorTask;
  adminMarkFinancialAdvisorTaskAsUndone: FinancialAdvisorTask;
  adminUpdateBuildingSavingsProduct: BuildingSavingsProduct;
  adminUpdateCashFlowAdjustment: CashFlowAdjustment;
  adminUpdateClient: Client;
  adminUpdateClientNote: ClientNote;
  adminUpdateCollisionInsuranceProduct: CollisionInsuranceProduct;
  adminUpdateCreditCardProduct: CreditCardProduct;
  adminUpdateFinancialReserve: FinancialReserve;
  adminUpdateGenericInsuranceProduct: GenericInsuranceProduct;
  adminUpdateGenericProduct: GenericProduct;
  adminUpdateInvestmentProduct: InvestmentProduct;
  adminUpdateLifeInsuranceProduct: LifeInsuranceProduct;
  adminUpdateLoanProduct: LoanProduct;
  adminUpdateMortgageProduct: MortgageProduct;
  adminUpdateMotorLiabilityInsuranceProduct: MotorLiabilityInsuranceProduct;
  adminUpdatePropertyInsuranceProduct: PropertyInsuranceProduct;
  adminUpdateReport: Report;
  adminUpdateRetirementPensionSavingsProduct: RetirementPensionSavingsProduct;
  adminUpdateSavingsProduct: SavingsProduct;
  adminUpdateStaff: Staff;
  adminUpdateSupplementaryPensionSavingsProduct: SupplementaryPensionSavingsProduct;
  adminUpdateUser: User;
  adminUpdateUserInvitation: UserInvitation;
  adminUpdateUserRelation: UserRelation;
  calculateAndSaveLifeInsuranceResultByProcessId: LifeInsuranceResult;
  calculateAndSaveMortgagePurchaseResultByProcessId: MortgagePurchaseResult;
  calculateAndSaveMortgageRefinanceResultByProcessId: MortgageRefinanceResult;
  createBuildingSavingsProduct: BuildingSavingsProduct;
  createBuildingSavingsProductDocument: Document;
  createCalendarEvent: CalendarEvent;
  createCashFlowAdjustment: CashFlowAdjustment;
  createCollisionInsuranceProduct: CollisionInsuranceProduct;
  createCollisionInsuranceProductDocument: Document;
  createCreditCardProduct: CreditCardProduct;
  createCreditCardProductDocument: Document;
  createFinancialReserve: FinancialReserve;
  createGenericInsuranceProduct: GenericInsuranceProduct;
  createGenericInsuranceProductDocument: Document;
  createGenericProduct: GenericProduct;
  createGenericProductDocument: Document;
  createInvestmentProduct: InvestmentProduct;
  createInvestmentProductDocument: Document;
  createLifeInsuranceAuditProcess: LifeInsuranceAuditProcess;
  createLifeInsuranceDocument: Document;
  createLifeInsuranceProduct: LifeInsuranceProduct;
  createLifeInsuranceProductDocument: Document;
  createLifeInsurancePurchaseProcess: LifeInsurancePurchaseProcess;
  createLoanProduct: LoanProduct;
  createLoanProductDocument: Document;
  createMortgageProduct: MortgageProduct;
  createMortgageProductDocument: Document;
  createMortgagePurchaseProcess: MortgagePurchaseProcess;
  createMortgageRefinanceProcess: MortgageRefinanceProcess;
  createMotorLiabilityInsuranceProduct: MotorLiabilityInsuranceProduct;
  createMotorLiabilityInsuranceProductDocument: Document;
  createOrUpdateClientProfile: ClientProfile;
  createOrUpdateLead: Scalars['Boolean'];
  createProcessWidget: ProcessWidget;
  createPropertyInsuranceProduct: PropertyInsuranceProduct;
  createPropertyInsuranceProductDocument: Document;
  createReport: Report;
  createRetirementPensionSavingsProduct: RetirementPensionSavingsProduct;
  createRetirementPensionSavingsProductDocument: Document;
  createSavingsProduct: SavingsProduct;
  createSavingsProductDocument: Document;
  createSupplementaryPensionSavingsProduct: SupplementaryPensionSavingsProduct;
  createSupplementaryPensionSavingsProductDocument: Document;
  createTransactionTag: TransactionTag;
  createUnregisteredUser: Scalars['ID'];
  deactivateNotification: Scalars['ID'];
  deleteBuildingSavingsProduct: Scalars['ID'];
  deleteCalendarEvent: Scalars['ID'];
  deleteCashFlowAdjustment: Scalars['ID'];
  deleteCollisionInsuranceProduct: Scalars['ID'];
  deleteCreditCardProduct: Scalars['ID'];
  deleteDocument: Scalars['ID'];
  deleteFinancialReserve: Scalars['ID'];
  deleteGenericInsuranceProduct: Scalars['ID'];
  deleteGenericProduct: Scalars['ID'];
  deleteInvestmentProduct: Scalars['ID'];
  deleteLifeInsuranceAuditProcess: Scalars['ID'];
  deleteLifeInsuranceProduct: Scalars['ID'];
  deleteLifeInsurancePurchaseProcess: Scalars['ID'];
  deleteLoanProduct: Scalars['ID'];
  deleteMortgageProduct: Scalars['ID'];
  deleteMortgagePurchaseProcess: Scalars['ID'];
  deleteMortgageRefinanceProcess: Scalars['ID'];
  deleteMotorLiabilityInsuranceProduct: Scalars['ID'];
  deleteProcessWidget?: Maybe<Scalars['ID']>;
  deletePropertyInsuranceProduct: Scalars['ID'];
  deleteRetirementPensionSavingsProduct: Scalars['ID'];
  deleteSavingsProduct: Scalars['ID'];
  deleteSupplementaryPensionSavingsProduct: Scalars['ID'];
  deleteTransactionTag: Scalars['ID'];
  generateFileDownloadUrl: Scalars['String'];
  initNordigenFlow: Scalars['Url'];
  markAllNotificationsAsRead: Array<Notification>;
  markNotificationAsRead: Notification;
  moveProcessWidget: Array<ProcessWidget>;
  preregisterUser: Scalars['Boolean'];
  refreshAccountsData?: Maybe<Scalars['String']>;
  removeAccount?: Maybe<Scalars['ID']>;
  removePeriodFromTransactionGroup: TransactionGroup;
  removeTagsFromTransactionGroup: TransactionGroup;
  removeTagsFromTransactions: Array<Transaction>;
  removeUser: Scalars['Boolean'];
  renameAccount?: Maybe<Account>;
  renameTransactionCounterparty?: Maybe<TransactionCounterparty>;
  renameTransactionTag: TransactionTag;
  requestContact: Scalars['Boolean'];
  requestContactFromAuthenticatedUser: Scalars['Boolean'];
  saveUtmParameters: Scalars['Boolean'];
  sendLifeInsuranceAuditNotificationEmailToSpecialist: Scalars['Boolean'];
  sendLifeInsurancePurchaseNotificationEmailToSpecialist: Scalars['Boolean'];
  sendMortgagePurchaseNotificationEmailToSpecialist: Scalars['Boolean'];
  sendMortgageRefinanceNotificationEmailToSpecialist: Scalars['Boolean'];
  setBudget: Scalars['BigDecimal'];
  synchronizeAccounts: Array<Account>;
  synchronizeUser: Scalars['Boolean'];
  updateBuildingSavingsProduct: BuildingSavingsProduct;
  updateCalendarEvent: CalendarEvent;
  updateCashFlowAdjustment: CashFlowAdjustment;
  updateCollisionInsuranceProduct: CollisionInsuranceProduct;
  updateCreditCardProduct: CreditCardProduct;
  updateFinancialReserve: FinancialReserve;
  updateGenericInsuranceProduct: GenericInsuranceProduct;
  updateGenericProduct: GenericProduct;
  updateInvestmentProduct: InvestmentProduct;
  updateLifeInsuranceAuditProcess: LifeInsuranceAuditProcess;
  updateLifeInsuranceProduct: LifeInsuranceProduct;
  updateLifeInsurancePurchaseProcess: LifeInsurancePurchaseProcess;
  updateLoanProduct: LoanProduct;
  updateMortgageProduct: MortgageProduct;
  updateMortgagePurchaseProcess: MortgagePurchaseProcess;
  updateMortgageRefinanceProcess: MortgageRefinanceProcess;
  updateMotorLiabilityInsuranceProduct: MotorLiabilityInsuranceProduct;
  /** @deprecated period input type renamed, use updatePeriodOfTransactionGroupNew */
  updatePeriodOfTransactionGroup: TransactionGroup;
  updatePeriodOfTransactionGroupNew: TransactionGroup;
  updateProductType: Scalars['ID'];
  updatePropertyInsuranceProduct: PropertyInsuranceProduct;
  updateRetirementPensionSavingsProduct: RetirementPensionSavingsProduct;
  updateSavingsProduct: SavingsProduct;
  updateSupplementaryPensionSavingsProduct: SupplementaryPensionSavingsProduct;
  updateTransactionGroup: TransactionGroup;
  updateTransactions: Array<Transaction>;
  updateUserAvatar: User;
  updateUserEmail?: Maybe<User>;
  /** @deprecated Use updateUserEmail instead */
  updateUserPersonalInformation?: Maybe<User>;
  verifyChangeEmail: Scalars['Boolean'];
  verifyRegistrationEmail?: Maybe<Scalars['Boolean']>;
};


export type MutationAcceptLifeInsuranceAuditResultArgs = {
  processId: Scalars['ID'];
};


export type MutationAcceptLifeInsurancePurchaseResultArgs = {
  processId: Scalars['ID'];
};


export type MutationAcceptMortgagePurchaseProposalArgs = {
  acceptanceType: MortgagePurchaseProcessAcceptanceType;
  processId: Scalars['ID'];
  proposalId?: InputMaybe<Scalars['ID']>;
};


export type MutationAcceptMortgageRefinanceProposalArgs = {
  processId: Scalars['ID'];
  refinanceProposalId: Scalars['ID'];
};


export type MutationAddTagsToTransactionGroupArgs = {
  groupId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};


export type MutationAddTagsToTransactionsArgs = {
  tagIds: Array<Scalars['ID']>;
  transactionIds: Array<Scalars['ID']>;
};


export type MutationAdminCreateBuildingSavingsProductArgs = {
  clientId: Scalars['ID'];
  product: BuildingSavingsProductInput;
};


export type MutationAdminCreateBuildingSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateCashFlowAdjustmentArgs = {
  cashFlowAdjustment: CashFlowAdjustmentInput;
  clientId: Scalars['ID'];
};


export type MutationAdminCreateClientNoteArgs = {
  clientNote: ClientNoteInput;
};


export type MutationAdminCreateCollisionInsuranceProductArgs = {
  clientId: Scalars['ID'];
  product: CollisionInsuranceProductInput;
};


export type MutationAdminCreateCollisionInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateCreditCardProductArgs = {
  clientId: Scalars['ID'];
  product: CreditCardProductInput;
};


export type MutationAdminCreateCreditCardProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateFinancialAdvisorTaskArgs = {
  clientId: Scalars['ID'];
  task: FinancialAdvisorTaskInput;
};


export type MutationAdminCreateFinancialReserveArgs = {
  clientId: Scalars['ID'];
  financialReserve: FinancialReserveInput;
};


export type MutationAdminCreateGenericInsuranceProductArgs = {
  clientId: Scalars['ID'];
  product: GenericInsuranceProductInput;
};


export type MutationAdminCreateGenericInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateGenericProductArgs = {
  clientId: Scalars['ID'];
  product: GenericProductInput;
};


export type MutationAdminCreateGenericProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateInvestmentProductArgs = {
  clientId: Scalars['ID'];
  product: InvestmentProductInput;
};


export type MutationAdminCreateInvestmentProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateLifeInsuranceProductArgs = {
  clientId: Scalars['ID'];
  product: LifeInsuranceProductInput;
};


export type MutationAdminCreateLifeInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateLoanProductArgs = {
  clientId: Scalars['ID'];
  product: LoanProductInput;
};


export type MutationAdminCreateLoanProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateMortgageProductArgs = {
  clientId: Scalars['ID'];
  product: MortgageProductInput;
};


export type MutationAdminCreateMortgageProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateMotorLiabilityInsuranceProductArgs = {
  clientId: Scalars['ID'];
  product: MotorLiabilityInsuranceProductInput;
};


export type MutationAdminCreateMotorLiabilityInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreatePropertyInsuranceProductArgs = {
  clientId: Scalars['ID'];
  product: PropertyInsuranceProductInput;
};


export type MutationAdminCreatePropertyInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateReportArgs = {
  report: ReportInput;
};


export type MutationAdminCreateRetirementPensionSavingsProductArgs = {
  clientId: Scalars['ID'];
  product: RetirementPensionSavingsProductInput;
};


export type MutationAdminCreateRetirementPensionSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateSavingsProductArgs = {
  clientId: Scalars['ID'];
  product: SavingsProductInput;
};


export type MutationAdminCreateSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateSupplementaryPensionSavingsProductArgs = {
  clientId: Scalars['ID'];
  product: SupplementaryPensionSavingsProductInput;
};


export type MutationAdminCreateSupplementaryPensionSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationAdminCreateUserArgs = {
  user: UserInput;
};


export type MutationAdminCreateUserInvitationArgs = {
  userInvitation: UserInvitationInput;
};


export type MutationAdminCreateUserRelationArgs = {
  userRelation: UserRelationInput;
};


export type MutationAdminDeactivateFinancialAdvisorTaskArgs = {
  taskId: Scalars['ID'];
};


export type MutationAdminDeleteBuildingSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteBuildingSavingsProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteCashFlowAdjustmentArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteCashFlowAdjustmentsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteClientNoteArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteClientNotesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteCollisionInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteCollisionInsuranceProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteCreditCardProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteCreditCardProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteFinancialReserveArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteFinancialReservesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteGenericInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteGenericInsuranceProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteGenericProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteGenericProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteInvestmentProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteInvestmentProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteLifeInsuranceAuditProcessArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteLifeInsuranceAuditProcessesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteLifeInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteLifeInsuranceProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteLifeInsurancePurchaseProcessArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteLifeInsurancePurchaseProcessesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteLoanProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteLoanProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteMortgageProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteMortgageProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteMortgagePurchaseProcessArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteMortgagePurchaseProcessesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteMortgageRefinanceProcessArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteMortgageRefinanceProcessesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteMotorLiabilityInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteMotorLiabilityInsuranceProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeletePropertyInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeletePropertyInsuranceProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteReportArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteReportsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteRetirementPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteRetirementPensionSavingsProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteSavingsProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteSupplementaryPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteSupplementaryPensionSavingsProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteUserInvitationArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteUserInvitationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteUserRelationArgs = {
  id: Scalars['ID'];
};


export type MutationAdminDeleteUserRelationsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminDeleteUsersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAdminMarkFinancialAdvisorTaskAsDoneArgs = {
  taskId: Scalars['ID'];
};


export type MutationAdminMarkFinancialAdvisorTaskAsUndoneArgs = {
  taskId: Scalars['ID'];
};


export type MutationAdminUpdateBuildingSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: BuildingSavingsProductInput;
};


export type MutationAdminUpdateCashFlowAdjustmentArgs = {
  id: Scalars['ID'];
  updatedCashFlowAdjustment: CashFlowAdjustmentInput;
};


export type MutationAdminUpdateClientArgs = {
  id: Scalars['ID'];
  updatedClient: ClientInput;
};


export type MutationAdminUpdateClientNoteArgs = {
  id: Scalars['ID'];
  updatedClientNote: ClientNoteInput;
};


export type MutationAdminUpdateCollisionInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: CollisionInsuranceProductInput;
};


export type MutationAdminUpdateCreditCardProductArgs = {
  id: Scalars['ID'];
  updatedProduct: CreditCardProductInput;
};


export type MutationAdminUpdateFinancialReserveArgs = {
  id: Scalars['ID'];
  updatedFinancialReserve: FinancialReserveInput;
};


export type MutationAdminUpdateGenericInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: GenericInsuranceProductInput;
};


export type MutationAdminUpdateGenericProductArgs = {
  id: Scalars['ID'];
  updatedProduct: GenericProductInput;
};


export type MutationAdminUpdateInvestmentProductArgs = {
  id: Scalars['ID'];
  updatedProduct: InvestmentProductInput;
};


export type MutationAdminUpdateLifeInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: LifeInsuranceProductInput;
};


export type MutationAdminUpdateLoanProductArgs = {
  id: Scalars['ID'];
  updatedProduct: LoanProductInput;
};


export type MutationAdminUpdateMortgageProductArgs = {
  id: Scalars['ID'];
  updatedProduct: MortgageProductInput;
};


export type MutationAdminUpdateMotorLiabilityInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: MotorLiabilityInsuranceProductInput;
};


export type MutationAdminUpdatePropertyInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: PropertyInsuranceProductInput;
};


export type MutationAdminUpdateReportArgs = {
  id: Scalars['ID'];
  updatedReport: ReportInput;
};


export type MutationAdminUpdateRetirementPensionSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: RetirementPensionSavingsProductInput;
};


export type MutationAdminUpdateSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: SavingsProductInput;
};


export type MutationAdminUpdateStaffArgs = {
  id: Scalars['ID'];
  updatedStaff: StaffInput;
};


export type MutationAdminUpdateSupplementaryPensionSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: SupplementaryPensionSavingsProductInput;
};


export type MutationAdminUpdateUserArgs = {
  id: Scalars['ID'];
  updatedUser: UserInput;
};


export type MutationAdminUpdateUserInvitationArgs = {
  id: Scalars['ID'];
  updatedUserInvitation: UserInvitationInput;
};


export type MutationAdminUpdateUserRelationArgs = {
  id: Scalars['ID'];
  updatedUserRelation: UserRelationInput;
};


export type MutationCalculateAndSaveLifeInsuranceResultByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type MutationCalculateAndSaveMortgagePurchaseResultByProcessIdArgs = {
  processId: Scalars['ID'];
  tuning: MortgagePurchaseTuningInput;
};


export type MutationCalculateAndSaveMortgageRefinanceResultByProcessIdArgs = {
  processId: Scalars['ID'];
  tuning: MortgageRefinanceTuningInput;
};


export type MutationCreateBuildingSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateCalendarEventArgs = {
  event: CalendarEventInput;
};


export type MutationCreateCashFlowAdjustmentArgs = {
  cashFlowAdjustment: CashFlowAdjustmentInput;
};


export type MutationCreateCollisionInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateCreditCardProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateFinancialReserveArgs = {
  financialReserve: FinancialReserveInput;
};


export type MutationCreateGenericInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateGenericProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateInvestmentProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateLifeInsuranceDocumentArgs = {
  document: DocumentInput;
  processId: Scalars['ID'];
};


export type MutationCreateLifeInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateLoanProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateMortgageProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateMotorLiabilityInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateOrUpdateClientProfileArgs = {
  clientProfile: ClientProfileInput;
};


export type MutationCreateOrUpdateLeadArgs = {
  context: LeadContext;
  userInfo: UserInfo;
};


export type MutationCreateProcessWidgetArgs = {
  insertBeforeId?: InputMaybe<Scalars['ID']>;
  widgetType: WidgetType;
};


export type MutationCreatePropertyInsuranceProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateReportArgs = {
  reportType: ReportType;
};


export type MutationCreateRetirementPensionSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateSupplementaryPensionSavingsProductDocumentArgs = {
  document: DocumentInput;
  productId: Scalars['ID'];
};


export type MutationCreateTransactionTagArgs = {
  tag: TransactionTagInput;
};


export type MutationCreateUnregisteredUserArgs = {
  input: UserInput;
};


export type MutationDeactivateNotificationArgs = {
  notificationId: Scalars['ID'];
};


export type MutationDeleteBuildingSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCalendarEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCashFlowAdjustmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCollisionInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCreditCardProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteFinancialReserveArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGenericInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGenericProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInvestmentProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLifeInsuranceAuditProcessArgs = {
  processId: Scalars['ID'];
};


export type MutationDeleteLifeInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLifeInsurancePurchaseProcessArgs = {
  processId: Scalars['ID'];
};


export type MutationDeleteLoanProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMortgageProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMortgagePurchaseProcessArgs = {
  processId: Scalars['ID'];
};


export type MutationDeleteMortgageRefinanceProcessArgs = {
  processId: Scalars['ID'];
};


export type MutationDeleteMotorLiabilityInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProcessWidgetArgs = {
  widgetId: Scalars['ID'];
};


export type MutationDeletePropertyInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRetirementPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSupplementaryPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTransactionTagArgs = {
  tagId: Scalars['ID'];
};


export type MutationGenerateFileDownloadUrlArgs = {
  contentDisposition?: InputMaybe<Scalars['String']>;
  fileId: Scalars['ID'];
};


export type MutationInitNordigenFlowArgs = {
  institutionId: Scalars['ID'];
  redirectUrl: Scalars['Url'];
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['ID'];
};


export type MutationMoveProcessWidgetArgs = {
  insertBeforeId: Scalars['ID'];
  widgetId: Scalars['ID'];
};


export type MutationPreregisterUserArgs = {
  data: Scalars['String'];
  signature: Scalars['String'];
};


export type MutationRemoveAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationRemovePeriodFromTransactionGroupArgs = {
  groupId: Scalars['ID'];
};


export type MutationRemoveTagsFromTransactionGroupArgs = {
  groupId: Scalars['ID'];
  tagIds: Array<Scalars['ID']>;
};


export type MutationRemoveTagsFromTransactionsArgs = {
  tagIds: Array<Scalars['ID']>;
  transactionIds: Array<Scalars['ID']>;
};


export type MutationRenameAccountArgs = {
  accountId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationRenameTransactionCounterpartyArgs = {
  counterpartyId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationRenameTransactionTagArgs = {
  name: Scalars['String'];
  tagId: Scalars['ID'];
};


export type MutationRequestContactArgs = {
  context: RequestContactContext;
  text: Scalars['String'];
  userInfo: UserInfo;
};


export type MutationRequestContactFromAuthenticatedUserArgs = {
  context: RequestContactContext;
  text: Scalars['String'];
};


export type MutationSaveUtmParametersArgs = {
  utmParameters: UtmParametersInput;
};


export type MutationSendLifeInsuranceAuditNotificationEmailToSpecialistArgs = {
  processId: Scalars['ID'];
};


export type MutationSendLifeInsurancePurchaseNotificationEmailToSpecialistArgs = {
  processId: Scalars['ID'];
};


export type MutationSendMortgagePurchaseNotificationEmailToSpecialistArgs = {
  processId: Scalars['ID'];
};


export type MutationSendMortgageRefinanceNotificationEmailToSpecialistArgs = {
  processId: Scalars['ID'];
};


export type MutationSetBudgetArgs = {
  amountInBaseCurrency: Scalars['BigDecimal'];
  sinceDate?: InputMaybe<Scalars['Date']>;
};


export type MutationSynchronizeAccountsArgs = {
  requisitionId: Scalars['UUID'];
};


export type MutationUpdateBuildingSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: BuildingSavingsProductInput;
};


export type MutationUpdateCalendarEventArgs = {
  id: Scalars['ID'];
  updatedEvent: CalendarEventInput;
};


export type MutationUpdateCashFlowAdjustmentArgs = {
  id: Scalars['ID'];
  updatedCashFlowAdjustment: CashFlowAdjustmentInput;
};


export type MutationUpdateCollisionInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: CollisionInsuranceProductInput;
};


export type MutationUpdateCreditCardProductArgs = {
  id: Scalars['ID'];
  updatedProduct: CreditCardProductInput;
};


export type MutationUpdateFinancialReserveArgs = {
  id: Scalars['ID'];
  updatedFinancialReserve: FinancialReserveInput;
};


export type MutationUpdateGenericInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: GenericInsuranceProductInput;
};


export type MutationUpdateGenericProductArgs = {
  id: Scalars['ID'];
  updatedProduct: GenericProductInput;
};


export type MutationUpdateInvestmentProductArgs = {
  id: Scalars['ID'];
  updatedProduct: InvestmentProductInput;
};


export type MutationUpdateLifeInsuranceAuditProcessArgs = {
  inquiry: LifeInsuranceInquiryInput;
  processId: Scalars['ID'];
};


export type MutationUpdateLifeInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: LifeInsuranceProductInput;
};


export type MutationUpdateLifeInsurancePurchaseProcessArgs = {
  inquiry: LifeInsuranceInquiryInput;
  processId: Scalars['ID'];
};


export type MutationUpdateLoanProductArgs = {
  id: Scalars['ID'];
  updatedProduct: LoanProductInput;
};


export type MutationUpdateMortgageProductArgs = {
  id: Scalars['ID'];
  updatedProduct: MortgageProductInput;
};


export type MutationUpdateMortgagePurchaseProcessArgs = {
  inquiry: MortgagePurchaseInquiryInput;
  processId: Scalars['ID'];
};


export type MutationUpdateMortgageRefinanceProcessArgs = {
  inquiry: MortgageRefinanceInquiryInput;
  processId: Scalars['ID'];
};


export type MutationUpdateMotorLiabilityInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: MotorLiabilityInsuranceProductInput;
};


export type MutationUpdatePeriodOfTransactionGroupArgs = {
  groupId: Scalars['ID'];
  period: TransactionGroupPeriodInput;
};


export type MutationUpdatePeriodOfTransactionGroupNewArgs = {
  groupId: Scalars['ID'];
  period: TransactionPeriodInput;
};


export type MutationUpdateProductTypeArgs = {
  id: Scalars['ID'];
  newProductType: FinancialProductType;
  productType: FinancialProductType;
};


export type MutationUpdatePropertyInsuranceProductArgs = {
  id: Scalars['ID'];
  updatedProduct: PropertyInsuranceProductInput;
};


export type MutationUpdateRetirementPensionSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: RetirementPensionSavingsProductInput;
};


export type MutationUpdateSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: SavingsProductInput;
};


export type MutationUpdateSupplementaryPensionSavingsProductArgs = {
  id: Scalars['ID'];
  updatedProduct: SupplementaryPensionSavingsProductInput;
};


export type MutationUpdateTransactionGroupArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateTransactionsArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  transactionIds: Array<Scalars['ID']>;
};


export type MutationUpdateUserAvatarArgs = {
  fileId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateUserEmailArgs = {
  email: Scalars['String'];
};


export type MutationUpdateUserPersonalInformationArgs = {
  input: UserInput;
};


export type MutationVerifyChangeEmailArgs = {
  confirmationCode: Scalars['String'];
};


export type MutationVerifyRegistrationEmailArgs = {
  clientId: Scalars['String'];
  confirmationCode: Scalars['String'];
  userName: Scalars['String'];
};

export type NewProposedFixation = {
  __typename?: 'NewProposedFixation';
  newInstallment?: Maybe<Money>;
  newInterestRate?: Maybe<Scalars['BigDecimal']>;
};

export type NewProposedFixationInput = {
  newInstallment?: InputMaybe<MoneyInput>;
  newInterestRate?: InputMaybe<Scalars['BigDecimal']>;
};

export type NordigenConnection = {
  __typename?: 'NordigenConnection';
  accounts: Array<Account>;
  institution: Institution;
};

export type NordigenConsentExpirationNotificationDetails = {
  __typename?: 'NordigenConsentExpirationNotificationDetails';
  nordigenConnection: NordigenConnection;
};

export type Notification = IdBase & {
  __typename?: 'Notification';
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  details?: Maybe<NotificationDetails>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  readDate?: Maybe<Scalars['DateTime']>;
  stage?: Maybe<Scalars['Int']>;
  type: NotificationType;
};

export type NotificationDetails = CalendarEventNotificationDetails | NordigenConsentExpirationNotificationDetails | ProductNotificationDetails;

export type NotificationPage = {
  __typename?: 'NotificationPage';
  items: Array<Notification>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum NotificationType {
  ActiveProductWithoutDocument = 'ACTIVE_PRODUCT_WITHOUT_DOCUMENT',
  CalendarEvent = 'CALENDAR_EVENT',
  CollisionInsuranceProductExpiration = 'COLLISION_INSURANCE_PRODUCT_EXPIRATION',
  CollisionInsuranceProductPayment = 'COLLISION_INSURANCE_PRODUCT_PAYMENT',
  GenericProductExpiration = 'GENERIC_PRODUCT_EXPIRATION',
  LifeInsuranceAnnualUpdate = 'LIFE_INSURANCE_ANNUAL_UPDATE',
  MortgageProductFixationEnd = 'MORTGAGE_PRODUCT_FIXATION_END',
  MotorLiabilityInsuranceProductExpiration = 'MOTOR_LIABILITY_INSURANCE_PRODUCT_EXPIRATION',
  MotorLiabilityInsuranceProductPayment = 'MOTOR_LIABILITY_INSURANCE_PRODUCT_PAYMENT',
  NordigenConsentExpiration = 'NORDIGEN_CONSENT_EXPIRATION',
  ProductWaitingForSubmission = 'PRODUCT_WAITING_FOR_SUBMISSION',
  PropertyInsuranceProductExpiration = 'PROPERTY_INSURANCE_PRODUCT_EXPIRATION',
  PropertyInsuranceProductPayment = 'PROPERTY_INSURANCE_PRODUCT_PAYMENT'
}

export type PageInput = {
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PairMoney = {
  __typename?: 'PairMoney';
  first?: Maybe<Money>;
  second?: Maybe<Money>;
};

export type PairMoneyInput = {
  first?: InputMaybe<MoneyInput>;
  second?: InputMaybe<MoneyInput>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  constantSymbol?: Maybe<Scalars['String']>;
  ibanForPayment?: Maybe<Scalars['String']>;
  specificSymbol?: Maybe<Scalars['String']>;
  variableSymbol?: Maybe<Scalars['String']>;
};

export type PaymentInfoInput = {
  constantSymbol?: InputMaybe<Scalars['String']>;
  ibanForPayment?: InputMaybe<Scalars['String']>;
  specificSymbol?: InputMaybe<Scalars['String']>;
  variableSymbol?: InputMaybe<Scalars['String']>;
};

export type PerformanceFilterInput = {
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  role?: InputMaybe<Role>;
  startDate?: InputMaybe<Scalars['Date']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type Process = MortgagePurchaseProcess | MortgageRefinanceProcess;

export type ProcessWidget = IdBase & {
  __typename?: 'ProcessWidget';
  id: Scalars['ID'];
  process: Process;
  type: WidgetType;
};

export type ProductBase = {
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type ProductFinancialAdvisorTaskDetails = {
  __typename?: 'ProductFinancialAdvisorTaskDetails';
  productId: Scalars['ID'];
  productType: FinancialProductType;
};

export type ProductNotificationDetails = {
  __typename?: 'ProductNotificationDetails';
  productId: Scalars['ID'];
  productType: FinancialProductType;
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  InPreparation = 'IN_PREPARATION',
  Processing = 'PROCESSING',
  Submitted = 'SUBMITTED',
  WaitingForReview = 'WAITING_FOR_REVIEW',
  WaitingForSubmission = 'WAITING_FOR_SUBMISSION'
}

export type PropertyInsuranceInsurance = {
  __typename?: 'PropertyInsuranceInsurance';
  annualCost?: Maybe<Money>;
  id: Scalars['ID'];
  insuranceRisks: Array<PropertyInsuranceInsuranceRisk>;
  insuredSum?: Maybe<Money>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyInsuranceInsuranceType>;
};

export type PropertyInsuranceInsuranceInput = {
  annualCost?: InputMaybe<MoneyInput>;
  insuranceRisks: Array<PropertyInsuranceInsuranceRiskInput>;
  insuredSum?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PropertyInsuranceInsuranceType>;
};

export type PropertyInsuranceInsuranceRisk = {
  __typename?: 'PropertyInsuranceInsuranceRisk';
  annualCost?: Maybe<Money>;
  id: Scalars['ID'];
  insuredSum?: Maybe<Money>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PropertyInsuranceInsuranceRiskType>;
};

export type PropertyInsuranceInsuranceRiskInput = {
  annualCost?: InputMaybe<MoneyInput>;
  insuredSum?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PropertyInsuranceInsuranceRiskType>;
};

export enum PropertyInsuranceInsuranceRiskType {
  Explosion = 'EXPLOSION',
  Indexation = 'INDEXATION',
  Liability = 'LIABILITY',
  NaturalDisaster = 'NATURAL_DISASTER',
  Other = 'OTHER',
  SmokeDamage = 'SMOKE_DAMAGE',
  Theft = 'THEFT',
  Vandalism = 'VANDALISM',
  WaterDamage = 'WATER_DAMAGE'
}

export enum PropertyInsuranceInsuranceType {
  Household = 'HOUSEHOLD',
  Other = 'OTHER',
  Property = 'PROPERTY'
}

export type PropertyInsuranceInsuredProperty = {
  __typename?: 'PropertyInsuranceInsuredProperty';
  address?: Maybe<Scalars['String']>;
  householdValue?: Maybe<Money>;
  propertyValue?: Maybe<Money>;
  type?: Maybe<PropertyInsuranceInsuredPropertyType>;
};

export type PropertyInsuranceInsuredPropertyInput = {
  address?: InputMaybe<Scalars['String']>;
  householdValue?: InputMaybe<MoneyInput>;
  propertyValue?: InputMaybe<MoneyInput>;
  type?: InputMaybe<PropertyInsuranceInsuredPropertyType>;
};

export enum PropertyInsuranceInsuredPropertyType {
  Apartment = 'APARTMENT',
  House = 'HOUSE',
  RecreationalFacility = 'RECREATIONAL_FACILITY'
}

export type PropertyInsuranceProduct = ProductBase & {
  __typename?: 'PropertyInsuranceProduct';
  basicInsurances: Array<PropertyInsuranceInsurance>;
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  insuredProperty?: Maybe<PropertyInsuranceInsuredProperty>;
  insuringPerson?: Maybe<InsuringPerson>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  otherInsurances: Array<PropertyInsuranceInsurance>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type PropertyInsuranceProductInput = {
  basicInsurances?: InputMaybe<Array<PropertyInsuranceInsuranceInput>>;
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  insuredProperty?: InputMaybe<PropertyInsuranceInsuredPropertyInput>;
  insuringPerson?: InputMaybe<InsuringPersonInput>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  otherInsurances?: InputMaybe<Array<PropertyInsuranceInsuranceInput>>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type PropertyInsuranceProductPage = {
  __typename?: 'PropertyInsuranceProductPage';
  items: Array<PropertyInsuranceProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  adminGetAccount: Account;
  adminGetAccountsPage: AccountPage;
  adminGetBuildingSavingsProduct: BuildingSavingsProduct;
  adminGetBuildingSavingsProductsPage: BuildingSavingsProductPage;
  adminGetCashFlowAdjustment: CashFlowAdjustment;
  adminGetCashFlowAdjustmentsPage: CashFlowAdjustmentPage;
  adminGetClient: Client;
  adminGetClientNote: ClientNote;
  adminGetClientNotesPage: ClientNotePage;
  adminGetClientsPage: ClientPage;
  adminGetCollisionInsuranceProduct: CollisionInsuranceProduct;
  adminGetCollisionInsuranceProductsPage: CollisionInsuranceProductPage;
  adminGetCreditCardProduct: CreditCardProduct;
  adminGetCreditCardProductsPage: CreditCardProductPage;
  adminGetFinancialAdvisorTask: FinancialAdvisorTask;
  adminGetFinancialAdvisorTasksPage: FinancialAdvisorTaskPage;
  adminGetFinancialReserve: FinancialReserve;
  adminGetFinancialReservesPage: FinancialReservePage;
  adminGetGenericInsuranceProduct: GenericInsuranceProduct;
  adminGetGenericInsuranceProductsPage: GenericInsuranceProductPage;
  adminGetGenericProduct: GenericProduct;
  adminGetGenericProductsPage: GenericProductPage;
  adminGetInvestmentProduct: InvestmentProduct;
  adminGetInvestmentProductsPage: InvestmentProductPage;
  adminGetLifeInsuranceAuditProcess: LifeInsuranceAuditProcess;
  adminGetLifeInsuranceAuditProcessesPage: LifeInsuranceAuditProcessPage;
  adminGetLifeInsuranceCalculatorCalculation: LifeInsuranceCalculatorCalculation;
  adminGetLifeInsuranceCalculatorCalculationsPage: LifeInsuranceCalculatorCalculationsPage;
  adminGetLifeInsuranceProduct: LifeInsuranceProduct;
  adminGetLifeInsuranceProductsPage: LifeInsuranceProductPage;
  adminGetLifeInsurancePurchaseProcess: LifeInsurancePurchaseProcess;
  adminGetLifeInsurancePurchaseProcessesPage: LifeInsurancePurchaseProcessPage;
  adminGetLoanProduct: LoanProduct;
  adminGetLoanProductsPage: LoanProductPage;
  adminGetMortgageCalculatorCalculation: MortgageCalculatorCalculation;
  adminGetMortgageCalculatorCalculationsPage: MortgageCalculatorCalculationsPage;
  adminGetMortgageProduct: MortgageProduct;
  adminGetMortgageProductsPage: MortgageProductPage;
  adminGetMortgagePurchaseProcess: MortgagePurchaseProcess;
  adminGetMortgagePurchaseProcessesPage: MortgagePurchaseProcessPage;
  adminGetMortgageRefinanceProcess: MortgageRefinanceProcess;
  adminGetMortgageRefinanceProcessesPage: MortgageRefinanceProcessPage;
  adminGetMotorLiabilityInsuranceProduct: MotorLiabilityInsuranceProduct;
  adminGetMotorLiabilityInsuranceProductsPage: MotorLiabilityInsuranceProductPage;
  adminGetPermanentFileLink: Scalars['String'];
  adminGetPropertyInsuranceProduct: PropertyInsuranceProduct;
  adminGetPropertyInsuranceProductsPage: PropertyInsuranceProductPage;
  adminGetReport: Report;
  adminGetReportsPage: ReportPage;
  adminGetRetirementPensionSavingsProduct: RetirementPensionSavingsProduct;
  adminGetRetirementPensionSavingsProductsPage: RetirementPensionSavingsProductPage;
  adminGetSalvePerformanceDataPage?: Maybe<SalvePerformanceDataPage>;
  adminGetSavingsProduct: SavingsProduct;
  adminGetSavingsProductsPage: SavingsProductPage;
  adminGetStaff: Staff;
  adminGetStaffsPage: StaffPage;
  adminGetSupplementaryPensionSavingsProduct: SupplementaryPensionSavingsProduct;
  adminGetSupplementaryPensionSavingsProductsPage: SupplementaryPensionSavingsProductPage;
  adminGetUser: User;
  adminGetUserInvitation: UserInvitation;
  adminGetUserInvitationsPage: UserInvitationPage;
  adminGetUserRelation: UserRelation;
  adminGetUserRelationsPage: UserRelationPage;
  adminGetUsersPage: UserPage;
  aggregateBalances: BalanceResult;
  aggregateTransactions: TransactionAggregationResult;
  aggregateUpcomingPayments: UpcomingPaymentAggregationResult;
  calculateLifeInsuranceResultByInquiry: LifeInsuranceResult;
  calculateMortgagePurchaseResultByInquiry: MortgagePurchaseResult;
  calculateMortgagePurchaseResultConstraintsByInquiry: MortgagePurchaseResultConstraints;
  calculateMortgagePurchaseResultConstraintsByProcessId: MortgagePurchaseResultConstraints;
  calculateMortgagePurchaseTuningLimitsByInquiry: MortgagePurchaseTuningLimits;
  calculateMortgagePurchaseTuningLimitsByProcessId: MortgagePurchaseTuningLimits;
  calculateMortgageRefinanceResultByInquiry: MortgageRefinanceResult;
  calculateMortgageRefinanceTuningLimitsByInquiry: MortgageRefinanceTuningLimits;
  calculateMortgageRefinanceTuningLimitsByProcessId: MortgageRefinanceTuningLimits;
  convert?: Maybe<Money>;
  getAccount: Account;
  /** @deprecated replaced by getAccountsPage */
  getAccounts: Array<Account>;
  getAccountsPage: AccountPage;
  /** @deprecated replaced by get~Page */
  getAllLifeInsuranceAuditProcesses?: Maybe<Array<LifeInsuranceAuditProcess>>;
  /** @deprecated replaced by get~Page */
  getAllLifeInsurancePurchaseProcesses?: Maybe<Array<LifeInsurancePurchaseProcess>>;
  /** @deprecated Replaced by getInstitutionsPage */
  getAllMortgageProviderInstitutions?: Maybe<Array<Institution>>;
  /** @deprecated replaced by get~Page */
  getAllMortgagePurchaseProcesses: Array<MortgagePurchaseProcess>;
  /** @deprecated replaced by get~Page */
  getAllMortgageRefinanceProcesses: Array<MortgageRefinanceProcess>;
  getAllProcessWidgets: Array<ProcessWidget>;
  getAvailableWidgetTypes: Array<WidgetType>;
  getAverageLifeInsuranceScore: Scalars['BigDecimal'];
  getBudget?: Maybe<Scalars['BigDecimal']>;
  getBuildingSavingsProduct: BuildingSavingsProduct;
  getBuildingSavingsProductsPage: BuildingSavingsProductPage;
  getCalendarEvent: CalendarEvent;
  getCalendarEventInstances?: Maybe<Array<CalendarEventInstance>>;
  getCalendarEvents?: Maybe<Array<CalendarEvent>>;
  getCashFlowAdjustment: CashFlowAdjustment;
  getCashFlowAdjustmentsPage: CashFlowAdjustmentPage;
  getClientProfile?: Maybe<ClientProfile>;
  getCollisionInsuranceProduct: CollisionInsuranceProduct;
  getCollisionInsuranceProductsPage: CollisionInsuranceProductPage;
  getContactUserRelation?: Maybe<UserRelation>;
  getCreditCardProduct: CreditCardProduct;
  getCreditCardProductsPage: CreditCardProductPage;
  getCurrentUser?: Maybe<User>;
  getFinancialReserve: FinancialReserve;
  getFinancialReservesPage: FinancialReservePage;
  getGenericInsuranceProduct: GenericInsuranceProduct;
  getGenericInsuranceProductsPage: GenericInsuranceProductPage;
  getGenericProduct: GenericProduct;
  getGenericProductsPage: GenericProductPage;
  /** @deprecated Replaced by getInstitutionsPage */
  getInstitutions?: Maybe<Array<Institution>>;
  getInstitutionsPage: InstitutionPage;
  getInvestmentProduct: InvestmentProduct;
  getInvestmentProductsPage: InvestmentProductPage;
  getJobStatus: JobStatus;
  getLastAccountsDataRefresh?: Maybe<Scalars['DateTime']>;
  getLifeInsuranceAuditProcessById: LifeInsuranceAuditProcess;
  getLifeInsuranceAuditProcessesPage: LifeInsuranceAuditProcessPage;
  getLifeInsuranceCalculatorCalculationsPage: LifeInsuranceCalculatorCalculationsPage;
  getLifeInsuranceCalculatorResult: LifeInsuranceCalculatorResult;
  getLifeInsuranceProduct: LifeInsuranceProduct;
  getLifeInsuranceProductsPage: LifeInsuranceProductPage;
  getLifeInsurancePurchaseProcessById: LifeInsurancePurchaseProcess;
  getLifeInsurancePurchaseProcessesPage: LifeInsurancePurchaseProcessPage;
  getLifeInsuranceResultByProcessId: LifeInsuranceResult;
  getLoanProduct: LoanProduct;
  getLoanProductsPage: LoanProductPage;
  getMortgageCalculatorCalculationsPage: MortgageCalculatorCalculationsPage;
  getMortgageCalculatorResult: MortgageCalculatorResult;
  getMortgageProduct: MortgageProduct;
  getMortgageProductsPage: MortgageProductPage;
  getMortgagePurchaseProcessById: MortgagePurchaseProcess;
  getMortgagePurchaseProcessesPage: MortgagePurchaseProcessPage;
  getMortgagePurchaseResultByProcessId: MortgagePurchaseResult;
  getMortgageRefinanceProcessById: MortgageRefinanceProcess;
  getMortgageRefinanceProcessesPage: MortgageRefinanceProcessPage;
  getMortgageRefinanceResultByProcessId: MortgageRefinanceResult;
  getMotorLiabilityInsuranceProduct: MotorLiabilityInsuranceProduct;
  getMotorLiabilityInsuranceProductsPage: MotorLiabilityInsuranceProductPage;
  getNotificationsPage?: Maybe<NotificationPage>;
  getPermanentFileLink: Scalars['String'];
  getPropertyInsuranceProduct: PropertyInsuranceProduct;
  getPropertyInsuranceProductsPage: PropertyInsuranceProductPage;
  getReport: Report;
  getReportsPage: ReportPage;
  getRetirementPensionSavingsProduct: RetirementPensionSavingsProduct;
  getRetirementPensionSavingsProductsPage: RetirementPensionSavingsProductPage;
  getSavingsProduct: SavingsProduct;
  getSavingsProductsPage: SavingsProductPage;
  getServiceLocationsPage: ServiceLocationPage;
  getSupplementaryPensionSavingsProduct: SupplementaryPensionSavingsProduct;
  getSupplementaryPensionSavingsProductsPage: SupplementaryPensionSavingsProductPage;
  getTransaction?: Maybe<Transaction>;
  getTransactionCategoriesPage: TransactionsCategoryPage;
  getTransactionCategoryGroupsPage: TransactionsCategoryGroupPage;
  getTransactionCounterpartiesPage?: Maybe<TransactionCounterpartyPage>;
  getTransactionTagsPage: TransactionTagPage;
  getTransactionsPage: TransactionsPage;
  getUpcomingPaymentsPage?: Maybe<UpcomingPaymentsPage>;
};


export type QueryAdminGetAccountArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetAccountsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetBuildingSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetBuildingSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetCashFlowAdjustmentArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetCashFlowAdjustmentsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetClientArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetClientNoteArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetClientNotesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetClientsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetCollisionInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetCollisionInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetCreditCardProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetCreditCardProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetFinancialAdvisorTaskArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetFinancialAdvisorTasksPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetFinancialReserveArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetFinancialReservesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetGenericInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetGenericInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetGenericProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetGenericProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetInvestmentProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetInvestmentProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetLifeInsuranceAuditProcessArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetLifeInsuranceAuditProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetLifeInsuranceCalculatorCalculationArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetLifeInsuranceCalculatorCalculationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetLifeInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetLifeInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetLifeInsurancePurchaseProcessArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetLifeInsurancePurchaseProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetLoanProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetLoanProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetMortgageCalculatorCalculationArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetMortgageCalculatorCalculationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetMortgageProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetMortgageProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetMortgagePurchaseProcessArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetMortgagePurchaseProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetMortgageRefinanceProcessArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetMortgageRefinanceProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetMotorLiabilityInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetMotorLiabilityInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetPermanentFileLinkArgs = {
  fileId: Scalars['ID'];
};


export type QueryAdminGetPropertyInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetPropertyInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetReportArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetReportsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetRetirementPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetRetirementPensionSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetSalvePerformanceDataPageArgs = {
  filterInput?: InputMaybe<PerformanceFilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetStaffArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetStaffsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetSupplementaryPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetSupplementaryPensionSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetUserArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetUserInvitationArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetUserInvitationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetUserRelationArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGetUserRelationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAdminGetUsersPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryAggregateBalancesArgs = {
  filterInput?: InputMaybe<AggregateBalanceFilter>;
  groupBy?: Array<BalanceAttribute>;
};


export type QueryAggregateTransactionsArgs = {
  filterInput?: InputMaybe<FilterInput>;
  groupBy?: Array<TransactionAttribute>;
};


export type QueryAggregateUpcomingPaymentsArgs = {
  filterInput: UpcomingPaymentFilter;
  groupBy?: Array<UpcomingPaymentAttribute>;
};


export type QueryCalculateLifeInsuranceResultByInquiryArgs = {
  inquiry: LifeInsuranceInquiryInput;
};


export type QueryCalculateMortgagePurchaseResultByInquiryArgs = {
  inquiry: MortgagePurchaseInquiryInput;
};


export type QueryCalculateMortgagePurchaseResultConstraintsByInquiryArgs = {
  inquiry: MortgagePurchaseInquiryInput;
};


export type QueryCalculateMortgagePurchaseResultConstraintsByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type QueryCalculateMortgagePurchaseTuningLimitsByInquiryArgs = {
  inquiry: MortgagePurchaseInquiryInput;
};


export type QueryCalculateMortgagePurchaseTuningLimitsByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type QueryCalculateMortgageRefinanceResultByInquiryArgs = {
  inquiry: MortgageRefinanceInquiryInput;
};


export type QueryCalculateMortgageRefinanceTuningLimitsByInquiryArgs = {
  inquiry: MortgageRefinanceInquiryInput;
};


export type QueryCalculateMortgageRefinanceTuningLimitsByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type QueryConvertArgs = {
  forDate: Scalars['Date'];
  fromMoney: MoneyInput;
  toCurrency: Scalars['String'];
};


export type QueryGetAccountArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetAccountsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetBudgetArgs = {
  asOfDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetBuildingSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetBuildingSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetCalendarEventArgs = {
  id: Scalars['ID'];
};


export type QueryGetCalendarEventInstancesArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetCashFlowAdjustmentArgs = {
  id: Scalars['ID'];
};


export type QueryGetCashFlowAdjustmentsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetCollisionInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetCollisionInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetCreditCardProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetCreditCardProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetFinancialReserveArgs = {
  id: Scalars['ID'];
};


export type QueryGetFinancialReservesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetGenericInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetGenericInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetGenericProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetGenericProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetInstitutionsArgs = {
  synchronizationMethod: AccountInformationSynchronizationMethod;
};


export type QueryGetInstitutionsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetInvestmentProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetInvestmentProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetJobStatusArgs = {
  jobId: Scalars['String'];
};


export type QueryGetLifeInsuranceAuditProcessByIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetLifeInsuranceAuditProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetLifeInsuranceCalculatorCalculationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetLifeInsuranceCalculatorResultArgs = {
  inquiry: LifeInsuranceCalculatorInquiryInput;
};


export type QueryGetLifeInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetLifeInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetLifeInsurancePurchaseProcessByIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetLifeInsurancePurchaseProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetLifeInsuranceResultByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetLoanProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetLoanProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetMortgageCalculatorCalculationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetMortgageCalculatorResultArgs = {
  inquiry: MortgageCalculatorInquiryInput;
};


export type QueryGetMortgageProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetMortgageProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetMortgagePurchaseProcessByIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetMortgagePurchaseProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetMortgagePurchaseResultByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetMortgageRefinanceProcessByIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetMortgageRefinanceProcessesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetMortgageRefinanceResultByProcessIdArgs = {
  processId: Scalars['ID'];
};


export type QueryGetMotorLiabilityInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetMotorLiabilityInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetNotificationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetPermanentFileLinkArgs = {
  fileId: Scalars['ID'];
};


export type QueryGetPropertyInsuranceProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetPropertyInsuranceProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetReportArgs = {
  id: Scalars['ID'];
};


export type QueryGetReportsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetRetirementPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetRetirementPensionSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetServiceLocationsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetSupplementaryPensionSavingsProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetSupplementaryPensionSavingsProductsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetTransactionArgs = {
  transactionId: Scalars['ID'];
};


export type QueryGetTransactionCategoriesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetTransactionCategoryGroupsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetTransactionCounterpartiesPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetTransactionTagsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetTransactionsPageArgs = {
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
};


export type QueryGetUpcomingPaymentsPageArgs = {
  filterInput: UpcomingPaymentFilter;
  pageInput?: InputMaybe<PageInput>;
};

export type Report = IdBase & {
  __typename?: 'Report';
  client: Client;
  creationTimestamp: Scalars['DateTime'];
  file: File;
  id: Scalars['ID'];
  published: Scalars['Boolean'];
  type: ReportType;
  updateTimestamp: Scalars['DateTime'];
};

export type ReportInput = {
  clientId: Scalars['ID'];
  published?: InputMaybe<Scalars['Boolean']>;
  type: ReportType;
};

export type ReportPage = {
  __typename?: 'ReportPage';
  items: Array<Report>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum ReportType {
  Finoptio = 'FINOPTIO',
  Fintelligence = 'FINTELLIGENCE'
}

export enum RequestContactContext {
  GenericSupport = 'GENERIC_SUPPORT',
  Investment = 'INVESTMENT',
  LifeInsuranceAudit = 'LIFE_INSURANCE_AUDIT',
  LifeInsurancePurchase = 'LIFE_INSURANCE_PURCHASE',
  MortgageRefinancing = 'MORTGAGE_REFINANCING',
  NewMortgage = 'NEW_MORTGAGE'
}

export type RetirementPensionSavingsProduct = ProductBase & {
  __typename?: 'RetirementPensionSavingsProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  currentMarketValue?: Maybe<Money>;
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  guaranteedFund?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nonGuaranteedFund?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  voluntaryContribution?: Maybe<Scalars['Boolean']>;
};

export type RetirementPensionSavingsProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  currentMarketValue?: InputMaybe<MoneyInput>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  guaranteedFund?: InputMaybe<Scalars['Boolean']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nonGuaranteedFund?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
  voluntaryContribution?: InputMaybe<Scalars['Boolean']>;
};

export type RetirementPensionSavingsProductPage = {
  __typename?: 'RetirementPensionSavingsProductPage';
  items: Array<RetirementPensionSavingsProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum Role {
  RoleAdmin = 'ROLE_ADMIN',
  RoleClient = 'ROLE_CLIENT',
  RoleFinancialAdvisor = 'ROLE_FINANCIAL_ADVISOR',
  RoleScout = 'ROLE_SCOUT'
}

export type SalvePerformanceData = {
  __typename?: 'SalvePerformanceData';
  acceptedUserInvitationsCount: Scalars['Int'];
  accountClientsCount: Scalars['Int'];
  email: Scalars['String'];
  finoptioReportClientsCount: Scalars['Int'];
  fintelligenceReportClientsCount: Scalars['Int'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  productClientsCount: Scalars['Int'];
  sentUserInvitationsCount: Scalars['Int'];
  surname?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export type SalvePerformanceDataPage = {
  __typename?: 'SalvePerformanceDataPage';
  items: Array<SalvePerformanceData>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type SavingsProduct = ProductBase & {
  __typename?: 'SavingsProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  documents: Array<Document>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type SavingsProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type SavingsProductPage = {
  __typename?: 'SavingsProductPage';
  items: Array<SavingsProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum ServiceAreaType {
  AlternativeFormsOfAssetAppreciation = 'ALTERNATIVE_FORMS_OF_ASSET_APPRECIATION',
  Deposits = 'DEPOSITS',
  Investments = 'INVESTMENTS',
  LifeInsurances = 'LIFE_INSURANCES',
  Loans = 'LOANS',
  NonLifeInsurances = 'NON_LIFE_INSURANCES',
  RealEstate = 'REAL_ESTATE',
  RetirementPensionSavings = 'RETIREMENT_PENSION_SAVINGS',
  SupplementaryPensionSavings = 'SUPPLEMENTARY_PENSION_SAVINGS'
}

export type ServiceLocation = IdBase & {
  __typename?: 'ServiceLocation';
  id: Scalars['ID'];
  name: Scalars['String'];
  region: ServiceLocationRegion;
};

export type ServiceLocationPage = {
  __typename?: 'ServiceLocationPage';
  items: Array<ServiceLocation>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum ServiceLocationRegion {
  CentralSlovakia = 'CENTRAL_SLOVAKIA',
  EasternSlovakia = 'EASTERN_SLOVAKIA',
  WesternSlovakia = 'WESTERN_SLOVAKIA'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortExpressionInput = {
  direction: SortDirection;
  fieldPath: Scalars['String'];
};

export type SortInput = {
  by: Array<SortExpressionInput>;
};

export type Staff = {
  __typename?: 'Staff';
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  serviceAreas: Array<ServiceAreaType>;
  serviceLocations: Array<ServiceLocation>;
  updateTimestamp: Scalars['DateTime'];
  user: User;
};

export type StaffInput = {
  serviceAreas: Array<ServiceAreaType>;
  serviceLocationIds: Array<Scalars['ID']>;
};

export type StaffPage = {
  __typename?: 'StaffPage';
  items: Array<Staff>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type SupplementaryPensionSavingsProduct = ProductBase & {
  __typename?: 'SupplementaryPensionSavingsProduct';
  client?: Maybe<Client>;
  contractEndDate?: Maybe<Scalars['Date']>;
  contractNumber?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['Date']>;
  creationTimestamp: Scalars['DateTime'];
  currentMarketValue?: Maybe<Money>;
  documents: Array<Document>;
  employeeContribution?: Maybe<Money>;
  employerContribution?: Maybe<Money>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: Maybe<Scalars['Date']>;
  guaranteedFund?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  institution?: Maybe<Institution>;
  institutionName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nonGuaranteedFund?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentPeriod?: Maybe<TransactionPeriod>;
  possibleEmployerContribution?: Maybe<Scalars['Boolean']>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type SupplementaryPensionSavingsProductInput = {
  contractEndDate?: InputMaybe<Scalars['Date']>;
  contractNumber?: InputMaybe<Scalars['String']>;
  contractSignDate?: InputMaybe<Scalars['Date']>;
  currentMarketValue?: InputMaybe<MoneyInput>;
  employeeContribution?: InputMaybe<MoneyInput>;
  employerContribution?: InputMaybe<MoneyInput>;
  enableFinancialAdvisorCare: Scalars['Boolean'];
  enableNotifications: Scalars['Boolean'];
  financialDetailsUpdatedAt?: InputMaybe<Scalars['Date']>;
  guaranteedFund?: InputMaybe<Scalars['Boolean']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  institutionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nonGuaranteedFund?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<PaymentInfoInput>;
  paymentPeriod?: InputMaybe<TransactionPeriodInput>;
  possibleEmployerContribution?: InputMaybe<Scalars['Boolean']>;
  status: ProductStatus;
  statusChangeDate: Scalars['Date'];
};

export type SupplementaryPensionSavingsProductPage = {
  __typename?: 'SupplementaryPensionSavingsProductPage';
  items: Array<SupplementaryPensionSavingsProduct>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Transaction = IdBase & {
  __typename?: 'Transaction';
  account: Account;
  amount: Money;
  baseAmount: Money;
  bookingDate: Scalars['Date'];
  category: TransactionCategory;
  constantSymbol?: Maybe<Scalars['String']>;
  counterparty?: Maybe<TransactionCounterparty>;
  description?: Maybe<Scalars['String']>;
  excludeFromAnalytics: Scalars['Boolean'];
  id: Scalars['ID'];
  messageForRecipient?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  payersReference?: Maybe<Scalars['String']>;
  specificSymbol?: Maybe<Scalars['String']>;
  streamGroup?: Maybe<TransactionGroup>;
  tags: Array<TransactionTag>;
  transactionTypeCode: TransactionTypeCode;
  variableSymbol?: Maybe<Scalars['String']>;
};

export type TransactionAggregateKey = Account | DateKey | TransactionCategory | TransactionTag;

export type TransactionAggregationResult = {
  __typename?: 'TransactionAggregationResult';
  baseCurrency: Scalars['Currency'];
  resultData: Array<TransactionAggregationValue>;
};

export type TransactionAggregationValue = {
  __typename?: 'TransactionAggregationValue';
  count: Scalars['Long'];
  key: Array<TransactionAggregateKey>;
  sum: Money;
};

export enum TransactionAttribute {
  Account = 'ACCOUNT',
  Category = 'CATEGORY',
  Day = 'DAY',
  Month = 'MONTH',
  Tag = 'TAG',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TransactionCategory = IdBase & {
  __typename?: 'TransactionCategory';
  categoryGroup: TransactionCategoryGroup;
  code: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type TransactionCategoryGroup = IdBase & {
  __typename?: 'TransactionCategoryGroup';
  code: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type TransactionCounterparty = IdBase & {
  __typename?: 'TransactionCounterparty';
  accountIban?: Maybe<Scalars['String']>;
  defaultName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type TransactionCounterpartyPage = {
  __typename?: 'TransactionCounterpartyPage';
  items: Array<TransactionCounterparty>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type TransactionGroup = {
  __typename?: 'TransactionGroup';
  account: Account;
  category: TransactionCategory;
  counterparty?: Maybe<TransactionCounterparty>;
  excludeFromAnalytics: Scalars['Boolean'];
  groupTypeCode: TransactionGroupTypeCode;
  id: Scalars['ID'];
  name: Scalars['String'];
  period?: Maybe<TransactionPeriod>;
  tags: Array<TransactionTag>;
  transactions: Array<Transaction>;
};

export type TransactionGroupPeriodInput = {
  expectedAmount: MoneyInput;
  expectedTransactionsCount?: InputMaybe<Scalars['Int']>;
  periodCount: Scalars['Int'];
  periodTypeCode: TransactionGroupPeriodTypeCode;
  referenceDate: Scalars['Date'];
};

export enum TransactionGroupPeriodTypeCode {
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum TransactionGroupTypeCode {
  Stream = 'STREAM'
}

export type TransactionPeriod = {
  __typename?: 'TransactionPeriod';
  expectedAmount?: Maybe<Money>;
  expectedDate?: Maybe<Scalars['Date']>;
  expectedTransactionsCount?: Maybe<Scalars['Int']>;
  periodCount?: Maybe<Scalars['Int']>;
  periodTypeCode?: Maybe<TransactionGroupPeriodTypeCode>;
  referenceDate?: Maybe<Scalars['Date']>;
};

export type TransactionPeriodInput = {
  expectedAmount?: InputMaybe<MoneyInput>;
  expectedTransactionsCount?: InputMaybe<Scalars['Int']>;
  periodCount?: InputMaybe<Scalars['Int']>;
  periodTypeCode?: InputMaybe<TransactionGroupPeriodTypeCode>;
  referenceDate?: InputMaybe<Scalars['Date']>;
};

export type TransactionTag = IdBase & {
  __typename?: 'TransactionTag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TransactionTagInput = {
  name: Scalars['String'];
};

export type TransactionTagPage = {
  __typename?: 'TransactionTagPage';
  items: Array<TransactionTag>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum TransactionTypeCode {
  Bonus = 'BONUS',
  Cash = 'CASH',
  Charge = 'CHARGE',
  Fee = 'FEE',
  Other = 'OTHER',
  Transfer = 'TRANSFER'
}

export type TransactionsCategoryGroupPage = {
  __typename?: 'TransactionsCategoryGroupPage';
  items: Array<TransactionCategoryGroup>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type TransactionsCategoryPage = {
  __typename?: 'TransactionsCategoryPage';
  items: Array<TransactionCategory>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type TransactionsPage = {
  __typename?: 'TransactionsPage';
  items: Array<Transaction>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type UpcomingPayment = {
  __typename?: 'UpcomingPayment';
  expectedAmount: Money;
  expectedBaseAmount: Money;
  expectedDate: Scalars['Date'];
  streamGroup: TransactionGroup;
};

export type UpcomingPaymentAggregationResult = {
  __typename?: 'UpcomingPaymentAggregationResult';
  baseCurrency: Scalars['Currency'];
  resultData: Array<UpcomingPaymentAggregationValue>;
};

export type UpcomingPaymentAggregationValue = {
  __typename?: 'UpcomingPaymentAggregationValue';
  count: Scalars['Long'];
  key: Array<DateKey>;
  sum: Money;
};

export enum UpcomingPaymentAttribute {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type UpcomingPaymentFilter = {
  asOfDate: Scalars['Date'];
  endDate: Scalars['Date'];
  excludeFromAnalytics?: InputMaybe<FilterOperatorValue>;
  expectedBaseAmount?: InputMaybe<FilterOperatorValue>;
};

export type UpcomingPaymentsPage = {
  __typename?: 'UpcomingPaymentsPage';
  items: Array<UpcomingPayment>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type User = IdBase & {
  __typename?: 'User';
  avatar?: Maybe<Avatar>;
  clientId: Scalars['ID'];
  creationTimestamp: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  inverseRelations?: Maybe<Array<UserRelation>>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  staffId: Scalars['ID'];
  subject?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updateTimestamp: Scalars['DateTime'];
};

export type UserInfo = {
  email: Scalars['String'];
  phoneNumber?: Scalars['String'];
};

export type UserInput = {
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Role>>;
};

export type UserInvitation = IdBase & {
  __typename?: 'UserInvitation';
  creationTimestamp: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inviter: User;
  relationType?: Maybe<UserRelationType>;
  role?: Maybe<Role>;
  status: UserInvitationStatus;
  statusChangeTimestamp: Scalars['DateTime'];
  token?: Maybe<Scalars['String']>;
  updateTimestamp: Scalars['DateTime'];
};

export type UserInvitationInput = {
  email: Scalars['String'];
  role: Role;
  status: UserInvitationStatus;
};

export type UserInvitationPage = {
  __typename?: 'UserInvitationPage';
  items: Array<UserInvitation>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum UserInvitationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING'
}

export type UserPage = {
  __typename?: 'UserPage';
  items: Array<User>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type UserRelation = IdBase & {
  __typename?: 'UserRelation';
  creationTimestamp: Scalars['DateTime'];
  id: Scalars['ID'];
  objectUser: User;
  relationType: UserRelationType;
  serviceAreas?: Maybe<Array<ServiceAreaType>>;
  subjectUser: User;
  updateTimestamp: Scalars['DateTime'];
};

export type UserRelationInput = {
  objectUserId: Scalars['ID'];
  relationType: UserRelationType;
  serviceAreas?: InputMaybe<Array<ServiceAreaType>>;
  subjectUserId: Scalars['ID'];
};

export type UserRelationPage = {
  __typename?: 'UserRelationPage';
  items: Array<UserRelation>;
  pageIndex: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum UserRelationType {
  AdditionalFinancialAdvisor = 'ADDITIONAL_FINANCIAL_ADVISOR',
  MainFinancialAdvisor = 'MAIN_FINANCIAL_ADVISOR',
  Scout = 'SCOUT'
}

export type UtmParametersInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

export type VehicleInfo = {
  __typename?: 'VehicleInfo';
  licenseNumber?: Maybe<Scalars['String']>;
  manufactureYear?: Maybe<Scalars['Int']>;
  owner?: Maybe<VehicleOwner>;
  type?: Maybe<VehicleType>;
};

export type VehicleInfoInput = {
  licenseNumber?: InputMaybe<Scalars['String']>;
  manufactureYear?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<VehicleOwnerInput>;
  type?: InputMaybe<VehicleType>;
};

export type VehicleOwner = {
  __typename?: 'VehicleOwner';
  dateOfBirth?: Maybe<Scalars['Date']>;
  numberOfRecentCollisions?: Maybe<Scalars['Int']>;
  postalCode?: Maybe<Scalars['String']>;
  yearOfLastCollision?: Maybe<Scalars['Int']>;
};

export type VehicleOwnerInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  numberOfRecentCollisions?: InputMaybe<Scalars['Int']>;
  postalCode?: InputMaybe<Scalars['String']>;
  yearOfLastCollision?: InputMaybe<Scalars['Int']>;
};

export enum VehicleType {
  Automobile = 'AUTOMOBILE',
  Motorcycle = 'MOTORCYCLE',
  Other = 'OTHER'
}

export enum WidgetType {
  MortgagePurchaseProcess = 'MORTGAGE_PURCHASE_PROCESS',
  MortgageRefinanceProcess = 'MORTGAGE_REFINANCE_PROCESS'
}

export type AdminGetPermanentFileLinkQueryVariables = Exact<{
  fileId: Scalars['ID'];
}>;


export type AdminGetPermanentFileLinkQuery = { __typename?: 'Query', adminGetPermanentFileLink: string };

export type MarkFinancialAdvisorTaskAsDoneMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type MarkFinancialAdvisorTaskAsDoneMutation = { __typename?: 'Mutation', adminMarkFinancialAdvisorTaskAsDone: { __typename?: 'FinancialAdvisorTask', id: string } };

export type MarkFinancialAdvisorTaskAsUndoneMutationVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type MarkFinancialAdvisorTaskAsUndoneMutation = { __typename?: 'Mutation', adminMarkFinancialAdvisorTaskAsUndone: { __typename?: 'FinancialAdvisorTask', id: string } };

export type StaffFragment = { __typename?: 'Staff', id: string, serviceAreas: Array<ServiceAreaType>, serviceLocations: Array<{ __typename?: 'ServiceLocation', id: string, name: string }> };

export type AdminGetStaffsQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type AdminGetStaffsQuery = { __typename?: 'Query', staffs: { __typename?: 'StaffPage', items: Array<{ __typename?: 'Staff', id: string, serviceAreas: Array<ServiceAreaType>, serviceLocations: Array<{ __typename?: 'ServiceLocation', id: string, name: string }> }> } };

export type AdminGetStaffQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminGetStaffQuery = { __typename?: 'Query', adminGetStaff: { __typename?: 'Staff', id: string, serviceAreas: Array<ServiceAreaType>, serviceLocations: Array<{ __typename?: 'ServiceLocation', id: string, name: string }> } };

export type AdminUpdateStaffMutationVariables = Exact<{
  id: Scalars['ID'];
  input: StaffInput;
}>;


export type AdminUpdateStaffMutation = { __typename?: 'Mutation', adminUpdateStaff: { __typename?: 'Staff', id: string, serviceAreas: Array<ServiceAreaType>, serviceLocations: Array<{ __typename?: 'ServiceLocation', id: string, name: string }> } };

export type AdminBuildingSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminBuildingSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'BuildingSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateBuildingSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateBuildingSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminCollisionInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminCollisionInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'CollisionInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, insuranceRisks?: Array<{ __typename?: 'CollisionInsuranceRisk', id: string, type?: CollisionInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateCollisionInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateCollisionInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminCreditCardProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminCreditCardProductQuery = { __typename?: 'Query', detail: { __typename?: 'CreditCardProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, regularUsage?: boolean | null, owedAmountPaidByMaturity?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, limitAmount?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateCreditCardProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateCreditCardProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminGenericProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminGenericProductQuery = { __typename?: 'Query', detail: { __typename?: 'GenericProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateGenericProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateGenericProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminGenericInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminGenericInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'GenericInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateGenericInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateGenericInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminInvestmentProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminInvestmentProductQuery = { __typename?: 'Query', detail: { __typename?: 'InvestmentProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialInstrument?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, amountInvested?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateInvestmentProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateInvestmentProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminLifeInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminLifeInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'LifeInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, applicants: Array<{ __typename?: 'LifeInsuranceApplicant', id: string, name: string, surname: string, isInsured: boolean, isInsuring: boolean, insurance?: { __typename?: 'LifeInsuranceInsurance', insuranceRisks: Array<{ __typename?: 'LifeInsuranceInsuranceRisk', id: string, type?: LifeInsuranceInsuranceRiskType | null, name?: string | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null }> } | null }>, surrenderValue?: { __typename?: 'Money', amount: number, currency: string } | null, savings?: { __typename?: 'LifeInsuranceSavings', amount?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateLifeInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateLifeInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminLoanProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminLoanProductQuery = { __typename?: 'Query', detail: { __typename?: 'LoanProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateLoanProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateLoanProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminMortgageProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminMortgageProductQuery = { __typename?: 'Query', detail: { __typename?: 'MortgageProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, collaterals: Array<{ __typename?: 'MortgageCollateral', address?: string | null }>, purchasedProperty?: { __typename?: 'MortgageProperty', address?: string | null } | null, participants: Array<{ __typename?: 'MortgageParticipant', name?: string | null }>, documents: Array<{ __typename?: 'Document', id: string, type: DocumentType, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateMortgageProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateMortgageProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminMotorLiabilityInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminMotorLiabilityInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'MotorLiabilityInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateMotorLiabilityInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateMotorLiabilityInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminPropertyInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminPropertyInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'PropertyInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', name?: string | null, surname?: string | null } | null, insuredProperty?: { __typename?: 'PropertyInsuranceInsuredProperty', type?: PropertyInsuranceInsuredPropertyType | null, address?: string | null, propertyValue?: { __typename?: 'Money', amount: number, currency: string } | null, householdValue?: { __typename?: 'Money', amount: number, currency: string } | null } | null, basicInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, otherInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreatePropertyInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreatePropertyInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminRetirementPensionSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminRetirementPensionSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'RetirementPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, voluntaryContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateRetirementPensionSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateRetirementPensionSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'SavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type AdminSupplementaryPensionSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminSupplementaryPensionSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'SupplementaryPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, possibleEmployerContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, employerContribution?: { __typename?: 'Money', amount: number, currency: string } | null, employeeContribution?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type AdminCreateSupplementaryPensionSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type AdminCreateSupplementaryPensionSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

type BalanceKey_Account_Fragment = { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null };

type BalanceKey_DateKey_Fragment = { __typename?: 'DateKey', startDate: Date, granularity: DateGranularity };

export type BalanceKeyFragment = BalanceKey_Account_Fragment | BalanceKey_DateKey_Fragment;

export type BalanceValueFragment = { __typename?: 'BalanceValue', key: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null } | { __typename?: 'DateKey', startDate: Date, granularity: DateGranularity }>, balance: { __typename?: 'Money', amount: number, currency: string } };

export type AggregateBalancesQueryVariables = Exact<{
  groupBy?: InputMaybe<Array<BalanceAttribute> | BalanceAttribute>;
  filterInput?: InputMaybe<AggregateBalanceFilter>;
}>;


export type AggregateBalancesQuery = { __typename?: 'Query', aggregateBalances: { __typename?: 'BalanceResult', baseCurrency: string, resultData: Array<{ __typename?: 'BalanceValue', key: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null } | { __typename?: 'DateKey', startDate: Date, granularity: DateGranularity }>, balance: { __typename?: 'Money', amount: number, currency: string } }> } };

export type AccountFragment = { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null };

export type ConnectedAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedAccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountPage', items: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }> } };

export type AccountDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountDetailQuery = { __typename?: 'Query', detail: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null } };

export type LastAccountsDataRefreshQueryVariables = Exact<{ [key: string]: never; }>;


export type LastAccountsDataRefreshQuery = { __typename?: 'Query', lastRefresh?: Date | null };

export type InitNordigenFlowMutationVariables = Exact<{
  institutionId: Scalars['ID'];
  redirectUrl: Scalars['Url'];
}>;


export type InitNordigenFlowMutation = { __typename?: 'Mutation', link: any };

export type SynchronizeAccountsMutationVariables = Exact<{
  requisitionId: Scalars['UUID'];
}>;


export type SynchronizeAccountsMutation = { __typename?: 'Mutation', newAccounts: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }> };

export type RefreshAccountsDataMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshAccountsDataMutation = { __typename?: 'Mutation', jobId?: string | null };

export type RenameAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type RenameAccountMutation = { __typename?: 'Mutation', renameAccount?: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null } | null };

export type RemoveAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type RemoveAccountMutation = { __typename?: 'Mutation', removeAccount?: string | null };

export type CalendarEventFragment = { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null };

export type CalendarEventInstanceFragment = { __typename?: 'CalendarEventInstance', id: string, originalEventId: string, type: CalendarEventType, name?: string | null, date: Date, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null };

export type CalendarEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarEventsQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null }> | null };

export type CalendarEventInstancesQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type CalendarEventInstancesQuery = { __typename?: 'Query', eventInstances?: Array<{ __typename?: 'CalendarEventInstance', id: string, originalEventId: string, type: CalendarEventType, name?: string | null, date: Date, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null }> | null };

export type CalendarEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CalendarEventQuery = { __typename?: 'Query', detail: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } };

export type CreateCalendarEventMutationVariables = Exact<{
  event: CalendarEventInput;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createCalendarEvent: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } };

export type UpdateCalendarEventMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedEvent: CalendarEventInput;
}>;


export type UpdateCalendarEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } };

export type DeleteCalendarEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCalendarEventMutation = { __typename?: 'Mutation', deleteEvent: string };

export type CashFlowAdjustmentFragment = { __typename?: 'CashFlowAdjustment', id: string, text?: string | null, period: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } };

export type CashFlowAdjustmentsQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type CashFlowAdjustmentsQuery = { __typename?: 'Query', cashFlowAdjustments: { __typename?: 'CashFlowAdjustmentPage', totalItems: number, items: Array<{ __typename?: 'CashFlowAdjustment', id: string, text?: string | null, period: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } }> } };

export type CashFlowAdjustmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CashFlowAdjustmentQuery = { __typename?: 'Query', detail: { __typename?: 'CashFlowAdjustment', id: string, text?: string | null, period: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } } };

export type CreateCashFlowAdjustmentMutationVariables = Exact<{
  cashFlowAdjustment: CashFlowAdjustmentInput;
}>;


export type CreateCashFlowAdjustmentMutation = { __typename?: 'Mutation', createCashFlowAdjustment: { __typename?: 'CashFlowAdjustment', id: string, text?: string | null, period: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } } };

export type UpdateCashFlowAdjustmentMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedCashFlowAdjustment: CashFlowAdjustmentInput;
}>;


export type UpdateCashFlowAdjustmentMutation = { __typename?: 'Mutation', updateCashFlowAdjustment: { __typename?: 'CashFlowAdjustment', id: string, text?: string | null, period: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } } };

export type DeleteCashFlowAdjustmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCashFlowAdjustmentMutation = { __typename?: 'Mutation', deleteCashFlowAdjustment: string };

export type BudgetQueryVariables = Exact<{
  asOfDate?: InputMaybe<Scalars['Date']>;
}>;


export type BudgetQuery = { __typename?: 'Query', budget?: number | null };

export type SetBudgetMutationVariables = Exact<{
  amountInBaseCurrency: Scalars['BigDecimal'];
  sinceDate?: InputMaybe<Scalars['Date']>;
}>;


export type SetBudgetMutation = { __typename?: 'Mutation', setBudget: number };

export type UpcomingPaymentListItemFragment = { __typename?: 'UpcomingPayment', expectedDate: Date, streamGroup: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, category: { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } }, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null }, expectedAmount: { __typename?: 'Money', amount: number, currency: string }, expectedBaseAmount: { __typename?: 'Money', amount: number, currency: string } };

export type UpcomingPaymentsQueryVariables = Exact<{
  pageInput?: InputMaybe<PageInput>;
  filterInput: UpcomingPaymentFilter;
}>;


export type UpcomingPaymentsQuery = { __typename?: 'Query', upcomingPaymentsList?: { __typename?: 'UpcomingPaymentsPage', totalItems: number, pageIndex: number, pageSize: number, items: Array<{ __typename?: 'UpcomingPayment', expectedDate: Date, streamGroup: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, category: { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } }, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null }, expectedAmount: { __typename?: 'Money', amount: number, currency: string }, expectedBaseAmount: { __typename?: 'Money', amount: number, currency: string } }> } | null };

export type UpcomingPaymentAggregationValueFragment = { __typename?: 'UpcomingPaymentAggregationValue', count: number, key: Array<{ __typename?: 'DateKey', startDate: Date, granularity: DateGranularity }>, sum: { __typename?: 'Money', amount: number, currency: string } };

export type AggregateUpcomingPaymentsQueryVariables = Exact<{
  groupBy?: InputMaybe<Array<UpcomingPaymentAttribute> | UpcomingPaymentAttribute>;
  filterInput: UpcomingPaymentFilter;
}>;


export type AggregateUpcomingPaymentsQuery = { __typename?: 'Query', aggregateUpcomingPayments: { __typename?: 'UpcomingPaymentAggregationResult', baseCurrency: string, resultData: Array<{ __typename?: 'UpcomingPaymentAggregationValue', count: number, key: Array<{ __typename?: 'DateKey', startDate: Date, granularity: DateGranularity }>, sum: { __typename?: 'Money', amount: number, currency: string } }> } };

export type ServiceLocationFragment = { __typename?: 'ServiceLocation', id: string, region: ServiceLocationRegion, name: string };

export type ServiceLocationsQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type ServiceLocationsQuery = { __typename?: 'Query', serviceLocations: { __typename?: 'ServiceLocationPage', totalItems: number, items: Array<{ __typename?: 'ServiceLocation', id: string, region: ServiceLocationRegion, name: string }> } };

export type ClientProfileFragment = { __typename?: 'ClientProfile', id: string, creationTimestamp: Date, updateTimestamp: Date, birthYear: number, partner: boolean, partnerBirthYear?: number | null, childrenNumber: number, youngestChildBirthYear?: number | null, preferredServiceLocation: { __typename?: 'ServiceLocation', id: string, region: ServiceLocationRegion, name: string } };

export type ClientProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientProfileQuery = { __typename?: 'Query', clientProfile?: { __typename?: 'ClientProfile', id: string, creationTimestamp: Date, updateTimestamp: Date, birthYear: number, partner: boolean, partnerBirthYear?: number | null, childrenNumber: number, youngestChildBirthYear?: number | null, preferredServiceLocation: { __typename?: 'ServiceLocation', id: string, region: ServiceLocationRegion, name: string } } | null };

export type UpdateClientProfileMutationVariables = Exact<{
  clientProfile: ClientProfileInput;
}>;


export type UpdateClientProfileMutation = { __typename?: 'Mutation', clientProfile: { __typename?: 'ClientProfile', id: string, creationTimestamp: Date, updateTimestamp: Date, birthYear: number, partner: boolean, partnerBirthYear?: number | null, childrenNumber: number, youngestChildBirthYear?: number | null, preferredServiceLocation: { __typename?: 'ServiceLocation', id: string, region: ServiceLocationRegion, name: string } } };

export type GenerateFileDownloadUrlMutationVariables = Exact<{
  fileId: Scalars['ID'];
  contentDisposition?: InputMaybe<Scalars['String']>;
}>;


export type GenerateFileDownloadUrlMutation = { __typename?: 'Mutation', generateFileDownloadUrl: string };

export type PermanentFileLinkQueryVariables = Exact<{
  fileId: Scalars['ID'];
}>;


export type PermanentFileLinkQuery = { __typename?: 'Query', permanentFileLink: string };

export type AllProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProcessesQuery = { __typename?: 'Query', purchaseProcesses: { __typename?: 'MortgagePurchaseProcessPage', items: Array<{ __typename?: 'MortgagePurchaseProcess', id: string, updateTimestamp?: Date | null, acceptedTimestamp?: Date | null, inquiry?: { __typename?: 'MortgagePurchaseInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null } | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string } | null }> }, refinanceProcesses: { __typename?: 'MortgageRefinanceProcessPage', items: Array<{ __typename?: 'MortgageRefinanceProcess', id: string, updateTimestamp?: Date | null, acceptedTimestamp?: Date | null, inquiry?: { __typename?: 'MortgageRefinanceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null } | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string } | null }> }, lifeInsuranceProcesses: { __typename?: 'LifeInsurancePurchaseProcessPage', items: Array<{ __typename?: 'LifeInsurancePurchaseProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null, inquiry?: { __typename?: 'LifeInsuranceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null } | null }> }, lifeInsuranceAuditProcesses: { __typename?: 'LifeInsuranceAuditProcessPage', items: Array<{ __typename?: 'LifeInsuranceAuditProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null, inquiry?: { __typename?: 'LifeInsuranceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null } | null }> } };

export type FinancialReserveFragment = { __typename?: 'FinancialReserve', id: string, text?: string | null, amount: { __typename?: 'Money', amount: number, currency: string } };

export type FinancialReservesQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type FinancialReservesQuery = { __typename?: 'Query', financialReserves: { __typename?: 'FinancialReservePage', totalItems: number, items: Array<{ __typename?: 'FinancialReserve', id: string, text?: string | null, amount: { __typename?: 'Money', amount: number, currency: string } }> } };

export type FinancialReserveQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FinancialReserveQuery = { __typename?: 'Query', detail: { __typename?: 'FinancialReserve', id: string, text?: string | null, amount: { __typename?: 'Money', amount: number, currency: string } } };

export type CreateFinancialReserveMutationVariables = Exact<{
  financialReserve: FinancialReserveInput;
}>;


export type CreateFinancialReserveMutation = { __typename?: 'Mutation', createFinancialReserve: { __typename?: 'FinancialReserve', id: string, text?: string | null, amount: { __typename?: 'Money', amount: number, currency: string } } };

export type UpdateFinancialReserveMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedFinancialReserve: FinancialReserveInput;
}>;


export type UpdateFinancialReserveMutation = { __typename?: 'Mutation', updateFinancialReserve: { __typename?: 'FinancialReserve', id: string, text?: string | null, amount: { __typename?: 'Money', amount: number, currency: string } } };

export type DeleteFinancialReserveMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFinancialReserveMutation = { __typename?: 'Mutation', deleteFinancialReserve: string };

export type MortgagePurchaseTuningLimitsByProcessIdQueryVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type MortgagePurchaseTuningLimitsByProcessIdQuery = { __typename?: 'Query', limits: { __typename?: 'MortgagePurchaseTuningLimits', fixationDefault: number, fixationOptions?: Array<number> | null, maturityInYearsDefault: number, amountDefault: { __typename?: 'Money', amount: number, currency: string }, amountRange: { __typename?: 'PairMoney', first?: { __typename?: 'Money', amount: number, currency: string } | null, second?: { __typename?: 'Money', amount: number, currency: string } | null }, maturityInYearsRange: { __typename?: 'IntInterval', lower?: number | null, upper?: number | null } } };

export type DetailedMortgageProposalFragment = { __typename?: 'MortgageProposal', id: string, fixationLength: number, interestRate: number, maturity: number, institutionAbbreviation: string, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null };

export type CalculateMortgagePurchaseResultByProcessIdMutationVariables = Exact<{
  processId: Scalars['ID'];
  tuning: MortgagePurchaseTuningInput;
}>;


export type CalculateMortgagePurchaseResultByProcessIdMutation = { __typename?: 'Mutation', result: { __typename?: 'MortgagePurchaseResult', id: string, creationTimestamp: Date, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, interestRate: number, maturity: number, institutionAbbreviation: string, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }> } };

export type CalculateMortgagePurchaseResultByInquiryQueryVariables = Exact<{
  inquiry: MortgagePurchaseInquiryInput;
}>;


export type CalculateMortgagePurchaseResultByInquiryQuery = { __typename?: 'Query', result: { __typename?: 'MortgagePurchaseResult', id: string, creationTimestamp: Date, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, interestRate: number, maturity: number, institutionAbbreviation: string, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }> } };

export type AcceptMortgagePurchaseProposalMutationVariables = Exact<{
  processId: Scalars['ID'];
  acceptanceType: MortgagePurchaseProcessAcceptanceType;
}>;


export type AcceptMortgagePurchaseProposalMutation = { __typename?: 'Mutation', acceptMortgagePurchaseProposal: { __typename?: 'MortgagePurchaseProcess', id: string } };

export type MortgagePurchaseResultConstraintsByProcessIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MortgagePurchaseResultConstraintsByProcessIdQuery = { __typename?: 'Query', constraints: { __typename?: 'MortgagePurchaseResultConstraints', minInterestRate: number, fixationLength: number, maturity: number, maxMortgageAmount: { __typename?: 'Money', amount: number, currency: string }, maxPropertyPrice: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string } } };

export type MortgagePurchaseResultConstraintsByInquiryQueryVariables = Exact<{
  inquiry: MortgagePurchaseInquiryInput;
}>;


export type MortgagePurchaseResultConstraintsByInquiryQuery = { __typename?: 'Query', constraints: { __typename?: 'MortgagePurchaseResultConstraints', minInterestRate: number, fixationLength: number, maturity: number, maxMortgageAmount: { __typename?: 'Money', amount: number, currency: string }, maxPropertyPrice: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string } } };

export type InstitutionFragment = { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean };

export type InstitutionsQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type InstitutionsQuery = { __typename?: 'Query', getInstitutionsPage: { __typename?: 'InstitutionPage', items: Array<{ __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }> } };

export type JobStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type JobStatusQuery = { __typename?: 'Query', getJobStatus: { __typename?: 'JobStatus', status: JobStatusType, errorMessage?: string | null } };

export type DocumentFragment = { __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> };

export type LifeInsuranceAuditProcessQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LifeInsuranceAuditProcessQuery = { __typename?: 'Query', process: { __typename?: 'LifeInsuranceAuditProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null, inquiry?: { __typename?: 'LifeInsuranceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, applicants?: Array<{ __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }> | null } | null, documents?: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> | null } };

export type AllLifeInsuranceAuditProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLifeInsuranceAuditProcessesQuery = { __typename?: 'Query', processes: { __typename?: 'LifeInsuranceAuditProcessPage', items: Array<{ __typename?: 'LifeInsuranceAuditProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null, inquiry?: { __typename?: 'LifeInsuranceInquiry', id: string, inquiryProgress?: number | null, inquiryCurrentStepUrl?: string | null } | null }> } };

export type LifeInsuranceAuditProcessLockedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LifeInsuranceAuditProcessLockedQuery = { __typename?: 'Query', process: { __typename?: 'LifeInsuranceAuditProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null } };

export type CreateLifeInsuranceAuditProcessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLifeInsuranceAuditProcessMutation = { __typename?: 'Mutation', createLifeInsuranceAuditProcess: { __typename?: 'LifeInsuranceAuditProcess', id: string, updateTimestamp?: Date | null } };

export type UpdateLifeInsuranceAuditProcessMutationVariables = Exact<{
  id: Scalars['ID'];
  inquiry: LifeInsuranceInquiryInput;
}>;


export type UpdateLifeInsuranceAuditProcessMutation = { __typename?: 'Mutation', updateLifeInsuranceAuditProcess: { __typename?: 'LifeInsuranceAuditProcess', id: string, updateTimestamp?: Date | null } };

export type CreateLifeInsuranceDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateLifeInsuranceDocumentMutation = { __typename?: 'Mutation', createLifeInsuranceDocument: { __typename?: 'Document', id: string } };

export type AcceptLifeInsuranceAuditResultMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type AcceptLifeInsuranceAuditResultMutation = { __typename?: 'Mutation', acceptLifeInsuranceAuditResult: { __typename?: 'LifeInsuranceAuditProcess', id: string } };

export type SendLifeInsuranceAuditNotificationToSpecialistMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type SendLifeInsuranceAuditNotificationToSpecialistMutation = { __typename?: 'Mutation', sendLifeInsuranceAuditNotificationEmailToSpecialist: boolean };

export type DeleteLifeInsuranceAuditProcessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLifeInsuranceAuditProcessMutation = { __typename?: 'Mutation', deleteLifeInsuranceAuditProcess: string };

export type LifeInsuranceCalculatorResultFragment = { __typename?: 'LifeInsuranceCalculatorResult', score: number, maximalScore: number, necessity: LifeInsuranceCalculatorNecessity, significantDomains: Array<LifeInsuranceCalculatorDomain>, similarUserRatio: number };

export type LifeInsuranceCalculatorResultQueryVariables = Exact<{
  inquiry: LifeInsuranceCalculatorInquiryInput;
}>;


export type LifeInsuranceCalculatorResultQuery = { __typename?: 'Query', result: { __typename?: 'LifeInsuranceCalculatorResult', score: number, maximalScore: number, necessity: LifeInsuranceCalculatorNecessity, significantDomains: Array<LifeInsuranceCalculatorDomain>, similarUserRatio: number } };

export type AverageLifeInsuranceScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type AverageLifeInsuranceScoreQuery = { __typename?: 'Query', averageScore: number };

export type LifeInsuranceCalculatorCalculationsQueryVariables = Exact<{
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type LifeInsuranceCalculatorCalculationsQuery = { __typename?: 'Query', calculations: { __typename?: 'LifeInsuranceCalculatorCalculationsPage', totalItems: number, items: Array<{ __typename?: 'LifeInsuranceCalculatorCalculation', id: string, result: { __typename?: 'LifeInsuranceCalculatorResult', score: number, maximalScore: number, necessity: LifeInsuranceCalculatorNecessity, significantDomains: Array<LifeInsuranceCalculatorDomain>, similarUserRatio: number } }> } };

export type LifeInsuranceApplicantFragment = { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> };

export type LifeInsuranceInquiryFragment = { __typename?: 'LifeInsuranceInquiry', inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, applicants?: Array<{ __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }> | null };

type LifeInsuranceProposal_LifeInsuranceAdultProposal_Fragment = { __typename: 'LifeInsuranceAdultProposal', id: string, applicant: { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }, disability: { __typename?: 'Money', amount: number }, permanentInjuryConsequences: { __typename?: 'Money', amount: number }, criticalIllnesses: { __typename?: 'Money', amount: number }, deathInsurance: { __typename?: 'Money', amount: number } };

type LifeInsuranceProposal_LifeInsuranceChildProposal_Fragment = { __typename: 'LifeInsuranceChildProposal', id: string, applicant: { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }, hospitalization: { __typename?: 'Money', amount: number }, permanentInjuryConsequences: { __typename?: 'Money', amount: number }, criticalIllnesses: { __typename?: 'Money', amount: number }, minorInjuries: { __typename?: 'Money', amount: number } };

export type LifeInsuranceProposalFragment = LifeInsuranceProposal_LifeInsuranceAdultProposal_Fragment | LifeInsuranceProposal_LifeInsuranceChildProposal_Fragment;

export type LifeInsurancePurchaseProcessQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LifeInsurancePurchaseProcessQuery = { __typename?: 'Query', process: { __typename?: 'LifeInsurancePurchaseProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null, inquiry?: { __typename?: 'LifeInsuranceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, applicants?: Array<{ __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }> | null } | null } };

export type LifeInsurancePurchaseProcessLockedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LifeInsurancePurchaseProcessLockedQuery = { __typename?: 'Query', process: { __typename?: 'LifeInsurancePurchaseProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null } };

export type AllLifeInsurancePurchaseProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLifeInsurancePurchaseProcessesQuery = { __typename?: 'Query', processes: { __typename?: 'LifeInsurancePurchaseProcessPage', items: Array<{ __typename?: 'LifeInsurancePurchaseProcess', id: string, updateTimestamp?: Date | null, creationTimestamp?: Date | null, locked?: boolean | null, inquiry?: { __typename?: 'LifeInsuranceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, applicants?: Array<{ __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }> | null } | null }> } };

export type CalculateLifeInsuranceResultByInquiryQueryVariables = Exact<{
  inquiry: LifeInsuranceInquiryInput;
}>;


export type CalculateLifeInsuranceResultByInquiryQuery = { __typename?: 'Query', proposals: { __typename?: 'LifeInsuranceResult', id: string, proposals: Array<{ __typename: 'LifeInsuranceAdultProposal', id: string, applicant: { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }, disability: { __typename?: 'Money', amount: number }, permanentInjuryConsequences: { __typename?: 'Money', amount: number }, criticalIllnesses: { __typename?: 'Money', amount: number }, deathInsurance: { __typename?: 'Money', amount: number } } | { __typename: 'LifeInsuranceChildProposal', id: string, applicant: { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }, hospitalization: { __typename?: 'Money', amount: number }, permanentInjuryConsequences: { __typename?: 'Money', amount: number }, criticalIllnesses: { __typename?: 'Money', amount: number }, minorInjuries: { __typename?: 'Money', amount: number } }> } };

export type CreateLifeInsurancePurchaseProcessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLifeInsurancePurchaseProcessMutation = { __typename?: 'Mutation', createLifeInsurancePurchaseProcess: { __typename?: 'LifeInsurancePurchaseProcess', id: string, updateTimestamp?: Date | null } };

export type UpdateLifeInsurancePurchaseProcessMutationVariables = Exact<{
  id: Scalars['ID'];
  inquiry: LifeInsuranceInquiryInput;
}>;


export type UpdateLifeInsurancePurchaseProcessMutation = { __typename?: 'Mutation', updateLifeInsurancePurchaseProcess: { __typename?: 'LifeInsurancePurchaseProcess', id: string, updateTimestamp?: Date | null } };

export type CalculateLifeInsuranceResultByProcessIdMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type CalculateLifeInsuranceResultByProcessIdMutation = { __typename?: 'Mutation', proposals: { __typename?: 'LifeInsuranceResult', id: string, proposals: Array<{ __typename: 'LifeInsuranceAdultProposal', id: string, applicant: { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }, disability: { __typename?: 'Money', amount: number }, permanentInjuryConsequences: { __typename?: 'Money', amount: number }, criticalIllnesses: { __typename?: 'Money', amount: number }, deathInsurance: { __typename?: 'Money', amount: number } } | { __typename: 'LifeInsuranceChildProposal', id: string, applicant: { __typename?: 'LifeInsuranceApplicant', dateOfBirth?: Date | null, hasSharedLiabilities?: boolean | null, hasSharedExpenses?: boolean | null, id: string, isInsured: boolean, isInsuring: boolean, name: string, occupationName?: string | null, surname: string, expenses?: { __typename?: 'LifeInsuranceExpenses', monthlyFamilyExpenses: { __typename?: 'Money', amount: number } } | null, healthCondition?: { __typename?: 'LifeInsuranceHealthCondition', isTreatedForDisease: boolean, isOnRegularMedication: boolean, hasPlannedMedicalProcedure: boolean, regularMedication: string, disabilityPension: DisabilityPensionType, hasPermanentInjuryConsequences: boolean, permanentInjuryConsequencesDescription: string, isOnSickLeave: boolean, diseases?: Array<{ __typename?: 'LifeInsuranceDisease', description: string }> | null, plannedMedicalProcedures?: Array<{ __typename?: 'LifeInsuranceMedicalProcedure', description: string, scheduledFor: string }> | null } | null, incomes: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', monthlyIncomeNullable?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', contractSignatureDate?: Date | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantUnemploymentBenefitIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }>, liabilities: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', balance: { __typename?: 'Money', amount: number }, monthlyInstallment: { __typename?: 'Money', amount: number } }>, practicedSports: Array<{ __typename?: 'LifeInsuranceSport', name: string, wayOfPracticing: LifeInsuranceWayOfPracticingSportType }> }, hospitalization: { __typename?: 'Money', amount: number }, permanentInjuryConsequences: { __typename?: 'Money', amount: number }, criticalIllnesses: { __typename?: 'Money', amount: number }, minorInjuries: { __typename?: 'Money', amount: number } }> } };

export type AcceptLifeInsuranceProposalMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type AcceptLifeInsuranceProposalMutation = { __typename?: 'Mutation', process: { __typename?: 'LifeInsurancePurchaseProcess', id: string } };

export type SendLifeInsurancePurchaseNotificationToSpecialistMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type SendLifeInsurancePurchaseNotificationToSpecialistMutation = { __typename?: 'Mutation', sendLifeInsurancePurchaseNotificationEmailToSpecialist: boolean };

export type DeleteLifeInsurancePurchaseProcessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLifeInsurancePurchaseProcessMutation = { __typename?: 'Mutation', deleteLifeInsurancePurchaseProcess: string };

export type MortgageCalculatorResultFragment = { __typename?: 'MortgageCalculatorResult', maxMortgageAmount: { __typename?: 'Money', amount: number, currency: string } };

export type MortgageCalculatorResultQueryVariables = Exact<{
  inquiry: MortgageCalculatorInquiryInput;
}>;


export type MortgageCalculatorResultQuery = { __typename?: 'Query', result: { __typename?: 'MortgageCalculatorResult', maxMortgageAmount: { __typename?: 'Money', amount: number, currency: string } } };

export type MortgageCalculatorCalculationsQueryVariables = Exact<{
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type MortgageCalculatorCalculationsQuery = { __typename?: 'Query', calculations: { __typename?: 'MortgageCalculatorCalculationsPage', totalItems: number, items: Array<{ __typename?: 'MortgageCalculatorCalculation', id: string, result: { __typename?: 'MortgageCalculatorResult', maxMortgageAmount: { __typename?: 'Money', amount: number, currency: string } } }> } };

export type MortgagePurchaseApplicantFragment = { __typename?: 'MortgagePurchaseApplicant', id: string, name: string, dateOfBirth: Date, familyStatus?: FamilyStatus | null, citizenship?: string | null, numberOfDependents?: number | null, incomes?: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDisabilityPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDoctoralScholarshipIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', expenseType?: EntrepreneurshipExpenseType | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null, taxBase?: { __typename?: 'Money', amount: number } | null, taxPayed?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', equityShares?: number | null, ceoCompensation?: { __typename?: 'Money', amount: number } | null, yearlyProfit?: { __typename?: 'Money', amount: number } | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOldAgePensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOrphanPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRealEstateRentalIncome', contractSignatureDate: Date, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRetirementPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantTravelCompensationIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWidowPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }> | null, liabilities?: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantCreditCardLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOverdraftLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } }> | null };

export type MortgagePurchaseInquiryFragment = { __typename?: 'MortgagePurchaseInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, numberOfCollaterals?: number | null, applicants?: Array<{ __typename?: 'MortgagePurchaseApplicant', id: string, name: string, dateOfBirth: Date, familyStatus?: FamilyStatus | null, citizenship?: string | null, numberOfDependents?: number | null, incomes?: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDisabilityPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDoctoralScholarshipIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', expenseType?: EntrepreneurshipExpenseType | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null, taxBase?: { __typename?: 'Money', amount: number } | null, taxPayed?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', equityShares?: number | null, ceoCompensation?: { __typename?: 'Money', amount: number } | null, yearlyProfit?: { __typename?: 'Money', amount: number } | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOldAgePensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOrphanPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRealEstateRentalIncome', contractSignatureDate: Date, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRetirementPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantTravelCompensationIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWidowPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }> | null, liabilities?: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantCreditCardLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOverdraftLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } }> | null }> | null, purpose?: { __typename?: 'MortgagePurpose', type?: MortgagePurposeType | null, typeOtherDescription?: string | null, mortgageAmount?: { __typename?: 'Money', amount: number } | null, property?: { __typename?: 'MortgageProperty', type?: MortgagePropertyType | null, size?: MortgagePropertySize | null, isChosen?: boolean | null, isDeveloperProject?: boolean | null, energyCertificateClassA?: boolean | null, price?: { __typename?: 'Money', amount: number } | null, sizeInterval?: { __typename?: 'IntInterval', upper?: number | null, lower?: number | null } | null } | null } | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, sameAsPurchasedProperty?: boolean | null, isInConstruction?: boolean | null, value?: { __typename?: 'Money', amount: number } | null }> | null };

export type AllMortgagePurchaseProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMortgagePurchaseProcessesQuery = { __typename?: 'Query', processes: { __typename?: 'MortgagePurchaseProcessPage', items: Array<{ __typename?: 'MortgagePurchaseProcess', id: string, updateTimestamp?: Date | null, creationTimestamp?: Date | null, inquiry?: { __typename?: 'MortgagePurchaseInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, numberOfCollaterals?: number | null, applicants?: Array<{ __typename?: 'MortgagePurchaseApplicant', id: string, name: string, dateOfBirth: Date, familyStatus?: FamilyStatus | null, citizenship?: string | null, numberOfDependents?: number | null, incomes?: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDisabilityPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDoctoralScholarshipIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', expenseType?: EntrepreneurshipExpenseType | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null, taxBase?: { __typename?: 'Money', amount: number } | null, taxPayed?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', equityShares?: number | null, ceoCompensation?: { __typename?: 'Money', amount: number } | null, yearlyProfit?: { __typename?: 'Money', amount: number } | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOldAgePensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOrphanPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRealEstateRentalIncome', contractSignatureDate: Date, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRetirementPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantTravelCompensationIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWidowPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }> | null, liabilities?: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantCreditCardLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOverdraftLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } }> | null }> | null, purpose?: { __typename?: 'MortgagePurpose', type?: MortgagePurposeType | null, typeOtherDescription?: string | null, mortgageAmount?: { __typename?: 'Money', amount: number } | null, property?: { __typename?: 'MortgageProperty', type?: MortgagePropertyType | null, size?: MortgagePropertySize | null, isChosen?: boolean | null, isDeveloperProject?: boolean | null, energyCertificateClassA?: boolean | null, price?: { __typename?: 'Money', amount: number } | null, sizeInterval?: { __typename?: 'IntInterval', upper?: number | null, lower?: number | null } | null } | null } | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, sameAsPurchasedProperty?: boolean | null, isInConstruction?: boolean | null, value?: { __typename?: 'Money', amount: number } | null }> | null } | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string } | null }> } };

export type MortgagePurchaseProcessQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MortgagePurchaseProcessQuery = { __typename?: 'Query', process: { __typename?: 'MortgagePurchaseProcess', id: string, updateTimestamp?: Date | null, locked?: boolean | null, acceptanceType?: MortgagePurchaseProcessAcceptanceType | null, inquiry?: { __typename?: 'MortgagePurchaseInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, numberOfCollaterals?: number | null, applicants?: Array<{ __typename?: 'MortgagePurchaseApplicant', id: string, name: string, dateOfBirth: Date, familyStatus?: FamilyStatus | null, citizenship?: string | null, numberOfDependents?: number | null, incomes?: Array<{ __typename?: 'ApplicantAlimonyIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDisabilityPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantDoctoralScholarshipIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantEntrepreneurshipIncome', expenseType?: EntrepreneurshipExpenseType | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null, taxBase?: { __typename?: 'Money', amount: number } | null, taxPayed?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantLtdIncome', equityShares?: number | null, ceoCompensation?: { __typename?: 'Money', amount: number } | null, yearlyProfit?: { __typename?: 'Money', amount: number } | null, yearlyRevenues?: { __typename?: 'Money', amount: number } | null } | { __typename?: 'ApplicantMaternityLeaveIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOldAgePensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOrphanPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherIncome', description?: string | null, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantParentalAllowanceIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRealEstateRentalIncome', contractSignatureDate: Date, monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantRetirementPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantSalaryIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantTravelCompensationIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWidowPensionIncome', monthlyIncome: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantWorkAgreementIncome', monthlyIncome: { __typename?: 'Money', amount: number } }> | null, liabilities?: Array<{ __typename?: 'ApplicantAlimonyLiability', monthlyInstallment: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantConsumerLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantCreditCardLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantLeaseLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantMortgageLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOtherLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantOverdraftLiability', limit: { __typename?: 'Money', amount: number } } | { __typename?: 'ApplicantReconstructionLoanLiability', monthlyInstallment: { __typename?: 'Money', amount: number }, balance: { __typename?: 'Money', amount: number } }> | null }> | null, purpose?: { __typename?: 'MortgagePurpose', type?: MortgagePurposeType | null, typeOtherDescription?: string | null, mortgageAmount?: { __typename?: 'Money', amount: number } | null, property?: { __typename?: 'MortgageProperty', type?: MortgagePropertyType | null, size?: MortgagePropertySize | null, isChosen?: boolean | null, isDeveloperProject?: boolean | null, energyCertificateClassA?: boolean | null, price?: { __typename?: 'Money', amount: number } | null, sizeInterval?: { __typename?: 'IntInterval', upper?: number | null, lower?: number | null } | null } | null } | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, sameAsPurchasedProperty?: boolean | null, isInConstruction?: boolean | null, value?: { __typename?: 'Money', amount: number } | null }> | null } | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string } | null } };

export type CreateMortgagePurchaseProcessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMortgagePurchaseProcessMutation = { __typename?: 'Mutation', createMortgagePurchaseProcess: { __typename?: 'MortgagePurchaseProcess', id: string, updateTimestamp?: Date | null } };

export type UpdateMortgagePurchaseProcessMutationVariables = Exact<{
  id: Scalars['ID'];
  inquiry: MortgagePurchaseInquiryInput;
}>;


export type UpdateMortgagePurchaseProcessMutation = { __typename?: 'Mutation', updateMortgagePurchaseProcess: { __typename?: 'MortgagePurchaseProcess', id: string, updateTimestamp?: Date | null } };

export type DeleteMortgagePurchaseProcessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMortgagePurchaseProcessMutation = { __typename?: 'Mutation', deleteMortgagePurchaseProcess: string };

export type AcceptedPurchaseProposalQueryVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type AcceptedPurchaseProposalQuery = { __typename?: 'Query', process: { __typename?: 'MortgagePurchaseProcess', id: string, locked?: boolean | null, acceptanceType?: MortgagePurchaseProcessAcceptanceType | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, interestRate: number, maturity: number, institutionAbbreviation: string, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null } };

export type SendMortgagePurchaseNotificationToSpecialistMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type SendMortgagePurchaseNotificationToSpecialistMutation = { __typename?: 'Mutation', sendMortgagePurchaseNotificationEmailToSpecialist: boolean };

export type NotificationFragment = { __typename?: 'Notification', id: string, creationTimestamp: Date, type: NotificationType, dueDate?: Date | null, readDate?: Date | null, stage?: number | null, details?: { __typename?: 'CalendarEventNotificationDetails', calendarEvent: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } } | { __typename?: 'NordigenConsentExpirationNotificationDetails', nordigenConnection: { __typename?: 'NordigenConnection', institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, accounts: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }> } } | { __typename?: 'ProductNotificationDetails', productId: string, productType: FinancialProductType } | null };

export type NotificationsQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationPage', totalItems: number, items: Array<{ __typename?: 'Notification', id: string, creationTimestamp: Date, type: NotificationType, dueDate?: Date | null, readDate?: Date | null, stage?: number | null, details?: { __typename?: 'CalendarEventNotificationDetails', calendarEvent: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } } | { __typename?: 'NordigenConsentExpirationNotificationDetails', nordigenConnection: { __typename?: 'NordigenConnection', institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, accounts: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }> } } | { __typename?: 'ProductNotificationDetails', productId: string, productType: FinancialProductType } | null }> } | null };

export type NotificationsCountQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type NotificationsCountQuery = { __typename?: 'Query', notificationsCount?: { __typename?: 'NotificationPage', totalItems: number } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['ID'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'Notification', id: string, creationTimestamp: Date, type: NotificationType, dueDate?: Date | null, readDate?: Date | null, stage?: number | null, details?: { __typename?: 'CalendarEventNotificationDetails', calendarEvent: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } } | { __typename?: 'NordigenConsentExpirationNotificationDetails', nordigenConnection: { __typename?: 'NordigenConnection', institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, accounts: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }> } } | { __typename?: 'ProductNotificationDetails', productId: string, productType: FinancialProductType } | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: Array<{ __typename?: 'Notification', id: string, creationTimestamp: Date, type: NotificationType, dueDate?: Date | null, readDate?: Date | null, stage?: number | null, details?: { __typename?: 'CalendarEventNotificationDetails', calendarEvent: { __typename?: 'CalendarEvent', id: string, type: CalendarEventType, name?: string | null, startDate: Date, recurrenceRule?: string | null, productId?: string | null, productType?: FinancialProductType | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null } } | { __typename?: 'NordigenConsentExpirationNotificationDetails', nordigenConnection: { __typename?: 'NordigenConnection', institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, accounts: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }> } } | { __typename?: 'ProductNotificationDetails', productId: string, productType: FinancialProductType } | null }> };

export type DeactivateNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID'];
}>;


export type DeactivateNotificationMutation = { __typename?: 'Mutation', deactivateNotification: string };

export type BuildingSavingsProductFragment = { __typename?: 'BuildingSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type BuildingSavingsProductListItemFragment = { __typename?: 'BuildingSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type BuildingSavingsProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type BuildingSavingsProductsQuery = { __typename?: 'Query', products: { __typename?: 'BuildingSavingsProductPage', items: Array<{ __typename?: 'BuildingSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type BuildingSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BuildingSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'BuildingSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateBuildingSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: BuildingSavingsProductInput;
}>;


export type UpdateBuildingSavingsProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'BuildingSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateBuildingSavingsProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateBuildingSavingsProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'BuildingSavingsProduct', id: string } };

export type DeleteBuildingSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBuildingSavingsProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateBuildingSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateBuildingSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type CollisionInsuranceRiskFragment = { __typename?: 'CollisionInsuranceRisk', id: string, type?: CollisionInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null };

export type CollisionInsuranceProductFragment = { __typename?: 'CollisionInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, insuranceRisks?: Array<{ __typename?: 'CollisionInsuranceRisk', id: string, type?: CollisionInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type CollisionInsuranceProductListItemFragment = { __typename?: 'CollisionInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type CollisionInsuranceProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollisionInsuranceProductsQuery = { __typename?: 'Query', products: { __typename?: 'CollisionInsuranceProductPage', items: Array<{ __typename?: 'CollisionInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type CollisionInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CollisionInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'CollisionInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, insuranceRisks?: Array<{ __typename?: 'CollisionInsuranceRisk', id: string, type?: CollisionInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateCollisionInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: CollisionInsuranceProductInput;
}>;


export type UpdateCollisionInsuranceProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'CollisionInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, insuranceRisks?: Array<{ __typename?: 'CollisionInsuranceRisk', id: string, type?: CollisionInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateCollisionInsuranceProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCollisionInsuranceProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'CollisionInsuranceProduct', id: string } };

export type DeleteCollisionInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCollisionInsuranceProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateCollisionInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateCollisionInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type CreditCardProductFragment = { __typename?: 'CreditCardProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, regularUsage?: boolean | null, owedAmountPaidByMaturity?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, limitAmount?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type CreditCardProductListItemFragment = { __typename?: 'CreditCardProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type CreditCardProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditCardProductsQuery = { __typename?: 'Query', products: { __typename?: 'CreditCardProductPage', items: Array<{ __typename?: 'CreditCardProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type CreditCardProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreditCardProductQuery = { __typename?: 'Query', detail: { __typename?: 'CreditCardProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, regularUsage?: boolean | null, owedAmountPaidByMaturity?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, limitAmount?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateCreditCardProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: CreditCardProductInput;
}>;


export type UpdateCreditCardProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'CreditCardProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, regularUsage?: boolean | null, owedAmountPaidByMaturity?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, limitAmount?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateCreditCardProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCreditCardProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'CreditCardProduct', id: string } };

export type DeleteCreditCardProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCreditCardProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateCreditCardProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateCreditCardProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type GenericProductFragment = { __typename?: 'GenericProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type GenericProductListItemFragment = { __typename?: 'GenericProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type GenericProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GenericProductsQuery = { __typename?: 'Query', products: { __typename?: 'GenericProductPage', items: Array<{ __typename?: 'GenericProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type GenericProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenericProductQuery = { __typename?: 'Query', detail: { __typename?: 'GenericProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateGenericProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: GenericProductInput;
}>;


export type UpdateGenericProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'GenericProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateGenericProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGenericProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'GenericProduct', id: string } };

export type DeleteGenericProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGenericProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateGenericProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateGenericProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type GenericInsuranceProductFragment = { __typename?: 'GenericInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type GenericInsuranceProductListItemFragment = { __typename?: 'GenericInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type GenericInsuranceProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GenericInsuranceProductsQuery = { __typename?: 'Query', products: { __typename?: 'GenericInsuranceProductPage', items: Array<{ __typename?: 'GenericInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type GenericInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GenericInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'GenericInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateGenericInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: GenericInsuranceProductInput;
}>;


export type UpdateGenericInsuranceProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'GenericInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateGenericInsuranceProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateGenericInsuranceProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'GenericInsuranceProduct', id: string } };

export type DeleteGenericInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGenericInsuranceProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateGenericInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateGenericInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type InvestmentProductFragment = { __typename?: 'InvestmentProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialInstrument?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, amountInvested?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type InvestmentProductListItemFragment = { __typename?: 'InvestmentProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type InvestmentProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvestmentProductsQuery = { __typename?: 'Query', products: { __typename?: 'InvestmentProductPage', items: Array<{ __typename?: 'InvestmentProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type InvestmentProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InvestmentProductQuery = { __typename?: 'Query', detail: { __typename?: 'InvestmentProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialInstrument?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, amountInvested?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateInvestmentProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: InvestmentProductInput;
}>;


export type UpdateInvestmentProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'InvestmentProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialInstrument?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, amountInvested?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateInvestmentProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateInvestmentProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'InvestmentProduct', id: string } };

export type DeleteInvestmentProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInvestmentProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateInvestmentProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateInvestmentProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type LifeInsuranceProductFragment = { __typename?: 'LifeInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, applicants: Array<{ __typename?: 'LifeInsuranceApplicant', id: string, name: string, surname: string, isInsured: boolean, isInsuring: boolean, insurance?: { __typename?: 'LifeInsuranceInsurance', insuranceRisks: Array<{ __typename?: 'LifeInsuranceInsuranceRisk', id: string, type?: LifeInsuranceInsuranceRiskType | null, name?: string | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null }> } | null }>, surrenderValue?: { __typename?: 'Money', amount: number, currency: string } | null, savings?: { __typename?: 'LifeInsuranceSavings', amount?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type LifeInsuranceProductListItemFragment = { __typename?: 'LifeInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type LifeInsuranceProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type LifeInsuranceProductsQuery = { __typename?: 'Query', products: { __typename?: 'LifeInsuranceProductPage', items: Array<{ __typename?: 'LifeInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type LifeInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LifeInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'LifeInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, applicants: Array<{ __typename?: 'LifeInsuranceApplicant', id: string, name: string, surname: string, isInsured: boolean, isInsuring: boolean, insurance?: { __typename?: 'LifeInsuranceInsurance', insuranceRisks: Array<{ __typename?: 'LifeInsuranceInsuranceRisk', id: string, type?: LifeInsuranceInsuranceRiskType | null, name?: string | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null }> } | null }>, surrenderValue?: { __typename?: 'Money', amount: number, currency: string } | null, savings?: { __typename?: 'LifeInsuranceSavings', amount?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateLifeInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: LifeInsuranceProductInput;
}>;


export type UpdateLifeInsuranceProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'LifeInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, applicants: Array<{ __typename?: 'LifeInsuranceApplicant', id: string, name: string, surname: string, isInsured: boolean, isInsuring: boolean, insurance?: { __typename?: 'LifeInsuranceInsurance', insuranceRisks: Array<{ __typename?: 'LifeInsuranceInsuranceRisk', id: string, type?: LifeInsuranceInsuranceRiskType | null, name?: string | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null }> } | null }>, surrenderValue?: { __typename?: 'Money', amount: number, currency: string } | null, savings?: { __typename?: 'LifeInsuranceSavings', amount?: { __typename?: 'Money', amount: number, currency: string } | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateLifeInsuranceProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLifeInsuranceProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'LifeInsuranceProduct', id: string } };

export type DeleteLifeInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLifeInsuranceProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateLifeInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateLifeInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type LoanProductFragment = { __typename?: 'LoanProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type LoanProductListItemFragment = { __typename?: 'LoanProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type LoanProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanProductsQuery = { __typename?: 'Query', products: { __typename?: 'LoanProductPage', items: Array<{ __typename?: 'LoanProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type LoanProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoanProductQuery = { __typename?: 'Query', detail: { __typename?: 'LoanProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateLoanProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: LoanProductInput;
}>;


export type UpdateLoanProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'LoanProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateLoanProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLoanProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'LoanProduct', id: string } };

export type DeleteLoanProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLoanProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateLoanProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateLoanProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type MortgageProductFragment = { __typename?: 'MortgageProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, collaterals: Array<{ __typename?: 'MortgageCollateral', address?: string | null }>, purchasedProperty?: { __typename?: 'MortgageProperty', address?: string | null } | null, participants: Array<{ __typename?: 'MortgageParticipant', name?: string | null }>, documents: Array<{ __typename?: 'Document', id: string, type: DocumentType, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type MortgageProductListItemFragment = { __typename?: 'MortgageProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, fixationEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type MortgageProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type MortgageProductsQuery = { __typename?: 'Query', products: { __typename?: 'MortgageProductPage', items: Array<{ __typename?: 'MortgageProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, fixationEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type MortgageProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MortgageProductQuery = { __typename?: 'Query', detail: { __typename?: 'MortgageProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, collaterals: Array<{ __typename?: 'MortgageCollateral', address?: string | null }>, purchasedProperty?: { __typename?: 'MortgageProperty', address?: string | null } | null, participants: Array<{ __typename?: 'MortgageParticipant', name?: string | null }>, documents: Array<{ __typename?: 'Document', id: string, type: DocumentType, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateMortgageProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: MortgageProductInput;
}>;


export type UpdateMortgageProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'MortgageProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, interestRate?: number | null, annualPercentageRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, amount?: { __typename?: 'Money', amount: number, currency: string } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, collaterals: Array<{ __typename?: 'MortgageCollateral', address?: string | null }>, purchasedProperty?: { __typename?: 'MortgageProperty', address?: string | null } | null, participants: Array<{ __typename?: 'MortgageParticipant', name?: string | null }>, documents: Array<{ __typename?: 'Document', id: string, type: DocumentType, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateMortgageProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMortgageProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'MortgageProduct', id: string } };

export type DeleteMortgageProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMortgageProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateMortgageProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateMortgageProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type MotorLiabilityInsuranceProductFragment = { __typename?: 'MotorLiabilityInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type MotorLiabilityInsuranceProductListItemFragment = { __typename?: 'MotorLiabilityInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type MotorLiabilityInsuranceProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type MotorLiabilityInsuranceProductsQuery = { __typename?: 'Query', products: { __typename?: 'MotorLiabilityInsuranceProductPage', items: Array<{ __typename?: 'MotorLiabilityInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type MotorLiabilityInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MotorLiabilityInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'MotorLiabilityInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateMotorLiabilityInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: MotorLiabilityInsuranceProductInput;
}>;


export type UpdateMotorLiabilityInsuranceProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'MotorLiabilityInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, vehicleInfo?: { __typename?: 'VehicleInfo', type?: VehicleType | null, manufactureYear?: number | null, licenseNumber?: string | null, owner?: { __typename?: 'VehicleOwner', dateOfBirth?: Date | null, postalCode?: string | null, yearOfLastCollision?: number | null, numberOfRecentCollisions?: number | null } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', type?: InsuringPersonType | null, name?: string | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateMotorLiabilityInsuranceProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMotorLiabilityInsuranceProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'MotorLiabilityInsuranceProduct', id: string } };

export type DeleteMotorLiabilityInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMotorLiabilityInsuranceProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateMotorLiabilityInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateMotorLiabilityInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type UpdateProductTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  productType: FinancialProductType;
  newProductType: FinancialProductType;
}>;


export type UpdateProductTypeMutation = { __typename?: 'Mutation', updateProductType: string };

export type PropertyInsuranceProductFragment = { __typename?: 'PropertyInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', name?: string | null, surname?: string | null } | null, insuredProperty?: { __typename?: 'PropertyInsuranceInsuredProperty', type?: PropertyInsuranceInsuredPropertyType | null, address?: string | null, propertyValue?: { __typename?: 'Money', amount: number, currency: string } | null, householdValue?: { __typename?: 'Money', amount: number, currency: string } | null } | null, basicInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, otherInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type PropertyInsuranceProductListItemFragment = { __typename?: 'PropertyInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type PropertyInsuranceProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyInsuranceProductsQuery = { __typename?: 'Query', products: { __typename?: 'PropertyInsuranceProductPage', items: Array<{ __typename?: 'PropertyInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type PropertyInsuranceProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyInsuranceProductQuery = { __typename?: 'Query', detail: { __typename?: 'PropertyInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', name?: string | null, surname?: string | null } | null, insuredProperty?: { __typename?: 'PropertyInsuranceInsuredProperty', type?: PropertyInsuranceInsuredPropertyType | null, address?: string | null, propertyValue?: { __typename?: 'Money', amount: number, currency: string } | null, householdValue?: { __typename?: 'Money', amount: number, currency: string } | null } | null, basicInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, otherInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdatePropertyInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: PropertyInsuranceProductInput;
}>;


export type UpdatePropertyInsuranceProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'PropertyInsuranceProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, insuringPerson?: { __typename?: 'InsuringPerson', name?: string | null, surname?: string | null } | null, insuredProperty?: { __typename?: 'PropertyInsuranceInsuredProperty', type?: PropertyInsuranceInsuredPropertyType | null, address?: string | null, propertyValue?: { __typename?: 'Money', amount: number, currency: string } | null, householdValue?: { __typename?: 'Money', amount: number, currency: string } | null } | null, basicInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, otherInsurances: Array<{ __typename?: 'PropertyInsuranceInsurance', id: string, type?: PropertyInsuranceInsuranceType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null, insuranceRisks: Array<{ __typename?: 'PropertyInsuranceInsuranceRisk', id: string, type?: PropertyInsuranceInsuranceRiskType | null, name?: string | null, insuredSum?: { __typename?: 'Money', amount: number, currency: string } | null, annualCost?: { __typename?: 'Money', amount: number, currency: string } | null }> }>, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreatePropertyInsuranceProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePropertyInsuranceProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'PropertyInsuranceProduct', id: string } };

export type DeletePropertyInsuranceProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePropertyInsuranceProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreatePropertyInsuranceProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreatePropertyInsuranceProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type RetirementPensionSavingsProductFragment = { __typename?: 'RetirementPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, voluntaryContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type RetirementPensionSavingsProductListItemFragment = { __typename?: 'RetirementPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type RetirementPensionSavingsProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type RetirementPensionSavingsProductsQuery = { __typename?: 'Query', products: { __typename?: 'RetirementPensionSavingsProductPage', items: Array<{ __typename?: 'RetirementPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type RetirementPensionSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RetirementPensionSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'RetirementPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, voluntaryContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateRetirementPensionSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: RetirementPensionSavingsProductInput;
}>;


export type UpdateRetirementPensionSavingsProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'RetirementPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, voluntaryContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateRetirementPensionSavingsProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateRetirementPensionSavingsProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'RetirementPensionSavingsProduct', id: string } };

export type DeleteRetirementPensionSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRetirementPensionSavingsProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateRetirementPensionSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateRetirementPensionSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type SavingsProductFragment = { __typename?: 'SavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type SavingsProductListItemFragment = { __typename?: 'SavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type SavingsProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavingsProductsQuery = { __typename?: 'Query', products: { __typename?: 'SavingsProductPage', items: Array<{ __typename?: 'SavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type SavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'SavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: SavingsProductInput;
}>;


export type UpdateSavingsProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'SavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateSavingsProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSavingsProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'SavingsProduct', id: string } };

export type DeleteSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSavingsProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type SupplementaryPensionSavingsProductFragment = { __typename?: 'SupplementaryPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, possibleEmployerContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, employerContribution?: { __typename?: 'Money', amount: number, currency: string } | null, employeeContribution?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type SupplementaryPensionSavingsProductListItemFragment = { __typename?: 'SupplementaryPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> };

export type SupplementaryPensionSavingsProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplementaryPensionSavingsProductsQuery = { __typename?: 'Query', products: { __typename?: 'SupplementaryPensionSavingsProductPage', items: Array<{ __typename?: 'SupplementaryPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractEndDate?: Date | null, institutionName?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> }> } };

export type SupplementaryPensionSavingsProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SupplementaryPensionSavingsProductQuery = { __typename?: 'Query', detail: { __typename?: 'SupplementaryPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, possibleEmployerContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, employerContribution?: { __typename?: 'Money', amount: number, currency: string } | null, employeeContribution?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type UpdateSupplementaryPensionSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updatedProduct: SupplementaryPensionSavingsProductInput;
}>;


export type UpdateSupplementaryPensionSavingsProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'SupplementaryPensionSavingsProduct', id: string, name?: string | null, creationTimestamp: Date, status: ProductStatus, statusChangeDate: Date, enableNotifications: boolean, enableFinancialAdvisorCare: boolean, contractNumber?: string | null, contractSignDate?: Date | null, contractEndDate?: Date | null, institutionName?: string | null, guaranteedFund?: boolean | null, nonGuaranteedFund?: boolean | null, possibleEmployerContribution?: boolean | null, financialDetailsUpdatedAt?: Date | null, note?: string | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, paymentInfo?: { __typename?: 'PaymentInfo', ibanForPayment?: string | null, variableSymbol?: string | null, constantSymbol?: string | null, specificSymbol?: string | null } | null, paymentPeriod?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, expectedDate?: Date | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, currentMarketValue?: { __typename?: 'Money', amount: number, currency: string } | null, employerContribution?: { __typename?: 'Money', amount: number, currency: string } | null, employeeContribution?: { __typename?: 'Money', amount: number, currency: string } | null, documents: Array<{ __typename?: 'Document', id: string, files: Array<{ __typename?: 'File', id: string, name?: string | null }> }> } };

export type CreateSupplementaryPensionSavingsProductMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSupplementaryPensionSavingsProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'SupplementaryPensionSavingsProduct', id: string } };

export type DeleteSupplementaryPensionSavingsProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSupplementaryPensionSavingsProductMutation = { __typename?: 'Mutation', deleteProduct: string };

export type CreateSupplementaryPensionSavingsProductDocumentMutationVariables = Exact<{
  productId: Scalars['ID'];
  document: DocumentInput;
}>;


export type CreateSupplementaryPensionSavingsProductDocumentMutation = { __typename?: 'Mutation', createProductDocument: { __typename?: 'Document', id: string } };

export type MortgageRefinanceApplicantFragment = { __typename?: 'MortgageRefinanceApplicant', id: string, incomeType: MortgageIncomeType, dateOfBirth: Date, incomeCommencementDate?: Date | null, name: string };

export type MortgageRefinanceInquiryFragment = { __typename?: 'MortgageRefinanceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, applicants?: Array<{ __typename?: 'MortgageRefinanceApplicant', id: string, incomeType: MortgageIncomeType, dateOfBirth: Date, incomeCommencementDate?: Date | null, name: string }> | null, currentSetup?: { __typename?: 'MortgageCurrentSetup', interestRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, isNewFixationProposed?: boolean | null, numberOfCollaterals?: number | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, value?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, installment?: { __typename?: 'Money', amount: number, currency: string } | null, newProposedFixation?: { __typename?: 'NewProposedFixation', newInterestRate?: number | null, newInstallment?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null };

export type MortgageRefinanceProcessQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MortgageRefinanceProcessQuery = { __typename?: 'Query', process: { __typename?: 'MortgageRefinanceProcess', id: string, updateTimestamp?: Date | null, inquiry?: { __typename?: 'MortgageRefinanceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, applicants?: Array<{ __typename?: 'MortgageRefinanceApplicant', id: string, incomeType: MortgageIncomeType, dateOfBirth: Date, incomeCommencementDate?: Date | null, name: string }> | null, currentSetup?: { __typename?: 'MortgageCurrentSetup', interestRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, isNewFixationProposed?: boolean | null, numberOfCollaterals?: number | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, value?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, installment?: { __typename?: 'Money', amount: number, currency: string } | null, newProposedFixation?: { __typename?: 'NewProposedFixation', newInterestRate?: number | null, newInstallment?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null } | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string } | null } };

export type AllMortgageRefinanceProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMortgageRefinanceProcessesQuery = { __typename?: 'Query', processes: { __typename?: 'MortgageRefinanceProcessPage', items: Array<{ __typename?: 'MortgageRefinanceProcess', id: string, updateTimestamp?: Date | null, creationTimestamp?: Date | null, inquiry?: { __typename?: 'MortgageRefinanceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, applicants?: Array<{ __typename?: 'MortgageRefinanceApplicant', id: string, incomeType: MortgageIncomeType, dateOfBirth: Date, incomeCommencementDate?: Date | null, name: string }> | null, currentSetup?: { __typename?: 'MortgageCurrentSetup', interestRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, isNewFixationProposed?: boolean | null, numberOfCollaterals?: number | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, value?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, installment?: { __typename?: 'Money', amount: number, currency: string } | null, newProposedFixation?: { __typename?: 'NewProposedFixation', newInterestRate?: number | null, newInstallment?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null } | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string } | null }> } };

export type CreateMortgageRefinanceProcessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateMortgageRefinanceProcessMutation = { __typename?: 'Mutation', createMortgageRefinanceProcess: { __typename?: 'MortgageRefinanceProcess', id: string, updateTimestamp?: Date | null } };

export type UpdateMortgageRefinanceProcessMutationVariables = Exact<{
  id: Scalars['ID'];
  inquiry: MortgageRefinanceInquiryInput;
}>;


export type UpdateMortgageRefinanceProcessMutation = { __typename?: 'Mutation', updateMortgageRefinanceProcess: { __typename?: 'MortgageRefinanceProcess', id: string, updateTimestamp?: Date | null } };

export type MortgageRefinanceTuningLimitsByProcessIdQueryVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type MortgageRefinanceTuningLimitsByProcessIdQuery = { __typename?: 'Query', limits: { __typename?: 'MortgageRefinanceTuningLimits', fixationDefault: number, fixationOptions?: Array<number> | null, maturityInYearsDefault: number, maturityInYearsRange: { __typename?: 'IntInterval', lower?: number | null, upper?: number | null } } };

export type MortgageRefinanceTuningLimitsByInquiryQueryVariables = Exact<{
  inquiry: MortgageRefinanceInquiryInput;
}>;


export type MortgageRefinanceTuningLimitsByInquiryQuery = { __typename?: 'Query', limits: { __typename?: 'MortgageRefinanceTuningLimits', fixationDefault: number, fixationOptions?: Array<number> | null, maturityInYearsDefault: number, maturityInYearsRange: { __typename?: 'IntInterval', lower?: number | null, upper?: number | null } } };

export type MortgageRefinanceProposalFragment = { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null };

export type MortgageRefinanceStrategyResultFragment = { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null };

export type CalculateMortgageRefinanceResultByProcessIdMutationVariables = Exact<{
  processId: Scalars['ID'];
  tuning: MortgageRefinanceTuningInput;
}>;


export type CalculateMortgageRefinanceResultByProcessIdMutation = { __typename?: 'Mutation', proposals: { __typename?: 'MortgageRefinanceResult', id: string, currentMortgageInFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, minimizingOverpaymentResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null }, customStrategyResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null }, preservingCurrentInstallmentResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null } } };

export type CalculateMortgageRefinanceResultByInquiryQueryVariables = Exact<{
  inquiry: MortgageRefinanceInquiryInput;
}>;


export type CalculateMortgageRefinanceResultByInquiryQuery = { __typename?: 'Query', proposals: { __typename?: 'MortgageRefinanceResult', id: string, currentMortgageInFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, minimizingOverpaymentResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null }, customStrategyResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null }, preservingCurrentInstallmentResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null } } };

export type MortgageRefinanceResultQueryVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type MortgageRefinanceResultQuery = { __typename?: 'Query', proposals: { __typename?: 'MortgageRefinanceResult', id: string, currentMortgageInFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, minimizingOverpaymentResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null }, customStrategyResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null }, preservingCurrentInstallmentResult: { __typename?: 'MortgageRefinanceStrategyResult', id: string, currentMortgageAfterFixationPeriod?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, proposals: Array<{ __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null }>, changeInOverpayment?: { __typename?: 'Money', amount: number, currency: string } | null } } };

export type SelectMortgageRefinanceProposalMutationVariables = Exact<{
  processId: Scalars['ID'];
  refinanceProposalId: Scalars['ID'];
}>;


export type SelectMortgageRefinanceProposalMutation = { __typename?: 'Mutation', proposal: { __typename?: 'MortgageRefinanceProcess', id: string, acceptedTimestamp?: Date | null, creationTimestamp?: Date | null, updateTimestamp?: Date | null, acceptedProposal?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null, inquiry?: { __typename?: 'MortgageRefinanceInquiry', id: string, inquiryCurrentStepUrl?: string | null, inquiryProgress?: number | null, numberOfApplicants?: number | null, applicants?: Array<{ __typename?: 'MortgageRefinanceApplicant', id: string, incomeType: MortgageIncomeType, dateOfBirth: Date, incomeCommencementDate?: Date | null, name: string }> | null, currentSetup?: { __typename?: 'MortgageCurrentSetup', interestRate?: number | null, fixationEndDate?: Date | null, fixationLength?: number | null, isNewFixationProposed?: boolean | null, numberOfCollaterals?: number | null, collaterals?: Array<{ __typename?: 'MortgageCollateral', type?: MortgageCollateralType | null, location?: string | null, value?: { __typename?: 'Money', amount: number, currency: string } | null }> | null, institution?: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean } | null, balance?: { __typename?: 'Money', amount: number, currency: string } | null, installment?: { __typename?: 'Money', amount: number, currency: string } | null, newProposedFixation?: { __typename?: 'NewProposedFixation', newInterestRate?: number | null, newInstallment?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null } | null } };

export type AcceptedRefinanceProposalQueryVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type AcceptedRefinanceProposalQuery = { __typename?: 'Query', process: { __typename?: 'MortgageRefinanceProcess', id: string, acceptedProposal?: { __typename?: 'MortgageProposal', id: string, fixationLength: number, maturity: number, incomeVerification?: boolean | null, interestRate: number, institutionAbbreviation: string, installmentChange?: { __typename?: 'Money', amount: number, currency: string } | null, amount: { __typename?: 'Money', amount: number, currency: string }, installment: { __typename?: 'Money', amount: number, currency: string }, overpaymentInFixationPeriod: { __typename?: 'Money', amount: number, currency: string }, fees?: { __typename?: 'MortgageProposalFees', provision: { __typename?: 'Money', amount: number, currency: string }, monthlyAccountManagement: { __typename?: 'Money', amount: number, currency: string }, monthlyMortgageInsurance: { __typename?: 'Money', amount: number, currency: string }, annualPropertyInsurance: { __typename?: 'Money', amount: number, currency: string } } | null } | null } };

export type SendMortgageRefinanceNotificationToSpecialistMutationVariables = Exact<{
  processId: Scalars['ID'];
}>;


export type SendMortgageRefinanceNotificationToSpecialistMutation = { __typename?: 'Mutation', sendMortgageRefinanceNotificationEmailToSpecialist: boolean };

export type DeleteMortgageRefinanceProcessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMortgageRefinanceProcessMutation = { __typename?: 'Mutation', deleteMortgageRefinanceProcess: string };

export type ReportFragment = { __typename?: 'Report', id: string, creationTimestamp: Date, type: ReportType, file: { __typename?: 'File', id: string, name?: string | null } };

export type CreateReportMutationVariables = Exact<{
  reportType: ReportType;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string, creationTimestamp: Date, type: ReportType, file: { __typename?: 'File', id: string, name?: string | null } } };

export type ReportsQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  sortInput?: InputMaybe<SortInput>;
}>;


export type ReportsQuery = { __typename?: 'Query', reports: { __typename?: 'ReportPage', totalItems: number, items: Array<{ __typename?: 'Report', id: string, creationTimestamp: Date, type: ReportType, file: { __typename?: 'File', id: string, name?: string | null } }> } };

export type RequestContactMutationVariables = Exact<{
  userInfo: UserInfo;
  context: RequestContactContext;
  text: Scalars['String'];
}>;


export type RequestContactMutation = { __typename?: 'Mutation', requestContact: boolean };

export type RequestContactAuthenticatedMutationVariables = Exact<{
  context: RequestContactContext;
  text: Scalars['String'];
}>;


export type RequestContactAuthenticatedMutation = { __typename?: 'Mutation', requestContactFromAuthenticatedUser: boolean };

type TransactionAggregateKey_Account_Fragment = { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null };

type TransactionAggregateKey_DateKey_Fragment = { __typename?: 'DateKey', startDate: Date, granularity: DateGranularity };

type TransactionAggregateKey_TransactionCategory_Fragment = { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } };

type TransactionAggregateKey_TransactionTag_Fragment = { __typename?: 'TransactionTag', id: string, name: string };

export type TransactionAggregateKeyFragment = TransactionAggregateKey_Account_Fragment | TransactionAggregateKey_DateKey_Fragment | TransactionAggregateKey_TransactionCategory_Fragment | TransactionAggregateKey_TransactionTag_Fragment;

export type TransactionAggregationValueFragment = { __typename?: 'TransactionAggregationValue', count: number, key: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null } | { __typename?: 'DateKey', startDate: Date, granularity: DateGranularity } | { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } } | { __typename?: 'TransactionTag', id: string, name: string }>, sum: { __typename?: 'Money', amount: number, currency: string } };

export type AggregateTransactionsQueryVariables = Exact<{
  groupBy?: InputMaybe<Array<TransactionAttribute> | TransactionAttribute>;
  filterInput?: InputMaybe<FilterInput>;
}>;


export type AggregateTransactionsQuery = { __typename?: 'Query', aggregateTransactions: { __typename?: 'TransactionAggregationResult', baseCurrency: string, resultData: Array<{ __typename?: 'TransactionAggregationValue', count: number, key: Array<{ __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null } | { __typename?: 'DateKey', startDate: Date, granularity: DateGranularity } | { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } } | { __typename?: 'TransactionTag', id: string, name: string }>, sum: { __typename?: 'Money', amount: number, currency: string } }> } };

export type TransactionTagFragment = { __typename?: 'TransactionTag', id: string, name: string };

export type TransactionTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionTagsQuery = { __typename?: 'Query', tags: { __typename?: 'TransactionTagPage', items: Array<{ __typename?: 'TransactionTag', id: string, name: string }> } };

export type CreateTagMutationVariables = Exact<{
  tag: TransactionTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTransactionTag: { __typename?: 'TransactionTag', id: string, name: string } };

export type DeleteTagMutationVariables = Exact<{
  tagId: Scalars['ID'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTransactionTag: string };

export type RenameTagMutationVariables = Exact<{
  tagId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type RenameTagMutation = { __typename?: 'Mutation', renameTransactionTag: { __typename?: 'TransactionTag', id: string, name: string } };

export type AddTagsToTransactionsMutationVariables = Exact<{
  transactionIds: Array<Scalars['ID']> | Scalars['ID'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddTagsToTransactionsMutation = { __typename?: 'Mutation', addTagsToTransactions: Array<{ __typename?: 'Transaction', id: string, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }> }> };

export type RemoveTagsFromTransactionsMutationVariables = Exact<{
  transactionIds: Array<Scalars['ID']> | Scalars['ID'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveTagsFromTransactionsMutation = { __typename?: 'Mutation', removeTagsFromTransactions: Array<{ __typename?: 'Transaction', id: string, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }> }> };

export type TransactionCategoryGroupFragment = { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string };

export type TransactionCategoryFragment = { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } };

export type TransactionDetailFragment = { __typename?: 'Transaction', id: string, bookingDate: Date, transactionTypeCode: TransactionTypeCode, variableSymbol?: string | null, specificSymbol?: string | null, constantSymbol?: string | null, messageForRecipient?: string | null, note?: string | null, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, category: { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, streamGroup?: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null };

export type TransactionDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TransactionDetailQuery = { __typename?: 'Query', detail?: { __typename?: 'Transaction', id: string, bookingDate: Date, transactionTypeCode: TransactionTypeCode, variableSymbol?: string | null, specificSymbol?: string | null, constantSymbol?: string | null, messageForRecipient?: string | null, note?: string | null, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, category: { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, streamGroup?: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null } | null };

export type TransactionCategoryGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionCategoryGroupsQuery = { __typename?: 'Query', page: { __typename?: 'TransactionsCategoryGroupPage', items: Array<{ __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string }> } };

export type TransactionCategoriesQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
}>;


export type TransactionCategoriesQuery = { __typename?: 'Query', page: { __typename?: 'TransactionsCategoryPage', items: Array<{ __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } }> } };

export type TransactionCounterpartiesQueryVariables = Exact<{
  filterInput?: InputMaybe<FilterInput>;
  pageInput?: InputMaybe<PageInput>;
}>;


export type TransactionCounterpartiesQuery = { __typename?: 'Query', page?: { __typename?: 'TransactionCounterpartyPage', items: Array<{ __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null }> } | null };

export type TransactionListItemFragment = { __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null };

export type TransactionsQueryVariables = Exact<{
  pageInput?: InputMaybe<PageInput>;
  sortInput?: InputMaybe<SortInput>;
  filterInput?: InputMaybe<FilterInput>;
}>;


export type TransactionsQuery = { __typename?: 'Query', transactionsList: { __typename?: 'TransactionsPage', totalItems: number, pageIndex: number, pageSize: number, items: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }> } };

export type UpdateTransactionsMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']>;
  transactionIds: Array<Scalars['ID']> | Scalars['ID'];
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateTransactionsMutation = { __typename?: 'Mutation', updateTransactions: Array<{ __typename?: 'Transaction', id: string, bookingDate: Date, transactionTypeCode: TransactionTypeCode, variableSymbol?: string | null, specificSymbol?: string | null, constantSymbol?: string | null, messageForRecipient?: string | null, note?: string | null, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, category: { __typename?: 'TransactionCategory', id: string, code: string, isActive: boolean, categoryName: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string, isActive: boolean } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, streamGroup?: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null } | null }> };

export type TransactionGroupFragment = { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null };

export type UpdateTransactionGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  categoryId?: InputMaybe<Scalars['ID']>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateTransactionGroupMutation = { __typename?: 'Mutation', updateTransactionGroup: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null } };

export type RemovePeriodFromTransactionGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type RemovePeriodFromTransactionGroupMutation = { __typename?: 'Mutation', removePeriodFromTransactionGroup: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null } };

export type UpdatePeriodOfTransactionGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  period: TransactionPeriodInput;
}>;


export type UpdatePeriodOfTransactionGroupMutation = { __typename?: 'Mutation', updatePeriodOfTransactionGroup: { __typename?: 'TransactionGroup', id: string, groupTypeCode: TransactionGroupTypeCode, excludeFromAnalytics: boolean, transactions: Array<{ __typename?: 'Transaction', id: string, note?: string | null, bookingDate: Date, transactionTypeCode: TransactionTypeCode, excludeFromAnalytics: boolean, amount: { __typename?: 'Money', amount: number, currency: string }, category: { __typename?: 'TransactionCategory', id: string, name: string, categoryGroup: { __typename?: 'TransactionCategoryGroup', id: string, code: string, name: string } }, tags: Array<{ __typename?: 'TransactionTag', id: string, name: string }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, streamGroup?: { __typename?: 'TransactionGroup', id: string, period?: { __typename?: 'TransactionPeriod', expectedDate?: Date | null } | null } | null }>, account: { __typename?: 'Account', id: string, creationTimestamp: Date, updateTimestamp: Date, iban: string, name: string, currency: string, type?: string | null, synchronizationMethod: AccountInformationSynchronizationMethod, consentExpired: boolean, accessUntil?: Date | null, colorIndex: number, institution: { __typename?: 'Institution', id: string, name: string, logoUrl: string, smallLogoUrl: string, abbreviation: string, wideLogoUrl?: string | null, bic?: string | null, possibleAispNordigenConnection: boolean }, transactionsRange?: Array<{ __typename?: 'DateRange', from?: Date | null, to?: Date | null }> | null }, counterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null, period?: { __typename?: 'TransactionPeriod', periodTypeCode?: TransactionGroupPeriodTypeCode | null, periodCount?: number | null, referenceDate?: Date | null, expectedDate?: Date | null, expectedTransactionsCount?: number | null, expectedAmount?: { __typename?: 'Money', amount: number, currency: string } | null } | null } };

export type TransactionCounterpartyFragment = { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null };

export type RenameTransactionCounterpartyMutationVariables = Exact<{
  counterpartyId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type RenameTransactionCounterpartyMutation = { __typename?: 'Mutation', renameTransactionCounterparty?: { __typename?: 'TransactionCounterparty', id: string, defaultName?: string | null, displayName?: string | null, accountIban?: string | null } | null };

export type SynchronizeUserMutationVariables = Exact<{ [key: string]: never; }>;


export type SynchronizeUserMutation = { __typename?: 'Mutation', synchronizeUser: boolean };

export type CreateUnregisteredUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type CreateUnregisteredUserMutation = { __typename?: 'Mutation', createUnregisteredUser: string };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUserPersonalInformation?: { __typename?: 'User', displayName?: string | null, email: string, subject?: string | null, phoneNumber?: string | null } | null };

export type RemoveUserMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser: boolean };

export type AvatarFragment = { __typename?: 'Avatar', id: string, fullSize?: { __typename?: 'File', id: string, name?: string | null } | null, thumbnail?: { __typename?: 'File', id: string, name?: string | null } | null };

export type UserRelationFragment = { __typename?: 'UserRelation', id: string, relationType: UserRelationType, subjectUser: { __typename?: 'User', id: string, subject?: string | null, email: string, phoneNumber?: string | null, displayName?: string | null, avatar?: { __typename?: 'Avatar', id: string, fullSize?: { __typename?: 'File', id: string, name?: string | null } | null, thumbnail?: { __typename?: 'File', id: string, name?: string | null } | null } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', email: string, subject?: string | null, displayName?: string | null, roles?: Array<Role> | null, phoneNumber?: string | null, clientId: string, staffId: string, avatar?: { __typename?: 'Avatar', id: string, fullSize?: { __typename?: 'File', id: string, name?: string | null } | null, thumbnail?: { __typename?: 'File', id: string, name?: string | null } | null } | null } | null };

export type ContactUserRelationQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactUserRelationQuery = { __typename?: 'Query', userRelation?: { __typename?: 'UserRelation', id: string, relationType: UserRelationType, subjectUser: { __typename?: 'User', id: string, subject?: string | null, email: string, phoneNumber?: string | null, displayName?: string | null, avatar?: { __typename?: 'Avatar', id: string, fullSize?: { __typename?: 'File', id: string, name?: string | null } | null, thumbnail?: { __typename?: 'File', id: string, name?: string | null } | null } | null } } | null };

export type CreateLeadMutationVariables = Exact<{
  context: LeadContext;
  userInfo: UserInfo;
}>;


export type CreateLeadMutation = { __typename?: 'Mutation', createOrUpdateLead: boolean };

export type UpdateUserAvatarMutationVariables = Exact<{
  fileId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateUserAvatarMutation = { __typename?: 'Mutation', updateUserAvatar: { __typename?: 'User', id: string, subject?: string | null } };

export type SaveUtmParametersMutationVariables = Exact<{
  utmParameters: UtmParametersInput;
}>;


export type SaveUtmParametersMutation = { __typename?: 'Mutation', saveUtmParameters: boolean };

export const StaffFragmentDoc = gql`
    fragment Staff on Staff {
  id
  serviceLocations {
    id
    name
  }
  serviceAreas
}
    `;
export const InstitutionFragmentDoc = gql`
    fragment Institution on Institution {
  id
  name
  logoUrl
  smallLogoUrl
  abbreviation
  wideLogoUrl
  bic
  possibleAispNordigenConnection
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  creationTimestamp
  updateTimestamp
  iban
  institution {
    id
    ...Institution
  }
  name
  currency
  type
  synchronizationMethod
  consentExpired
  accessUntil
  transactionsRange {
    from
    to
  }
  colorIndex
}
    ${InstitutionFragmentDoc}`;
export const BalanceKeyFragmentDoc = gql`
    fragment BalanceKey on BalanceKey {
  ... on DateKey {
    startDate
    granularity
  }
  ...Account
}
    ${AccountFragmentDoc}`;
export const BalanceValueFragmentDoc = gql`
    fragment BalanceValue on BalanceValue {
  key {
    ... on IdBase {
      id
    }
    ...BalanceKey
  }
  balance {
    amount
    currency
  }
}
    ${BalanceKeyFragmentDoc}`;
export const CalendarEventInstanceFragmentDoc = gql`
    fragment CalendarEventInstance on CalendarEventInstance {
  id
  originalEventId
  type
  name
  date
  productId
  productType
  institution {
    id
    ...Institution
  }
  institutionName
  amount {
    amount
    currency
  }
}
    ${InstitutionFragmentDoc}`;
export const CashFlowAdjustmentFragmentDoc = gql`
    fragment CashFlowAdjustment on CashFlowAdjustment {
  id
  text
  period {
    periodTypeCode
    periodCount
    referenceDate
    expectedAmount {
      amount
      currency
    }
  }
}
    `;
export const TransactionCounterpartyFragmentDoc = gql`
    fragment TransactionCounterparty on TransactionCounterparty {
  id
  defaultName
  displayName
  accountIban
}
    `;
export const TransactionListItemFragmentDoc = gql`
    fragment TransactionListItem on Transaction {
  id
  amount {
    amount
    currency
  }
  category {
    id
    name
    categoryGroup {
      id
      code
      name
    }
  }
  tags {
    id
    name
  }
  account {
    ...Account
  }
  counterparty {
    ...TransactionCounterparty
  }
  streamGroup {
    id
    period {
      expectedDate
    }
  }
  note
  bookingDate
  transactionTypeCode
  excludeFromAnalytics
}
    ${AccountFragmentDoc}
${TransactionCounterpartyFragmentDoc}`;
export const TransactionGroupFragmentDoc = gql`
    fragment TransactionGroup on TransactionGroup {
  id
  transactions {
    id
    ...TransactionListItem
  }
  account {
    ...Account
  }
  counterparty {
    ...TransactionCounterparty
  }
  groupTypeCode
  period {
    periodTypeCode
    periodCount
    referenceDate
    expectedAmount {
      amount
      currency
    }
    expectedDate
    expectedTransactionsCount
  }
  excludeFromAnalytics
}
    ${TransactionListItemFragmentDoc}
${AccountFragmentDoc}
${TransactionCounterpartyFragmentDoc}`;
export const TransactionCategoryFragmentDoc = gql`
    fragment TransactionCategory on TransactionCategory {
  id
  code
  categoryName: name
  isActive
  categoryGroup {
    id
    code
    name
    isActive
  }
}
    `;
export const UpcomingPaymentListItemFragmentDoc = gql`
    fragment UpcomingPaymentListItem on UpcomingPayment {
  streamGroup {
    ...TransactionGroup
    category {
      id
      ...TransactionCategory
    }
  }
  expectedAmount {
    amount
    currency
  }
  expectedBaseAmount {
    amount
    currency
  }
  expectedDate
}
    ${TransactionGroupFragmentDoc}
${TransactionCategoryFragmentDoc}`;
export const UpcomingPaymentAggregationValueFragmentDoc = gql`
    fragment UpcomingPaymentAggregationValue on UpcomingPaymentAggregationValue {
  key {
    startDate
    granularity
  }
  sum {
    amount
    currency
  }
  count
}
    `;
export const ServiceLocationFragmentDoc = gql`
    fragment ServiceLocation on ServiceLocation {
  id
  region
  name
}
    `;
export const ClientProfileFragmentDoc = gql`
    fragment ClientProfile on ClientProfile {
  id
  creationTimestamp
  updateTimestamp
  preferredServiceLocation {
    id
    ...ServiceLocation
  }
  birthYear
  partner
  partnerBirthYear
  childrenNumber
  youngestChildBirthYear
}
    ${ServiceLocationFragmentDoc}`;
export const FinancialReserveFragmentDoc = gql`
    fragment FinancialReserve on FinancialReserve {
  id
  text
  amount {
    amount
    currency
  }
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on Document {
  id
  files {
    id
    name
  }
}
    `;
export const LifeInsuranceCalculatorResultFragmentDoc = gql`
    fragment LifeInsuranceCalculatorResult on LifeInsuranceCalculatorResult {
  score
  maximalScore
  necessity
  significantDomains
  similarUserRatio
}
    `;
export const LifeInsuranceApplicantFragmentDoc = gql`
    fragment LifeInsuranceApplicant on LifeInsuranceApplicant {
  dateOfBirth
  expenses {
    monthlyFamilyExpenses {
      amount
    }
  }
  healthCondition {
    isTreatedForDisease
    diseases {
      description
    }
    isOnRegularMedication
    hasPlannedMedicalProcedure
    plannedMedicalProcedures {
      description
      scheduledFor
    }
    regularMedication
    disabilityPension
    hasPermanentInjuryConsequences
    permanentInjuryConsequencesDescription
    isOnSickLeave
  }
  hasSharedLiabilities
  hasSharedExpenses
  id
  incomes {
    ... on ApplicantSalaryIncome {
      contractSignatureDate
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantAlimonyIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantEntrepreneurshipIncome {
      monthlyIncomeNullable: monthlyIncome {
        amount
      }
    }
    ... on ApplicantLtdIncome {
      monthlyIncomeNullable: monthlyIncome {
        amount
      }
    }
    ... on ApplicantMaternityLeaveIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantOtherIncome {
      description
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantUnemploymentBenefitIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantWorkAgreementIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantParentalAllowanceIncome {
      monthlyIncome {
        amount
      }
    }
  }
  isInsured
  isInsuring
  liabilities {
    ... on ApplicantAlimonyLiability {
      monthlyInstallment {
        amount
      }
    }
    ... on ApplicantConsumerLoanLiability {
      balance {
        amount
      }
      monthlyInstallment {
        amount
      }
    }
    ... on ApplicantLeaseLiability {
      balance {
        amount
      }
      monthlyInstallment {
        amount
      }
    }
    ... on ApplicantMortgageLiability {
      balance {
        amount
      }
      monthlyInstallment {
        amount
      }
    }
    ... on ApplicantOtherLoanLiability {
      balance {
        amount
      }
      monthlyInstallment {
        amount
      }
    }
    ... on ApplicantReconstructionLoanLiability {
      balance {
        amount
      }
      monthlyInstallment {
        amount
      }
    }
  }
  name
  occupationName
  practicedSports {
    name
    wayOfPracticing
  }
  surname
}
    `;
export const LifeInsuranceInquiryFragmentDoc = gql`
    fragment LifeInsuranceInquiry on LifeInsuranceInquiry {
  applicants {
    ...LifeInsuranceApplicant
  }
  inquiryCurrentStepUrl
  inquiryProgress
}
    ${LifeInsuranceApplicantFragmentDoc}`;
export const LifeInsuranceProposalFragmentDoc = gql`
    fragment LifeInsuranceProposal on LifeInsuranceProposal {
  ... on LifeInsuranceAdultProposal {
    id
    __typename
    applicant {
      ...LifeInsuranceApplicant
    }
    disability {
      amount
    }
    permanentInjuryConsequences {
      amount
    }
    criticalIllnesses {
      amount
    }
    deathInsurance {
      amount
    }
  }
  ... on LifeInsuranceChildProposal {
    id
    __typename
    applicant {
      ...LifeInsuranceApplicant
    }
    hospitalization {
      amount
    }
    permanentInjuryConsequences {
      amount
    }
    criticalIllnesses {
      amount
    }
    minorInjuries {
      amount
    }
  }
}
    ${LifeInsuranceApplicantFragmentDoc}`;
export const MortgageCalculatorResultFragmentDoc = gql`
    fragment MortgageCalculatorResult on MortgageCalculatorResult {
  maxMortgageAmount {
    amount
    currency
  }
}
    `;
export const MortgagePurchaseApplicantFragmentDoc = gql`
    fragment MortgagePurchaseApplicant on MortgagePurchaseApplicant {
  id
  name
  dateOfBirth
  familyStatus
  citizenship
  numberOfDependents
  incomes {
    ... on ApplicantSalaryIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantEntrepreneurshipIncome {
      yearlyRevenues {
        amount
      }
      taxBase {
        amount
      }
      taxPayed {
        amount
      }
      expenseType
    }
    ... on ApplicantLtdIncome {
      ceoCompensation {
        amount
      }
      equityShares
      yearlyProfit {
        amount
      }
      yearlyRevenues {
        amount
      }
    }
    ... on ApplicantTravelCompensationIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantRealEstateRentalIncome {
      contractSignatureDate
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantMaternityLeaveIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantParentalAllowanceIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantAlimonyIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantWorkAgreementIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantDoctoralScholarshipIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantDisabilityPensionIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantOldAgePensionIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantOrphanPensionIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantRetirementPensionIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantWidowPensionIncome {
      monthlyIncome {
        amount
      }
    }
    ... on ApplicantOtherIncome {
      monthlyIncome {
        amount
      }
      description
    }
  }
  liabilities {
    ... on ApplicantMortgageLiability {
      monthlyInstallment {
        amount
      }
      balance {
        amount
      }
    }
    ... on ApplicantConsumerLoanLiability {
      monthlyInstallment {
        amount
      }
      balance {
        amount
      }
    }
    ... on ApplicantReconstructionLoanLiability {
      monthlyInstallment {
        amount
      }
      balance {
        amount
      }
    }
    ... on ApplicantCreditCardLiability {
      limit {
        amount
      }
    }
    ... on ApplicantOverdraftLiability {
      limit {
        amount
      }
    }
    ... on ApplicantLeaseLiability {
      monthlyInstallment {
        amount
      }
      balance {
        amount
      }
    }
    ... on ApplicantAlimonyLiability {
      monthlyInstallment {
        amount
      }
    }
    ... on ApplicantOtherLoanLiability {
      monthlyInstallment {
        amount
      }
      balance {
        amount
      }
    }
  }
}
    `;
export const MortgagePurchaseInquiryFragmentDoc = gql`
    fragment MortgagePurchaseInquiry on MortgagePurchaseInquiry {
  id
  applicants {
    ...MortgagePurchaseApplicant
  }
  purpose {
    type
    typeOtherDescription
    mortgageAmount {
      amount
    }
    property {
      type
      price {
        amount
      }
      size
      sizeInterval {
        upper
        lower
      }
      isChosen
      isDeveloperProject
      energyCertificateClassA
    }
  }
  collaterals {
    type
    value {
      amount
    }
    location
    sameAsPurchasedProperty
    isInConstruction
  }
  inquiryCurrentStepUrl
  inquiryProgress
  numberOfApplicants
  numberOfCollaterals
}
    ${MortgagePurchaseApplicantFragmentDoc}`;
export const CalendarEventFragmentDoc = gql`
    fragment CalendarEvent on CalendarEvent {
  id
  type
  name
  startDate
  recurrenceRule
  productId
  productType
  institution {
    id
    ...Institution
  }
  institutionName
  amount {
    amount
    currency
  }
}
    ${InstitutionFragmentDoc}`;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  creationTimestamp
  type
  dueDate
  readDate
  stage
  details {
    ... on NordigenConsentExpirationNotificationDetails {
      nordigenConnection {
        institution {
          ...Institution
        }
        accounts {
          ...Account
        }
      }
    }
    ... on ProductNotificationDetails {
      productId
      productType
    }
    ... on CalendarEventNotificationDetails {
      calendarEvent {
        ...CalendarEvent
      }
    }
  }
}
    ${InstitutionFragmentDoc}
${AccountFragmentDoc}
${CalendarEventFragmentDoc}`;
export const BuildingSavingsProductFragmentDoc = gql`
    fragment BuildingSavingsProduct on BuildingSavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const BuildingSavingsProductListItemFragmentDoc = gql`
    fragment BuildingSavingsProductListItem on BuildingSavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const CollisionInsuranceRiskFragmentDoc = gql`
    fragment CollisionInsuranceRisk on CollisionInsuranceRisk {
  id
  type
  name
  insuredSum {
    amount
    currency
  }
  annualCost {
    amount
    currency
  }
}
    `;
export const CollisionInsuranceProductFragmentDoc = gql`
    fragment CollisionInsuranceProduct on CollisionInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  vehicleInfo {
    type
    manufactureYear
    licenseNumber
    owner {
      dateOfBirth
      postalCode
      yearOfLastCollision
      numberOfRecentCollisions
    }
  }
  insuringPerson {
    type
    name
  }
  insuranceRisks {
    ...CollisionInsuranceRisk
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}
${CollisionInsuranceRiskFragmentDoc}`;
export const CollisionInsuranceProductListItemFragmentDoc = gql`
    fragment CollisionInsuranceProductListItem on CollisionInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const CreditCardProductFragmentDoc = gql`
    fragment CreditCardProduct on CreditCardProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  limitAmount {
    amount
    currency
  }
  regularUsage
  owedAmountPaidByMaturity
  financialDetailsUpdatedAt
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const CreditCardProductListItemFragmentDoc = gql`
    fragment CreditCardProductListItem on CreditCardProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const GenericProductFragmentDoc = gql`
    fragment GenericProduct on GenericProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const GenericProductListItemFragmentDoc = gql`
    fragment GenericProductListItem on GenericProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const GenericInsuranceProductFragmentDoc = gql`
    fragment GenericInsuranceProduct on GenericInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const GenericInsuranceProductListItemFragmentDoc = gql`
    fragment GenericInsuranceProductListItem on GenericInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const InvestmentProductFragmentDoc = gql`
    fragment InvestmentProduct on InvestmentProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  financialInstrument
  currentMarketValue {
    amount
    currency
  }
  amountInvested {
    amount
    currency
  }
  financialDetailsUpdatedAt
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const InvestmentProductListItemFragmentDoc = gql`
    fragment InvestmentProductListItem on InvestmentProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const LifeInsuranceProductFragmentDoc = gql`
    fragment LifeInsuranceProduct on LifeInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  applicants {
    id
    name
    surname
    isInsured
    isInsuring
    insurance {
      insuranceRisks {
        id
        type
        name
        annualCost {
          amount
          currency
        }
        insuredSum {
          amount
          currency
        }
      }
    }
  }
  surrenderValue {
    amount
    currency
  }
  savings {
    amount {
      amount
      currency
    }
    insuredSum {
      amount
      currency
    }
  }
  financialDetailsUpdatedAt
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const LifeInsuranceProductListItemFragmentDoc = gql`
    fragment LifeInsuranceProductListItem on LifeInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const LoanProductFragmentDoc = gql`
    fragment LoanProduct on LoanProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  amount {
    amount
    currency
  }
  balance {
    amount
    currency
  }
  interestRate
  annualPercentageRate
  financialDetailsUpdatedAt
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const LoanProductListItemFragmentDoc = gql`
    fragment LoanProductListItem on LoanProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const MortgageProductFragmentDoc = gql`
    fragment MortgageProduct on MortgageProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  amount {
    amount
    currency
  }
  balance {
    amount
    currency
  }
  interestRate
  annualPercentageRate
  fixationEndDate
  fixationLength
  collaterals {
    address
  }
  purchasedProperty {
    address
  }
  participants {
    name
  }
  financialDetailsUpdatedAt
  note
  documents {
    id
    type
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const MortgageProductListItemFragmentDoc = gql`
    fragment MortgageProductListItem on MortgageProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  fixationEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const MotorLiabilityInsuranceProductFragmentDoc = gql`
    fragment MotorLiabilityInsuranceProduct on MotorLiabilityInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  vehicleInfo {
    type
    manufactureYear
    licenseNumber
    owner {
      dateOfBirth
      postalCode
      yearOfLastCollision
      numberOfRecentCollisions
    }
  }
  insuringPerson {
    type
    name
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const MotorLiabilityInsuranceProductListItemFragmentDoc = gql`
    fragment MotorLiabilityInsuranceProductListItem on MotorLiabilityInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const PropertyInsuranceProductFragmentDoc = gql`
    fragment PropertyInsuranceProduct on PropertyInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  insuringPerson {
    name
    surname
  }
  insuredProperty {
    type
    address
    propertyValue {
      amount
      currency
    }
    householdValue {
      amount
      currency
    }
  }
  basicInsurances {
    id
    type
    name
    insuredSum {
      amount
      currency
    }
    annualCost {
      amount
      currency
    }
    insuranceRisks {
      id
      type
      name
      insuredSum {
        amount
        currency
      }
      annualCost {
        amount
        currency
      }
    }
  }
  otherInsurances {
    id
    type
    name
    insuredSum {
      amount
      currency
    }
    annualCost {
      amount
      currency
    }
    insuranceRisks {
      id
      type
      name
      insuredSum {
        amount
        currency
      }
      annualCost {
        amount
        currency
      }
    }
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const PropertyInsuranceProductListItemFragmentDoc = gql`
    fragment PropertyInsuranceProductListItem on PropertyInsuranceProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const RetirementPensionSavingsProductFragmentDoc = gql`
    fragment RetirementPensionSavingsProduct on RetirementPensionSavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  currentMarketValue {
    amount
    currency
  }
  guaranteedFund
  nonGuaranteedFund
  voluntaryContribution
  financialDetailsUpdatedAt
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const RetirementPensionSavingsProductListItemFragmentDoc = gql`
    fragment RetirementPensionSavingsProductListItem on RetirementPensionSavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const SavingsProductFragmentDoc = gql`
    fragment SavingsProduct on SavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const SavingsProductListItemFragmentDoc = gql`
    fragment SavingsProductListItem on SavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const SupplementaryPensionSavingsProductFragmentDoc = gql`
    fragment SupplementaryPensionSavingsProduct on SupplementaryPensionSavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractNumber
  contractSignDate
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  currentMarketValue {
    amount
    currency
  }
  guaranteedFund
  nonGuaranteedFund
  possibleEmployerContribution
  employerContribution {
    amount
    currency
  }
  employeeContribution {
    amount
    currency
  }
  financialDetailsUpdatedAt
  note
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const SupplementaryPensionSavingsProductListItemFragmentDoc = gql`
    fragment SupplementaryPensionSavingsProductListItem on SupplementaryPensionSavingsProduct {
  id
  name
  creationTimestamp
  status
  statusChangeDate
  enableNotifications
  enableFinancialAdvisorCare
  contractEndDate
  institution {
    id
    ...Institution
  }
  institutionName
  paymentInfo {
    ibanForPayment
    variableSymbol
    constantSymbol
    specificSymbol
  }
  paymentPeriod {
    periodTypeCode
    periodCount
    expectedDate
    expectedAmount {
      amount
      currency
    }
  }
  documents {
    id
    files {
      id
      name
    }
  }
}
    ${InstitutionFragmentDoc}`;
export const MortgageRefinanceApplicantFragmentDoc = gql`
    fragment MortgageRefinanceApplicant on MortgageRefinanceApplicant {
  id
  incomeType
  dateOfBirth
  incomeCommencementDate
  name
}
    `;
export const MortgageRefinanceInquiryFragmentDoc = gql`
    fragment MortgageRefinanceInquiry on MortgageRefinanceInquiry {
  id
  applicants {
    ...MortgageRefinanceApplicant
  }
  currentSetup {
    collaterals {
      type
      value {
        amount
        currency
      }
      location
    }
    institution {
      id
      ...Institution
    }
    balance {
      amount
      currency
    }
    installment {
      amount
      currency
    }
    interestRate
    fixationEndDate
    fixationLength
    isNewFixationProposed
    newProposedFixation {
      newInterestRate
      newInstallment {
        amount
        currency
      }
    }
    numberOfCollaterals
  }
  inquiryCurrentStepUrl
  inquiryProgress
  numberOfApplicants
}
    ${MortgageRefinanceApplicantFragmentDoc}
${InstitutionFragmentDoc}`;
export const DetailedMortgageProposalFragmentDoc = gql`
    fragment DetailedMortgageProposal on MortgageProposal {
  id
  amount {
    amount
    currency
  }
  fixationLength
  installment {
    amount
    currency
  }
  interestRate
  maturity
  overpaymentInFixationPeriod {
    amount
    currency
  }
  institutionAbbreviation
  fees {
    provision {
      amount
      currency
    }
    monthlyAccountManagement {
      amount
      currency
    }
    monthlyMortgageInsurance {
      amount
      currency
    }
    annualPropertyInsurance {
      amount
      currency
    }
  }
}
    `;
export const MortgageRefinanceProposalFragmentDoc = gql`
    fragment MortgageRefinanceProposal on MortgageProposal {
  id
  ...DetailedMortgageProposal
  fixationLength
  maturity
  incomeVerification
  installmentChange {
    amount
    currency
  }
}
    ${DetailedMortgageProposalFragmentDoc}`;
export const MortgageRefinanceStrategyResultFragmentDoc = gql`
    fragment MortgageRefinanceStrategyResult on MortgageRefinanceStrategyResult {
  id
  currentMortgageAfterFixationPeriod {
    ...MortgageRefinanceProposal
  }
  proposals {
    ...MortgageRefinanceProposal
  }
  changeInOverpayment {
    amount
    currency
  }
}
    ${MortgageRefinanceProposalFragmentDoc}`;
export const ReportFragmentDoc = gql`
    fragment Report on Report {
  id
  creationTimestamp
  type
  file {
    id
    name
  }
}
    `;
export const TransactionTagFragmentDoc = gql`
    fragment TransactionTag on TransactionTag {
  id
  name
}
    `;
export const TransactionAggregateKeyFragmentDoc = gql`
    fragment TransactionAggregateKey on TransactionAggregateKey {
  ... on DateKey {
    startDate
    granularity
  }
  ... on TransactionCategory {
    id
    ...TransactionCategory
  }
  ... on TransactionTag {
    id
    ...TransactionTag
  }
  ...Account
}
    ${TransactionCategoryFragmentDoc}
${TransactionTagFragmentDoc}
${AccountFragmentDoc}`;
export const TransactionAggregationValueFragmentDoc = gql`
    fragment TransactionAggregationValue on TransactionAggregationValue {
  key {
    ... on IdBase {
      id
    }
    ...TransactionAggregateKey
  }
  sum {
    amount
    currency
  }
  count
}
    ${TransactionAggregateKeyFragmentDoc}`;
export const TransactionCategoryGroupFragmentDoc = gql`
    fragment TransactionCategoryGroup on TransactionCategoryGroup {
  id
  code
  name
}
    `;
export const TransactionDetailFragmentDoc = gql`
    fragment TransactionDetail on Transaction {
  id
  bookingDate
  amount {
    amount
    currency
  }
  counterparty {
    ...TransactionCounterparty
  }
  transactionTypeCode
  variableSymbol
  specificSymbol
  constantSymbol
  messageForRecipient
  note
  excludeFromAnalytics
  category {
    id
    ...TransactionCategory
    categoryGroup {
      ...TransactionCategoryGroup
    }
  }
  tags {
    id
    name
  }
  account {
    ...Account
  }
  streamGroup {
    ...TransactionGroup
  }
}
    ${TransactionCounterpartyFragmentDoc}
${TransactionCategoryFragmentDoc}
${TransactionCategoryGroupFragmentDoc}
${AccountFragmentDoc}
${TransactionGroupFragmentDoc}`;
export const AvatarFragmentDoc = gql`
    fragment Avatar on Avatar {
  id
  fullSize {
    id
    name
  }
  thumbnail {
    id
    name
  }
}
    `;
export const UserRelationFragmentDoc = gql`
    fragment UserRelation on UserRelation {
  id
  relationType
  subjectUser {
    id
    subject
    email
    phoneNumber
    displayName
    avatar {
      ...Avatar
    }
  }
}
    ${AvatarFragmentDoc}`;
export const AdminGetPermanentFileLinkDocument = gql`
    query AdminGetPermanentFileLink($fileId: ID!) {
  adminGetPermanentFileLink(fileId: $fileId)
}
    `;

/**
 * __useAdminGetPermanentFileLinkQuery__
 *
 * To run a query within a React component, call `useAdminGetPermanentFileLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPermanentFileLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPermanentFileLinkQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAdminGetPermanentFileLinkQuery(baseOptions: Apollo.QueryHookOptions<AdminGetPermanentFileLinkQuery, AdminGetPermanentFileLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPermanentFileLinkQuery, AdminGetPermanentFileLinkQueryVariables>(AdminGetPermanentFileLinkDocument, options);
      }
export function useAdminGetPermanentFileLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPermanentFileLinkQuery, AdminGetPermanentFileLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPermanentFileLinkQuery, AdminGetPermanentFileLinkQueryVariables>(AdminGetPermanentFileLinkDocument, options);
        }
export type AdminGetPermanentFileLinkQueryHookResult = ReturnType<typeof useAdminGetPermanentFileLinkQuery>;
export type AdminGetPermanentFileLinkLazyQueryHookResult = ReturnType<typeof useAdminGetPermanentFileLinkLazyQuery>;
export type AdminGetPermanentFileLinkQueryResult = Apollo.QueryResult<AdminGetPermanentFileLinkQuery, AdminGetPermanentFileLinkQueryVariables>;
export const MarkFinancialAdvisorTaskAsDoneDocument = gql`
    mutation MarkFinancialAdvisorTaskAsDone($taskId: ID!) {
  adminMarkFinancialAdvisorTaskAsDone(taskId: $taskId) {
    id
  }
}
    `;
export type MarkFinancialAdvisorTaskAsDoneMutationFn = Apollo.MutationFunction<MarkFinancialAdvisorTaskAsDoneMutation, MarkFinancialAdvisorTaskAsDoneMutationVariables>;

/**
 * __useMarkFinancialAdvisorTaskAsDoneMutation__
 *
 * To run a mutation, you first call `useMarkFinancialAdvisorTaskAsDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFinancialAdvisorTaskAsDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFinancialAdvisorTaskAsDoneMutation, { data, loading, error }] = useMarkFinancialAdvisorTaskAsDoneMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useMarkFinancialAdvisorTaskAsDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkFinancialAdvisorTaskAsDoneMutation, MarkFinancialAdvisorTaskAsDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFinancialAdvisorTaskAsDoneMutation, MarkFinancialAdvisorTaskAsDoneMutationVariables>(MarkFinancialAdvisorTaskAsDoneDocument, options);
      }
export type MarkFinancialAdvisorTaskAsDoneMutationHookResult = ReturnType<typeof useMarkFinancialAdvisorTaskAsDoneMutation>;
export type MarkFinancialAdvisorTaskAsDoneMutationResult = Apollo.MutationResult<MarkFinancialAdvisorTaskAsDoneMutation>;
export type MarkFinancialAdvisorTaskAsDoneMutationOptions = Apollo.BaseMutationOptions<MarkFinancialAdvisorTaskAsDoneMutation, MarkFinancialAdvisorTaskAsDoneMutationVariables>;
export const MarkFinancialAdvisorTaskAsUndoneDocument = gql`
    mutation MarkFinancialAdvisorTaskAsUndone($taskId: ID!) {
  adminMarkFinancialAdvisorTaskAsUndone(taskId: $taskId) {
    id
  }
}
    `;
export type MarkFinancialAdvisorTaskAsUndoneMutationFn = Apollo.MutationFunction<MarkFinancialAdvisorTaskAsUndoneMutation, MarkFinancialAdvisorTaskAsUndoneMutationVariables>;

/**
 * __useMarkFinancialAdvisorTaskAsUndoneMutation__
 *
 * To run a mutation, you first call `useMarkFinancialAdvisorTaskAsUndoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFinancialAdvisorTaskAsUndoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFinancialAdvisorTaskAsUndoneMutation, { data, loading, error }] = useMarkFinancialAdvisorTaskAsUndoneMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useMarkFinancialAdvisorTaskAsUndoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkFinancialAdvisorTaskAsUndoneMutation, MarkFinancialAdvisorTaskAsUndoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFinancialAdvisorTaskAsUndoneMutation, MarkFinancialAdvisorTaskAsUndoneMutationVariables>(MarkFinancialAdvisorTaskAsUndoneDocument, options);
      }
export type MarkFinancialAdvisorTaskAsUndoneMutationHookResult = ReturnType<typeof useMarkFinancialAdvisorTaskAsUndoneMutation>;
export type MarkFinancialAdvisorTaskAsUndoneMutationResult = Apollo.MutationResult<MarkFinancialAdvisorTaskAsUndoneMutation>;
export type MarkFinancialAdvisorTaskAsUndoneMutationOptions = Apollo.BaseMutationOptions<MarkFinancialAdvisorTaskAsUndoneMutation, MarkFinancialAdvisorTaskAsUndoneMutationVariables>;
export const AdminGetStaffsDocument = gql`
    query AdminGetStaffs($filterInput: FilterInput, $sortInput: SortInput) {
  staffs: adminGetStaffsPage(filterInput: $filterInput, sortInput: $sortInput) {
    items {
      id
      ...Staff
    }
  }
}
    ${StaffFragmentDoc}`;

/**
 * __useAdminGetStaffsQuery__
 *
 * To run a query within a React component, call `useAdminGetStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetStaffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetStaffsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useAdminGetStaffsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetStaffsQuery, AdminGetStaffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetStaffsQuery, AdminGetStaffsQueryVariables>(AdminGetStaffsDocument, options);
      }
export function useAdminGetStaffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetStaffsQuery, AdminGetStaffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetStaffsQuery, AdminGetStaffsQueryVariables>(AdminGetStaffsDocument, options);
        }
export type AdminGetStaffsQueryHookResult = ReturnType<typeof useAdminGetStaffsQuery>;
export type AdminGetStaffsLazyQueryHookResult = ReturnType<typeof useAdminGetStaffsLazyQuery>;
export type AdminGetStaffsQueryResult = Apollo.QueryResult<AdminGetStaffsQuery, AdminGetStaffsQueryVariables>;
export const AdminGetStaffDocument = gql`
    query AdminGetStaff($id: ID!) {
  adminGetStaff(id: $id) {
    id
    ...Staff
  }
}
    ${StaffFragmentDoc}`;

/**
 * __useAdminGetStaffQuery__
 *
 * To run a query within a React component, call `useAdminGetStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetStaffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetStaffQuery(baseOptions: Apollo.QueryHookOptions<AdminGetStaffQuery, AdminGetStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetStaffQuery, AdminGetStaffQueryVariables>(AdminGetStaffDocument, options);
      }
export function useAdminGetStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetStaffQuery, AdminGetStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetStaffQuery, AdminGetStaffQueryVariables>(AdminGetStaffDocument, options);
        }
export type AdminGetStaffQueryHookResult = ReturnType<typeof useAdminGetStaffQuery>;
export type AdminGetStaffLazyQueryHookResult = ReturnType<typeof useAdminGetStaffLazyQuery>;
export type AdminGetStaffQueryResult = Apollo.QueryResult<AdminGetStaffQuery, AdminGetStaffQueryVariables>;
export const AdminUpdateStaffDocument = gql`
    mutation AdminUpdateStaff($id: ID!, $input: StaffInput!) {
  adminUpdateStaff(id: $id, updatedStaff: $input) {
    id
    ...Staff
  }
}
    ${StaffFragmentDoc}`;
export type AdminUpdateStaffMutationFn = Apollo.MutationFunction<AdminUpdateStaffMutation, AdminUpdateStaffMutationVariables>;

/**
 * __useAdminUpdateStaffMutation__
 *
 * To run a mutation, you first call `useAdminUpdateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateStaffMutation, { data, loading, error }] = useAdminUpdateStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateStaffMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateStaffMutation, AdminUpdateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateStaffMutation, AdminUpdateStaffMutationVariables>(AdminUpdateStaffDocument, options);
      }
export type AdminUpdateStaffMutationHookResult = ReturnType<typeof useAdminUpdateStaffMutation>;
export type AdminUpdateStaffMutationResult = Apollo.MutationResult<AdminUpdateStaffMutation>;
export type AdminUpdateStaffMutationOptions = Apollo.BaseMutationOptions<AdminUpdateStaffMutation, AdminUpdateStaffMutationVariables>;
export const AdminBuildingSavingsProductDocument = gql`
    query AdminBuildingSavingsProduct($id: ID!) {
  detail: adminGetBuildingSavingsProduct(id: $id) {
    id
    ...BuildingSavingsProduct
  }
}
    ${BuildingSavingsProductFragmentDoc}`;

/**
 * __useAdminBuildingSavingsProductQuery__
 *
 * To run a query within a React component, call `useAdminBuildingSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBuildingSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBuildingSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminBuildingSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<AdminBuildingSavingsProductQuery, AdminBuildingSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBuildingSavingsProductQuery, AdminBuildingSavingsProductQueryVariables>(AdminBuildingSavingsProductDocument, options);
      }
export function useAdminBuildingSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBuildingSavingsProductQuery, AdminBuildingSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBuildingSavingsProductQuery, AdminBuildingSavingsProductQueryVariables>(AdminBuildingSavingsProductDocument, options);
        }
export type AdminBuildingSavingsProductQueryHookResult = ReturnType<typeof useAdminBuildingSavingsProductQuery>;
export type AdminBuildingSavingsProductLazyQueryHookResult = ReturnType<typeof useAdminBuildingSavingsProductLazyQuery>;
export type AdminBuildingSavingsProductQueryResult = Apollo.QueryResult<AdminBuildingSavingsProductQuery, AdminBuildingSavingsProductQueryVariables>;
export const AdminCreateBuildingSavingsProductDocumentDocument = gql`
    mutation AdminCreateBuildingSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateBuildingSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateBuildingSavingsProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateBuildingSavingsProductDocumentMutation, AdminCreateBuildingSavingsProductDocumentMutationVariables>;

/**
 * __useAdminCreateBuildingSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateBuildingSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateBuildingSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateBuildingSavingsProductDocumentMutation, { data, loading, error }] = useAdminCreateBuildingSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateBuildingSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateBuildingSavingsProductDocumentMutation, AdminCreateBuildingSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateBuildingSavingsProductDocumentMutation, AdminCreateBuildingSavingsProductDocumentMutationVariables>(AdminCreateBuildingSavingsProductDocumentDocument, options);
      }
export type AdminCreateBuildingSavingsProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateBuildingSavingsProductDocumentMutation>;
export type AdminCreateBuildingSavingsProductDocumentMutationResult = Apollo.MutationResult<AdminCreateBuildingSavingsProductDocumentMutation>;
export type AdminCreateBuildingSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateBuildingSavingsProductDocumentMutation, AdminCreateBuildingSavingsProductDocumentMutationVariables>;
export const AdminCollisionInsuranceProductDocument = gql`
    query AdminCollisionInsuranceProduct($id: ID!) {
  detail: adminGetCollisionInsuranceProduct(id: $id) {
    id
    ...CollisionInsuranceProduct
  }
}
    ${CollisionInsuranceProductFragmentDoc}`;

/**
 * __useAdminCollisionInsuranceProductQuery__
 *
 * To run a query within a React component, call `useAdminCollisionInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCollisionInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCollisionInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminCollisionInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<AdminCollisionInsuranceProductQuery, AdminCollisionInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCollisionInsuranceProductQuery, AdminCollisionInsuranceProductQueryVariables>(AdminCollisionInsuranceProductDocument, options);
      }
export function useAdminCollisionInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCollisionInsuranceProductQuery, AdminCollisionInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCollisionInsuranceProductQuery, AdminCollisionInsuranceProductQueryVariables>(AdminCollisionInsuranceProductDocument, options);
        }
export type AdminCollisionInsuranceProductQueryHookResult = ReturnType<typeof useAdminCollisionInsuranceProductQuery>;
export type AdminCollisionInsuranceProductLazyQueryHookResult = ReturnType<typeof useAdminCollisionInsuranceProductLazyQuery>;
export type AdminCollisionInsuranceProductQueryResult = Apollo.QueryResult<AdminCollisionInsuranceProductQuery, AdminCollisionInsuranceProductQueryVariables>;
export const AdminCreateCollisionInsuranceProductDocumentDocument = gql`
    mutation AdminCreateCollisionInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateCollisionInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateCollisionInsuranceProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateCollisionInsuranceProductDocumentMutation, AdminCreateCollisionInsuranceProductDocumentMutationVariables>;

/**
 * __useAdminCreateCollisionInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateCollisionInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCollisionInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCollisionInsuranceProductDocumentMutation, { data, loading, error }] = useAdminCreateCollisionInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateCollisionInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCollisionInsuranceProductDocumentMutation, AdminCreateCollisionInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCollisionInsuranceProductDocumentMutation, AdminCreateCollisionInsuranceProductDocumentMutationVariables>(AdminCreateCollisionInsuranceProductDocumentDocument, options);
      }
export type AdminCreateCollisionInsuranceProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateCollisionInsuranceProductDocumentMutation>;
export type AdminCreateCollisionInsuranceProductDocumentMutationResult = Apollo.MutationResult<AdminCreateCollisionInsuranceProductDocumentMutation>;
export type AdminCreateCollisionInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateCollisionInsuranceProductDocumentMutation, AdminCreateCollisionInsuranceProductDocumentMutationVariables>;
export const AdminCreditCardProductDocument = gql`
    query AdminCreditCardProduct($id: ID!) {
  detail: adminGetCreditCardProduct(id: $id) {
    id
    ...CreditCardProduct
  }
}
    ${CreditCardProductFragmentDoc}`;

/**
 * __useAdminCreditCardProductQuery__
 *
 * To run a query within a React component, call `useAdminCreditCardProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCreditCardProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCreditCardProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminCreditCardProductQuery(baseOptions: Apollo.QueryHookOptions<AdminCreditCardProductQuery, AdminCreditCardProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCreditCardProductQuery, AdminCreditCardProductQueryVariables>(AdminCreditCardProductDocument, options);
      }
export function useAdminCreditCardProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCreditCardProductQuery, AdminCreditCardProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCreditCardProductQuery, AdminCreditCardProductQueryVariables>(AdminCreditCardProductDocument, options);
        }
export type AdminCreditCardProductQueryHookResult = ReturnType<typeof useAdminCreditCardProductQuery>;
export type AdminCreditCardProductLazyQueryHookResult = ReturnType<typeof useAdminCreditCardProductLazyQuery>;
export type AdminCreditCardProductQueryResult = Apollo.QueryResult<AdminCreditCardProductQuery, AdminCreditCardProductQueryVariables>;
export const AdminCreateCreditCardProductDocumentDocument = gql`
    mutation AdminCreateCreditCardProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateCreditCardProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateCreditCardProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateCreditCardProductDocumentMutation, AdminCreateCreditCardProductDocumentMutationVariables>;

/**
 * __useAdminCreateCreditCardProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateCreditCardProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCreditCardProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCreditCardProductDocumentMutation, { data, loading, error }] = useAdminCreateCreditCardProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateCreditCardProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCreditCardProductDocumentMutation, AdminCreateCreditCardProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCreditCardProductDocumentMutation, AdminCreateCreditCardProductDocumentMutationVariables>(AdminCreateCreditCardProductDocumentDocument, options);
      }
export type AdminCreateCreditCardProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateCreditCardProductDocumentMutation>;
export type AdminCreateCreditCardProductDocumentMutationResult = Apollo.MutationResult<AdminCreateCreditCardProductDocumentMutation>;
export type AdminCreateCreditCardProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateCreditCardProductDocumentMutation, AdminCreateCreditCardProductDocumentMutationVariables>;
export const AdminGenericProductDocument = gql`
    query AdminGenericProduct($id: ID!) {
  detail: adminGetGenericProduct(id: $id) {
    id
    ...GenericProduct
  }
}
    ${GenericProductFragmentDoc}`;

/**
 * __useAdminGenericProductQuery__
 *
 * To run a query within a React component, call `useAdminGenericProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGenericProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGenericProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGenericProductQuery(baseOptions: Apollo.QueryHookOptions<AdminGenericProductQuery, AdminGenericProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGenericProductQuery, AdminGenericProductQueryVariables>(AdminGenericProductDocument, options);
      }
export function useAdminGenericProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGenericProductQuery, AdminGenericProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGenericProductQuery, AdminGenericProductQueryVariables>(AdminGenericProductDocument, options);
        }
export type AdminGenericProductQueryHookResult = ReturnType<typeof useAdminGenericProductQuery>;
export type AdminGenericProductLazyQueryHookResult = ReturnType<typeof useAdminGenericProductLazyQuery>;
export type AdminGenericProductQueryResult = Apollo.QueryResult<AdminGenericProductQuery, AdminGenericProductQueryVariables>;
export const AdminCreateGenericProductDocumentDocument = gql`
    mutation AdminCreateGenericProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateGenericProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateGenericProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateGenericProductDocumentMutation, AdminCreateGenericProductDocumentMutationVariables>;

/**
 * __useAdminCreateGenericProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateGenericProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateGenericProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateGenericProductDocumentMutation, { data, loading, error }] = useAdminCreateGenericProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateGenericProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateGenericProductDocumentMutation, AdminCreateGenericProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateGenericProductDocumentMutation, AdminCreateGenericProductDocumentMutationVariables>(AdminCreateGenericProductDocumentDocument, options);
      }
export type AdminCreateGenericProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateGenericProductDocumentMutation>;
export type AdminCreateGenericProductDocumentMutationResult = Apollo.MutationResult<AdminCreateGenericProductDocumentMutation>;
export type AdminCreateGenericProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateGenericProductDocumentMutation, AdminCreateGenericProductDocumentMutationVariables>;
export const AdminGenericInsuranceProductDocument = gql`
    query AdminGenericInsuranceProduct($id: ID!) {
  detail: adminGetGenericInsuranceProduct(id: $id) {
    id
    ...GenericInsuranceProduct
  }
}
    ${GenericInsuranceProductFragmentDoc}`;

/**
 * __useAdminGenericInsuranceProductQuery__
 *
 * To run a query within a React component, call `useAdminGenericInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGenericInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGenericInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGenericInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<AdminGenericInsuranceProductQuery, AdminGenericInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGenericInsuranceProductQuery, AdminGenericInsuranceProductQueryVariables>(AdminGenericInsuranceProductDocument, options);
      }
export function useAdminGenericInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGenericInsuranceProductQuery, AdminGenericInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGenericInsuranceProductQuery, AdminGenericInsuranceProductQueryVariables>(AdminGenericInsuranceProductDocument, options);
        }
export type AdminGenericInsuranceProductQueryHookResult = ReturnType<typeof useAdminGenericInsuranceProductQuery>;
export type AdminGenericInsuranceProductLazyQueryHookResult = ReturnType<typeof useAdminGenericInsuranceProductLazyQuery>;
export type AdminGenericInsuranceProductQueryResult = Apollo.QueryResult<AdminGenericInsuranceProductQuery, AdminGenericInsuranceProductQueryVariables>;
export const AdminCreateGenericInsuranceProductDocumentDocument = gql`
    mutation AdminCreateGenericInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateGenericInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateGenericInsuranceProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateGenericInsuranceProductDocumentMutation, AdminCreateGenericInsuranceProductDocumentMutationVariables>;

/**
 * __useAdminCreateGenericInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateGenericInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateGenericInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateGenericInsuranceProductDocumentMutation, { data, loading, error }] = useAdminCreateGenericInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateGenericInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateGenericInsuranceProductDocumentMutation, AdminCreateGenericInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateGenericInsuranceProductDocumentMutation, AdminCreateGenericInsuranceProductDocumentMutationVariables>(AdminCreateGenericInsuranceProductDocumentDocument, options);
      }
export type AdminCreateGenericInsuranceProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateGenericInsuranceProductDocumentMutation>;
export type AdminCreateGenericInsuranceProductDocumentMutationResult = Apollo.MutationResult<AdminCreateGenericInsuranceProductDocumentMutation>;
export type AdminCreateGenericInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateGenericInsuranceProductDocumentMutation, AdminCreateGenericInsuranceProductDocumentMutationVariables>;
export const AdminInvestmentProductDocument = gql`
    query AdminInvestmentProduct($id: ID!) {
  detail: adminGetInvestmentProduct(id: $id) {
    id
    ...InvestmentProduct
  }
}
    ${InvestmentProductFragmentDoc}`;

/**
 * __useAdminInvestmentProductQuery__
 *
 * To run a query within a React component, call `useAdminInvestmentProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminInvestmentProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminInvestmentProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminInvestmentProductQuery(baseOptions: Apollo.QueryHookOptions<AdminInvestmentProductQuery, AdminInvestmentProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminInvestmentProductQuery, AdminInvestmentProductQueryVariables>(AdminInvestmentProductDocument, options);
      }
export function useAdminInvestmentProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminInvestmentProductQuery, AdminInvestmentProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminInvestmentProductQuery, AdminInvestmentProductQueryVariables>(AdminInvestmentProductDocument, options);
        }
export type AdminInvestmentProductQueryHookResult = ReturnType<typeof useAdminInvestmentProductQuery>;
export type AdminInvestmentProductLazyQueryHookResult = ReturnType<typeof useAdminInvestmentProductLazyQuery>;
export type AdminInvestmentProductQueryResult = Apollo.QueryResult<AdminInvestmentProductQuery, AdminInvestmentProductQueryVariables>;
export const AdminCreateInvestmentProductDocumentDocument = gql`
    mutation AdminCreateInvestmentProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateInvestmentProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateInvestmentProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateInvestmentProductDocumentMutation, AdminCreateInvestmentProductDocumentMutationVariables>;

/**
 * __useAdminCreateInvestmentProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateInvestmentProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateInvestmentProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateInvestmentProductDocumentMutation, { data, loading, error }] = useAdminCreateInvestmentProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateInvestmentProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateInvestmentProductDocumentMutation, AdminCreateInvestmentProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateInvestmentProductDocumentMutation, AdminCreateInvestmentProductDocumentMutationVariables>(AdminCreateInvestmentProductDocumentDocument, options);
      }
export type AdminCreateInvestmentProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateInvestmentProductDocumentMutation>;
export type AdminCreateInvestmentProductDocumentMutationResult = Apollo.MutationResult<AdminCreateInvestmentProductDocumentMutation>;
export type AdminCreateInvestmentProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateInvestmentProductDocumentMutation, AdminCreateInvestmentProductDocumentMutationVariables>;
export const AdminLifeInsuranceProductDocument = gql`
    query AdminLifeInsuranceProduct($id: ID!) {
  detail: adminGetLifeInsuranceProduct(id: $id) {
    id
    ...LifeInsuranceProduct
  }
}
    ${LifeInsuranceProductFragmentDoc}`;

/**
 * __useAdminLifeInsuranceProductQuery__
 *
 * To run a query within a React component, call `useAdminLifeInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLifeInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLifeInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminLifeInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<AdminLifeInsuranceProductQuery, AdminLifeInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLifeInsuranceProductQuery, AdminLifeInsuranceProductQueryVariables>(AdminLifeInsuranceProductDocument, options);
      }
export function useAdminLifeInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLifeInsuranceProductQuery, AdminLifeInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLifeInsuranceProductQuery, AdminLifeInsuranceProductQueryVariables>(AdminLifeInsuranceProductDocument, options);
        }
export type AdminLifeInsuranceProductQueryHookResult = ReturnType<typeof useAdminLifeInsuranceProductQuery>;
export type AdminLifeInsuranceProductLazyQueryHookResult = ReturnType<typeof useAdminLifeInsuranceProductLazyQuery>;
export type AdminLifeInsuranceProductQueryResult = Apollo.QueryResult<AdminLifeInsuranceProductQuery, AdminLifeInsuranceProductQueryVariables>;
export const AdminCreateLifeInsuranceProductDocumentDocument = gql`
    mutation AdminCreateLifeInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateLifeInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateLifeInsuranceProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateLifeInsuranceProductDocumentMutation, AdminCreateLifeInsuranceProductDocumentMutationVariables>;

/**
 * __useAdminCreateLifeInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateLifeInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateLifeInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateLifeInsuranceProductDocumentMutation, { data, loading, error }] = useAdminCreateLifeInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateLifeInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateLifeInsuranceProductDocumentMutation, AdminCreateLifeInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateLifeInsuranceProductDocumentMutation, AdminCreateLifeInsuranceProductDocumentMutationVariables>(AdminCreateLifeInsuranceProductDocumentDocument, options);
      }
export type AdminCreateLifeInsuranceProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateLifeInsuranceProductDocumentMutation>;
export type AdminCreateLifeInsuranceProductDocumentMutationResult = Apollo.MutationResult<AdminCreateLifeInsuranceProductDocumentMutation>;
export type AdminCreateLifeInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateLifeInsuranceProductDocumentMutation, AdminCreateLifeInsuranceProductDocumentMutationVariables>;
export const AdminLoanProductDocument = gql`
    query AdminLoanProduct($id: ID!) {
  detail: adminGetLoanProduct(id: $id) {
    id
    ...LoanProduct
  }
}
    ${LoanProductFragmentDoc}`;

/**
 * __useAdminLoanProductQuery__
 *
 * To run a query within a React component, call `useAdminLoanProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLoanProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLoanProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminLoanProductQuery(baseOptions: Apollo.QueryHookOptions<AdminLoanProductQuery, AdminLoanProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminLoanProductQuery, AdminLoanProductQueryVariables>(AdminLoanProductDocument, options);
      }
export function useAdminLoanProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminLoanProductQuery, AdminLoanProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminLoanProductQuery, AdminLoanProductQueryVariables>(AdminLoanProductDocument, options);
        }
export type AdminLoanProductQueryHookResult = ReturnType<typeof useAdminLoanProductQuery>;
export type AdminLoanProductLazyQueryHookResult = ReturnType<typeof useAdminLoanProductLazyQuery>;
export type AdminLoanProductQueryResult = Apollo.QueryResult<AdminLoanProductQuery, AdminLoanProductQueryVariables>;
export const AdminCreateLoanProductDocumentDocument = gql`
    mutation AdminCreateLoanProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateLoanProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateLoanProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateLoanProductDocumentMutation, AdminCreateLoanProductDocumentMutationVariables>;

/**
 * __useAdminCreateLoanProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateLoanProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateLoanProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateLoanProductDocumentMutation, { data, loading, error }] = useAdminCreateLoanProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateLoanProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateLoanProductDocumentMutation, AdminCreateLoanProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateLoanProductDocumentMutation, AdminCreateLoanProductDocumentMutationVariables>(AdminCreateLoanProductDocumentDocument, options);
      }
export type AdminCreateLoanProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateLoanProductDocumentMutation>;
export type AdminCreateLoanProductDocumentMutationResult = Apollo.MutationResult<AdminCreateLoanProductDocumentMutation>;
export type AdminCreateLoanProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateLoanProductDocumentMutation, AdminCreateLoanProductDocumentMutationVariables>;
export const AdminMortgageProductDocument = gql`
    query AdminMortgageProduct($id: ID!) {
  detail: adminGetMortgageProduct(id: $id) {
    id
    ...MortgageProduct
  }
}
    ${MortgageProductFragmentDoc}`;

/**
 * __useAdminMortgageProductQuery__
 *
 * To run a query within a React component, call `useAdminMortgageProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMortgageProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMortgageProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminMortgageProductQuery(baseOptions: Apollo.QueryHookOptions<AdminMortgageProductQuery, AdminMortgageProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMortgageProductQuery, AdminMortgageProductQueryVariables>(AdminMortgageProductDocument, options);
      }
export function useAdminMortgageProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMortgageProductQuery, AdminMortgageProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMortgageProductQuery, AdminMortgageProductQueryVariables>(AdminMortgageProductDocument, options);
        }
export type AdminMortgageProductQueryHookResult = ReturnType<typeof useAdminMortgageProductQuery>;
export type AdminMortgageProductLazyQueryHookResult = ReturnType<typeof useAdminMortgageProductLazyQuery>;
export type AdminMortgageProductQueryResult = Apollo.QueryResult<AdminMortgageProductQuery, AdminMortgageProductQueryVariables>;
export const AdminCreateMortgageProductDocumentDocument = gql`
    mutation AdminCreateMortgageProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateMortgageProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateMortgageProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateMortgageProductDocumentMutation, AdminCreateMortgageProductDocumentMutationVariables>;

/**
 * __useAdminCreateMortgageProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateMortgageProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMortgageProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMortgageProductDocumentMutation, { data, loading, error }] = useAdminCreateMortgageProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateMortgageProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMortgageProductDocumentMutation, AdminCreateMortgageProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMortgageProductDocumentMutation, AdminCreateMortgageProductDocumentMutationVariables>(AdminCreateMortgageProductDocumentDocument, options);
      }
export type AdminCreateMortgageProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateMortgageProductDocumentMutation>;
export type AdminCreateMortgageProductDocumentMutationResult = Apollo.MutationResult<AdminCreateMortgageProductDocumentMutation>;
export type AdminCreateMortgageProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateMortgageProductDocumentMutation, AdminCreateMortgageProductDocumentMutationVariables>;
export const AdminMotorLiabilityInsuranceProductDocument = gql`
    query AdminMotorLiabilityInsuranceProduct($id: ID!) {
  detail: adminGetMotorLiabilityInsuranceProduct(id: $id) {
    id
    ...MotorLiabilityInsuranceProduct
  }
}
    ${MotorLiabilityInsuranceProductFragmentDoc}`;

/**
 * __useAdminMotorLiabilityInsuranceProductQuery__
 *
 * To run a query within a React component, call `useAdminMotorLiabilityInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMotorLiabilityInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMotorLiabilityInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminMotorLiabilityInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<AdminMotorLiabilityInsuranceProductQuery, AdminMotorLiabilityInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMotorLiabilityInsuranceProductQuery, AdminMotorLiabilityInsuranceProductQueryVariables>(AdminMotorLiabilityInsuranceProductDocument, options);
      }
export function useAdminMotorLiabilityInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMotorLiabilityInsuranceProductQuery, AdminMotorLiabilityInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMotorLiabilityInsuranceProductQuery, AdminMotorLiabilityInsuranceProductQueryVariables>(AdminMotorLiabilityInsuranceProductDocument, options);
        }
export type AdminMotorLiabilityInsuranceProductQueryHookResult = ReturnType<typeof useAdminMotorLiabilityInsuranceProductQuery>;
export type AdminMotorLiabilityInsuranceProductLazyQueryHookResult = ReturnType<typeof useAdminMotorLiabilityInsuranceProductLazyQuery>;
export type AdminMotorLiabilityInsuranceProductQueryResult = Apollo.QueryResult<AdminMotorLiabilityInsuranceProductQuery, AdminMotorLiabilityInsuranceProductQueryVariables>;
export const AdminCreateMotorLiabilityInsuranceProductDocumentDocument = gql`
    mutation AdminCreateMotorLiabilityInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateMotorLiabilityInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateMotorLiabilityInsuranceProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateMotorLiabilityInsuranceProductDocumentMutation, AdminCreateMotorLiabilityInsuranceProductDocumentMutationVariables>;

/**
 * __useAdminCreateMotorLiabilityInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateMotorLiabilityInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMotorLiabilityInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMotorLiabilityInsuranceProductDocumentMutation, { data, loading, error }] = useAdminCreateMotorLiabilityInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateMotorLiabilityInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMotorLiabilityInsuranceProductDocumentMutation, AdminCreateMotorLiabilityInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMotorLiabilityInsuranceProductDocumentMutation, AdminCreateMotorLiabilityInsuranceProductDocumentMutationVariables>(AdminCreateMotorLiabilityInsuranceProductDocumentDocument, options);
      }
export type AdminCreateMotorLiabilityInsuranceProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateMotorLiabilityInsuranceProductDocumentMutation>;
export type AdminCreateMotorLiabilityInsuranceProductDocumentMutationResult = Apollo.MutationResult<AdminCreateMotorLiabilityInsuranceProductDocumentMutation>;
export type AdminCreateMotorLiabilityInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateMotorLiabilityInsuranceProductDocumentMutation, AdminCreateMotorLiabilityInsuranceProductDocumentMutationVariables>;
export const AdminPropertyInsuranceProductDocument = gql`
    query AdminPropertyInsuranceProduct($id: ID!) {
  detail: adminGetPropertyInsuranceProduct(id: $id) {
    id
    ...PropertyInsuranceProduct
  }
}
    ${PropertyInsuranceProductFragmentDoc}`;

/**
 * __useAdminPropertyInsuranceProductQuery__
 *
 * To run a query within a React component, call `useAdminPropertyInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPropertyInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPropertyInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminPropertyInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<AdminPropertyInsuranceProductQuery, AdminPropertyInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPropertyInsuranceProductQuery, AdminPropertyInsuranceProductQueryVariables>(AdminPropertyInsuranceProductDocument, options);
      }
export function useAdminPropertyInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPropertyInsuranceProductQuery, AdminPropertyInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPropertyInsuranceProductQuery, AdminPropertyInsuranceProductQueryVariables>(AdminPropertyInsuranceProductDocument, options);
        }
export type AdminPropertyInsuranceProductQueryHookResult = ReturnType<typeof useAdminPropertyInsuranceProductQuery>;
export type AdminPropertyInsuranceProductLazyQueryHookResult = ReturnType<typeof useAdminPropertyInsuranceProductLazyQuery>;
export type AdminPropertyInsuranceProductQueryResult = Apollo.QueryResult<AdminPropertyInsuranceProductQuery, AdminPropertyInsuranceProductQueryVariables>;
export const AdminCreatePropertyInsuranceProductDocumentDocument = gql`
    mutation AdminCreatePropertyInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreatePropertyInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreatePropertyInsuranceProductDocumentMutationFn = Apollo.MutationFunction<AdminCreatePropertyInsuranceProductDocumentMutation, AdminCreatePropertyInsuranceProductDocumentMutationVariables>;

/**
 * __useAdminCreatePropertyInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreatePropertyInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePropertyInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePropertyInsuranceProductDocumentMutation, { data, loading, error }] = useAdminCreatePropertyInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreatePropertyInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePropertyInsuranceProductDocumentMutation, AdminCreatePropertyInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePropertyInsuranceProductDocumentMutation, AdminCreatePropertyInsuranceProductDocumentMutationVariables>(AdminCreatePropertyInsuranceProductDocumentDocument, options);
      }
export type AdminCreatePropertyInsuranceProductDocumentMutationHookResult = ReturnType<typeof useAdminCreatePropertyInsuranceProductDocumentMutation>;
export type AdminCreatePropertyInsuranceProductDocumentMutationResult = Apollo.MutationResult<AdminCreatePropertyInsuranceProductDocumentMutation>;
export type AdminCreatePropertyInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreatePropertyInsuranceProductDocumentMutation, AdminCreatePropertyInsuranceProductDocumentMutationVariables>;
export const AdminRetirementPensionSavingsProductDocument = gql`
    query AdminRetirementPensionSavingsProduct($id: ID!) {
  detail: adminGetRetirementPensionSavingsProduct(id: $id) {
    id
    ...RetirementPensionSavingsProduct
  }
}
    ${RetirementPensionSavingsProductFragmentDoc}`;

/**
 * __useAdminRetirementPensionSavingsProductQuery__
 *
 * To run a query within a React component, call `useAdminRetirementPensionSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRetirementPensionSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRetirementPensionSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRetirementPensionSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<AdminRetirementPensionSavingsProductQuery, AdminRetirementPensionSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminRetirementPensionSavingsProductQuery, AdminRetirementPensionSavingsProductQueryVariables>(AdminRetirementPensionSavingsProductDocument, options);
      }
export function useAdminRetirementPensionSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminRetirementPensionSavingsProductQuery, AdminRetirementPensionSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminRetirementPensionSavingsProductQuery, AdminRetirementPensionSavingsProductQueryVariables>(AdminRetirementPensionSavingsProductDocument, options);
        }
export type AdminRetirementPensionSavingsProductQueryHookResult = ReturnType<typeof useAdminRetirementPensionSavingsProductQuery>;
export type AdminRetirementPensionSavingsProductLazyQueryHookResult = ReturnType<typeof useAdminRetirementPensionSavingsProductLazyQuery>;
export type AdminRetirementPensionSavingsProductQueryResult = Apollo.QueryResult<AdminRetirementPensionSavingsProductQuery, AdminRetirementPensionSavingsProductQueryVariables>;
export const AdminCreateRetirementPensionSavingsProductDocumentDocument = gql`
    mutation AdminCreateRetirementPensionSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateRetirementPensionSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateRetirementPensionSavingsProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateRetirementPensionSavingsProductDocumentMutation, AdminCreateRetirementPensionSavingsProductDocumentMutationVariables>;

/**
 * __useAdminCreateRetirementPensionSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateRetirementPensionSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateRetirementPensionSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateRetirementPensionSavingsProductDocumentMutation, { data, loading, error }] = useAdminCreateRetirementPensionSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateRetirementPensionSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateRetirementPensionSavingsProductDocumentMutation, AdminCreateRetirementPensionSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateRetirementPensionSavingsProductDocumentMutation, AdminCreateRetirementPensionSavingsProductDocumentMutationVariables>(AdminCreateRetirementPensionSavingsProductDocumentDocument, options);
      }
export type AdminCreateRetirementPensionSavingsProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateRetirementPensionSavingsProductDocumentMutation>;
export type AdminCreateRetirementPensionSavingsProductDocumentMutationResult = Apollo.MutationResult<AdminCreateRetirementPensionSavingsProductDocumentMutation>;
export type AdminCreateRetirementPensionSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateRetirementPensionSavingsProductDocumentMutation, AdminCreateRetirementPensionSavingsProductDocumentMutationVariables>;
export const AdminSavingsProductDocument = gql`
    query AdminSavingsProduct($id: ID!) {
  detail: adminGetSavingsProduct(id: $id) {
    id
    ...SavingsProduct
  }
}
    ${SavingsProductFragmentDoc}`;

/**
 * __useAdminSavingsProductQuery__
 *
 * To run a query within a React component, call `useAdminSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<AdminSavingsProductQuery, AdminSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSavingsProductQuery, AdminSavingsProductQueryVariables>(AdminSavingsProductDocument, options);
      }
export function useAdminSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSavingsProductQuery, AdminSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSavingsProductQuery, AdminSavingsProductQueryVariables>(AdminSavingsProductDocument, options);
        }
export type AdminSavingsProductQueryHookResult = ReturnType<typeof useAdminSavingsProductQuery>;
export type AdminSavingsProductLazyQueryHookResult = ReturnType<typeof useAdminSavingsProductLazyQuery>;
export type AdminSavingsProductQueryResult = Apollo.QueryResult<AdminSavingsProductQuery, AdminSavingsProductQueryVariables>;
export const AdminCreateSavingsProductDocumentDocument = gql`
    mutation AdminCreateSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateSavingsProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateSavingsProductDocumentMutation, AdminCreateSavingsProductDocumentMutationVariables>;

/**
 * __useAdminCreateSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSavingsProductDocumentMutation, { data, loading, error }] = useAdminCreateSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateSavingsProductDocumentMutation, AdminCreateSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSavingsProductDocumentMutation, AdminCreateSavingsProductDocumentMutationVariables>(AdminCreateSavingsProductDocumentDocument, options);
      }
export type AdminCreateSavingsProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateSavingsProductDocumentMutation>;
export type AdminCreateSavingsProductDocumentMutationResult = Apollo.MutationResult<AdminCreateSavingsProductDocumentMutation>;
export type AdminCreateSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateSavingsProductDocumentMutation, AdminCreateSavingsProductDocumentMutationVariables>;
export const AdminSupplementaryPensionSavingsProductDocument = gql`
    query AdminSupplementaryPensionSavingsProduct($id: ID!) {
  detail: adminGetSupplementaryPensionSavingsProduct(id: $id) {
    id
    ...SupplementaryPensionSavingsProduct
  }
}
    ${SupplementaryPensionSavingsProductFragmentDoc}`;

/**
 * __useAdminSupplementaryPensionSavingsProductQuery__
 *
 * To run a query within a React component, call `useAdminSupplementaryPensionSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSupplementaryPensionSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSupplementaryPensionSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminSupplementaryPensionSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<AdminSupplementaryPensionSavingsProductQuery, AdminSupplementaryPensionSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSupplementaryPensionSavingsProductQuery, AdminSupplementaryPensionSavingsProductQueryVariables>(AdminSupplementaryPensionSavingsProductDocument, options);
      }
export function useAdminSupplementaryPensionSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSupplementaryPensionSavingsProductQuery, AdminSupplementaryPensionSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSupplementaryPensionSavingsProductQuery, AdminSupplementaryPensionSavingsProductQueryVariables>(AdminSupplementaryPensionSavingsProductDocument, options);
        }
export type AdminSupplementaryPensionSavingsProductQueryHookResult = ReturnType<typeof useAdminSupplementaryPensionSavingsProductQuery>;
export type AdminSupplementaryPensionSavingsProductLazyQueryHookResult = ReturnType<typeof useAdminSupplementaryPensionSavingsProductLazyQuery>;
export type AdminSupplementaryPensionSavingsProductQueryResult = Apollo.QueryResult<AdminSupplementaryPensionSavingsProductQuery, AdminSupplementaryPensionSavingsProductQueryVariables>;
export const AdminCreateSupplementaryPensionSavingsProductDocumentDocument = gql`
    mutation AdminCreateSupplementaryPensionSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: adminCreateSupplementaryPensionSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type AdminCreateSupplementaryPensionSavingsProductDocumentMutationFn = Apollo.MutationFunction<AdminCreateSupplementaryPensionSavingsProductDocumentMutation, AdminCreateSupplementaryPensionSavingsProductDocumentMutationVariables>;

/**
 * __useAdminCreateSupplementaryPensionSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useAdminCreateSupplementaryPensionSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSupplementaryPensionSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSupplementaryPensionSavingsProductDocumentMutation, { data, loading, error }] = useAdminCreateSupplementaryPensionSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useAdminCreateSupplementaryPensionSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateSupplementaryPensionSavingsProductDocumentMutation, AdminCreateSupplementaryPensionSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSupplementaryPensionSavingsProductDocumentMutation, AdminCreateSupplementaryPensionSavingsProductDocumentMutationVariables>(AdminCreateSupplementaryPensionSavingsProductDocumentDocument, options);
      }
export type AdminCreateSupplementaryPensionSavingsProductDocumentMutationHookResult = ReturnType<typeof useAdminCreateSupplementaryPensionSavingsProductDocumentMutation>;
export type AdminCreateSupplementaryPensionSavingsProductDocumentMutationResult = Apollo.MutationResult<AdminCreateSupplementaryPensionSavingsProductDocumentMutation>;
export type AdminCreateSupplementaryPensionSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<AdminCreateSupplementaryPensionSavingsProductDocumentMutation, AdminCreateSupplementaryPensionSavingsProductDocumentMutationVariables>;
export const AggregateBalancesDocument = gql`
    query AggregateBalances($groupBy: [BalanceAttribute!], $filterInput: AggregateBalanceFilter) {
  aggregateBalances(groupBy: $groupBy, filterInput: $filterInput) {
    baseCurrency
    resultData {
      ...BalanceValue
    }
  }
}
    ${BalanceValueFragmentDoc}`;

/**
 * __useAggregateBalancesQuery__
 *
 * To run a query within a React component, call `useAggregateBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateBalancesQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useAggregateBalancesQuery(baseOptions?: Apollo.QueryHookOptions<AggregateBalancesQuery, AggregateBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregateBalancesQuery, AggregateBalancesQueryVariables>(AggregateBalancesDocument, options);
      }
export function useAggregateBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregateBalancesQuery, AggregateBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregateBalancesQuery, AggregateBalancesQueryVariables>(AggregateBalancesDocument, options);
        }
export type AggregateBalancesQueryHookResult = ReturnType<typeof useAggregateBalancesQuery>;
export type AggregateBalancesLazyQueryHookResult = ReturnType<typeof useAggregateBalancesLazyQuery>;
export type AggregateBalancesQueryResult = Apollo.QueryResult<AggregateBalancesQuery, AggregateBalancesQueryVariables>;
export const ConnectedAccountsDocument = gql`
    query ConnectedAccounts {
  accounts: getAccountsPage {
    items {
      id
      ...Account
    }
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useConnectedAccountsQuery__
 *
 * To run a query within a React component, call `useConnectedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectedAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedAccountsQuery, ConnectedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedAccountsQuery, ConnectedAccountsQueryVariables>(ConnectedAccountsDocument, options);
      }
export function useConnectedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedAccountsQuery, ConnectedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedAccountsQuery, ConnectedAccountsQueryVariables>(ConnectedAccountsDocument, options);
        }
export type ConnectedAccountsQueryHookResult = ReturnType<typeof useConnectedAccountsQuery>;
export type ConnectedAccountsLazyQueryHookResult = ReturnType<typeof useConnectedAccountsLazyQuery>;
export type ConnectedAccountsQueryResult = Apollo.QueryResult<ConnectedAccountsQuery, ConnectedAccountsQueryVariables>;
export const AccountDetailDocument = gql`
    query AccountDetail($id: ID!) {
  detail: getAccount(accountId: $id) {
    id
    ...Account
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useAccountDetailQuery__
 *
 * To run a query within a React component, call `useAccountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountDetailQuery(baseOptions: Apollo.QueryHookOptions<AccountDetailQuery, AccountDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountDetailQuery, AccountDetailQueryVariables>(AccountDetailDocument, options);
      }
export function useAccountDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountDetailQuery, AccountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountDetailQuery, AccountDetailQueryVariables>(AccountDetailDocument, options);
        }
export type AccountDetailQueryHookResult = ReturnType<typeof useAccountDetailQuery>;
export type AccountDetailLazyQueryHookResult = ReturnType<typeof useAccountDetailLazyQuery>;
export type AccountDetailQueryResult = Apollo.QueryResult<AccountDetailQuery, AccountDetailQueryVariables>;
export const LastAccountsDataRefreshDocument = gql`
    query LastAccountsDataRefresh {
  lastRefresh: getLastAccountsDataRefresh
}
    `;

/**
 * __useLastAccountsDataRefreshQuery__
 *
 * To run a query within a React component, call `useLastAccountsDataRefreshQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastAccountsDataRefreshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastAccountsDataRefreshQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastAccountsDataRefreshQuery(baseOptions?: Apollo.QueryHookOptions<LastAccountsDataRefreshQuery, LastAccountsDataRefreshQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastAccountsDataRefreshQuery, LastAccountsDataRefreshQueryVariables>(LastAccountsDataRefreshDocument, options);
      }
export function useLastAccountsDataRefreshLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastAccountsDataRefreshQuery, LastAccountsDataRefreshQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastAccountsDataRefreshQuery, LastAccountsDataRefreshQueryVariables>(LastAccountsDataRefreshDocument, options);
        }
export type LastAccountsDataRefreshQueryHookResult = ReturnType<typeof useLastAccountsDataRefreshQuery>;
export type LastAccountsDataRefreshLazyQueryHookResult = ReturnType<typeof useLastAccountsDataRefreshLazyQuery>;
export type LastAccountsDataRefreshQueryResult = Apollo.QueryResult<LastAccountsDataRefreshQuery, LastAccountsDataRefreshQueryVariables>;
export const InitNordigenFlowDocument = gql`
    mutation InitNordigenFlow($institutionId: ID!, $redirectUrl: Url!) {
  link: initNordigenFlow(institutionId: $institutionId, redirectUrl: $redirectUrl)
}
    `;
export type InitNordigenFlowMutationFn = Apollo.MutationFunction<InitNordigenFlowMutation, InitNordigenFlowMutationVariables>;

/**
 * __useInitNordigenFlowMutation__
 *
 * To run a mutation, you first call `useInitNordigenFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitNordigenFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initNordigenFlowMutation, { data, loading, error }] = useInitNordigenFlowMutation({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useInitNordigenFlowMutation(baseOptions?: Apollo.MutationHookOptions<InitNordigenFlowMutation, InitNordigenFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitNordigenFlowMutation, InitNordigenFlowMutationVariables>(InitNordigenFlowDocument, options);
      }
export type InitNordigenFlowMutationHookResult = ReturnType<typeof useInitNordigenFlowMutation>;
export type InitNordigenFlowMutationResult = Apollo.MutationResult<InitNordigenFlowMutation>;
export type InitNordigenFlowMutationOptions = Apollo.BaseMutationOptions<InitNordigenFlowMutation, InitNordigenFlowMutationVariables>;
export const SynchronizeAccountsDocument = gql`
    mutation SynchronizeAccounts($requisitionId: UUID!) {
  newAccounts: synchronizeAccounts(requisitionId: $requisitionId) {
    id
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export type SynchronizeAccountsMutationFn = Apollo.MutationFunction<SynchronizeAccountsMutation, SynchronizeAccountsMutationVariables>;

/**
 * __useSynchronizeAccountsMutation__
 *
 * To run a mutation, you first call `useSynchronizeAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynchronizeAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synchronizeAccountsMutation, { data, loading, error }] = useSynchronizeAccountsMutation({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useSynchronizeAccountsMutation(baseOptions?: Apollo.MutationHookOptions<SynchronizeAccountsMutation, SynchronizeAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynchronizeAccountsMutation, SynchronizeAccountsMutationVariables>(SynchronizeAccountsDocument, options);
      }
export type SynchronizeAccountsMutationHookResult = ReturnType<typeof useSynchronizeAccountsMutation>;
export type SynchronizeAccountsMutationResult = Apollo.MutationResult<SynchronizeAccountsMutation>;
export type SynchronizeAccountsMutationOptions = Apollo.BaseMutationOptions<SynchronizeAccountsMutation, SynchronizeAccountsMutationVariables>;
export const RefreshAccountsDataDocument = gql`
    mutation RefreshAccountsData {
  jobId: refreshAccountsData
}
    `;
export type RefreshAccountsDataMutationFn = Apollo.MutationFunction<RefreshAccountsDataMutation, RefreshAccountsDataMutationVariables>;

/**
 * __useRefreshAccountsDataMutation__
 *
 * To run a mutation, you first call `useRefreshAccountsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAccountsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAccountsDataMutation, { data, loading, error }] = useRefreshAccountsDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshAccountsDataMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAccountsDataMutation, RefreshAccountsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAccountsDataMutation, RefreshAccountsDataMutationVariables>(RefreshAccountsDataDocument, options);
      }
export type RefreshAccountsDataMutationHookResult = ReturnType<typeof useRefreshAccountsDataMutation>;
export type RefreshAccountsDataMutationResult = Apollo.MutationResult<RefreshAccountsDataMutation>;
export type RefreshAccountsDataMutationOptions = Apollo.BaseMutationOptions<RefreshAccountsDataMutation, RefreshAccountsDataMutationVariables>;
export const RenameAccountDocument = gql`
    mutation RenameAccount($accountId: ID!, $name: String!) {
  renameAccount(accountId: $accountId, name: $name) {
    id
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export type RenameAccountMutationFn = Apollo.MutationFunction<RenameAccountMutation, RenameAccountMutationVariables>;

/**
 * __useRenameAccountMutation__
 *
 * To run a mutation, you first call `useRenameAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameAccountMutation, { data, loading, error }] = useRenameAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameAccountMutation(baseOptions?: Apollo.MutationHookOptions<RenameAccountMutation, RenameAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameAccountMutation, RenameAccountMutationVariables>(RenameAccountDocument, options);
      }
export type RenameAccountMutationHookResult = ReturnType<typeof useRenameAccountMutation>;
export type RenameAccountMutationResult = Apollo.MutationResult<RenameAccountMutation>;
export type RenameAccountMutationOptions = Apollo.BaseMutationOptions<RenameAccountMutation, RenameAccountMutationVariables>;
export const RemoveAccountDocument = gql`
    mutation RemoveAccount($accountId: ID!) {
  removeAccount(accountId: $accountId)
}
    `;
export type RemoveAccountMutationFn = Apollo.MutationFunction<RemoveAccountMutation, RemoveAccountMutationVariables>;

/**
 * __useRemoveAccountMutation__
 *
 * To run a mutation, you first call `useRemoveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccountMutation, { data, loading, error }] = useRemoveAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRemoveAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccountMutation, RemoveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccountMutation, RemoveAccountMutationVariables>(RemoveAccountDocument, options);
      }
export type RemoveAccountMutationHookResult = ReturnType<typeof useRemoveAccountMutation>;
export type RemoveAccountMutationResult = Apollo.MutationResult<RemoveAccountMutation>;
export type RemoveAccountMutationOptions = Apollo.BaseMutationOptions<RemoveAccountMutation, RemoveAccountMutationVariables>;
export const CalendarEventsDocument = gql`
    query CalendarEvents {
  events: getCalendarEvents {
    id
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;

/**
 * __useCalendarEventsQuery__
 *
 * To run a query within a React component, call `useCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarEventsQuery(baseOptions?: Apollo.QueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
      }
export function useCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
        }
export type CalendarEventsQueryHookResult = ReturnType<typeof useCalendarEventsQuery>;
export type CalendarEventsLazyQueryHookResult = ReturnType<typeof useCalendarEventsLazyQuery>;
export type CalendarEventsQueryResult = Apollo.QueryResult<CalendarEventsQuery, CalendarEventsQueryVariables>;
export const CalendarEventInstancesDocument = gql`
    query CalendarEventInstances($startDate: Date, $endDate: Date) {
  eventInstances: getCalendarEventInstances(
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    ...CalendarEventInstance
  }
}
    ${CalendarEventInstanceFragmentDoc}`;

/**
 * __useCalendarEventInstancesQuery__
 *
 * To run a query within a React component, call `useCalendarEventInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventInstancesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCalendarEventInstancesQuery(baseOptions?: Apollo.QueryHookOptions<CalendarEventInstancesQuery, CalendarEventInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventInstancesQuery, CalendarEventInstancesQueryVariables>(CalendarEventInstancesDocument, options);
      }
export function useCalendarEventInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventInstancesQuery, CalendarEventInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventInstancesQuery, CalendarEventInstancesQueryVariables>(CalendarEventInstancesDocument, options);
        }
export type CalendarEventInstancesQueryHookResult = ReturnType<typeof useCalendarEventInstancesQuery>;
export type CalendarEventInstancesLazyQueryHookResult = ReturnType<typeof useCalendarEventInstancesLazyQuery>;
export type CalendarEventInstancesQueryResult = Apollo.QueryResult<CalendarEventInstancesQuery, CalendarEventInstancesQueryVariables>;
export const CalendarEventDocument = gql`
    query CalendarEvent($id: ID!) {
  detail: getCalendarEvent(id: $id) {
    id
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;

/**
 * __useCalendarEventQuery__
 *
 * To run a query within a React component, call `useCalendarEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventQuery(baseOptions: Apollo.QueryHookOptions<CalendarEventQuery, CalendarEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventQuery, CalendarEventQueryVariables>(CalendarEventDocument, options);
      }
export function useCalendarEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventQuery, CalendarEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventQuery, CalendarEventQueryVariables>(CalendarEventDocument, options);
        }
export type CalendarEventQueryHookResult = ReturnType<typeof useCalendarEventQuery>;
export type CalendarEventLazyQueryHookResult = ReturnType<typeof useCalendarEventLazyQuery>;
export type CalendarEventQueryResult = Apollo.QueryResult<CalendarEventQuery, CalendarEventQueryVariables>;
export const CreateCalendarEventDocument = gql`
    mutation CreateCalendarEvent($event: CalendarEventInput!) {
  createCalendarEvent: createCalendarEvent(event: $event) {
    id
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;
export type CreateCalendarEventMutationFn = Apollo.MutationFunction<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;

/**
 * __useCreateCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarEventMutation, { data, loading, error }] = useCreateCalendarEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useCreateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>(CreateCalendarEventDocument, options);
      }
export type CreateCalendarEventMutationHookResult = ReturnType<typeof useCreateCalendarEventMutation>;
export type CreateCalendarEventMutationResult = Apollo.MutationResult<CreateCalendarEventMutation>;
export type CreateCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;
export const UpdateCalendarEventDocument = gql`
    mutation UpdateCalendarEvent($id: ID!, $updatedEvent: CalendarEventInput!) {
  updateEvent: updateCalendarEvent(id: $id, updatedEvent: $updatedEvent) {
    id
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;
export type UpdateCalendarEventMutationFn = Apollo.MutationFunction<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;

/**
 * __useUpdateCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarEventMutation, { data, loading, error }] = useUpdateCalendarEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedEvent: // value for 'updatedEvent'
 *   },
 * });
 */
export function useUpdateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>(UpdateCalendarEventDocument, options);
      }
export type UpdateCalendarEventMutationHookResult = ReturnType<typeof useUpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationResult = Apollo.MutationResult<UpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;
export const DeleteCalendarEventDocument = gql`
    mutation DeleteCalendarEvent($id: ID!) {
  deleteEvent: deleteCalendarEvent(id: $id)
}
    `;
export type DeleteCalendarEventMutationFn = Apollo.MutationFunction<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarEventMutation, { data, loading, error }] = useDeleteCalendarEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>(DeleteCalendarEventDocument, options);
      }
export type DeleteCalendarEventMutationHookResult = ReturnType<typeof useDeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationResult = Apollo.MutationResult<DeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;
export const CashFlowAdjustmentsDocument = gql`
    query CashFlowAdjustments($filterInput: FilterInput, $sortInput: SortInput) {
  cashFlowAdjustments: getCashFlowAdjustmentsPage(
    filterInput: $filterInput
    sortInput: $sortInput
  ) {
    items {
      id
      ...CashFlowAdjustment
    }
    totalItems
  }
}
    ${CashFlowAdjustmentFragmentDoc}`;

/**
 * __useCashFlowAdjustmentsQuery__
 *
 * To run a query within a React component, call `useCashFlowAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowAdjustmentsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useCashFlowAdjustmentsQuery(baseOptions?: Apollo.QueryHookOptions<CashFlowAdjustmentsQuery, CashFlowAdjustmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashFlowAdjustmentsQuery, CashFlowAdjustmentsQueryVariables>(CashFlowAdjustmentsDocument, options);
      }
export function useCashFlowAdjustmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowAdjustmentsQuery, CashFlowAdjustmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashFlowAdjustmentsQuery, CashFlowAdjustmentsQueryVariables>(CashFlowAdjustmentsDocument, options);
        }
export type CashFlowAdjustmentsQueryHookResult = ReturnType<typeof useCashFlowAdjustmentsQuery>;
export type CashFlowAdjustmentsLazyQueryHookResult = ReturnType<typeof useCashFlowAdjustmentsLazyQuery>;
export type CashFlowAdjustmentsQueryResult = Apollo.QueryResult<CashFlowAdjustmentsQuery, CashFlowAdjustmentsQueryVariables>;
export const CashFlowAdjustmentDocument = gql`
    query CashFlowAdjustment($id: ID!) {
  detail: getCashFlowAdjustment(id: $id) {
    id
    ...CashFlowAdjustment
  }
}
    ${CashFlowAdjustmentFragmentDoc}`;

/**
 * __useCashFlowAdjustmentQuery__
 *
 * To run a query within a React component, call `useCashFlowAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashFlowAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashFlowAdjustmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCashFlowAdjustmentQuery(baseOptions: Apollo.QueryHookOptions<CashFlowAdjustmentQuery, CashFlowAdjustmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashFlowAdjustmentQuery, CashFlowAdjustmentQueryVariables>(CashFlowAdjustmentDocument, options);
      }
export function useCashFlowAdjustmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashFlowAdjustmentQuery, CashFlowAdjustmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashFlowAdjustmentQuery, CashFlowAdjustmentQueryVariables>(CashFlowAdjustmentDocument, options);
        }
export type CashFlowAdjustmentQueryHookResult = ReturnType<typeof useCashFlowAdjustmentQuery>;
export type CashFlowAdjustmentLazyQueryHookResult = ReturnType<typeof useCashFlowAdjustmentLazyQuery>;
export type CashFlowAdjustmentQueryResult = Apollo.QueryResult<CashFlowAdjustmentQuery, CashFlowAdjustmentQueryVariables>;
export const CreateCashFlowAdjustmentDocument = gql`
    mutation CreateCashFlowAdjustment($cashFlowAdjustment: CashFlowAdjustmentInput!) {
  createCashFlowAdjustment: createCashFlowAdjustment(
    cashFlowAdjustment: $cashFlowAdjustment
  ) {
    id
    ...CashFlowAdjustment
  }
}
    ${CashFlowAdjustmentFragmentDoc}`;
export type CreateCashFlowAdjustmentMutationFn = Apollo.MutationFunction<CreateCashFlowAdjustmentMutation, CreateCashFlowAdjustmentMutationVariables>;

/**
 * __useCreateCashFlowAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateCashFlowAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFlowAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFlowAdjustmentMutation, { data, loading, error }] = useCreateCashFlowAdjustmentMutation({
 *   variables: {
 *      cashFlowAdjustment: // value for 'cashFlowAdjustment'
 *   },
 * });
 */
export function useCreateCashFlowAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashFlowAdjustmentMutation, CreateCashFlowAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashFlowAdjustmentMutation, CreateCashFlowAdjustmentMutationVariables>(CreateCashFlowAdjustmentDocument, options);
      }
export type CreateCashFlowAdjustmentMutationHookResult = ReturnType<typeof useCreateCashFlowAdjustmentMutation>;
export type CreateCashFlowAdjustmentMutationResult = Apollo.MutationResult<CreateCashFlowAdjustmentMutation>;
export type CreateCashFlowAdjustmentMutationOptions = Apollo.BaseMutationOptions<CreateCashFlowAdjustmentMutation, CreateCashFlowAdjustmentMutationVariables>;
export const UpdateCashFlowAdjustmentDocument = gql`
    mutation UpdateCashFlowAdjustment($id: ID!, $updatedCashFlowAdjustment: CashFlowAdjustmentInput!) {
  updateCashFlowAdjustment: updateCashFlowAdjustment(
    id: $id
    updatedCashFlowAdjustment: $updatedCashFlowAdjustment
  ) {
    id
    ...CashFlowAdjustment
  }
}
    ${CashFlowAdjustmentFragmentDoc}`;
export type UpdateCashFlowAdjustmentMutationFn = Apollo.MutationFunction<UpdateCashFlowAdjustmentMutation, UpdateCashFlowAdjustmentMutationVariables>;

/**
 * __useUpdateCashFlowAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpdateCashFlowAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashFlowAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashFlowAdjustmentMutation, { data, loading, error }] = useUpdateCashFlowAdjustmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedCashFlowAdjustment: // value for 'updatedCashFlowAdjustment'
 *   },
 * });
 */
export function useUpdateCashFlowAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashFlowAdjustmentMutation, UpdateCashFlowAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCashFlowAdjustmentMutation, UpdateCashFlowAdjustmentMutationVariables>(UpdateCashFlowAdjustmentDocument, options);
      }
export type UpdateCashFlowAdjustmentMutationHookResult = ReturnType<typeof useUpdateCashFlowAdjustmentMutation>;
export type UpdateCashFlowAdjustmentMutationResult = Apollo.MutationResult<UpdateCashFlowAdjustmentMutation>;
export type UpdateCashFlowAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpdateCashFlowAdjustmentMutation, UpdateCashFlowAdjustmentMutationVariables>;
export const DeleteCashFlowAdjustmentDocument = gql`
    mutation DeleteCashFlowAdjustment($id: ID!) {
  deleteCashFlowAdjustment: deleteCashFlowAdjustment(id: $id)
}
    `;
export type DeleteCashFlowAdjustmentMutationFn = Apollo.MutationFunction<DeleteCashFlowAdjustmentMutation, DeleteCashFlowAdjustmentMutationVariables>;

/**
 * __useDeleteCashFlowAdjustmentMutation__
 *
 * To run a mutation, you first call `useDeleteCashFlowAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCashFlowAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCashFlowAdjustmentMutation, { data, loading, error }] = useDeleteCashFlowAdjustmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCashFlowAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCashFlowAdjustmentMutation, DeleteCashFlowAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCashFlowAdjustmentMutation, DeleteCashFlowAdjustmentMutationVariables>(DeleteCashFlowAdjustmentDocument, options);
      }
export type DeleteCashFlowAdjustmentMutationHookResult = ReturnType<typeof useDeleteCashFlowAdjustmentMutation>;
export type DeleteCashFlowAdjustmentMutationResult = Apollo.MutationResult<DeleteCashFlowAdjustmentMutation>;
export type DeleteCashFlowAdjustmentMutationOptions = Apollo.BaseMutationOptions<DeleteCashFlowAdjustmentMutation, DeleteCashFlowAdjustmentMutationVariables>;
export const BudgetDocument = gql`
    query Budget($asOfDate: Date) {
  budget: getBudget(asOfDate: $asOfDate)
}
    `;

/**
 * __useBudgetQuery__
 *
 * To run a query within a React component, call `useBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useBudgetQuery(baseOptions?: Apollo.QueryHookOptions<BudgetQuery, BudgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BudgetQuery, BudgetQueryVariables>(BudgetDocument, options);
      }
export function useBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetQuery, BudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BudgetQuery, BudgetQueryVariables>(BudgetDocument, options);
        }
export type BudgetQueryHookResult = ReturnType<typeof useBudgetQuery>;
export type BudgetLazyQueryHookResult = ReturnType<typeof useBudgetLazyQuery>;
export type BudgetQueryResult = Apollo.QueryResult<BudgetQuery, BudgetQueryVariables>;
export const SetBudgetDocument = gql`
    mutation SetBudget($amountInBaseCurrency: BigDecimal!, $sinceDate: Date) {
  setBudget(amountInBaseCurrency: $amountInBaseCurrency, sinceDate: $sinceDate)
}
    `;
export type SetBudgetMutationFn = Apollo.MutationFunction<SetBudgetMutation, SetBudgetMutationVariables>;

/**
 * __useSetBudgetMutation__
 *
 * To run a mutation, you first call `useSetBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBudgetMutation, { data, loading, error }] = useSetBudgetMutation({
 *   variables: {
 *      amountInBaseCurrency: // value for 'amountInBaseCurrency'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useSetBudgetMutation(baseOptions?: Apollo.MutationHookOptions<SetBudgetMutation, SetBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBudgetMutation, SetBudgetMutationVariables>(SetBudgetDocument, options);
      }
export type SetBudgetMutationHookResult = ReturnType<typeof useSetBudgetMutation>;
export type SetBudgetMutationResult = Apollo.MutationResult<SetBudgetMutation>;
export type SetBudgetMutationOptions = Apollo.BaseMutationOptions<SetBudgetMutation, SetBudgetMutationVariables>;
export const UpcomingPaymentsDocument = gql`
    query UpcomingPayments($pageInput: PageInput, $filterInput: UpcomingPaymentFilter!) {
  upcomingPaymentsList: getUpcomingPaymentsPage(
    pageInput: $pageInput
    filterInput: $filterInput
  ) {
    totalItems
    pageIndex
    pageSize
    items {
      ...UpcomingPaymentListItem
    }
  }
}
    ${UpcomingPaymentListItemFragmentDoc}`;

/**
 * __useUpcomingPaymentsQuery__
 *
 * To run a query within a React component, call `useUpcomingPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingPaymentsQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useUpcomingPaymentsQuery(baseOptions: Apollo.QueryHookOptions<UpcomingPaymentsQuery, UpcomingPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingPaymentsQuery, UpcomingPaymentsQueryVariables>(UpcomingPaymentsDocument, options);
      }
export function useUpcomingPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingPaymentsQuery, UpcomingPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingPaymentsQuery, UpcomingPaymentsQueryVariables>(UpcomingPaymentsDocument, options);
        }
export type UpcomingPaymentsQueryHookResult = ReturnType<typeof useUpcomingPaymentsQuery>;
export type UpcomingPaymentsLazyQueryHookResult = ReturnType<typeof useUpcomingPaymentsLazyQuery>;
export type UpcomingPaymentsQueryResult = Apollo.QueryResult<UpcomingPaymentsQuery, UpcomingPaymentsQueryVariables>;
export const AggregateUpcomingPaymentsDocument = gql`
    query AggregateUpcomingPayments($groupBy: [UpcomingPaymentAttribute!], $filterInput: UpcomingPaymentFilter!) {
  aggregateUpcomingPayments(groupBy: $groupBy, filterInput: $filterInput) {
    baseCurrency
    resultData {
      ...UpcomingPaymentAggregationValue
    }
  }
}
    ${UpcomingPaymentAggregationValueFragmentDoc}`;

/**
 * __useAggregateUpcomingPaymentsQuery__
 *
 * To run a query within a React component, call `useAggregateUpcomingPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateUpcomingPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateUpcomingPaymentsQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useAggregateUpcomingPaymentsQuery(baseOptions: Apollo.QueryHookOptions<AggregateUpcomingPaymentsQuery, AggregateUpcomingPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregateUpcomingPaymentsQuery, AggregateUpcomingPaymentsQueryVariables>(AggregateUpcomingPaymentsDocument, options);
      }
export function useAggregateUpcomingPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregateUpcomingPaymentsQuery, AggregateUpcomingPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregateUpcomingPaymentsQuery, AggregateUpcomingPaymentsQueryVariables>(AggregateUpcomingPaymentsDocument, options);
        }
export type AggregateUpcomingPaymentsQueryHookResult = ReturnType<typeof useAggregateUpcomingPaymentsQuery>;
export type AggregateUpcomingPaymentsLazyQueryHookResult = ReturnType<typeof useAggregateUpcomingPaymentsLazyQuery>;
export type AggregateUpcomingPaymentsQueryResult = Apollo.QueryResult<AggregateUpcomingPaymentsQuery, AggregateUpcomingPaymentsQueryVariables>;
export const ServiceLocationsDocument = gql`
    query ServiceLocations($filterInput: FilterInput, $sortInput: SortInput) {
  serviceLocations: getServiceLocationsPage(
    filterInput: $filterInput
    sortInput: $sortInput
  ) {
    items {
      id
      ...ServiceLocation
    }
    totalItems
  }
}
    ${ServiceLocationFragmentDoc}`;

/**
 * __useServiceLocationsQuery__
 *
 * To run a query within a React component, call `useServiceLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceLocationsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useServiceLocationsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceLocationsQuery, ServiceLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceLocationsQuery, ServiceLocationsQueryVariables>(ServiceLocationsDocument, options);
      }
export function useServiceLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceLocationsQuery, ServiceLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceLocationsQuery, ServiceLocationsQueryVariables>(ServiceLocationsDocument, options);
        }
export type ServiceLocationsQueryHookResult = ReturnType<typeof useServiceLocationsQuery>;
export type ServiceLocationsLazyQueryHookResult = ReturnType<typeof useServiceLocationsLazyQuery>;
export type ServiceLocationsQueryResult = Apollo.QueryResult<ServiceLocationsQuery, ServiceLocationsQueryVariables>;
export const ClientProfileDocument = gql`
    query ClientProfile {
  clientProfile: getClientProfile {
    id
    ...ClientProfile
  }
}
    ${ClientProfileFragmentDoc}`;

/**
 * __useClientProfileQuery__
 *
 * To run a query within a React component, call `useClientProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientProfileQuery(baseOptions?: Apollo.QueryHookOptions<ClientProfileQuery, ClientProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfileQuery, ClientProfileQueryVariables>(ClientProfileDocument, options);
      }
export function useClientProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfileQuery, ClientProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfileQuery, ClientProfileQueryVariables>(ClientProfileDocument, options);
        }
export type ClientProfileQueryHookResult = ReturnType<typeof useClientProfileQuery>;
export type ClientProfileLazyQueryHookResult = ReturnType<typeof useClientProfileLazyQuery>;
export type ClientProfileQueryResult = Apollo.QueryResult<ClientProfileQuery, ClientProfileQueryVariables>;
export const UpdateClientProfileDocument = gql`
    mutation UpdateClientProfile($clientProfile: ClientProfileInput!) {
  clientProfile: createOrUpdateClientProfile(clientProfile: $clientProfile) {
    id
    ...ClientProfile
  }
}
    ${ClientProfileFragmentDoc}`;
export type UpdateClientProfileMutationFn = Apollo.MutationFunction<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>;

/**
 * __useUpdateClientProfileMutation__
 *
 * To run a mutation, you first call `useUpdateClientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientProfileMutation, { data, loading, error }] = useUpdateClientProfileMutation({
 *   variables: {
 *      clientProfile: // value for 'clientProfile'
 *   },
 * });
 */
export function useUpdateClientProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>(UpdateClientProfileDocument, options);
      }
export type UpdateClientProfileMutationHookResult = ReturnType<typeof useUpdateClientProfileMutation>;
export type UpdateClientProfileMutationResult = Apollo.MutationResult<UpdateClientProfileMutation>;
export type UpdateClientProfileMutationOptions = Apollo.BaseMutationOptions<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>;
export const GenerateFileDownloadUrlDocument = gql`
    mutation GenerateFileDownloadUrl($fileId: ID!, $contentDisposition: String) {
  generateFileDownloadUrl(
    fileId: $fileId
    contentDisposition: $contentDisposition
  )
}
    `;
export type GenerateFileDownloadUrlMutationFn = Apollo.MutationFunction<GenerateFileDownloadUrlMutation, GenerateFileDownloadUrlMutationVariables>;

/**
 * __useGenerateFileDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateFileDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFileDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFileDownloadUrlMutation, { data, loading, error }] = useGenerateFileDownloadUrlMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      contentDisposition: // value for 'contentDisposition'
 *   },
 * });
 */
export function useGenerateFileDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFileDownloadUrlMutation, GenerateFileDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateFileDownloadUrlMutation, GenerateFileDownloadUrlMutationVariables>(GenerateFileDownloadUrlDocument, options);
      }
export type GenerateFileDownloadUrlMutationHookResult = ReturnType<typeof useGenerateFileDownloadUrlMutation>;
export type GenerateFileDownloadUrlMutationResult = Apollo.MutationResult<GenerateFileDownloadUrlMutation>;
export type GenerateFileDownloadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateFileDownloadUrlMutation, GenerateFileDownloadUrlMutationVariables>;
export const PermanentFileLinkDocument = gql`
    query PermanentFileLink($fileId: ID!) {
  permanentFileLink: getPermanentFileLink(fileId: $fileId)
}
    `;

/**
 * __usePermanentFileLinkQuery__
 *
 * To run a query within a React component, call `usePermanentFileLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermanentFileLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermanentFileLinkQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function usePermanentFileLinkQuery(baseOptions: Apollo.QueryHookOptions<PermanentFileLinkQuery, PermanentFileLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermanentFileLinkQuery, PermanentFileLinkQueryVariables>(PermanentFileLinkDocument, options);
      }
export function usePermanentFileLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermanentFileLinkQuery, PermanentFileLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermanentFileLinkQuery, PermanentFileLinkQueryVariables>(PermanentFileLinkDocument, options);
        }
export type PermanentFileLinkQueryHookResult = ReturnType<typeof usePermanentFileLinkQuery>;
export type PermanentFileLinkLazyQueryHookResult = ReturnType<typeof usePermanentFileLinkLazyQuery>;
export type PermanentFileLinkQueryResult = Apollo.QueryResult<PermanentFileLinkQuery, PermanentFileLinkQueryVariables>;
export const AllProcessesDocument = gql`
    query AllProcesses {
  purchaseProcesses: getMortgagePurchaseProcessesPage {
    items {
      id
      updateTimestamp
      inquiry {
        id
        inquiryCurrentStepUrl
        inquiryProgress
      }
      acceptedProposal {
        id
      }
      acceptedTimestamp
    }
  }
  refinanceProcesses: getMortgageRefinanceProcessesPage {
    items {
      id
      updateTimestamp
      inquiry {
        id
        inquiryCurrentStepUrl
        inquiryProgress
      }
      acceptedProposal {
        id
      }
      acceptedTimestamp
    }
  }
  lifeInsuranceProcesses: getLifeInsurancePurchaseProcessesPage {
    items {
      id
      updateTimestamp
      inquiry {
        id
        inquiryCurrentStepUrl
        inquiryProgress
      }
      locked
    }
  }
  lifeInsuranceAuditProcesses: getLifeInsuranceAuditProcessesPage {
    items {
      id
      updateTimestamp
      inquiry {
        id
        inquiryCurrentStepUrl
        inquiryProgress
      }
      locked
    }
  }
}
    `;

/**
 * __useAllProcessesQuery__
 *
 * To run a query within a React component, call `useAllProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProcessesQuery(baseOptions?: Apollo.QueryHookOptions<AllProcessesQuery, AllProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProcessesQuery, AllProcessesQueryVariables>(AllProcessesDocument, options);
      }
export function useAllProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProcessesQuery, AllProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProcessesQuery, AllProcessesQueryVariables>(AllProcessesDocument, options);
        }
export type AllProcessesQueryHookResult = ReturnType<typeof useAllProcessesQuery>;
export type AllProcessesLazyQueryHookResult = ReturnType<typeof useAllProcessesLazyQuery>;
export type AllProcessesQueryResult = Apollo.QueryResult<AllProcessesQuery, AllProcessesQueryVariables>;
export const FinancialReservesDocument = gql`
    query FinancialReserves($filterInput: FilterInput, $sortInput: SortInput) {
  financialReserves: getFinancialReservesPage(
    filterInput: $filterInput
    sortInput: $sortInput
  ) {
    items {
      id
      ...FinancialReserve
    }
    totalItems
  }
}
    ${FinancialReserveFragmentDoc}`;

/**
 * __useFinancialReservesQuery__
 *
 * To run a query within a React component, call `useFinancialReservesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialReservesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialReservesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useFinancialReservesQuery(baseOptions?: Apollo.QueryHookOptions<FinancialReservesQuery, FinancialReservesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialReservesQuery, FinancialReservesQueryVariables>(FinancialReservesDocument, options);
      }
export function useFinancialReservesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialReservesQuery, FinancialReservesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialReservesQuery, FinancialReservesQueryVariables>(FinancialReservesDocument, options);
        }
export type FinancialReservesQueryHookResult = ReturnType<typeof useFinancialReservesQuery>;
export type FinancialReservesLazyQueryHookResult = ReturnType<typeof useFinancialReservesLazyQuery>;
export type FinancialReservesQueryResult = Apollo.QueryResult<FinancialReservesQuery, FinancialReservesQueryVariables>;
export const FinancialReserveDocument = gql`
    query FinancialReserve($id: ID!) {
  detail: getFinancialReserve(id: $id) {
    id
    ...FinancialReserve
  }
}
    ${FinancialReserveFragmentDoc}`;

/**
 * __useFinancialReserveQuery__
 *
 * To run a query within a React component, call `useFinancialReserveQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialReserveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialReserveQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinancialReserveQuery(baseOptions: Apollo.QueryHookOptions<FinancialReserveQuery, FinancialReserveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialReserveQuery, FinancialReserveQueryVariables>(FinancialReserveDocument, options);
      }
export function useFinancialReserveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialReserveQuery, FinancialReserveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialReserveQuery, FinancialReserveQueryVariables>(FinancialReserveDocument, options);
        }
export type FinancialReserveQueryHookResult = ReturnType<typeof useFinancialReserveQuery>;
export type FinancialReserveLazyQueryHookResult = ReturnType<typeof useFinancialReserveLazyQuery>;
export type FinancialReserveQueryResult = Apollo.QueryResult<FinancialReserveQuery, FinancialReserveQueryVariables>;
export const CreateFinancialReserveDocument = gql`
    mutation CreateFinancialReserve($financialReserve: FinancialReserveInput!) {
  createFinancialReserve: createFinancialReserve(
    financialReserve: $financialReserve
  ) {
    id
    ...FinancialReserve
  }
}
    ${FinancialReserveFragmentDoc}`;
export type CreateFinancialReserveMutationFn = Apollo.MutationFunction<CreateFinancialReserveMutation, CreateFinancialReserveMutationVariables>;

/**
 * __useCreateFinancialReserveMutation__
 *
 * To run a mutation, you first call `useCreateFinancialReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinancialReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinancialReserveMutation, { data, loading, error }] = useCreateFinancialReserveMutation({
 *   variables: {
 *      financialReserve: // value for 'financialReserve'
 *   },
 * });
 */
export function useCreateFinancialReserveMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinancialReserveMutation, CreateFinancialReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinancialReserveMutation, CreateFinancialReserveMutationVariables>(CreateFinancialReserveDocument, options);
      }
export type CreateFinancialReserveMutationHookResult = ReturnType<typeof useCreateFinancialReserveMutation>;
export type CreateFinancialReserveMutationResult = Apollo.MutationResult<CreateFinancialReserveMutation>;
export type CreateFinancialReserveMutationOptions = Apollo.BaseMutationOptions<CreateFinancialReserveMutation, CreateFinancialReserveMutationVariables>;
export const UpdateFinancialReserveDocument = gql`
    mutation UpdateFinancialReserve($id: ID!, $updatedFinancialReserve: FinancialReserveInput!) {
  updateFinancialReserve: updateFinancialReserve(
    id: $id
    updatedFinancialReserve: $updatedFinancialReserve
  ) {
    id
    ...FinancialReserve
  }
}
    ${FinancialReserveFragmentDoc}`;
export type UpdateFinancialReserveMutationFn = Apollo.MutationFunction<UpdateFinancialReserveMutation, UpdateFinancialReserveMutationVariables>;

/**
 * __useUpdateFinancialReserveMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialReserveMutation, { data, loading, error }] = useUpdateFinancialReserveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedFinancialReserve: // value for 'updatedFinancialReserve'
 *   },
 * });
 */
export function useUpdateFinancialReserveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialReserveMutation, UpdateFinancialReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialReserveMutation, UpdateFinancialReserveMutationVariables>(UpdateFinancialReserveDocument, options);
      }
export type UpdateFinancialReserveMutationHookResult = ReturnType<typeof useUpdateFinancialReserveMutation>;
export type UpdateFinancialReserveMutationResult = Apollo.MutationResult<UpdateFinancialReserveMutation>;
export type UpdateFinancialReserveMutationOptions = Apollo.BaseMutationOptions<UpdateFinancialReserveMutation, UpdateFinancialReserveMutationVariables>;
export const DeleteFinancialReserveDocument = gql`
    mutation DeleteFinancialReserve($id: ID!) {
  deleteFinancialReserve: deleteFinancialReserve(id: $id)
}
    `;
export type DeleteFinancialReserveMutationFn = Apollo.MutationFunction<DeleteFinancialReserveMutation, DeleteFinancialReserveMutationVariables>;

/**
 * __useDeleteFinancialReserveMutation__
 *
 * To run a mutation, you first call `useDeleteFinancialReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinancialReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinancialReserveMutation, { data, loading, error }] = useDeleteFinancialReserveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFinancialReserveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFinancialReserveMutation, DeleteFinancialReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFinancialReserveMutation, DeleteFinancialReserveMutationVariables>(DeleteFinancialReserveDocument, options);
      }
export type DeleteFinancialReserveMutationHookResult = ReturnType<typeof useDeleteFinancialReserveMutation>;
export type DeleteFinancialReserveMutationResult = Apollo.MutationResult<DeleteFinancialReserveMutation>;
export type DeleteFinancialReserveMutationOptions = Apollo.BaseMutationOptions<DeleteFinancialReserveMutation, DeleteFinancialReserveMutationVariables>;
export const MortgagePurchaseTuningLimitsByProcessIdDocument = gql`
    query MortgagePurchaseTuningLimitsByProcessId($processId: ID!) {
  limits: calculateMortgagePurchaseTuningLimitsByProcessId(processId: $processId) {
    amountDefault {
      amount
      currency
    }
    amountRange {
      first {
        amount
        currency
      }
      second {
        amount
        currency
      }
    }
    fixationDefault
    fixationOptions
    maturityInYearsDefault
    maturityInYearsRange {
      lower
      upper
    }
  }
}
    `;

/**
 * __useMortgagePurchaseTuningLimitsByProcessIdQuery__
 *
 * To run a query within a React component, call `useMortgagePurchaseTuningLimitsByProcessIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgagePurchaseTuningLimitsByProcessIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgagePurchaseTuningLimitsByProcessIdQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useMortgagePurchaseTuningLimitsByProcessIdQuery(baseOptions: Apollo.QueryHookOptions<MortgagePurchaseTuningLimitsByProcessIdQuery, MortgagePurchaseTuningLimitsByProcessIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgagePurchaseTuningLimitsByProcessIdQuery, MortgagePurchaseTuningLimitsByProcessIdQueryVariables>(MortgagePurchaseTuningLimitsByProcessIdDocument, options);
      }
export function useMortgagePurchaseTuningLimitsByProcessIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgagePurchaseTuningLimitsByProcessIdQuery, MortgagePurchaseTuningLimitsByProcessIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgagePurchaseTuningLimitsByProcessIdQuery, MortgagePurchaseTuningLimitsByProcessIdQueryVariables>(MortgagePurchaseTuningLimitsByProcessIdDocument, options);
        }
export type MortgagePurchaseTuningLimitsByProcessIdQueryHookResult = ReturnType<typeof useMortgagePurchaseTuningLimitsByProcessIdQuery>;
export type MortgagePurchaseTuningLimitsByProcessIdLazyQueryHookResult = ReturnType<typeof useMortgagePurchaseTuningLimitsByProcessIdLazyQuery>;
export type MortgagePurchaseTuningLimitsByProcessIdQueryResult = Apollo.QueryResult<MortgagePurchaseTuningLimitsByProcessIdQuery, MortgagePurchaseTuningLimitsByProcessIdQueryVariables>;
export const CalculateMortgagePurchaseResultByProcessIdDocument = gql`
    mutation CalculateMortgagePurchaseResultByProcessId($processId: ID!, $tuning: MortgagePurchaseTuningInput!) {
  result: calculateAndSaveMortgagePurchaseResultByProcessId(
    processId: $processId
    tuning: $tuning
  ) {
    id
    proposals {
      ...DetailedMortgageProposal
    }
    creationTimestamp
  }
}
    ${DetailedMortgageProposalFragmentDoc}`;
export type CalculateMortgagePurchaseResultByProcessIdMutationFn = Apollo.MutationFunction<CalculateMortgagePurchaseResultByProcessIdMutation, CalculateMortgagePurchaseResultByProcessIdMutationVariables>;

/**
 * __useCalculateMortgagePurchaseResultByProcessIdMutation__
 *
 * To run a mutation, you first call `useCalculateMortgagePurchaseResultByProcessIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateMortgagePurchaseResultByProcessIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateMortgagePurchaseResultByProcessIdMutation, { data, loading, error }] = useCalculateMortgagePurchaseResultByProcessIdMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *      tuning: // value for 'tuning'
 *   },
 * });
 */
export function useCalculateMortgagePurchaseResultByProcessIdMutation(baseOptions?: Apollo.MutationHookOptions<CalculateMortgagePurchaseResultByProcessIdMutation, CalculateMortgagePurchaseResultByProcessIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateMortgagePurchaseResultByProcessIdMutation, CalculateMortgagePurchaseResultByProcessIdMutationVariables>(CalculateMortgagePurchaseResultByProcessIdDocument, options);
      }
export type CalculateMortgagePurchaseResultByProcessIdMutationHookResult = ReturnType<typeof useCalculateMortgagePurchaseResultByProcessIdMutation>;
export type CalculateMortgagePurchaseResultByProcessIdMutationResult = Apollo.MutationResult<CalculateMortgagePurchaseResultByProcessIdMutation>;
export type CalculateMortgagePurchaseResultByProcessIdMutationOptions = Apollo.BaseMutationOptions<CalculateMortgagePurchaseResultByProcessIdMutation, CalculateMortgagePurchaseResultByProcessIdMutationVariables>;
export const CalculateMortgagePurchaseResultByInquiryDocument = gql`
    query CalculateMortgagePurchaseResultByInquiry($inquiry: MortgagePurchaseInquiryInput!) {
  result: calculateMortgagePurchaseResultByInquiry(inquiry: $inquiry) {
    id
    proposals {
      ...DetailedMortgageProposal
    }
    creationTimestamp
  }
}
    ${DetailedMortgageProposalFragmentDoc}`;

/**
 * __useCalculateMortgagePurchaseResultByInquiryQuery__
 *
 * To run a query within a React component, call `useCalculateMortgagePurchaseResultByInquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateMortgagePurchaseResultByInquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateMortgagePurchaseResultByInquiryQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useCalculateMortgagePurchaseResultByInquiryQuery(baseOptions: Apollo.QueryHookOptions<CalculateMortgagePurchaseResultByInquiryQuery, CalculateMortgagePurchaseResultByInquiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateMortgagePurchaseResultByInquiryQuery, CalculateMortgagePurchaseResultByInquiryQueryVariables>(CalculateMortgagePurchaseResultByInquiryDocument, options);
      }
export function useCalculateMortgagePurchaseResultByInquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateMortgagePurchaseResultByInquiryQuery, CalculateMortgagePurchaseResultByInquiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateMortgagePurchaseResultByInquiryQuery, CalculateMortgagePurchaseResultByInquiryQueryVariables>(CalculateMortgagePurchaseResultByInquiryDocument, options);
        }
export type CalculateMortgagePurchaseResultByInquiryQueryHookResult = ReturnType<typeof useCalculateMortgagePurchaseResultByInquiryQuery>;
export type CalculateMortgagePurchaseResultByInquiryLazyQueryHookResult = ReturnType<typeof useCalculateMortgagePurchaseResultByInquiryLazyQuery>;
export type CalculateMortgagePurchaseResultByInquiryQueryResult = Apollo.QueryResult<CalculateMortgagePurchaseResultByInquiryQuery, CalculateMortgagePurchaseResultByInquiryQueryVariables>;
export const AcceptMortgagePurchaseProposalDocument = gql`
    mutation AcceptMortgagePurchaseProposal($processId: ID!, $acceptanceType: MortgagePurchaseProcessAcceptanceType!) {
  acceptMortgagePurchaseProposal(
    processId: $processId
    acceptanceType: $acceptanceType
  ) {
    id
  }
}
    `;
export type AcceptMortgagePurchaseProposalMutationFn = Apollo.MutationFunction<AcceptMortgagePurchaseProposalMutation, AcceptMortgagePurchaseProposalMutationVariables>;

/**
 * __useAcceptMortgagePurchaseProposalMutation__
 *
 * To run a mutation, you first call `useAcceptMortgagePurchaseProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptMortgagePurchaseProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptMortgagePurchaseProposalMutation, { data, loading, error }] = useAcceptMortgagePurchaseProposalMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *      acceptanceType: // value for 'acceptanceType'
 *   },
 * });
 */
export function useAcceptMortgagePurchaseProposalMutation(baseOptions?: Apollo.MutationHookOptions<AcceptMortgagePurchaseProposalMutation, AcceptMortgagePurchaseProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptMortgagePurchaseProposalMutation, AcceptMortgagePurchaseProposalMutationVariables>(AcceptMortgagePurchaseProposalDocument, options);
      }
export type AcceptMortgagePurchaseProposalMutationHookResult = ReturnType<typeof useAcceptMortgagePurchaseProposalMutation>;
export type AcceptMortgagePurchaseProposalMutationResult = Apollo.MutationResult<AcceptMortgagePurchaseProposalMutation>;
export type AcceptMortgagePurchaseProposalMutationOptions = Apollo.BaseMutationOptions<AcceptMortgagePurchaseProposalMutation, AcceptMortgagePurchaseProposalMutationVariables>;
export const MortgagePurchaseResultConstraintsByProcessIdDocument = gql`
    query MortgagePurchaseResultConstraintsByProcessId($id: ID!) {
  constraints: calculateMortgagePurchaseResultConstraintsByProcessId(
    processId: $id
  ) {
    maxMortgageAmount {
      amount
      currency
    }
    maxPropertyPrice {
      amount
      currency
    }
    minInterestRate
    installment {
      amount
      currency
    }
    fixationLength
    maturity
  }
}
    `;

/**
 * __useMortgagePurchaseResultConstraintsByProcessIdQuery__
 *
 * To run a query within a React component, call `useMortgagePurchaseResultConstraintsByProcessIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgagePurchaseResultConstraintsByProcessIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgagePurchaseResultConstraintsByProcessIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMortgagePurchaseResultConstraintsByProcessIdQuery(baseOptions: Apollo.QueryHookOptions<MortgagePurchaseResultConstraintsByProcessIdQuery, MortgagePurchaseResultConstraintsByProcessIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgagePurchaseResultConstraintsByProcessIdQuery, MortgagePurchaseResultConstraintsByProcessIdQueryVariables>(MortgagePurchaseResultConstraintsByProcessIdDocument, options);
      }
export function useMortgagePurchaseResultConstraintsByProcessIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgagePurchaseResultConstraintsByProcessIdQuery, MortgagePurchaseResultConstraintsByProcessIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgagePurchaseResultConstraintsByProcessIdQuery, MortgagePurchaseResultConstraintsByProcessIdQueryVariables>(MortgagePurchaseResultConstraintsByProcessIdDocument, options);
        }
export type MortgagePurchaseResultConstraintsByProcessIdQueryHookResult = ReturnType<typeof useMortgagePurchaseResultConstraintsByProcessIdQuery>;
export type MortgagePurchaseResultConstraintsByProcessIdLazyQueryHookResult = ReturnType<typeof useMortgagePurchaseResultConstraintsByProcessIdLazyQuery>;
export type MortgagePurchaseResultConstraintsByProcessIdQueryResult = Apollo.QueryResult<MortgagePurchaseResultConstraintsByProcessIdQuery, MortgagePurchaseResultConstraintsByProcessIdQueryVariables>;
export const MortgagePurchaseResultConstraintsByInquiryDocument = gql`
    query MortgagePurchaseResultConstraintsByInquiry($inquiry: MortgagePurchaseInquiryInput!) {
  constraints: calculateMortgagePurchaseResultConstraintsByInquiry(
    inquiry: $inquiry
  ) {
    maxMortgageAmount {
      amount
      currency
    }
    maxPropertyPrice {
      amount
      currency
    }
    minInterestRate
    installment {
      amount
      currency
    }
    fixationLength
    maturity
  }
}
    `;

/**
 * __useMortgagePurchaseResultConstraintsByInquiryQuery__
 *
 * To run a query within a React component, call `useMortgagePurchaseResultConstraintsByInquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgagePurchaseResultConstraintsByInquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgagePurchaseResultConstraintsByInquiryQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useMortgagePurchaseResultConstraintsByInquiryQuery(baseOptions: Apollo.QueryHookOptions<MortgagePurchaseResultConstraintsByInquiryQuery, MortgagePurchaseResultConstraintsByInquiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgagePurchaseResultConstraintsByInquiryQuery, MortgagePurchaseResultConstraintsByInquiryQueryVariables>(MortgagePurchaseResultConstraintsByInquiryDocument, options);
      }
export function useMortgagePurchaseResultConstraintsByInquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgagePurchaseResultConstraintsByInquiryQuery, MortgagePurchaseResultConstraintsByInquiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgagePurchaseResultConstraintsByInquiryQuery, MortgagePurchaseResultConstraintsByInquiryQueryVariables>(MortgagePurchaseResultConstraintsByInquiryDocument, options);
        }
export type MortgagePurchaseResultConstraintsByInquiryQueryHookResult = ReturnType<typeof useMortgagePurchaseResultConstraintsByInquiryQuery>;
export type MortgagePurchaseResultConstraintsByInquiryLazyQueryHookResult = ReturnType<typeof useMortgagePurchaseResultConstraintsByInquiryLazyQuery>;
export type MortgagePurchaseResultConstraintsByInquiryQueryResult = Apollo.QueryResult<MortgagePurchaseResultConstraintsByInquiryQuery, MortgagePurchaseResultConstraintsByInquiryQueryVariables>;
export const InstitutionsDocument = gql`
    query Institutions($filterInput: FilterInput, $sortInput: SortInput) {
  getInstitutionsPage(filterInput: $filterInput, sortInput: $sortInput) {
    items {
      id
      ...Institution
    }
  }
}
    ${InstitutionFragmentDoc}`;

/**
 * __useInstitutionsQuery__
 *
 * To run a query within a React component, call `useInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstitutionsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useInstitutionsQuery(baseOptions?: Apollo.QueryHookOptions<InstitutionsQuery, InstitutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstitutionsQuery, InstitutionsQueryVariables>(InstitutionsDocument, options);
      }
export function useInstitutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstitutionsQuery, InstitutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstitutionsQuery, InstitutionsQueryVariables>(InstitutionsDocument, options);
        }
export type InstitutionsQueryHookResult = ReturnType<typeof useInstitutionsQuery>;
export type InstitutionsLazyQueryHookResult = ReturnType<typeof useInstitutionsLazyQuery>;
export type InstitutionsQueryResult = Apollo.QueryResult<InstitutionsQuery, InstitutionsQueryVariables>;
export const JobStatusDocument = gql`
    query JobStatus($jobId: String!) {
  getJobStatus(jobId: $jobId) {
    status
    errorMessage
  }
}
    `;

/**
 * __useJobStatusQuery__
 *
 * To run a query within a React component, call `useJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobStatusQuery(baseOptions: Apollo.QueryHookOptions<JobStatusQuery, JobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStatusQuery, JobStatusQueryVariables>(JobStatusDocument, options);
      }
export function useJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStatusQuery, JobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStatusQuery, JobStatusQueryVariables>(JobStatusDocument, options);
        }
export type JobStatusQueryHookResult = ReturnType<typeof useJobStatusQuery>;
export type JobStatusLazyQueryHookResult = ReturnType<typeof useJobStatusLazyQuery>;
export type JobStatusQueryResult = Apollo.QueryResult<JobStatusQuery, JobStatusQueryVariables>;
export const LifeInsuranceAuditProcessDocument = gql`
    query LifeInsuranceAuditProcess($id: ID!) {
  process: getLifeInsuranceAuditProcessById(processId: $id) {
    id
    updateTimestamp
    locked
    inquiry {
      id
      ...LifeInsuranceInquiry
    }
    documents {
      id
      ...Document
    }
  }
}
    ${LifeInsuranceInquiryFragmentDoc}
${DocumentFragmentDoc}`;

/**
 * __useLifeInsuranceAuditProcessQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceAuditProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceAuditProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceAuditProcessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLifeInsuranceAuditProcessQuery(baseOptions: Apollo.QueryHookOptions<LifeInsuranceAuditProcessQuery, LifeInsuranceAuditProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceAuditProcessQuery, LifeInsuranceAuditProcessQueryVariables>(LifeInsuranceAuditProcessDocument, options);
      }
export function useLifeInsuranceAuditProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceAuditProcessQuery, LifeInsuranceAuditProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceAuditProcessQuery, LifeInsuranceAuditProcessQueryVariables>(LifeInsuranceAuditProcessDocument, options);
        }
export type LifeInsuranceAuditProcessQueryHookResult = ReturnType<typeof useLifeInsuranceAuditProcessQuery>;
export type LifeInsuranceAuditProcessLazyQueryHookResult = ReturnType<typeof useLifeInsuranceAuditProcessLazyQuery>;
export type LifeInsuranceAuditProcessQueryResult = Apollo.QueryResult<LifeInsuranceAuditProcessQuery, LifeInsuranceAuditProcessQueryVariables>;
export const AllLifeInsuranceAuditProcessesDocument = gql`
    query AllLifeInsuranceAuditProcesses {
  processes: getLifeInsuranceAuditProcessesPage {
    items {
      id
      updateTimestamp
      locked
      inquiry {
        id
        inquiryProgress
        inquiryCurrentStepUrl
      }
    }
  }
}
    `;

/**
 * __useAllLifeInsuranceAuditProcessesQuery__
 *
 * To run a query within a React component, call `useAllLifeInsuranceAuditProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLifeInsuranceAuditProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLifeInsuranceAuditProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLifeInsuranceAuditProcessesQuery(baseOptions?: Apollo.QueryHookOptions<AllLifeInsuranceAuditProcessesQuery, AllLifeInsuranceAuditProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLifeInsuranceAuditProcessesQuery, AllLifeInsuranceAuditProcessesQueryVariables>(AllLifeInsuranceAuditProcessesDocument, options);
      }
export function useAllLifeInsuranceAuditProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLifeInsuranceAuditProcessesQuery, AllLifeInsuranceAuditProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLifeInsuranceAuditProcessesQuery, AllLifeInsuranceAuditProcessesQueryVariables>(AllLifeInsuranceAuditProcessesDocument, options);
        }
export type AllLifeInsuranceAuditProcessesQueryHookResult = ReturnType<typeof useAllLifeInsuranceAuditProcessesQuery>;
export type AllLifeInsuranceAuditProcessesLazyQueryHookResult = ReturnType<typeof useAllLifeInsuranceAuditProcessesLazyQuery>;
export type AllLifeInsuranceAuditProcessesQueryResult = Apollo.QueryResult<AllLifeInsuranceAuditProcessesQuery, AllLifeInsuranceAuditProcessesQueryVariables>;
export const LifeInsuranceAuditProcessLockedDocument = gql`
    query LifeInsuranceAuditProcessLocked($id: ID!) {
  process: getLifeInsuranceAuditProcessById(processId: $id) {
    id
    updateTimestamp
    locked
  }
}
    `;

/**
 * __useLifeInsuranceAuditProcessLockedQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceAuditProcessLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceAuditProcessLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceAuditProcessLockedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLifeInsuranceAuditProcessLockedQuery(baseOptions: Apollo.QueryHookOptions<LifeInsuranceAuditProcessLockedQuery, LifeInsuranceAuditProcessLockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceAuditProcessLockedQuery, LifeInsuranceAuditProcessLockedQueryVariables>(LifeInsuranceAuditProcessLockedDocument, options);
      }
export function useLifeInsuranceAuditProcessLockedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceAuditProcessLockedQuery, LifeInsuranceAuditProcessLockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceAuditProcessLockedQuery, LifeInsuranceAuditProcessLockedQueryVariables>(LifeInsuranceAuditProcessLockedDocument, options);
        }
export type LifeInsuranceAuditProcessLockedQueryHookResult = ReturnType<typeof useLifeInsuranceAuditProcessLockedQuery>;
export type LifeInsuranceAuditProcessLockedLazyQueryHookResult = ReturnType<typeof useLifeInsuranceAuditProcessLockedLazyQuery>;
export type LifeInsuranceAuditProcessLockedQueryResult = Apollo.QueryResult<LifeInsuranceAuditProcessLockedQuery, LifeInsuranceAuditProcessLockedQueryVariables>;
export const CreateLifeInsuranceAuditProcessDocument = gql`
    mutation CreateLifeInsuranceAuditProcess {
  createLifeInsuranceAuditProcess {
    id
    updateTimestamp
  }
}
    `;
export type CreateLifeInsuranceAuditProcessMutationFn = Apollo.MutationFunction<CreateLifeInsuranceAuditProcessMutation, CreateLifeInsuranceAuditProcessMutationVariables>;

/**
 * __useCreateLifeInsuranceAuditProcessMutation__
 *
 * To run a mutation, you first call `useCreateLifeInsuranceAuditProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifeInsuranceAuditProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifeInsuranceAuditProcessMutation, { data, loading, error }] = useCreateLifeInsuranceAuditProcessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLifeInsuranceAuditProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateLifeInsuranceAuditProcessMutation, CreateLifeInsuranceAuditProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLifeInsuranceAuditProcessMutation, CreateLifeInsuranceAuditProcessMutationVariables>(CreateLifeInsuranceAuditProcessDocument, options);
      }
export type CreateLifeInsuranceAuditProcessMutationHookResult = ReturnType<typeof useCreateLifeInsuranceAuditProcessMutation>;
export type CreateLifeInsuranceAuditProcessMutationResult = Apollo.MutationResult<CreateLifeInsuranceAuditProcessMutation>;
export type CreateLifeInsuranceAuditProcessMutationOptions = Apollo.BaseMutationOptions<CreateLifeInsuranceAuditProcessMutation, CreateLifeInsuranceAuditProcessMutationVariables>;
export const UpdateLifeInsuranceAuditProcessDocument = gql`
    mutation UpdateLifeInsuranceAuditProcess($id: ID!, $inquiry: LifeInsuranceInquiryInput!) {
  updateLifeInsuranceAuditProcess(processId: $id, inquiry: $inquiry) {
    id
    updateTimestamp
  }
}
    `;
export type UpdateLifeInsuranceAuditProcessMutationFn = Apollo.MutationFunction<UpdateLifeInsuranceAuditProcessMutation, UpdateLifeInsuranceAuditProcessMutationVariables>;

/**
 * __useUpdateLifeInsuranceAuditProcessMutation__
 *
 * To run a mutation, you first call `useUpdateLifeInsuranceAuditProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifeInsuranceAuditProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifeInsuranceAuditProcessMutation, { data, loading, error }] = useUpdateLifeInsuranceAuditProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useUpdateLifeInsuranceAuditProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLifeInsuranceAuditProcessMutation, UpdateLifeInsuranceAuditProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLifeInsuranceAuditProcessMutation, UpdateLifeInsuranceAuditProcessMutationVariables>(UpdateLifeInsuranceAuditProcessDocument, options);
      }
export type UpdateLifeInsuranceAuditProcessMutationHookResult = ReturnType<typeof useUpdateLifeInsuranceAuditProcessMutation>;
export type UpdateLifeInsuranceAuditProcessMutationResult = Apollo.MutationResult<UpdateLifeInsuranceAuditProcessMutation>;
export type UpdateLifeInsuranceAuditProcessMutationOptions = Apollo.BaseMutationOptions<UpdateLifeInsuranceAuditProcessMutation, UpdateLifeInsuranceAuditProcessMutationVariables>;
export const CreateLifeInsuranceDocumentDocument = gql`
    mutation CreateLifeInsuranceDocument($id: ID!, $document: DocumentInput!) {
  createLifeInsuranceDocument(processId: $id, document: $document) {
    id
  }
}
    `;
export type CreateLifeInsuranceDocumentMutationFn = Apollo.MutationFunction<CreateLifeInsuranceDocumentMutation, CreateLifeInsuranceDocumentMutationVariables>;

/**
 * __useCreateLifeInsuranceDocumentMutation__
 *
 * To run a mutation, you first call `useCreateLifeInsuranceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifeInsuranceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifeInsuranceDocumentMutation, { data, loading, error }] = useCreateLifeInsuranceDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateLifeInsuranceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateLifeInsuranceDocumentMutation, CreateLifeInsuranceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLifeInsuranceDocumentMutation, CreateLifeInsuranceDocumentMutationVariables>(CreateLifeInsuranceDocumentDocument, options);
      }
export type CreateLifeInsuranceDocumentMutationHookResult = ReturnType<typeof useCreateLifeInsuranceDocumentMutation>;
export type CreateLifeInsuranceDocumentMutationResult = Apollo.MutationResult<CreateLifeInsuranceDocumentMutation>;
export type CreateLifeInsuranceDocumentMutationOptions = Apollo.BaseMutationOptions<CreateLifeInsuranceDocumentMutation, CreateLifeInsuranceDocumentMutationVariables>;
export const AcceptLifeInsuranceAuditResultDocument = gql`
    mutation AcceptLifeInsuranceAuditResult($processId: ID!) {
  acceptLifeInsuranceAuditResult(processId: $processId) {
    id
  }
}
    `;
export type AcceptLifeInsuranceAuditResultMutationFn = Apollo.MutationFunction<AcceptLifeInsuranceAuditResultMutation, AcceptLifeInsuranceAuditResultMutationVariables>;

/**
 * __useAcceptLifeInsuranceAuditResultMutation__
 *
 * To run a mutation, you first call `useAcceptLifeInsuranceAuditResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLifeInsuranceAuditResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLifeInsuranceAuditResultMutation, { data, loading, error }] = useAcceptLifeInsuranceAuditResultMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useAcceptLifeInsuranceAuditResultMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLifeInsuranceAuditResultMutation, AcceptLifeInsuranceAuditResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLifeInsuranceAuditResultMutation, AcceptLifeInsuranceAuditResultMutationVariables>(AcceptLifeInsuranceAuditResultDocument, options);
      }
export type AcceptLifeInsuranceAuditResultMutationHookResult = ReturnType<typeof useAcceptLifeInsuranceAuditResultMutation>;
export type AcceptLifeInsuranceAuditResultMutationResult = Apollo.MutationResult<AcceptLifeInsuranceAuditResultMutation>;
export type AcceptLifeInsuranceAuditResultMutationOptions = Apollo.BaseMutationOptions<AcceptLifeInsuranceAuditResultMutation, AcceptLifeInsuranceAuditResultMutationVariables>;
export const SendLifeInsuranceAuditNotificationToSpecialistDocument = gql`
    mutation SendLifeInsuranceAuditNotificationToSpecialist($processId: ID!) {
  sendLifeInsuranceAuditNotificationEmailToSpecialist(processId: $processId)
}
    `;
export type SendLifeInsuranceAuditNotificationToSpecialistMutationFn = Apollo.MutationFunction<SendLifeInsuranceAuditNotificationToSpecialistMutation, SendLifeInsuranceAuditNotificationToSpecialistMutationVariables>;

/**
 * __useSendLifeInsuranceAuditNotificationToSpecialistMutation__
 *
 * To run a mutation, you first call `useSendLifeInsuranceAuditNotificationToSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLifeInsuranceAuditNotificationToSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLifeInsuranceAuditNotificationToSpecialistMutation, { data, loading, error }] = useSendLifeInsuranceAuditNotificationToSpecialistMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useSendLifeInsuranceAuditNotificationToSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<SendLifeInsuranceAuditNotificationToSpecialistMutation, SendLifeInsuranceAuditNotificationToSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendLifeInsuranceAuditNotificationToSpecialistMutation, SendLifeInsuranceAuditNotificationToSpecialistMutationVariables>(SendLifeInsuranceAuditNotificationToSpecialistDocument, options);
      }
export type SendLifeInsuranceAuditNotificationToSpecialistMutationHookResult = ReturnType<typeof useSendLifeInsuranceAuditNotificationToSpecialistMutation>;
export type SendLifeInsuranceAuditNotificationToSpecialistMutationResult = Apollo.MutationResult<SendLifeInsuranceAuditNotificationToSpecialistMutation>;
export type SendLifeInsuranceAuditNotificationToSpecialistMutationOptions = Apollo.BaseMutationOptions<SendLifeInsuranceAuditNotificationToSpecialistMutation, SendLifeInsuranceAuditNotificationToSpecialistMutationVariables>;
export const DeleteLifeInsuranceAuditProcessDocument = gql`
    mutation DeleteLifeInsuranceAuditProcess($id: ID!) {
  deleteLifeInsuranceAuditProcess(processId: $id)
}
    `;
export type DeleteLifeInsuranceAuditProcessMutationFn = Apollo.MutationFunction<DeleteLifeInsuranceAuditProcessMutation, DeleteLifeInsuranceAuditProcessMutationVariables>;

/**
 * __useDeleteLifeInsuranceAuditProcessMutation__
 *
 * To run a mutation, you first call `useDeleteLifeInsuranceAuditProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLifeInsuranceAuditProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLifeInsuranceAuditProcessMutation, { data, loading, error }] = useDeleteLifeInsuranceAuditProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLifeInsuranceAuditProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLifeInsuranceAuditProcessMutation, DeleteLifeInsuranceAuditProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLifeInsuranceAuditProcessMutation, DeleteLifeInsuranceAuditProcessMutationVariables>(DeleteLifeInsuranceAuditProcessDocument, options);
      }
export type DeleteLifeInsuranceAuditProcessMutationHookResult = ReturnType<typeof useDeleteLifeInsuranceAuditProcessMutation>;
export type DeleteLifeInsuranceAuditProcessMutationResult = Apollo.MutationResult<DeleteLifeInsuranceAuditProcessMutation>;
export type DeleteLifeInsuranceAuditProcessMutationOptions = Apollo.BaseMutationOptions<DeleteLifeInsuranceAuditProcessMutation, DeleteLifeInsuranceAuditProcessMutationVariables>;
export const LifeInsuranceCalculatorResultDocument = gql`
    query LifeInsuranceCalculatorResult($inquiry: LifeInsuranceCalculatorInquiryInput!) {
  result: getLifeInsuranceCalculatorResult(inquiry: $inquiry) {
    ...LifeInsuranceCalculatorResult
  }
}
    ${LifeInsuranceCalculatorResultFragmentDoc}`;

/**
 * __useLifeInsuranceCalculatorResultQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceCalculatorResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceCalculatorResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceCalculatorResultQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useLifeInsuranceCalculatorResultQuery(baseOptions: Apollo.QueryHookOptions<LifeInsuranceCalculatorResultQuery, LifeInsuranceCalculatorResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceCalculatorResultQuery, LifeInsuranceCalculatorResultQueryVariables>(LifeInsuranceCalculatorResultDocument, options);
      }
export function useLifeInsuranceCalculatorResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceCalculatorResultQuery, LifeInsuranceCalculatorResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceCalculatorResultQuery, LifeInsuranceCalculatorResultQueryVariables>(LifeInsuranceCalculatorResultDocument, options);
        }
export type LifeInsuranceCalculatorResultQueryHookResult = ReturnType<typeof useLifeInsuranceCalculatorResultQuery>;
export type LifeInsuranceCalculatorResultLazyQueryHookResult = ReturnType<typeof useLifeInsuranceCalculatorResultLazyQuery>;
export type LifeInsuranceCalculatorResultQueryResult = Apollo.QueryResult<LifeInsuranceCalculatorResultQuery, LifeInsuranceCalculatorResultQueryVariables>;
export const AverageLifeInsuranceScoreDocument = gql`
    query AverageLifeInsuranceScore {
  averageScore: getAverageLifeInsuranceScore
}
    `;

/**
 * __useAverageLifeInsuranceScoreQuery__
 *
 * To run a query within a React component, call `useAverageLifeInsuranceScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageLifeInsuranceScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageLifeInsuranceScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useAverageLifeInsuranceScoreQuery(baseOptions?: Apollo.QueryHookOptions<AverageLifeInsuranceScoreQuery, AverageLifeInsuranceScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AverageLifeInsuranceScoreQuery, AverageLifeInsuranceScoreQueryVariables>(AverageLifeInsuranceScoreDocument, options);
      }
export function useAverageLifeInsuranceScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AverageLifeInsuranceScoreQuery, AverageLifeInsuranceScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AverageLifeInsuranceScoreQuery, AverageLifeInsuranceScoreQueryVariables>(AverageLifeInsuranceScoreDocument, options);
        }
export type AverageLifeInsuranceScoreQueryHookResult = ReturnType<typeof useAverageLifeInsuranceScoreQuery>;
export type AverageLifeInsuranceScoreLazyQueryHookResult = ReturnType<typeof useAverageLifeInsuranceScoreLazyQuery>;
export type AverageLifeInsuranceScoreQueryResult = Apollo.QueryResult<AverageLifeInsuranceScoreQuery, AverageLifeInsuranceScoreQueryVariables>;
export const LifeInsuranceCalculatorCalculationsDocument = gql`
    query LifeInsuranceCalculatorCalculations($pageInput: PageInput, $sortInput: SortInput) {
  calculations: getLifeInsuranceCalculatorCalculationsPage(
    pageInput: $pageInput
    sortInput: $sortInput
  ) {
    items {
      id
      result {
        ...LifeInsuranceCalculatorResult
      }
    }
    totalItems
  }
}
    ${LifeInsuranceCalculatorResultFragmentDoc}`;

/**
 * __useLifeInsuranceCalculatorCalculationsQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceCalculatorCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceCalculatorCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceCalculatorCalculationsQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useLifeInsuranceCalculatorCalculationsQuery(baseOptions?: Apollo.QueryHookOptions<LifeInsuranceCalculatorCalculationsQuery, LifeInsuranceCalculatorCalculationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceCalculatorCalculationsQuery, LifeInsuranceCalculatorCalculationsQueryVariables>(LifeInsuranceCalculatorCalculationsDocument, options);
      }
export function useLifeInsuranceCalculatorCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceCalculatorCalculationsQuery, LifeInsuranceCalculatorCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceCalculatorCalculationsQuery, LifeInsuranceCalculatorCalculationsQueryVariables>(LifeInsuranceCalculatorCalculationsDocument, options);
        }
export type LifeInsuranceCalculatorCalculationsQueryHookResult = ReturnType<typeof useLifeInsuranceCalculatorCalculationsQuery>;
export type LifeInsuranceCalculatorCalculationsLazyQueryHookResult = ReturnType<typeof useLifeInsuranceCalculatorCalculationsLazyQuery>;
export type LifeInsuranceCalculatorCalculationsQueryResult = Apollo.QueryResult<LifeInsuranceCalculatorCalculationsQuery, LifeInsuranceCalculatorCalculationsQueryVariables>;
export const LifeInsurancePurchaseProcessDocument = gql`
    query LifeInsurancePurchaseProcess($id: ID!) {
  process: getLifeInsurancePurchaseProcessById(processId: $id) {
    id
    updateTimestamp
    locked
    inquiry {
      id
      ...LifeInsuranceInquiry
    }
  }
}
    ${LifeInsuranceInquiryFragmentDoc}`;

/**
 * __useLifeInsurancePurchaseProcessQuery__
 *
 * To run a query within a React component, call `useLifeInsurancePurchaseProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsurancePurchaseProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsurancePurchaseProcessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLifeInsurancePurchaseProcessQuery(baseOptions: Apollo.QueryHookOptions<LifeInsurancePurchaseProcessQuery, LifeInsurancePurchaseProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsurancePurchaseProcessQuery, LifeInsurancePurchaseProcessQueryVariables>(LifeInsurancePurchaseProcessDocument, options);
      }
export function useLifeInsurancePurchaseProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsurancePurchaseProcessQuery, LifeInsurancePurchaseProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsurancePurchaseProcessQuery, LifeInsurancePurchaseProcessQueryVariables>(LifeInsurancePurchaseProcessDocument, options);
        }
export type LifeInsurancePurchaseProcessQueryHookResult = ReturnType<typeof useLifeInsurancePurchaseProcessQuery>;
export type LifeInsurancePurchaseProcessLazyQueryHookResult = ReturnType<typeof useLifeInsurancePurchaseProcessLazyQuery>;
export type LifeInsurancePurchaseProcessQueryResult = Apollo.QueryResult<LifeInsurancePurchaseProcessQuery, LifeInsurancePurchaseProcessQueryVariables>;
export const LifeInsurancePurchaseProcessLockedDocument = gql`
    query LifeInsurancePurchaseProcessLocked($id: ID!) {
  process: getLifeInsurancePurchaseProcessById(processId: $id) {
    id
    updateTimestamp
    locked
  }
}
    `;

/**
 * __useLifeInsurancePurchaseProcessLockedQuery__
 *
 * To run a query within a React component, call `useLifeInsurancePurchaseProcessLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsurancePurchaseProcessLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsurancePurchaseProcessLockedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLifeInsurancePurchaseProcessLockedQuery(baseOptions: Apollo.QueryHookOptions<LifeInsurancePurchaseProcessLockedQuery, LifeInsurancePurchaseProcessLockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsurancePurchaseProcessLockedQuery, LifeInsurancePurchaseProcessLockedQueryVariables>(LifeInsurancePurchaseProcessLockedDocument, options);
      }
export function useLifeInsurancePurchaseProcessLockedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsurancePurchaseProcessLockedQuery, LifeInsurancePurchaseProcessLockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsurancePurchaseProcessLockedQuery, LifeInsurancePurchaseProcessLockedQueryVariables>(LifeInsurancePurchaseProcessLockedDocument, options);
        }
export type LifeInsurancePurchaseProcessLockedQueryHookResult = ReturnType<typeof useLifeInsurancePurchaseProcessLockedQuery>;
export type LifeInsurancePurchaseProcessLockedLazyQueryHookResult = ReturnType<typeof useLifeInsurancePurchaseProcessLockedLazyQuery>;
export type LifeInsurancePurchaseProcessLockedQueryResult = Apollo.QueryResult<LifeInsurancePurchaseProcessLockedQuery, LifeInsurancePurchaseProcessLockedQueryVariables>;
export const AllLifeInsurancePurchaseProcessesDocument = gql`
    query AllLifeInsurancePurchaseProcesses {
  processes: getLifeInsurancePurchaseProcessesPage {
    items {
      id
      inquiry {
        id
        ...LifeInsuranceInquiry
      }
      updateTimestamp
      creationTimestamp
      locked
    }
  }
}
    ${LifeInsuranceInquiryFragmentDoc}`;

/**
 * __useAllLifeInsurancePurchaseProcessesQuery__
 *
 * To run a query within a React component, call `useAllLifeInsurancePurchaseProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLifeInsurancePurchaseProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLifeInsurancePurchaseProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllLifeInsurancePurchaseProcessesQuery(baseOptions?: Apollo.QueryHookOptions<AllLifeInsurancePurchaseProcessesQuery, AllLifeInsurancePurchaseProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLifeInsurancePurchaseProcessesQuery, AllLifeInsurancePurchaseProcessesQueryVariables>(AllLifeInsurancePurchaseProcessesDocument, options);
      }
export function useAllLifeInsurancePurchaseProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLifeInsurancePurchaseProcessesQuery, AllLifeInsurancePurchaseProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLifeInsurancePurchaseProcessesQuery, AllLifeInsurancePurchaseProcessesQueryVariables>(AllLifeInsurancePurchaseProcessesDocument, options);
        }
export type AllLifeInsurancePurchaseProcessesQueryHookResult = ReturnType<typeof useAllLifeInsurancePurchaseProcessesQuery>;
export type AllLifeInsurancePurchaseProcessesLazyQueryHookResult = ReturnType<typeof useAllLifeInsurancePurchaseProcessesLazyQuery>;
export type AllLifeInsurancePurchaseProcessesQueryResult = Apollo.QueryResult<AllLifeInsurancePurchaseProcessesQuery, AllLifeInsurancePurchaseProcessesQueryVariables>;
export const CalculateLifeInsuranceResultByInquiryDocument = gql`
    query CalculateLifeInsuranceResultByInquiry($inquiry: LifeInsuranceInquiryInput!) {
  proposals: calculateLifeInsuranceResultByInquiry(inquiry: $inquiry) {
    id
    proposals {
      ...LifeInsuranceProposal
    }
  }
}
    ${LifeInsuranceProposalFragmentDoc}`;

/**
 * __useCalculateLifeInsuranceResultByInquiryQuery__
 *
 * To run a query within a React component, call `useCalculateLifeInsuranceResultByInquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateLifeInsuranceResultByInquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateLifeInsuranceResultByInquiryQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useCalculateLifeInsuranceResultByInquiryQuery(baseOptions: Apollo.QueryHookOptions<CalculateLifeInsuranceResultByInquiryQuery, CalculateLifeInsuranceResultByInquiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateLifeInsuranceResultByInquiryQuery, CalculateLifeInsuranceResultByInquiryQueryVariables>(CalculateLifeInsuranceResultByInquiryDocument, options);
      }
export function useCalculateLifeInsuranceResultByInquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateLifeInsuranceResultByInquiryQuery, CalculateLifeInsuranceResultByInquiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateLifeInsuranceResultByInquiryQuery, CalculateLifeInsuranceResultByInquiryQueryVariables>(CalculateLifeInsuranceResultByInquiryDocument, options);
        }
export type CalculateLifeInsuranceResultByInquiryQueryHookResult = ReturnType<typeof useCalculateLifeInsuranceResultByInquiryQuery>;
export type CalculateLifeInsuranceResultByInquiryLazyQueryHookResult = ReturnType<typeof useCalculateLifeInsuranceResultByInquiryLazyQuery>;
export type CalculateLifeInsuranceResultByInquiryQueryResult = Apollo.QueryResult<CalculateLifeInsuranceResultByInquiryQuery, CalculateLifeInsuranceResultByInquiryQueryVariables>;
export const CreateLifeInsurancePurchaseProcessDocument = gql`
    mutation CreateLifeInsurancePurchaseProcess {
  createLifeInsurancePurchaseProcess {
    id
    updateTimestamp
  }
}
    `;
export type CreateLifeInsurancePurchaseProcessMutationFn = Apollo.MutationFunction<CreateLifeInsurancePurchaseProcessMutation, CreateLifeInsurancePurchaseProcessMutationVariables>;

/**
 * __useCreateLifeInsurancePurchaseProcessMutation__
 *
 * To run a mutation, you first call `useCreateLifeInsurancePurchaseProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifeInsurancePurchaseProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifeInsurancePurchaseProcessMutation, { data, loading, error }] = useCreateLifeInsurancePurchaseProcessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLifeInsurancePurchaseProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateLifeInsurancePurchaseProcessMutation, CreateLifeInsurancePurchaseProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLifeInsurancePurchaseProcessMutation, CreateLifeInsurancePurchaseProcessMutationVariables>(CreateLifeInsurancePurchaseProcessDocument, options);
      }
export type CreateLifeInsurancePurchaseProcessMutationHookResult = ReturnType<typeof useCreateLifeInsurancePurchaseProcessMutation>;
export type CreateLifeInsurancePurchaseProcessMutationResult = Apollo.MutationResult<CreateLifeInsurancePurchaseProcessMutation>;
export type CreateLifeInsurancePurchaseProcessMutationOptions = Apollo.BaseMutationOptions<CreateLifeInsurancePurchaseProcessMutation, CreateLifeInsurancePurchaseProcessMutationVariables>;
export const UpdateLifeInsurancePurchaseProcessDocument = gql`
    mutation UpdateLifeInsurancePurchaseProcess($id: ID!, $inquiry: LifeInsuranceInquiryInput!) {
  updateLifeInsurancePurchaseProcess(processId: $id, inquiry: $inquiry) {
    id
    updateTimestamp
  }
}
    `;
export type UpdateLifeInsurancePurchaseProcessMutationFn = Apollo.MutationFunction<UpdateLifeInsurancePurchaseProcessMutation, UpdateLifeInsurancePurchaseProcessMutationVariables>;

/**
 * __useUpdateLifeInsurancePurchaseProcessMutation__
 *
 * To run a mutation, you first call `useUpdateLifeInsurancePurchaseProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifeInsurancePurchaseProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifeInsurancePurchaseProcessMutation, { data, loading, error }] = useUpdateLifeInsurancePurchaseProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useUpdateLifeInsurancePurchaseProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLifeInsurancePurchaseProcessMutation, UpdateLifeInsurancePurchaseProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLifeInsurancePurchaseProcessMutation, UpdateLifeInsurancePurchaseProcessMutationVariables>(UpdateLifeInsurancePurchaseProcessDocument, options);
      }
export type UpdateLifeInsurancePurchaseProcessMutationHookResult = ReturnType<typeof useUpdateLifeInsurancePurchaseProcessMutation>;
export type UpdateLifeInsurancePurchaseProcessMutationResult = Apollo.MutationResult<UpdateLifeInsurancePurchaseProcessMutation>;
export type UpdateLifeInsurancePurchaseProcessMutationOptions = Apollo.BaseMutationOptions<UpdateLifeInsurancePurchaseProcessMutation, UpdateLifeInsurancePurchaseProcessMutationVariables>;
export const CalculateLifeInsuranceResultByProcessIdDocument = gql`
    mutation CalculateLifeInsuranceResultByProcessId($processId: ID!) {
  proposals: calculateAndSaveLifeInsuranceResultByProcessId(processId: $processId) {
    id
    proposals {
      ...LifeInsuranceProposal
    }
  }
}
    ${LifeInsuranceProposalFragmentDoc}`;
export type CalculateLifeInsuranceResultByProcessIdMutationFn = Apollo.MutationFunction<CalculateLifeInsuranceResultByProcessIdMutation, CalculateLifeInsuranceResultByProcessIdMutationVariables>;

/**
 * __useCalculateLifeInsuranceResultByProcessIdMutation__
 *
 * To run a mutation, you first call `useCalculateLifeInsuranceResultByProcessIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateLifeInsuranceResultByProcessIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateLifeInsuranceResultByProcessIdMutation, { data, loading, error }] = useCalculateLifeInsuranceResultByProcessIdMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useCalculateLifeInsuranceResultByProcessIdMutation(baseOptions?: Apollo.MutationHookOptions<CalculateLifeInsuranceResultByProcessIdMutation, CalculateLifeInsuranceResultByProcessIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateLifeInsuranceResultByProcessIdMutation, CalculateLifeInsuranceResultByProcessIdMutationVariables>(CalculateLifeInsuranceResultByProcessIdDocument, options);
      }
export type CalculateLifeInsuranceResultByProcessIdMutationHookResult = ReturnType<typeof useCalculateLifeInsuranceResultByProcessIdMutation>;
export type CalculateLifeInsuranceResultByProcessIdMutationResult = Apollo.MutationResult<CalculateLifeInsuranceResultByProcessIdMutation>;
export type CalculateLifeInsuranceResultByProcessIdMutationOptions = Apollo.BaseMutationOptions<CalculateLifeInsuranceResultByProcessIdMutation, CalculateLifeInsuranceResultByProcessIdMutationVariables>;
export const AcceptLifeInsuranceProposalDocument = gql`
    mutation AcceptLifeInsuranceProposal($processId: ID!) {
  process: acceptLifeInsurancePurchaseResult(processId: $processId) {
    id
  }
}
    `;
export type AcceptLifeInsuranceProposalMutationFn = Apollo.MutationFunction<AcceptLifeInsuranceProposalMutation, AcceptLifeInsuranceProposalMutationVariables>;

/**
 * __useAcceptLifeInsuranceProposalMutation__
 *
 * To run a mutation, you first call `useAcceptLifeInsuranceProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLifeInsuranceProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLifeInsuranceProposalMutation, { data, loading, error }] = useAcceptLifeInsuranceProposalMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useAcceptLifeInsuranceProposalMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLifeInsuranceProposalMutation, AcceptLifeInsuranceProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLifeInsuranceProposalMutation, AcceptLifeInsuranceProposalMutationVariables>(AcceptLifeInsuranceProposalDocument, options);
      }
export type AcceptLifeInsuranceProposalMutationHookResult = ReturnType<typeof useAcceptLifeInsuranceProposalMutation>;
export type AcceptLifeInsuranceProposalMutationResult = Apollo.MutationResult<AcceptLifeInsuranceProposalMutation>;
export type AcceptLifeInsuranceProposalMutationOptions = Apollo.BaseMutationOptions<AcceptLifeInsuranceProposalMutation, AcceptLifeInsuranceProposalMutationVariables>;
export const SendLifeInsurancePurchaseNotificationToSpecialistDocument = gql`
    mutation SendLifeInsurancePurchaseNotificationToSpecialist($processId: ID!) {
  sendLifeInsurancePurchaseNotificationEmailToSpecialist(processId: $processId)
}
    `;
export type SendLifeInsurancePurchaseNotificationToSpecialistMutationFn = Apollo.MutationFunction<SendLifeInsurancePurchaseNotificationToSpecialistMutation, SendLifeInsurancePurchaseNotificationToSpecialistMutationVariables>;

/**
 * __useSendLifeInsurancePurchaseNotificationToSpecialistMutation__
 *
 * To run a mutation, you first call `useSendLifeInsurancePurchaseNotificationToSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLifeInsurancePurchaseNotificationToSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLifeInsurancePurchaseNotificationToSpecialistMutation, { data, loading, error }] = useSendLifeInsurancePurchaseNotificationToSpecialistMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useSendLifeInsurancePurchaseNotificationToSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<SendLifeInsurancePurchaseNotificationToSpecialistMutation, SendLifeInsurancePurchaseNotificationToSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendLifeInsurancePurchaseNotificationToSpecialistMutation, SendLifeInsurancePurchaseNotificationToSpecialistMutationVariables>(SendLifeInsurancePurchaseNotificationToSpecialistDocument, options);
      }
export type SendLifeInsurancePurchaseNotificationToSpecialistMutationHookResult = ReturnType<typeof useSendLifeInsurancePurchaseNotificationToSpecialistMutation>;
export type SendLifeInsurancePurchaseNotificationToSpecialistMutationResult = Apollo.MutationResult<SendLifeInsurancePurchaseNotificationToSpecialistMutation>;
export type SendLifeInsurancePurchaseNotificationToSpecialistMutationOptions = Apollo.BaseMutationOptions<SendLifeInsurancePurchaseNotificationToSpecialistMutation, SendLifeInsurancePurchaseNotificationToSpecialistMutationVariables>;
export const DeleteLifeInsurancePurchaseProcessDocument = gql`
    mutation DeleteLifeInsurancePurchaseProcess($id: ID!) {
  deleteLifeInsurancePurchaseProcess(processId: $id)
}
    `;
export type DeleteLifeInsurancePurchaseProcessMutationFn = Apollo.MutationFunction<DeleteLifeInsurancePurchaseProcessMutation, DeleteLifeInsurancePurchaseProcessMutationVariables>;

/**
 * __useDeleteLifeInsurancePurchaseProcessMutation__
 *
 * To run a mutation, you first call `useDeleteLifeInsurancePurchaseProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLifeInsurancePurchaseProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLifeInsurancePurchaseProcessMutation, { data, loading, error }] = useDeleteLifeInsurancePurchaseProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLifeInsurancePurchaseProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLifeInsurancePurchaseProcessMutation, DeleteLifeInsurancePurchaseProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLifeInsurancePurchaseProcessMutation, DeleteLifeInsurancePurchaseProcessMutationVariables>(DeleteLifeInsurancePurchaseProcessDocument, options);
      }
export type DeleteLifeInsurancePurchaseProcessMutationHookResult = ReturnType<typeof useDeleteLifeInsurancePurchaseProcessMutation>;
export type DeleteLifeInsurancePurchaseProcessMutationResult = Apollo.MutationResult<DeleteLifeInsurancePurchaseProcessMutation>;
export type DeleteLifeInsurancePurchaseProcessMutationOptions = Apollo.BaseMutationOptions<DeleteLifeInsurancePurchaseProcessMutation, DeleteLifeInsurancePurchaseProcessMutationVariables>;
export const MortgageCalculatorResultDocument = gql`
    query MortgageCalculatorResult($inquiry: MortgageCalculatorInquiryInput!) {
  result: getMortgageCalculatorResult(inquiry: $inquiry) {
    ...MortgageCalculatorResult
  }
}
    ${MortgageCalculatorResultFragmentDoc}`;

/**
 * __useMortgageCalculatorResultQuery__
 *
 * To run a query within a React component, call `useMortgageCalculatorResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageCalculatorResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageCalculatorResultQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useMortgageCalculatorResultQuery(baseOptions: Apollo.QueryHookOptions<MortgageCalculatorResultQuery, MortgageCalculatorResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageCalculatorResultQuery, MortgageCalculatorResultQueryVariables>(MortgageCalculatorResultDocument, options);
      }
export function useMortgageCalculatorResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageCalculatorResultQuery, MortgageCalculatorResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageCalculatorResultQuery, MortgageCalculatorResultQueryVariables>(MortgageCalculatorResultDocument, options);
        }
export type MortgageCalculatorResultQueryHookResult = ReturnType<typeof useMortgageCalculatorResultQuery>;
export type MortgageCalculatorResultLazyQueryHookResult = ReturnType<typeof useMortgageCalculatorResultLazyQuery>;
export type MortgageCalculatorResultQueryResult = Apollo.QueryResult<MortgageCalculatorResultQuery, MortgageCalculatorResultQueryVariables>;
export const MortgageCalculatorCalculationsDocument = gql`
    query MortgageCalculatorCalculations($pageInput: PageInput, $sortInput: SortInput) {
  calculations: getMortgageCalculatorCalculationsPage(
    pageInput: $pageInput
    sortInput: $sortInput
  ) {
    items {
      id
      result {
        ...MortgageCalculatorResult
      }
    }
    totalItems
  }
}
    ${MortgageCalculatorResultFragmentDoc}`;

/**
 * __useMortgageCalculatorCalculationsQuery__
 *
 * To run a query within a React component, call `useMortgageCalculatorCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageCalculatorCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageCalculatorCalculationsQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useMortgageCalculatorCalculationsQuery(baseOptions?: Apollo.QueryHookOptions<MortgageCalculatorCalculationsQuery, MortgageCalculatorCalculationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageCalculatorCalculationsQuery, MortgageCalculatorCalculationsQueryVariables>(MortgageCalculatorCalculationsDocument, options);
      }
export function useMortgageCalculatorCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageCalculatorCalculationsQuery, MortgageCalculatorCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageCalculatorCalculationsQuery, MortgageCalculatorCalculationsQueryVariables>(MortgageCalculatorCalculationsDocument, options);
        }
export type MortgageCalculatorCalculationsQueryHookResult = ReturnType<typeof useMortgageCalculatorCalculationsQuery>;
export type MortgageCalculatorCalculationsLazyQueryHookResult = ReturnType<typeof useMortgageCalculatorCalculationsLazyQuery>;
export type MortgageCalculatorCalculationsQueryResult = Apollo.QueryResult<MortgageCalculatorCalculationsQuery, MortgageCalculatorCalculationsQueryVariables>;
export const AllMortgagePurchaseProcessesDocument = gql`
    query AllMortgagePurchaseProcesses {
  processes: getMortgagePurchaseProcessesPage {
    items {
      id
      inquiry {
        ...MortgagePurchaseInquiry
      }
      acceptedProposal {
        id
      }
      updateTimestamp
      creationTimestamp
    }
  }
}
    ${MortgagePurchaseInquiryFragmentDoc}`;

/**
 * __useAllMortgagePurchaseProcessesQuery__
 *
 * To run a query within a React component, call `useAllMortgagePurchaseProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMortgagePurchaseProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMortgagePurchaseProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMortgagePurchaseProcessesQuery(baseOptions?: Apollo.QueryHookOptions<AllMortgagePurchaseProcessesQuery, AllMortgagePurchaseProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMortgagePurchaseProcessesQuery, AllMortgagePurchaseProcessesQueryVariables>(AllMortgagePurchaseProcessesDocument, options);
      }
export function useAllMortgagePurchaseProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMortgagePurchaseProcessesQuery, AllMortgagePurchaseProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMortgagePurchaseProcessesQuery, AllMortgagePurchaseProcessesQueryVariables>(AllMortgagePurchaseProcessesDocument, options);
        }
export type AllMortgagePurchaseProcessesQueryHookResult = ReturnType<typeof useAllMortgagePurchaseProcessesQuery>;
export type AllMortgagePurchaseProcessesLazyQueryHookResult = ReturnType<typeof useAllMortgagePurchaseProcessesLazyQuery>;
export type AllMortgagePurchaseProcessesQueryResult = Apollo.QueryResult<AllMortgagePurchaseProcessesQuery, AllMortgagePurchaseProcessesQueryVariables>;
export const MortgagePurchaseProcessDocument = gql`
    query MortgagePurchaseProcess($id: ID!) {
  process: getMortgagePurchaseProcessById(processId: $id) {
    id
    updateTimestamp
    inquiry {
      ...MortgagePurchaseInquiry
    }
    locked
    acceptanceType
    acceptedProposal {
      id
    }
  }
}
    ${MortgagePurchaseInquiryFragmentDoc}`;

/**
 * __useMortgagePurchaseProcessQuery__
 *
 * To run a query within a React component, call `useMortgagePurchaseProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgagePurchaseProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgagePurchaseProcessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMortgagePurchaseProcessQuery(baseOptions: Apollo.QueryHookOptions<MortgagePurchaseProcessQuery, MortgagePurchaseProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgagePurchaseProcessQuery, MortgagePurchaseProcessQueryVariables>(MortgagePurchaseProcessDocument, options);
      }
export function useMortgagePurchaseProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgagePurchaseProcessQuery, MortgagePurchaseProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgagePurchaseProcessQuery, MortgagePurchaseProcessQueryVariables>(MortgagePurchaseProcessDocument, options);
        }
export type MortgagePurchaseProcessQueryHookResult = ReturnType<typeof useMortgagePurchaseProcessQuery>;
export type MortgagePurchaseProcessLazyQueryHookResult = ReturnType<typeof useMortgagePurchaseProcessLazyQuery>;
export type MortgagePurchaseProcessQueryResult = Apollo.QueryResult<MortgagePurchaseProcessQuery, MortgagePurchaseProcessQueryVariables>;
export const CreateMortgagePurchaseProcessDocument = gql`
    mutation CreateMortgagePurchaseProcess {
  createMortgagePurchaseProcess {
    id
    updateTimestamp
  }
}
    `;
export type CreateMortgagePurchaseProcessMutationFn = Apollo.MutationFunction<CreateMortgagePurchaseProcessMutation, CreateMortgagePurchaseProcessMutationVariables>;

/**
 * __useCreateMortgagePurchaseProcessMutation__
 *
 * To run a mutation, you first call `useCreateMortgagePurchaseProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgagePurchaseProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgagePurchaseProcessMutation, { data, loading, error }] = useCreateMortgagePurchaseProcessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateMortgagePurchaseProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgagePurchaseProcessMutation, CreateMortgagePurchaseProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgagePurchaseProcessMutation, CreateMortgagePurchaseProcessMutationVariables>(CreateMortgagePurchaseProcessDocument, options);
      }
export type CreateMortgagePurchaseProcessMutationHookResult = ReturnType<typeof useCreateMortgagePurchaseProcessMutation>;
export type CreateMortgagePurchaseProcessMutationResult = Apollo.MutationResult<CreateMortgagePurchaseProcessMutation>;
export type CreateMortgagePurchaseProcessMutationOptions = Apollo.BaseMutationOptions<CreateMortgagePurchaseProcessMutation, CreateMortgagePurchaseProcessMutationVariables>;
export const UpdateMortgagePurchaseProcessDocument = gql`
    mutation UpdateMortgagePurchaseProcess($id: ID!, $inquiry: MortgagePurchaseInquiryInput!) {
  updateMortgagePurchaseProcess(processId: $id, inquiry: $inquiry) {
    id
    updateTimestamp
  }
}
    `;
export type UpdateMortgagePurchaseProcessMutationFn = Apollo.MutationFunction<UpdateMortgagePurchaseProcessMutation, UpdateMortgagePurchaseProcessMutationVariables>;

/**
 * __useUpdateMortgagePurchaseProcessMutation__
 *
 * To run a mutation, you first call `useUpdateMortgagePurchaseProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgagePurchaseProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgagePurchaseProcessMutation, { data, loading, error }] = useUpdateMortgagePurchaseProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useUpdateMortgagePurchaseProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgagePurchaseProcessMutation, UpdateMortgagePurchaseProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgagePurchaseProcessMutation, UpdateMortgagePurchaseProcessMutationVariables>(UpdateMortgagePurchaseProcessDocument, options);
      }
export type UpdateMortgagePurchaseProcessMutationHookResult = ReturnType<typeof useUpdateMortgagePurchaseProcessMutation>;
export type UpdateMortgagePurchaseProcessMutationResult = Apollo.MutationResult<UpdateMortgagePurchaseProcessMutation>;
export type UpdateMortgagePurchaseProcessMutationOptions = Apollo.BaseMutationOptions<UpdateMortgagePurchaseProcessMutation, UpdateMortgagePurchaseProcessMutationVariables>;
export const DeleteMortgagePurchaseProcessDocument = gql`
    mutation DeleteMortgagePurchaseProcess($id: ID!) {
  deleteMortgagePurchaseProcess(processId: $id)
}
    `;
export type DeleteMortgagePurchaseProcessMutationFn = Apollo.MutationFunction<DeleteMortgagePurchaseProcessMutation, DeleteMortgagePurchaseProcessMutationVariables>;

/**
 * __useDeleteMortgagePurchaseProcessMutation__
 *
 * To run a mutation, you first call `useDeleteMortgagePurchaseProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgagePurchaseProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgagePurchaseProcessMutation, { data, loading, error }] = useDeleteMortgagePurchaseProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMortgagePurchaseProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgagePurchaseProcessMutation, DeleteMortgagePurchaseProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgagePurchaseProcessMutation, DeleteMortgagePurchaseProcessMutationVariables>(DeleteMortgagePurchaseProcessDocument, options);
      }
export type DeleteMortgagePurchaseProcessMutationHookResult = ReturnType<typeof useDeleteMortgagePurchaseProcessMutation>;
export type DeleteMortgagePurchaseProcessMutationResult = Apollo.MutationResult<DeleteMortgagePurchaseProcessMutation>;
export type DeleteMortgagePurchaseProcessMutationOptions = Apollo.BaseMutationOptions<DeleteMortgagePurchaseProcessMutation, DeleteMortgagePurchaseProcessMutationVariables>;
export const AcceptedPurchaseProposalDocument = gql`
    query AcceptedPurchaseProposal($processId: ID!) {
  process: getMortgagePurchaseProcessById(processId: $processId) {
    id
    locked
    acceptanceType
    acceptedProposal {
      ...DetailedMortgageProposal
    }
  }
}
    ${DetailedMortgageProposalFragmentDoc}`;

/**
 * __useAcceptedPurchaseProposalQuery__
 *
 * To run a query within a React component, call `useAcceptedPurchaseProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcceptedPurchaseProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcceptedPurchaseProposalQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useAcceptedPurchaseProposalQuery(baseOptions: Apollo.QueryHookOptions<AcceptedPurchaseProposalQuery, AcceptedPurchaseProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcceptedPurchaseProposalQuery, AcceptedPurchaseProposalQueryVariables>(AcceptedPurchaseProposalDocument, options);
      }
export function useAcceptedPurchaseProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcceptedPurchaseProposalQuery, AcceptedPurchaseProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcceptedPurchaseProposalQuery, AcceptedPurchaseProposalQueryVariables>(AcceptedPurchaseProposalDocument, options);
        }
export type AcceptedPurchaseProposalQueryHookResult = ReturnType<typeof useAcceptedPurchaseProposalQuery>;
export type AcceptedPurchaseProposalLazyQueryHookResult = ReturnType<typeof useAcceptedPurchaseProposalLazyQuery>;
export type AcceptedPurchaseProposalQueryResult = Apollo.QueryResult<AcceptedPurchaseProposalQuery, AcceptedPurchaseProposalQueryVariables>;
export const SendMortgagePurchaseNotificationToSpecialistDocument = gql`
    mutation SendMortgagePurchaseNotificationToSpecialist($processId: ID!) {
  sendMortgagePurchaseNotificationEmailToSpecialist(processId: $processId)
}
    `;
export type SendMortgagePurchaseNotificationToSpecialistMutationFn = Apollo.MutationFunction<SendMortgagePurchaseNotificationToSpecialistMutation, SendMortgagePurchaseNotificationToSpecialistMutationVariables>;

/**
 * __useSendMortgagePurchaseNotificationToSpecialistMutation__
 *
 * To run a mutation, you first call `useSendMortgagePurchaseNotificationToSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMortgagePurchaseNotificationToSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMortgagePurchaseNotificationToSpecialistMutation, { data, loading, error }] = useSendMortgagePurchaseNotificationToSpecialistMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useSendMortgagePurchaseNotificationToSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<SendMortgagePurchaseNotificationToSpecialistMutation, SendMortgagePurchaseNotificationToSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMortgagePurchaseNotificationToSpecialistMutation, SendMortgagePurchaseNotificationToSpecialistMutationVariables>(SendMortgagePurchaseNotificationToSpecialistDocument, options);
      }
export type SendMortgagePurchaseNotificationToSpecialistMutationHookResult = ReturnType<typeof useSendMortgagePurchaseNotificationToSpecialistMutation>;
export type SendMortgagePurchaseNotificationToSpecialistMutationResult = Apollo.MutationResult<SendMortgagePurchaseNotificationToSpecialistMutation>;
export type SendMortgagePurchaseNotificationToSpecialistMutationOptions = Apollo.BaseMutationOptions<SendMortgagePurchaseNotificationToSpecialistMutation, SendMortgagePurchaseNotificationToSpecialistMutationVariables>;
export const NotificationsDocument = gql`
    query Notifications($filterInput: FilterInput, $sortInput: SortInput) {
  notifications: getNotificationsPage(
    filterInput: $filterInput
    sortInput: $sortInput
  ) {
    items {
      id
      ...Notification
    }
    totalItems
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationsCountDocument = gql`
    query NotificationsCount($filterInput: FilterInput, $sortInput: SortInput) {
  notificationsCount: getNotificationsPage(
    filterInput: $filterInput
    sortInput: $sortInput
  ) {
    totalItems
  }
}
    `;

/**
 * __useNotificationsCountQuery__
 *
 * To run a query within a React component, call `useNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsCountQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsCountQuery, NotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsCountQuery, NotificationsCountQueryVariables>(NotificationsCountDocument, options);
      }
export function useNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsCountQuery, NotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsCountQuery, NotificationsCountQueryVariables>(NotificationsCountDocument, options);
        }
export type NotificationsCountQueryHookResult = ReturnType<typeof useNotificationsCountQuery>;
export type NotificationsCountLazyQueryHookResult = ReturnType<typeof useNotificationsCountLazyQuery>;
export type NotificationsCountQueryResult = Apollo.QueryResult<NotificationsCountQuery, NotificationsCountQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($notificationId: ID!) {
  markNotificationAsRead(notificationId: $notificationId) {
    id
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead {
  markAllNotificationsAsRead {
    id
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const DeactivateNotificationDocument = gql`
    mutation DeactivateNotification($notificationId: ID!) {
  deactivateNotification(notificationId: $notificationId)
}
    `;
export type DeactivateNotificationMutationFn = Apollo.MutationFunction<DeactivateNotificationMutation, DeactivateNotificationMutationVariables>;

/**
 * __useDeactivateNotificationMutation__
 *
 * To run a mutation, you first call `useDeactivateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateNotificationMutation, { data, loading, error }] = useDeactivateNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useDeactivateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateNotificationMutation, DeactivateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateNotificationMutation, DeactivateNotificationMutationVariables>(DeactivateNotificationDocument, options);
      }
export type DeactivateNotificationMutationHookResult = ReturnType<typeof useDeactivateNotificationMutation>;
export type DeactivateNotificationMutationResult = Apollo.MutationResult<DeactivateNotificationMutation>;
export type DeactivateNotificationMutationOptions = Apollo.BaseMutationOptions<DeactivateNotificationMutation, DeactivateNotificationMutationVariables>;
export const BuildingSavingsProductsDocument = gql`
    query BuildingSavingsProducts {
  products: getBuildingSavingsProductsPage {
    items {
      id
      ...BuildingSavingsProductListItem
    }
  }
}
    ${BuildingSavingsProductListItemFragmentDoc}`;

/**
 * __useBuildingSavingsProductsQuery__
 *
 * To run a query within a React component, call `useBuildingSavingsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingSavingsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingSavingsProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuildingSavingsProductsQuery(baseOptions?: Apollo.QueryHookOptions<BuildingSavingsProductsQuery, BuildingSavingsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingSavingsProductsQuery, BuildingSavingsProductsQueryVariables>(BuildingSavingsProductsDocument, options);
      }
export function useBuildingSavingsProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingSavingsProductsQuery, BuildingSavingsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingSavingsProductsQuery, BuildingSavingsProductsQueryVariables>(BuildingSavingsProductsDocument, options);
        }
export type BuildingSavingsProductsQueryHookResult = ReturnType<typeof useBuildingSavingsProductsQuery>;
export type BuildingSavingsProductsLazyQueryHookResult = ReturnType<typeof useBuildingSavingsProductsLazyQuery>;
export type BuildingSavingsProductsQueryResult = Apollo.QueryResult<BuildingSavingsProductsQuery, BuildingSavingsProductsQueryVariables>;
export const BuildingSavingsProductDocument = gql`
    query BuildingSavingsProduct($id: ID!) {
  detail: getBuildingSavingsProduct(id: $id) {
    id
    ...BuildingSavingsProduct
  }
}
    ${BuildingSavingsProductFragmentDoc}`;

/**
 * __useBuildingSavingsProductQuery__
 *
 * To run a query within a React component, call `useBuildingSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildingSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<BuildingSavingsProductQuery, BuildingSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingSavingsProductQuery, BuildingSavingsProductQueryVariables>(BuildingSavingsProductDocument, options);
      }
export function useBuildingSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingSavingsProductQuery, BuildingSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingSavingsProductQuery, BuildingSavingsProductQueryVariables>(BuildingSavingsProductDocument, options);
        }
export type BuildingSavingsProductQueryHookResult = ReturnType<typeof useBuildingSavingsProductQuery>;
export type BuildingSavingsProductLazyQueryHookResult = ReturnType<typeof useBuildingSavingsProductLazyQuery>;
export type BuildingSavingsProductQueryResult = Apollo.QueryResult<BuildingSavingsProductQuery, BuildingSavingsProductQueryVariables>;
export const UpdateBuildingSavingsProductDocument = gql`
    mutation UpdateBuildingSavingsProduct($id: ID!, $updatedProduct: BuildingSavingsProductInput!) {
  updateProduct: updateBuildingSavingsProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...BuildingSavingsProduct
  }
}
    ${BuildingSavingsProductFragmentDoc}`;
export type UpdateBuildingSavingsProductMutationFn = Apollo.MutationFunction<UpdateBuildingSavingsProductMutation, UpdateBuildingSavingsProductMutationVariables>;

/**
 * __useUpdateBuildingSavingsProductMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingSavingsProductMutation, { data, loading, error }] = useUpdateBuildingSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateBuildingSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingSavingsProductMutation, UpdateBuildingSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingSavingsProductMutation, UpdateBuildingSavingsProductMutationVariables>(UpdateBuildingSavingsProductDocument, options);
      }
export type UpdateBuildingSavingsProductMutationHookResult = ReturnType<typeof useUpdateBuildingSavingsProductMutation>;
export type UpdateBuildingSavingsProductMutationResult = Apollo.MutationResult<UpdateBuildingSavingsProductMutation>;
export type UpdateBuildingSavingsProductMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingSavingsProductMutation, UpdateBuildingSavingsProductMutationVariables>;
export const CreateBuildingSavingsProductDocument = gql`
    mutation CreateBuildingSavingsProduct {
  createProduct: createBuildingSavingsProduct {
    id
  }
}
    `;
export type CreateBuildingSavingsProductMutationFn = Apollo.MutationFunction<CreateBuildingSavingsProductMutation, CreateBuildingSavingsProductMutationVariables>;

/**
 * __useCreateBuildingSavingsProductMutation__
 *
 * To run a mutation, you first call `useCreateBuildingSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingSavingsProductMutation, { data, loading, error }] = useCreateBuildingSavingsProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateBuildingSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingSavingsProductMutation, CreateBuildingSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingSavingsProductMutation, CreateBuildingSavingsProductMutationVariables>(CreateBuildingSavingsProductDocument, options);
      }
export type CreateBuildingSavingsProductMutationHookResult = ReturnType<typeof useCreateBuildingSavingsProductMutation>;
export type CreateBuildingSavingsProductMutationResult = Apollo.MutationResult<CreateBuildingSavingsProductMutation>;
export type CreateBuildingSavingsProductMutationOptions = Apollo.BaseMutationOptions<CreateBuildingSavingsProductMutation, CreateBuildingSavingsProductMutationVariables>;
export const DeleteBuildingSavingsProductDocument = gql`
    mutation DeleteBuildingSavingsProduct($id: ID!) {
  deleteProduct: deleteBuildingSavingsProduct(id: $id)
}
    `;
export type DeleteBuildingSavingsProductMutationFn = Apollo.MutationFunction<DeleteBuildingSavingsProductMutation, DeleteBuildingSavingsProductMutationVariables>;

/**
 * __useDeleteBuildingSavingsProductMutation__
 *
 * To run a mutation, you first call `useDeleteBuildingSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBuildingSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBuildingSavingsProductMutation, { data, loading, error }] = useDeleteBuildingSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBuildingSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBuildingSavingsProductMutation, DeleteBuildingSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBuildingSavingsProductMutation, DeleteBuildingSavingsProductMutationVariables>(DeleteBuildingSavingsProductDocument, options);
      }
export type DeleteBuildingSavingsProductMutationHookResult = ReturnType<typeof useDeleteBuildingSavingsProductMutation>;
export type DeleteBuildingSavingsProductMutationResult = Apollo.MutationResult<DeleteBuildingSavingsProductMutation>;
export type DeleteBuildingSavingsProductMutationOptions = Apollo.BaseMutationOptions<DeleteBuildingSavingsProductMutation, DeleteBuildingSavingsProductMutationVariables>;
export const CreateBuildingSavingsProductDocumentDocument = gql`
    mutation CreateBuildingSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createBuildingSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateBuildingSavingsProductDocumentMutationFn = Apollo.MutationFunction<CreateBuildingSavingsProductDocumentMutation, CreateBuildingSavingsProductDocumentMutationVariables>;

/**
 * __useCreateBuildingSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateBuildingSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingSavingsProductDocumentMutation, { data, loading, error }] = useCreateBuildingSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateBuildingSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingSavingsProductDocumentMutation, CreateBuildingSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingSavingsProductDocumentMutation, CreateBuildingSavingsProductDocumentMutationVariables>(CreateBuildingSavingsProductDocumentDocument, options);
      }
export type CreateBuildingSavingsProductDocumentMutationHookResult = ReturnType<typeof useCreateBuildingSavingsProductDocumentMutation>;
export type CreateBuildingSavingsProductDocumentMutationResult = Apollo.MutationResult<CreateBuildingSavingsProductDocumentMutation>;
export type CreateBuildingSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateBuildingSavingsProductDocumentMutation, CreateBuildingSavingsProductDocumentMutationVariables>;
export const CollisionInsuranceProductsDocument = gql`
    query CollisionInsuranceProducts {
  products: getCollisionInsuranceProductsPage {
    items {
      id
      ...CollisionInsuranceProductListItem
    }
  }
}
    ${CollisionInsuranceProductListItemFragmentDoc}`;

/**
 * __useCollisionInsuranceProductsQuery__
 *
 * To run a query within a React component, call `useCollisionInsuranceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollisionInsuranceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollisionInsuranceProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollisionInsuranceProductsQuery(baseOptions?: Apollo.QueryHookOptions<CollisionInsuranceProductsQuery, CollisionInsuranceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollisionInsuranceProductsQuery, CollisionInsuranceProductsQueryVariables>(CollisionInsuranceProductsDocument, options);
      }
export function useCollisionInsuranceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollisionInsuranceProductsQuery, CollisionInsuranceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollisionInsuranceProductsQuery, CollisionInsuranceProductsQueryVariables>(CollisionInsuranceProductsDocument, options);
        }
export type CollisionInsuranceProductsQueryHookResult = ReturnType<typeof useCollisionInsuranceProductsQuery>;
export type CollisionInsuranceProductsLazyQueryHookResult = ReturnType<typeof useCollisionInsuranceProductsLazyQuery>;
export type CollisionInsuranceProductsQueryResult = Apollo.QueryResult<CollisionInsuranceProductsQuery, CollisionInsuranceProductsQueryVariables>;
export const CollisionInsuranceProductDocument = gql`
    query CollisionInsuranceProduct($id: ID!) {
  detail: getCollisionInsuranceProduct(id: $id) {
    id
    ...CollisionInsuranceProduct
  }
}
    ${CollisionInsuranceProductFragmentDoc}`;

/**
 * __useCollisionInsuranceProductQuery__
 *
 * To run a query within a React component, call `useCollisionInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollisionInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollisionInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollisionInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<CollisionInsuranceProductQuery, CollisionInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollisionInsuranceProductQuery, CollisionInsuranceProductQueryVariables>(CollisionInsuranceProductDocument, options);
      }
export function useCollisionInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollisionInsuranceProductQuery, CollisionInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollisionInsuranceProductQuery, CollisionInsuranceProductQueryVariables>(CollisionInsuranceProductDocument, options);
        }
export type CollisionInsuranceProductQueryHookResult = ReturnType<typeof useCollisionInsuranceProductQuery>;
export type CollisionInsuranceProductLazyQueryHookResult = ReturnType<typeof useCollisionInsuranceProductLazyQuery>;
export type CollisionInsuranceProductQueryResult = Apollo.QueryResult<CollisionInsuranceProductQuery, CollisionInsuranceProductQueryVariables>;
export const UpdateCollisionInsuranceProductDocument = gql`
    mutation UpdateCollisionInsuranceProduct($id: ID!, $updatedProduct: CollisionInsuranceProductInput!) {
  updateProduct: updateCollisionInsuranceProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...CollisionInsuranceProduct
  }
}
    ${CollisionInsuranceProductFragmentDoc}`;
export type UpdateCollisionInsuranceProductMutationFn = Apollo.MutationFunction<UpdateCollisionInsuranceProductMutation, UpdateCollisionInsuranceProductMutationVariables>;

/**
 * __useUpdateCollisionInsuranceProductMutation__
 *
 * To run a mutation, you first call `useUpdateCollisionInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollisionInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollisionInsuranceProductMutation, { data, loading, error }] = useUpdateCollisionInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateCollisionInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollisionInsuranceProductMutation, UpdateCollisionInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollisionInsuranceProductMutation, UpdateCollisionInsuranceProductMutationVariables>(UpdateCollisionInsuranceProductDocument, options);
      }
export type UpdateCollisionInsuranceProductMutationHookResult = ReturnType<typeof useUpdateCollisionInsuranceProductMutation>;
export type UpdateCollisionInsuranceProductMutationResult = Apollo.MutationResult<UpdateCollisionInsuranceProductMutation>;
export type UpdateCollisionInsuranceProductMutationOptions = Apollo.BaseMutationOptions<UpdateCollisionInsuranceProductMutation, UpdateCollisionInsuranceProductMutationVariables>;
export const CreateCollisionInsuranceProductDocument = gql`
    mutation CreateCollisionInsuranceProduct {
  createProduct: createCollisionInsuranceProduct {
    id
  }
}
    `;
export type CreateCollisionInsuranceProductMutationFn = Apollo.MutationFunction<CreateCollisionInsuranceProductMutation, CreateCollisionInsuranceProductMutationVariables>;

/**
 * __useCreateCollisionInsuranceProductMutation__
 *
 * To run a mutation, you first call `useCreateCollisionInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollisionInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollisionInsuranceProductMutation, { data, loading, error }] = useCreateCollisionInsuranceProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCollisionInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollisionInsuranceProductMutation, CreateCollisionInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollisionInsuranceProductMutation, CreateCollisionInsuranceProductMutationVariables>(CreateCollisionInsuranceProductDocument, options);
      }
export type CreateCollisionInsuranceProductMutationHookResult = ReturnType<typeof useCreateCollisionInsuranceProductMutation>;
export type CreateCollisionInsuranceProductMutationResult = Apollo.MutationResult<CreateCollisionInsuranceProductMutation>;
export type CreateCollisionInsuranceProductMutationOptions = Apollo.BaseMutationOptions<CreateCollisionInsuranceProductMutation, CreateCollisionInsuranceProductMutationVariables>;
export const DeleteCollisionInsuranceProductDocument = gql`
    mutation DeleteCollisionInsuranceProduct($id: ID!) {
  deleteProduct: deleteCollisionInsuranceProduct(id: $id)
}
    `;
export type DeleteCollisionInsuranceProductMutationFn = Apollo.MutationFunction<DeleteCollisionInsuranceProductMutation, DeleteCollisionInsuranceProductMutationVariables>;

/**
 * __useDeleteCollisionInsuranceProductMutation__
 *
 * To run a mutation, you first call `useDeleteCollisionInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollisionInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollisionInsuranceProductMutation, { data, loading, error }] = useDeleteCollisionInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCollisionInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollisionInsuranceProductMutation, DeleteCollisionInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollisionInsuranceProductMutation, DeleteCollisionInsuranceProductMutationVariables>(DeleteCollisionInsuranceProductDocument, options);
      }
export type DeleteCollisionInsuranceProductMutationHookResult = ReturnType<typeof useDeleteCollisionInsuranceProductMutation>;
export type DeleteCollisionInsuranceProductMutationResult = Apollo.MutationResult<DeleteCollisionInsuranceProductMutation>;
export type DeleteCollisionInsuranceProductMutationOptions = Apollo.BaseMutationOptions<DeleteCollisionInsuranceProductMutation, DeleteCollisionInsuranceProductMutationVariables>;
export const CreateCollisionInsuranceProductDocumentDocument = gql`
    mutation CreateCollisionInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createCollisionInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateCollisionInsuranceProductDocumentMutationFn = Apollo.MutationFunction<CreateCollisionInsuranceProductDocumentMutation, CreateCollisionInsuranceProductDocumentMutationVariables>;

/**
 * __useCreateCollisionInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateCollisionInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollisionInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollisionInsuranceProductDocumentMutation, { data, loading, error }] = useCreateCollisionInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateCollisionInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollisionInsuranceProductDocumentMutation, CreateCollisionInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollisionInsuranceProductDocumentMutation, CreateCollisionInsuranceProductDocumentMutationVariables>(CreateCollisionInsuranceProductDocumentDocument, options);
      }
export type CreateCollisionInsuranceProductDocumentMutationHookResult = ReturnType<typeof useCreateCollisionInsuranceProductDocumentMutation>;
export type CreateCollisionInsuranceProductDocumentMutationResult = Apollo.MutationResult<CreateCollisionInsuranceProductDocumentMutation>;
export type CreateCollisionInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateCollisionInsuranceProductDocumentMutation, CreateCollisionInsuranceProductDocumentMutationVariables>;
export const CreditCardProductsDocument = gql`
    query CreditCardProducts {
  products: getCreditCardProductsPage {
    items {
      id
      ...CreditCardProductListItem
    }
  }
}
    ${CreditCardProductListItemFragmentDoc}`;

/**
 * __useCreditCardProductsQuery__
 *
 * To run a query within a React component, call `useCreditCardProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCardProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCardProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditCardProductsQuery(baseOptions?: Apollo.QueryHookOptions<CreditCardProductsQuery, CreditCardProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditCardProductsQuery, CreditCardProductsQueryVariables>(CreditCardProductsDocument, options);
      }
export function useCreditCardProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditCardProductsQuery, CreditCardProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditCardProductsQuery, CreditCardProductsQueryVariables>(CreditCardProductsDocument, options);
        }
export type CreditCardProductsQueryHookResult = ReturnType<typeof useCreditCardProductsQuery>;
export type CreditCardProductsLazyQueryHookResult = ReturnType<typeof useCreditCardProductsLazyQuery>;
export type CreditCardProductsQueryResult = Apollo.QueryResult<CreditCardProductsQuery, CreditCardProductsQueryVariables>;
export const CreditCardProductDocument = gql`
    query CreditCardProduct($id: ID!) {
  detail: getCreditCardProduct(id: $id) {
    id
    ...CreditCardProduct
  }
}
    ${CreditCardProductFragmentDoc}`;

/**
 * __useCreditCardProductQuery__
 *
 * To run a query within a React component, call `useCreditCardProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCardProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCardProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreditCardProductQuery(baseOptions: Apollo.QueryHookOptions<CreditCardProductQuery, CreditCardProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditCardProductQuery, CreditCardProductQueryVariables>(CreditCardProductDocument, options);
      }
export function useCreditCardProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditCardProductQuery, CreditCardProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditCardProductQuery, CreditCardProductQueryVariables>(CreditCardProductDocument, options);
        }
export type CreditCardProductQueryHookResult = ReturnType<typeof useCreditCardProductQuery>;
export type CreditCardProductLazyQueryHookResult = ReturnType<typeof useCreditCardProductLazyQuery>;
export type CreditCardProductQueryResult = Apollo.QueryResult<CreditCardProductQuery, CreditCardProductQueryVariables>;
export const UpdateCreditCardProductDocument = gql`
    mutation UpdateCreditCardProduct($id: ID!, $updatedProduct: CreditCardProductInput!) {
  updateProduct: updateCreditCardProduct(id: $id, updatedProduct: $updatedProduct) {
    id
    ...CreditCardProduct
  }
}
    ${CreditCardProductFragmentDoc}`;
export type UpdateCreditCardProductMutationFn = Apollo.MutationFunction<UpdateCreditCardProductMutation, UpdateCreditCardProductMutationVariables>;

/**
 * __useUpdateCreditCardProductMutation__
 *
 * To run a mutation, you first call `useUpdateCreditCardProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditCardProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditCardProductMutation, { data, loading, error }] = useUpdateCreditCardProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateCreditCardProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditCardProductMutation, UpdateCreditCardProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditCardProductMutation, UpdateCreditCardProductMutationVariables>(UpdateCreditCardProductDocument, options);
      }
export type UpdateCreditCardProductMutationHookResult = ReturnType<typeof useUpdateCreditCardProductMutation>;
export type UpdateCreditCardProductMutationResult = Apollo.MutationResult<UpdateCreditCardProductMutation>;
export type UpdateCreditCardProductMutationOptions = Apollo.BaseMutationOptions<UpdateCreditCardProductMutation, UpdateCreditCardProductMutationVariables>;
export const CreateCreditCardProductDocument = gql`
    mutation CreateCreditCardProduct {
  createProduct: createCreditCardProduct {
    id
  }
}
    `;
export type CreateCreditCardProductMutationFn = Apollo.MutationFunction<CreateCreditCardProductMutation, CreateCreditCardProductMutationVariables>;

/**
 * __useCreateCreditCardProductMutation__
 *
 * To run a mutation, you first call `useCreateCreditCardProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditCardProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditCardProductMutation, { data, loading, error }] = useCreateCreditCardProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCreditCardProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditCardProductMutation, CreateCreditCardProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditCardProductMutation, CreateCreditCardProductMutationVariables>(CreateCreditCardProductDocument, options);
      }
export type CreateCreditCardProductMutationHookResult = ReturnType<typeof useCreateCreditCardProductMutation>;
export type CreateCreditCardProductMutationResult = Apollo.MutationResult<CreateCreditCardProductMutation>;
export type CreateCreditCardProductMutationOptions = Apollo.BaseMutationOptions<CreateCreditCardProductMutation, CreateCreditCardProductMutationVariables>;
export const DeleteCreditCardProductDocument = gql`
    mutation DeleteCreditCardProduct($id: ID!) {
  deleteProduct: deleteCreditCardProduct(id: $id)
}
    `;
export type DeleteCreditCardProductMutationFn = Apollo.MutationFunction<DeleteCreditCardProductMutation, DeleteCreditCardProductMutationVariables>;

/**
 * __useDeleteCreditCardProductMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardProductMutation, { data, loading, error }] = useDeleteCreditCardProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCreditCardProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCreditCardProductMutation, DeleteCreditCardProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCreditCardProductMutation, DeleteCreditCardProductMutationVariables>(DeleteCreditCardProductDocument, options);
      }
export type DeleteCreditCardProductMutationHookResult = ReturnType<typeof useDeleteCreditCardProductMutation>;
export type DeleteCreditCardProductMutationResult = Apollo.MutationResult<DeleteCreditCardProductMutation>;
export type DeleteCreditCardProductMutationOptions = Apollo.BaseMutationOptions<DeleteCreditCardProductMutation, DeleteCreditCardProductMutationVariables>;
export const CreateCreditCardProductDocumentDocument = gql`
    mutation CreateCreditCardProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createCreditCardProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateCreditCardProductDocumentMutationFn = Apollo.MutationFunction<CreateCreditCardProductDocumentMutation, CreateCreditCardProductDocumentMutationVariables>;

/**
 * __useCreateCreditCardProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateCreditCardProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditCardProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditCardProductDocumentMutation, { data, loading, error }] = useCreateCreditCardProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateCreditCardProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditCardProductDocumentMutation, CreateCreditCardProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditCardProductDocumentMutation, CreateCreditCardProductDocumentMutationVariables>(CreateCreditCardProductDocumentDocument, options);
      }
export type CreateCreditCardProductDocumentMutationHookResult = ReturnType<typeof useCreateCreditCardProductDocumentMutation>;
export type CreateCreditCardProductDocumentMutationResult = Apollo.MutationResult<CreateCreditCardProductDocumentMutation>;
export type CreateCreditCardProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateCreditCardProductDocumentMutation, CreateCreditCardProductDocumentMutationVariables>;
export const GenericProductsDocument = gql`
    query GenericProducts {
  products: getGenericProductsPage {
    items {
      id
      ...GenericProductListItem
    }
  }
}
    ${GenericProductListItemFragmentDoc}`;

/**
 * __useGenericProductsQuery__
 *
 * To run a query within a React component, call `useGenericProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenericProductsQuery(baseOptions?: Apollo.QueryHookOptions<GenericProductsQuery, GenericProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericProductsQuery, GenericProductsQueryVariables>(GenericProductsDocument, options);
      }
export function useGenericProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericProductsQuery, GenericProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericProductsQuery, GenericProductsQueryVariables>(GenericProductsDocument, options);
        }
export type GenericProductsQueryHookResult = ReturnType<typeof useGenericProductsQuery>;
export type GenericProductsLazyQueryHookResult = ReturnType<typeof useGenericProductsLazyQuery>;
export type GenericProductsQueryResult = Apollo.QueryResult<GenericProductsQuery, GenericProductsQueryVariables>;
export const GenericProductDocument = gql`
    query GenericProduct($id: ID!) {
  detail: getGenericProduct(id: $id) {
    id
    ...GenericProduct
  }
}
    ${GenericProductFragmentDoc}`;

/**
 * __useGenericProductQuery__
 *
 * To run a query within a React component, call `useGenericProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenericProductQuery(baseOptions: Apollo.QueryHookOptions<GenericProductQuery, GenericProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericProductQuery, GenericProductQueryVariables>(GenericProductDocument, options);
      }
export function useGenericProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericProductQuery, GenericProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericProductQuery, GenericProductQueryVariables>(GenericProductDocument, options);
        }
export type GenericProductQueryHookResult = ReturnType<typeof useGenericProductQuery>;
export type GenericProductLazyQueryHookResult = ReturnType<typeof useGenericProductLazyQuery>;
export type GenericProductQueryResult = Apollo.QueryResult<GenericProductQuery, GenericProductQueryVariables>;
export const UpdateGenericProductDocument = gql`
    mutation UpdateGenericProduct($id: ID!, $updatedProduct: GenericProductInput!) {
  updateProduct: updateGenericProduct(id: $id, updatedProduct: $updatedProduct) {
    id
    ...GenericProduct
  }
}
    ${GenericProductFragmentDoc}`;
export type UpdateGenericProductMutationFn = Apollo.MutationFunction<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>;

/**
 * __useUpdateGenericProductMutation__
 *
 * To run a mutation, you first call `useUpdateGenericProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericProductMutation, { data, loading, error }] = useUpdateGenericProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateGenericProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>(UpdateGenericProductDocument, options);
      }
export type UpdateGenericProductMutationHookResult = ReturnType<typeof useUpdateGenericProductMutation>;
export type UpdateGenericProductMutationResult = Apollo.MutationResult<UpdateGenericProductMutation>;
export type UpdateGenericProductMutationOptions = Apollo.BaseMutationOptions<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>;
export const CreateGenericProductDocument = gql`
    mutation CreateGenericProduct {
  createProduct: createGenericProduct {
    id
  }
}
    `;
export type CreateGenericProductMutationFn = Apollo.MutationFunction<CreateGenericProductMutation, CreateGenericProductMutationVariables>;

/**
 * __useCreateGenericProductMutation__
 *
 * To run a mutation, you first call `useCreateGenericProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericProductMutation, { data, loading, error }] = useCreateGenericProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateGenericProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericProductMutation, CreateGenericProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericProductMutation, CreateGenericProductMutationVariables>(CreateGenericProductDocument, options);
      }
export type CreateGenericProductMutationHookResult = ReturnType<typeof useCreateGenericProductMutation>;
export type CreateGenericProductMutationResult = Apollo.MutationResult<CreateGenericProductMutation>;
export type CreateGenericProductMutationOptions = Apollo.BaseMutationOptions<CreateGenericProductMutation, CreateGenericProductMutationVariables>;
export const DeleteGenericProductDocument = gql`
    mutation DeleteGenericProduct($id: ID!) {
  deleteProduct: deleteGenericProduct(id: $id)
}
    `;
export type DeleteGenericProductMutationFn = Apollo.MutationFunction<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>;

/**
 * __useDeleteGenericProductMutation__
 *
 * To run a mutation, you first call `useDeleteGenericProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericProductMutation, { data, loading, error }] = useDeleteGenericProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGenericProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>(DeleteGenericProductDocument, options);
      }
export type DeleteGenericProductMutationHookResult = ReturnType<typeof useDeleteGenericProductMutation>;
export type DeleteGenericProductMutationResult = Apollo.MutationResult<DeleteGenericProductMutation>;
export type DeleteGenericProductMutationOptions = Apollo.BaseMutationOptions<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>;
export const CreateGenericProductDocumentDocument = gql`
    mutation CreateGenericProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createGenericProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateGenericProductDocumentMutationFn = Apollo.MutationFunction<CreateGenericProductDocumentMutation, CreateGenericProductDocumentMutationVariables>;

/**
 * __useCreateGenericProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateGenericProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericProductDocumentMutation, { data, loading, error }] = useCreateGenericProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateGenericProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericProductDocumentMutation, CreateGenericProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericProductDocumentMutation, CreateGenericProductDocumentMutationVariables>(CreateGenericProductDocumentDocument, options);
      }
export type CreateGenericProductDocumentMutationHookResult = ReturnType<typeof useCreateGenericProductDocumentMutation>;
export type CreateGenericProductDocumentMutationResult = Apollo.MutationResult<CreateGenericProductDocumentMutation>;
export type CreateGenericProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateGenericProductDocumentMutation, CreateGenericProductDocumentMutationVariables>;
export const GenericInsuranceProductsDocument = gql`
    query GenericInsuranceProducts {
  products: getGenericInsuranceProductsPage {
    items {
      id
      ...GenericInsuranceProductListItem
    }
  }
}
    ${GenericInsuranceProductListItemFragmentDoc}`;

/**
 * __useGenericInsuranceProductsQuery__
 *
 * To run a query within a React component, call `useGenericInsuranceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericInsuranceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericInsuranceProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenericInsuranceProductsQuery(baseOptions?: Apollo.QueryHookOptions<GenericInsuranceProductsQuery, GenericInsuranceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericInsuranceProductsQuery, GenericInsuranceProductsQueryVariables>(GenericInsuranceProductsDocument, options);
      }
export function useGenericInsuranceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericInsuranceProductsQuery, GenericInsuranceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericInsuranceProductsQuery, GenericInsuranceProductsQueryVariables>(GenericInsuranceProductsDocument, options);
        }
export type GenericInsuranceProductsQueryHookResult = ReturnType<typeof useGenericInsuranceProductsQuery>;
export type GenericInsuranceProductsLazyQueryHookResult = ReturnType<typeof useGenericInsuranceProductsLazyQuery>;
export type GenericInsuranceProductsQueryResult = Apollo.QueryResult<GenericInsuranceProductsQuery, GenericInsuranceProductsQueryVariables>;
export const GenericInsuranceProductDocument = gql`
    query GenericInsuranceProduct($id: ID!) {
  detail: getGenericInsuranceProduct(id: $id) {
    id
    ...GenericInsuranceProduct
  }
}
    ${GenericInsuranceProductFragmentDoc}`;

/**
 * __useGenericInsuranceProductQuery__
 *
 * To run a query within a React component, call `useGenericInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenericInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<GenericInsuranceProductQuery, GenericInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericInsuranceProductQuery, GenericInsuranceProductQueryVariables>(GenericInsuranceProductDocument, options);
      }
export function useGenericInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericInsuranceProductQuery, GenericInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericInsuranceProductQuery, GenericInsuranceProductQueryVariables>(GenericInsuranceProductDocument, options);
        }
export type GenericInsuranceProductQueryHookResult = ReturnType<typeof useGenericInsuranceProductQuery>;
export type GenericInsuranceProductLazyQueryHookResult = ReturnType<typeof useGenericInsuranceProductLazyQuery>;
export type GenericInsuranceProductQueryResult = Apollo.QueryResult<GenericInsuranceProductQuery, GenericInsuranceProductQueryVariables>;
export const UpdateGenericInsuranceProductDocument = gql`
    mutation UpdateGenericInsuranceProduct($id: ID!, $updatedProduct: GenericInsuranceProductInput!) {
  updateProduct: updateGenericInsuranceProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...GenericInsuranceProduct
  }
}
    ${GenericInsuranceProductFragmentDoc}`;
export type UpdateGenericInsuranceProductMutationFn = Apollo.MutationFunction<UpdateGenericInsuranceProductMutation, UpdateGenericInsuranceProductMutationVariables>;

/**
 * __useUpdateGenericInsuranceProductMutation__
 *
 * To run a mutation, you first call `useUpdateGenericInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericInsuranceProductMutation, { data, loading, error }] = useUpdateGenericInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateGenericInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericInsuranceProductMutation, UpdateGenericInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericInsuranceProductMutation, UpdateGenericInsuranceProductMutationVariables>(UpdateGenericInsuranceProductDocument, options);
      }
export type UpdateGenericInsuranceProductMutationHookResult = ReturnType<typeof useUpdateGenericInsuranceProductMutation>;
export type UpdateGenericInsuranceProductMutationResult = Apollo.MutationResult<UpdateGenericInsuranceProductMutation>;
export type UpdateGenericInsuranceProductMutationOptions = Apollo.BaseMutationOptions<UpdateGenericInsuranceProductMutation, UpdateGenericInsuranceProductMutationVariables>;
export const CreateGenericInsuranceProductDocument = gql`
    mutation CreateGenericInsuranceProduct {
  createProduct: createGenericInsuranceProduct {
    id
  }
}
    `;
export type CreateGenericInsuranceProductMutationFn = Apollo.MutationFunction<CreateGenericInsuranceProductMutation, CreateGenericInsuranceProductMutationVariables>;

/**
 * __useCreateGenericInsuranceProductMutation__
 *
 * To run a mutation, you first call `useCreateGenericInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericInsuranceProductMutation, { data, loading, error }] = useCreateGenericInsuranceProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateGenericInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericInsuranceProductMutation, CreateGenericInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericInsuranceProductMutation, CreateGenericInsuranceProductMutationVariables>(CreateGenericInsuranceProductDocument, options);
      }
export type CreateGenericInsuranceProductMutationHookResult = ReturnType<typeof useCreateGenericInsuranceProductMutation>;
export type CreateGenericInsuranceProductMutationResult = Apollo.MutationResult<CreateGenericInsuranceProductMutation>;
export type CreateGenericInsuranceProductMutationOptions = Apollo.BaseMutationOptions<CreateGenericInsuranceProductMutation, CreateGenericInsuranceProductMutationVariables>;
export const DeleteGenericInsuranceProductDocument = gql`
    mutation DeleteGenericInsuranceProduct($id: ID!) {
  deleteProduct: deleteGenericInsuranceProduct(id: $id)
}
    `;
export type DeleteGenericInsuranceProductMutationFn = Apollo.MutationFunction<DeleteGenericInsuranceProductMutation, DeleteGenericInsuranceProductMutationVariables>;

/**
 * __useDeleteGenericInsuranceProductMutation__
 *
 * To run a mutation, you first call `useDeleteGenericInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericInsuranceProductMutation, { data, loading, error }] = useDeleteGenericInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGenericInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericInsuranceProductMutation, DeleteGenericInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericInsuranceProductMutation, DeleteGenericInsuranceProductMutationVariables>(DeleteGenericInsuranceProductDocument, options);
      }
export type DeleteGenericInsuranceProductMutationHookResult = ReturnType<typeof useDeleteGenericInsuranceProductMutation>;
export type DeleteGenericInsuranceProductMutationResult = Apollo.MutationResult<DeleteGenericInsuranceProductMutation>;
export type DeleteGenericInsuranceProductMutationOptions = Apollo.BaseMutationOptions<DeleteGenericInsuranceProductMutation, DeleteGenericInsuranceProductMutationVariables>;
export const CreateGenericInsuranceProductDocumentDocument = gql`
    mutation CreateGenericInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createGenericInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateGenericInsuranceProductDocumentMutationFn = Apollo.MutationFunction<CreateGenericInsuranceProductDocumentMutation, CreateGenericInsuranceProductDocumentMutationVariables>;

/**
 * __useCreateGenericInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateGenericInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericInsuranceProductDocumentMutation, { data, loading, error }] = useCreateGenericInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateGenericInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericInsuranceProductDocumentMutation, CreateGenericInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericInsuranceProductDocumentMutation, CreateGenericInsuranceProductDocumentMutationVariables>(CreateGenericInsuranceProductDocumentDocument, options);
      }
export type CreateGenericInsuranceProductDocumentMutationHookResult = ReturnType<typeof useCreateGenericInsuranceProductDocumentMutation>;
export type CreateGenericInsuranceProductDocumentMutationResult = Apollo.MutationResult<CreateGenericInsuranceProductDocumentMutation>;
export type CreateGenericInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateGenericInsuranceProductDocumentMutation, CreateGenericInsuranceProductDocumentMutationVariables>;
export const InvestmentProductsDocument = gql`
    query InvestmentProducts {
  products: getInvestmentProductsPage {
    items {
      id
      ...InvestmentProductListItem
    }
  }
}
    ${InvestmentProductListItemFragmentDoc}`;

/**
 * __useInvestmentProductsQuery__
 *
 * To run a query within a React component, call `useInvestmentProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentProductsQuery(baseOptions?: Apollo.QueryHookOptions<InvestmentProductsQuery, InvestmentProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentProductsQuery, InvestmentProductsQueryVariables>(InvestmentProductsDocument, options);
      }
export function useInvestmentProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentProductsQuery, InvestmentProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentProductsQuery, InvestmentProductsQueryVariables>(InvestmentProductsDocument, options);
        }
export type InvestmentProductsQueryHookResult = ReturnType<typeof useInvestmentProductsQuery>;
export type InvestmentProductsLazyQueryHookResult = ReturnType<typeof useInvestmentProductsLazyQuery>;
export type InvestmentProductsQueryResult = Apollo.QueryResult<InvestmentProductsQuery, InvestmentProductsQueryVariables>;
export const InvestmentProductDocument = gql`
    query InvestmentProduct($id: ID!) {
  detail: getInvestmentProduct(id: $id) {
    id
    ...InvestmentProduct
  }
}
    ${InvestmentProductFragmentDoc}`;

/**
 * __useInvestmentProductQuery__
 *
 * To run a query within a React component, call `useInvestmentProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvestmentProductQuery(baseOptions: Apollo.QueryHookOptions<InvestmentProductQuery, InvestmentProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentProductQuery, InvestmentProductQueryVariables>(InvestmentProductDocument, options);
      }
export function useInvestmentProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentProductQuery, InvestmentProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentProductQuery, InvestmentProductQueryVariables>(InvestmentProductDocument, options);
        }
export type InvestmentProductQueryHookResult = ReturnType<typeof useInvestmentProductQuery>;
export type InvestmentProductLazyQueryHookResult = ReturnType<typeof useInvestmentProductLazyQuery>;
export type InvestmentProductQueryResult = Apollo.QueryResult<InvestmentProductQuery, InvestmentProductQueryVariables>;
export const UpdateInvestmentProductDocument = gql`
    mutation UpdateInvestmentProduct($id: ID!, $updatedProduct: InvestmentProductInput!) {
  updateProduct: updateInvestmentProduct(id: $id, updatedProduct: $updatedProduct) {
    id
    ...InvestmentProduct
  }
}
    ${InvestmentProductFragmentDoc}`;
export type UpdateInvestmentProductMutationFn = Apollo.MutationFunction<UpdateInvestmentProductMutation, UpdateInvestmentProductMutationVariables>;

/**
 * __useUpdateInvestmentProductMutation__
 *
 * To run a mutation, you first call `useUpdateInvestmentProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvestmentProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvestmentProductMutation, { data, loading, error }] = useUpdateInvestmentProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateInvestmentProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvestmentProductMutation, UpdateInvestmentProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvestmentProductMutation, UpdateInvestmentProductMutationVariables>(UpdateInvestmentProductDocument, options);
      }
export type UpdateInvestmentProductMutationHookResult = ReturnType<typeof useUpdateInvestmentProductMutation>;
export type UpdateInvestmentProductMutationResult = Apollo.MutationResult<UpdateInvestmentProductMutation>;
export type UpdateInvestmentProductMutationOptions = Apollo.BaseMutationOptions<UpdateInvestmentProductMutation, UpdateInvestmentProductMutationVariables>;
export const CreateInvestmentProductDocument = gql`
    mutation CreateInvestmentProduct {
  createProduct: createInvestmentProduct {
    id
  }
}
    `;
export type CreateInvestmentProductMutationFn = Apollo.MutationFunction<CreateInvestmentProductMutation, CreateInvestmentProductMutationVariables>;

/**
 * __useCreateInvestmentProductMutation__
 *
 * To run a mutation, you first call `useCreateInvestmentProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvestmentProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvestmentProductMutation, { data, loading, error }] = useCreateInvestmentProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateInvestmentProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvestmentProductMutation, CreateInvestmentProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvestmentProductMutation, CreateInvestmentProductMutationVariables>(CreateInvestmentProductDocument, options);
      }
export type CreateInvestmentProductMutationHookResult = ReturnType<typeof useCreateInvestmentProductMutation>;
export type CreateInvestmentProductMutationResult = Apollo.MutationResult<CreateInvestmentProductMutation>;
export type CreateInvestmentProductMutationOptions = Apollo.BaseMutationOptions<CreateInvestmentProductMutation, CreateInvestmentProductMutationVariables>;
export const DeleteInvestmentProductDocument = gql`
    mutation DeleteInvestmentProduct($id: ID!) {
  deleteProduct: deleteInvestmentProduct(id: $id)
}
    `;
export type DeleteInvestmentProductMutationFn = Apollo.MutationFunction<DeleteInvestmentProductMutation, DeleteInvestmentProductMutationVariables>;

/**
 * __useDeleteInvestmentProductMutation__
 *
 * To run a mutation, you first call `useDeleteInvestmentProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvestmentProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvestmentProductMutation, { data, loading, error }] = useDeleteInvestmentProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvestmentProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvestmentProductMutation, DeleteInvestmentProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvestmentProductMutation, DeleteInvestmentProductMutationVariables>(DeleteInvestmentProductDocument, options);
      }
export type DeleteInvestmentProductMutationHookResult = ReturnType<typeof useDeleteInvestmentProductMutation>;
export type DeleteInvestmentProductMutationResult = Apollo.MutationResult<DeleteInvestmentProductMutation>;
export type DeleteInvestmentProductMutationOptions = Apollo.BaseMutationOptions<DeleteInvestmentProductMutation, DeleteInvestmentProductMutationVariables>;
export const CreateInvestmentProductDocumentDocument = gql`
    mutation CreateInvestmentProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createInvestmentProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateInvestmentProductDocumentMutationFn = Apollo.MutationFunction<CreateInvestmentProductDocumentMutation, CreateInvestmentProductDocumentMutationVariables>;

/**
 * __useCreateInvestmentProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateInvestmentProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvestmentProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvestmentProductDocumentMutation, { data, loading, error }] = useCreateInvestmentProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateInvestmentProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvestmentProductDocumentMutation, CreateInvestmentProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvestmentProductDocumentMutation, CreateInvestmentProductDocumentMutationVariables>(CreateInvestmentProductDocumentDocument, options);
      }
export type CreateInvestmentProductDocumentMutationHookResult = ReturnType<typeof useCreateInvestmentProductDocumentMutation>;
export type CreateInvestmentProductDocumentMutationResult = Apollo.MutationResult<CreateInvestmentProductDocumentMutation>;
export type CreateInvestmentProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateInvestmentProductDocumentMutation, CreateInvestmentProductDocumentMutationVariables>;
export const LifeInsuranceProductsDocument = gql`
    query LifeInsuranceProducts {
  products: getLifeInsuranceProductsPage {
    items {
      id
      ...LifeInsuranceProductListItem
    }
  }
}
    ${LifeInsuranceProductListItemFragmentDoc}`;

/**
 * __useLifeInsuranceProductsQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLifeInsuranceProductsQuery(baseOptions?: Apollo.QueryHookOptions<LifeInsuranceProductsQuery, LifeInsuranceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceProductsQuery, LifeInsuranceProductsQueryVariables>(LifeInsuranceProductsDocument, options);
      }
export function useLifeInsuranceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceProductsQuery, LifeInsuranceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceProductsQuery, LifeInsuranceProductsQueryVariables>(LifeInsuranceProductsDocument, options);
        }
export type LifeInsuranceProductsQueryHookResult = ReturnType<typeof useLifeInsuranceProductsQuery>;
export type LifeInsuranceProductsLazyQueryHookResult = ReturnType<typeof useLifeInsuranceProductsLazyQuery>;
export type LifeInsuranceProductsQueryResult = Apollo.QueryResult<LifeInsuranceProductsQuery, LifeInsuranceProductsQueryVariables>;
export const LifeInsuranceProductDocument = gql`
    query LifeInsuranceProduct($id: ID!) {
  detail: getLifeInsuranceProduct(id: $id) {
    id
    ...LifeInsuranceProduct
  }
}
    ${LifeInsuranceProductFragmentDoc}`;

/**
 * __useLifeInsuranceProductQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLifeInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<LifeInsuranceProductQuery, LifeInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceProductQuery, LifeInsuranceProductQueryVariables>(LifeInsuranceProductDocument, options);
      }
export function useLifeInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceProductQuery, LifeInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceProductQuery, LifeInsuranceProductQueryVariables>(LifeInsuranceProductDocument, options);
        }
export type LifeInsuranceProductQueryHookResult = ReturnType<typeof useLifeInsuranceProductQuery>;
export type LifeInsuranceProductLazyQueryHookResult = ReturnType<typeof useLifeInsuranceProductLazyQuery>;
export type LifeInsuranceProductQueryResult = Apollo.QueryResult<LifeInsuranceProductQuery, LifeInsuranceProductQueryVariables>;
export const UpdateLifeInsuranceProductDocument = gql`
    mutation UpdateLifeInsuranceProduct($id: ID!, $updatedProduct: LifeInsuranceProductInput!) {
  updateProduct: updateLifeInsuranceProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...LifeInsuranceProduct
  }
}
    ${LifeInsuranceProductFragmentDoc}`;
export type UpdateLifeInsuranceProductMutationFn = Apollo.MutationFunction<UpdateLifeInsuranceProductMutation, UpdateLifeInsuranceProductMutationVariables>;

/**
 * __useUpdateLifeInsuranceProductMutation__
 *
 * To run a mutation, you first call `useUpdateLifeInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifeInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifeInsuranceProductMutation, { data, loading, error }] = useUpdateLifeInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateLifeInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLifeInsuranceProductMutation, UpdateLifeInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLifeInsuranceProductMutation, UpdateLifeInsuranceProductMutationVariables>(UpdateLifeInsuranceProductDocument, options);
      }
export type UpdateLifeInsuranceProductMutationHookResult = ReturnType<typeof useUpdateLifeInsuranceProductMutation>;
export type UpdateLifeInsuranceProductMutationResult = Apollo.MutationResult<UpdateLifeInsuranceProductMutation>;
export type UpdateLifeInsuranceProductMutationOptions = Apollo.BaseMutationOptions<UpdateLifeInsuranceProductMutation, UpdateLifeInsuranceProductMutationVariables>;
export const CreateLifeInsuranceProductDocument = gql`
    mutation CreateLifeInsuranceProduct {
  createProduct: createLifeInsuranceProduct {
    id
  }
}
    `;
export type CreateLifeInsuranceProductMutationFn = Apollo.MutationFunction<CreateLifeInsuranceProductMutation, CreateLifeInsuranceProductMutationVariables>;

/**
 * __useCreateLifeInsuranceProductMutation__
 *
 * To run a mutation, you first call `useCreateLifeInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifeInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifeInsuranceProductMutation, { data, loading, error }] = useCreateLifeInsuranceProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLifeInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateLifeInsuranceProductMutation, CreateLifeInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLifeInsuranceProductMutation, CreateLifeInsuranceProductMutationVariables>(CreateLifeInsuranceProductDocument, options);
      }
export type CreateLifeInsuranceProductMutationHookResult = ReturnType<typeof useCreateLifeInsuranceProductMutation>;
export type CreateLifeInsuranceProductMutationResult = Apollo.MutationResult<CreateLifeInsuranceProductMutation>;
export type CreateLifeInsuranceProductMutationOptions = Apollo.BaseMutationOptions<CreateLifeInsuranceProductMutation, CreateLifeInsuranceProductMutationVariables>;
export const DeleteLifeInsuranceProductDocument = gql`
    mutation DeleteLifeInsuranceProduct($id: ID!) {
  deleteProduct: deleteLifeInsuranceProduct(id: $id)
}
    `;
export type DeleteLifeInsuranceProductMutationFn = Apollo.MutationFunction<DeleteLifeInsuranceProductMutation, DeleteLifeInsuranceProductMutationVariables>;

/**
 * __useDeleteLifeInsuranceProductMutation__
 *
 * To run a mutation, you first call `useDeleteLifeInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLifeInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLifeInsuranceProductMutation, { data, loading, error }] = useDeleteLifeInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLifeInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLifeInsuranceProductMutation, DeleteLifeInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLifeInsuranceProductMutation, DeleteLifeInsuranceProductMutationVariables>(DeleteLifeInsuranceProductDocument, options);
      }
export type DeleteLifeInsuranceProductMutationHookResult = ReturnType<typeof useDeleteLifeInsuranceProductMutation>;
export type DeleteLifeInsuranceProductMutationResult = Apollo.MutationResult<DeleteLifeInsuranceProductMutation>;
export type DeleteLifeInsuranceProductMutationOptions = Apollo.BaseMutationOptions<DeleteLifeInsuranceProductMutation, DeleteLifeInsuranceProductMutationVariables>;
export const CreateLifeInsuranceProductDocumentDocument = gql`
    mutation CreateLifeInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createLifeInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateLifeInsuranceProductDocumentMutationFn = Apollo.MutationFunction<CreateLifeInsuranceProductDocumentMutation, CreateLifeInsuranceProductDocumentMutationVariables>;

/**
 * __useCreateLifeInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateLifeInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLifeInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLifeInsuranceProductDocumentMutation, { data, loading, error }] = useCreateLifeInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateLifeInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateLifeInsuranceProductDocumentMutation, CreateLifeInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLifeInsuranceProductDocumentMutation, CreateLifeInsuranceProductDocumentMutationVariables>(CreateLifeInsuranceProductDocumentDocument, options);
      }
export type CreateLifeInsuranceProductDocumentMutationHookResult = ReturnType<typeof useCreateLifeInsuranceProductDocumentMutation>;
export type CreateLifeInsuranceProductDocumentMutationResult = Apollo.MutationResult<CreateLifeInsuranceProductDocumentMutation>;
export type CreateLifeInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateLifeInsuranceProductDocumentMutation, CreateLifeInsuranceProductDocumentMutationVariables>;
export const LoanProductsDocument = gql`
    query LoanProducts {
  products: getLoanProductsPage {
    items {
      id
      ...LoanProductListItem
    }
  }
}
    ${LoanProductListItemFragmentDoc}`;

/**
 * __useLoanProductsQuery__
 *
 * To run a query within a React component, call `useLoanProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoanProductsQuery(baseOptions?: Apollo.QueryHookOptions<LoanProductsQuery, LoanProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanProductsQuery, LoanProductsQueryVariables>(LoanProductsDocument, options);
      }
export function useLoanProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanProductsQuery, LoanProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanProductsQuery, LoanProductsQueryVariables>(LoanProductsDocument, options);
        }
export type LoanProductsQueryHookResult = ReturnType<typeof useLoanProductsQuery>;
export type LoanProductsLazyQueryHookResult = ReturnType<typeof useLoanProductsLazyQuery>;
export type LoanProductsQueryResult = Apollo.QueryResult<LoanProductsQuery, LoanProductsQueryVariables>;
export const LoanProductDocument = gql`
    query LoanProduct($id: ID!) {
  detail: getLoanProduct(id: $id) {
    id
    ...LoanProduct
  }
}
    ${LoanProductFragmentDoc}`;

/**
 * __useLoanProductQuery__
 *
 * To run a query within a React component, call `useLoanProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoanProductQuery(baseOptions: Apollo.QueryHookOptions<LoanProductQuery, LoanProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanProductQuery, LoanProductQueryVariables>(LoanProductDocument, options);
      }
export function useLoanProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanProductQuery, LoanProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanProductQuery, LoanProductQueryVariables>(LoanProductDocument, options);
        }
export type LoanProductQueryHookResult = ReturnType<typeof useLoanProductQuery>;
export type LoanProductLazyQueryHookResult = ReturnType<typeof useLoanProductLazyQuery>;
export type LoanProductQueryResult = Apollo.QueryResult<LoanProductQuery, LoanProductQueryVariables>;
export const UpdateLoanProductDocument = gql`
    mutation UpdateLoanProduct($id: ID!, $updatedProduct: LoanProductInput!) {
  updateProduct: updateLoanProduct(id: $id, updatedProduct: $updatedProduct) {
    id
    ...LoanProduct
  }
}
    ${LoanProductFragmentDoc}`;
export type UpdateLoanProductMutationFn = Apollo.MutationFunction<UpdateLoanProductMutation, UpdateLoanProductMutationVariables>;

/**
 * __useUpdateLoanProductMutation__
 *
 * To run a mutation, you first call `useUpdateLoanProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanProductMutation, { data, loading, error }] = useUpdateLoanProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateLoanProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanProductMutation, UpdateLoanProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanProductMutation, UpdateLoanProductMutationVariables>(UpdateLoanProductDocument, options);
      }
export type UpdateLoanProductMutationHookResult = ReturnType<typeof useUpdateLoanProductMutation>;
export type UpdateLoanProductMutationResult = Apollo.MutationResult<UpdateLoanProductMutation>;
export type UpdateLoanProductMutationOptions = Apollo.BaseMutationOptions<UpdateLoanProductMutation, UpdateLoanProductMutationVariables>;
export const CreateLoanProductDocument = gql`
    mutation CreateLoanProduct {
  createProduct: createLoanProduct {
    id
  }
}
    `;
export type CreateLoanProductMutationFn = Apollo.MutationFunction<CreateLoanProductMutation, CreateLoanProductMutationVariables>;

/**
 * __useCreateLoanProductMutation__
 *
 * To run a mutation, you first call `useCreateLoanProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanProductMutation, { data, loading, error }] = useCreateLoanProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateLoanProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoanProductMutation, CreateLoanProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoanProductMutation, CreateLoanProductMutationVariables>(CreateLoanProductDocument, options);
      }
export type CreateLoanProductMutationHookResult = ReturnType<typeof useCreateLoanProductMutation>;
export type CreateLoanProductMutationResult = Apollo.MutationResult<CreateLoanProductMutation>;
export type CreateLoanProductMutationOptions = Apollo.BaseMutationOptions<CreateLoanProductMutation, CreateLoanProductMutationVariables>;
export const DeleteLoanProductDocument = gql`
    mutation DeleteLoanProduct($id: ID!) {
  deleteProduct: deleteLoanProduct(id: $id)
}
    `;
export type DeleteLoanProductMutationFn = Apollo.MutationFunction<DeleteLoanProductMutation, DeleteLoanProductMutationVariables>;

/**
 * __useDeleteLoanProductMutation__
 *
 * To run a mutation, you first call `useDeleteLoanProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoanProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoanProductMutation, { data, loading, error }] = useDeleteLoanProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLoanProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoanProductMutation, DeleteLoanProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoanProductMutation, DeleteLoanProductMutationVariables>(DeleteLoanProductDocument, options);
      }
export type DeleteLoanProductMutationHookResult = ReturnType<typeof useDeleteLoanProductMutation>;
export type DeleteLoanProductMutationResult = Apollo.MutationResult<DeleteLoanProductMutation>;
export type DeleteLoanProductMutationOptions = Apollo.BaseMutationOptions<DeleteLoanProductMutation, DeleteLoanProductMutationVariables>;
export const CreateLoanProductDocumentDocument = gql`
    mutation CreateLoanProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createLoanProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateLoanProductDocumentMutationFn = Apollo.MutationFunction<CreateLoanProductDocumentMutation, CreateLoanProductDocumentMutationVariables>;

/**
 * __useCreateLoanProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateLoanProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanProductDocumentMutation, { data, loading, error }] = useCreateLoanProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateLoanProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoanProductDocumentMutation, CreateLoanProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoanProductDocumentMutation, CreateLoanProductDocumentMutationVariables>(CreateLoanProductDocumentDocument, options);
      }
export type CreateLoanProductDocumentMutationHookResult = ReturnType<typeof useCreateLoanProductDocumentMutation>;
export type CreateLoanProductDocumentMutationResult = Apollo.MutationResult<CreateLoanProductDocumentMutation>;
export type CreateLoanProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateLoanProductDocumentMutation, CreateLoanProductDocumentMutationVariables>;
export const MortgageProductsDocument = gql`
    query MortgageProducts {
  products: getMortgageProductsPage {
    items {
      id
      ...MortgageProductListItem
    }
  }
}
    ${MortgageProductListItemFragmentDoc}`;

/**
 * __useMortgageProductsQuery__
 *
 * To run a query within a React component, call `useMortgageProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMortgageProductsQuery(baseOptions?: Apollo.QueryHookOptions<MortgageProductsQuery, MortgageProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageProductsQuery, MortgageProductsQueryVariables>(MortgageProductsDocument, options);
      }
export function useMortgageProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageProductsQuery, MortgageProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageProductsQuery, MortgageProductsQueryVariables>(MortgageProductsDocument, options);
        }
export type MortgageProductsQueryHookResult = ReturnType<typeof useMortgageProductsQuery>;
export type MortgageProductsLazyQueryHookResult = ReturnType<typeof useMortgageProductsLazyQuery>;
export type MortgageProductsQueryResult = Apollo.QueryResult<MortgageProductsQuery, MortgageProductsQueryVariables>;
export const MortgageProductDocument = gql`
    query MortgageProduct($id: ID!) {
  detail: getMortgageProduct(id: $id) {
    id
    ...MortgageProduct
  }
}
    ${MortgageProductFragmentDoc}`;

/**
 * __useMortgageProductQuery__
 *
 * To run a query within a React component, call `useMortgageProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMortgageProductQuery(baseOptions: Apollo.QueryHookOptions<MortgageProductQuery, MortgageProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageProductQuery, MortgageProductQueryVariables>(MortgageProductDocument, options);
      }
export function useMortgageProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageProductQuery, MortgageProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageProductQuery, MortgageProductQueryVariables>(MortgageProductDocument, options);
        }
export type MortgageProductQueryHookResult = ReturnType<typeof useMortgageProductQuery>;
export type MortgageProductLazyQueryHookResult = ReturnType<typeof useMortgageProductLazyQuery>;
export type MortgageProductQueryResult = Apollo.QueryResult<MortgageProductQuery, MortgageProductQueryVariables>;
export const UpdateMortgageProductDocument = gql`
    mutation UpdateMortgageProduct($id: ID!, $updatedProduct: MortgageProductInput!) {
  updateProduct: updateMortgageProduct(id: $id, updatedProduct: $updatedProduct) {
    id
    ...MortgageProduct
  }
}
    ${MortgageProductFragmentDoc}`;
export type UpdateMortgageProductMutationFn = Apollo.MutationFunction<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>;

/**
 * __useUpdateMortgageProductMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageProductMutation, { data, loading, error }] = useUpdateMortgageProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateMortgageProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>(UpdateMortgageProductDocument, options);
      }
export type UpdateMortgageProductMutationHookResult = ReturnType<typeof useUpdateMortgageProductMutation>;
export type UpdateMortgageProductMutationResult = Apollo.MutationResult<UpdateMortgageProductMutation>;
export type UpdateMortgageProductMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>;
export const CreateMortgageProductDocument = gql`
    mutation CreateMortgageProduct {
  createProduct: createMortgageProduct {
    id
  }
}
    `;
export type CreateMortgageProductMutationFn = Apollo.MutationFunction<CreateMortgageProductMutation, CreateMortgageProductMutationVariables>;

/**
 * __useCreateMortgageProductMutation__
 *
 * To run a mutation, you first call `useCreateMortgageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgageProductMutation, { data, loading, error }] = useCreateMortgageProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateMortgageProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgageProductMutation, CreateMortgageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgageProductMutation, CreateMortgageProductMutationVariables>(CreateMortgageProductDocument, options);
      }
export type CreateMortgageProductMutationHookResult = ReturnType<typeof useCreateMortgageProductMutation>;
export type CreateMortgageProductMutationResult = Apollo.MutationResult<CreateMortgageProductMutation>;
export type CreateMortgageProductMutationOptions = Apollo.BaseMutationOptions<CreateMortgageProductMutation, CreateMortgageProductMutationVariables>;
export const DeleteMortgageProductDocument = gql`
    mutation DeleteMortgageProduct($id: ID!) {
  deleteProduct: deleteMortgageProduct(id: $id)
}
    `;
export type DeleteMortgageProductMutationFn = Apollo.MutationFunction<DeleteMortgageProductMutation, DeleteMortgageProductMutationVariables>;

/**
 * __useDeleteMortgageProductMutation__
 *
 * To run a mutation, you first call `useDeleteMortgageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgageProductMutation, { data, loading, error }] = useDeleteMortgageProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMortgageProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgageProductMutation, DeleteMortgageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgageProductMutation, DeleteMortgageProductMutationVariables>(DeleteMortgageProductDocument, options);
      }
export type DeleteMortgageProductMutationHookResult = ReturnType<typeof useDeleteMortgageProductMutation>;
export type DeleteMortgageProductMutationResult = Apollo.MutationResult<DeleteMortgageProductMutation>;
export type DeleteMortgageProductMutationOptions = Apollo.BaseMutationOptions<DeleteMortgageProductMutation, DeleteMortgageProductMutationVariables>;
export const CreateMortgageProductDocumentDocument = gql`
    mutation CreateMortgageProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createMortgageProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateMortgageProductDocumentMutationFn = Apollo.MutationFunction<CreateMortgageProductDocumentMutation, CreateMortgageProductDocumentMutationVariables>;

/**
 * __useCreateMortgageProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateMortgageProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgageProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgageProductDocumentMutation, { data, loading, error }] = useCreateMortgageProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateMortgageProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgageProductDocumentMutation, CreateMortgageProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgageProductDocumentMutation, CreateMortgageProductDocumentMutationVariables>(CreateMortgageProductDocumentDocument, options);
      }
export type CreateMortgageProductDocumentMutationHookResult = ReturnType<typeof useCreateMortgageProductDocumentMutation>;
export type CreateMortgageProductDocumentMutationResult = Apollo.MutationResult<CreateMortgageProductDocumentMutation>;
export type CreateMortgageProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateMortgageProductDocumentMutation, CreateMortgageProductDocumentMutationVariables>;
export const MotorLiabilityInsuranceProductsDocument = gql`
    query MotorLiabilityInsuranceProducts {
  products: getMotorLiabilityInsuranceProductsPage {
    items {
      id
      ...MotorLiabilityInsuranceProductListItem
    }
  }
}
    ${MotorLiabilityInsuranceProductListItemFragmentDoc}`;

/**
 * __useMotorLiabilityInsuranceProductsQuery__
 *
 * To run a query within a React component, call `useMotorLiabilityInsuranceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMotorLiabilityInsuranceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMotorLiabilityInsuranceProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMotorLiabilityInsuranceProductsQuery(baseOptions?: Apollo.QueryHookOptions<MotorLiabilityInsuranceProductsQuery, MotorLiabilityInsuranceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MotorLiabilityInsuranceProductsQuery, MotorLiabilityInsuranceProductsQueryVariables>(MotorLiabilityInsuranceProductsDocument, options);
      }
export function useMotorLiabilityInsuranceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MotorLiabilityInsuranceProductsQuery, MotorLiabilityInsuranceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MotorLiabilityInsuranceProductsQuery, MotorLiabilityInsuranceProductsQueryVariables>(MotorLiabilityInsuranceProductsDocument, options);
        }
export type MotorLiabilityInsuranceProductsQueryHookResult = ReturnType<typeof useMotorLiabilityInsuranceProductsQuery>;
export type MotorLiabilityInsuranceProductsLazyQueryHookResult = ReturnType<typeof useMotorLiabilityInsuranceProductsLazyQuery>;
export type MotorLiabilityInsuranceProductsQueryResult = Apollo.QueryResult<MotorLiabilityInsuranceProductsQuery, MotorLiabilityInsuranceProductsQueryVariables>;
export const MotorLiabilityInsuranceProductDocument = gql`
    query MotorLiabilityInsuranceProduct($id: ID!) {
  detail: getMotorLiabilityInsuranceProduct(id: $id) {
    id
    ...MotorLiabilityInsuranceProduct
  }
}
    ${MotorLiabilityInsuranceProductFragmentDoc}`;

/**
 * __useMotorLiabilityInsuranceProductQuery__
 *
 * To run a query within a React component, call `useMotorLiabilityInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useMotorLiabilityInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMotorLiabilityInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMotorLiabilityInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<MotorLiabilityInsuranceProductQuery, MotorLiabilityInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MotorLiabilityInsuranceProductQuery, MotorLiabilityInsuranceProductQueryVariables>(MotorLiabilityInsuranceProductDocument, options);
      }
export function useMotorLiabilityInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MotorLiabilityInsuranceProductQuery, MotorLiabilityInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MotorLiabilityInsuranceProductQuery, MotorLiabilityInsuranceProductQueryVariables>(MotorLiabilityInsuranceProductDocument, options);
        }
export type MotorLiabilityInsuranceProductQueryHookResult = ReturnType<typeof useMotorLiabilityInsuranceProductQuery>;
export type MotorLiabilityInsuranceProductLazyQueryHookResult = ReturnType<typeof useMotorLiabilityInsuranceProductLazyQuery>;
export type MotorLiabilityInsuranceProductQueryResult = Apollo.QueryResult<MotorLiabilityInsuranceProductQuery, MotorLiabilityInsuranceProductQueryVariables>;
export const UpdateMotorLiabilityInsuranceProductDocument = gql`
    mutation UpdateMotorLiabilityInsuranceProduct($id: ID!, $updatedProduct: MotorLiabilityInsuranceProductInput!) {
  updateProduct: updateMotorLiabilityInsuranceProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...MotorLiabilityInsuranceProduct
  }
}
    ${MotorLiabilityInsuranceProductFragmentDoc}`;
export type UpdateMotorLiabilityInsuranceProductMutationFn = Apollo.MutationFunction<UpdateMotorLiabilityInsuranceProductMutation, UpdateMotorLiabilityInsuranceProductMutationVariables>;

/**
 * __useUpdateMotorLiabilityInsuranceProductMutation__
 *
 * To run a mutation, you first call `useUpdateMotorLiabilityInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMotorLiabilityInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMotorLiabilityInsuranceProductMutation, { data, loading, error }] = useUpdateMotorLiabilityInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateMotorLiabilityInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMotorLiabilityInsuranceProductMutation, UpdateMotorLiabilityInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMotorLiabilityInsuranceProductMutation, UpdateMotorLiabilityInsuranceProductMutationVariables>(UpdateMotorLiabilityInsuranceProductDocument, options);
      }
export type UpdateMotorLiabilityInsuranceProductMutationHookResult = ReturnType<typeof useUpdateMotorLiabilityInsuranceProductMutation>;
export type UpdateMotorLiabilityInsuranceProductMutationResult = Apollo.MutationResult<UpdateMotorLiabilityInsuranceProductMutation>;
export type UpdateMotorLiabilityInsuranceProductMutationOptions = Apollo.BaseMutationOptions<UpdateMotorLiabilityInsuranceProductMutation, UpdateMotorLiabilityInsuranceProductMutationVariables>;
export const CreateMotorLiabilityInsuranceProductDocument = gql`
    mutation CreateMotorLiabilityInsuranceProduct {
  createProduct: createMotorLiabilityInsuranceProduct {
    id
  }
}
    `;
export type CreateMotorLiabilityInsuranceProductMutationFn = Apollo.MutationFunction<CreateMotorLiabilityInsuranceProductMutation, CreateMotorLiabilityInsuranceProductMutationVariables>;

/**
 * __useCreateMotorLiabilityInsuranceProductMutation__
 *
 * To run a mutation, you first call `useCreateMotorLiabilityInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMotorLiabilityInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMotorLiabilityInsuranceProductMutation, { data, loading, error }] = useCreateMotorLiabilityInsuranceProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateMotorLiabilityInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateMotorLiabilityInsuranceProductMutation, CreateMotorLiabilityInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMotorLiabilityInsuranceProductMutation, CreateMotorLiabilityInsuranceProductMutationVariables>(CreateMotorLiabilityInsuranceProductDocument, options);
      }
export type CreateMotorLiabilityInsuranceProductMutationHookResult = ReturnType<typeof useCreateMotorLiabilityInsuranceProductMutation>;
export type CreateMotorLiabilityInsuranceProductMutationResult = Apollo.MutationResult<CreateMotorLiabilityInsuranceProductMutation>;
export type CreateMotorLiabilityInsuranceProductMutationOptions = Apollo.BaseMutationOptions<CreateMotorLiabilityInsuranceProductMutation, CreateMotorLiabilityInsuranceProductMutationVariables>;
export const DeleteMotorLiabilityInsuranceProductDocument = gql`
    mutation DeleteMotorLiabilityInsuranceProduct($id: ID!) {
  deleteProduct: deleteMotorLiabilityInsuranceProduct(id: $id)
}
    `;
export type DeleteMotorLiabilityInsuranceProductMutationFn = Apollo.MutationFunction<DeleteMotorLiabilityInsuranceProductMutation, DeleteMotorLiabilityInsuranceProductMutationVariables>;

/**
 * __useDeleteMotorLiabilityInsuranceProductMutation__
 *
 * To run a mutation, you first call `useDeleteMotorLiabilityInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMotorLiabilityInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMotorLiabilityInsuranceProductMutation, { data, loading, error }] = useDeleteMotorLiabilityInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMotorLiabilityInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMotorLiabilityInsuranceProductMutation, DeleteMotorLiabilityInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMotorLiabilityInsuranceProductMutation, DeleteMotorLiabilityInsuranceProductMutationVariables>(DeleteMotorLiabilityInsuranceProductDocument, options);
      }
export type DeleteMotorLiabilityInsuranceProductMutationHookResult = ReturnType<typeof useDeleteMotorLiabilityInsuranceProductMutation>;
export type DeleteMotorLiabilityInsuranceProductMutationResult = Apollo.MutationResult<DeleteMotorLiabilityInsuranceProductMutation>;
export type DeleteMotorLiabilityInsuranceProductMutationOptions = Apollo.BaseMutationOptions<DeleteMotorLiabilityInsuranceProductMutation, DeleteMotorLiabilityInsuranceProductMutationVariables>;
export const CreateMotorLiabilityInsuranceProductDocumentDocument = gql`
    mutation CreateMotorLiabilityInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createMotorLiabilityInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateMotorLiabilityInsuranceProductDocumentMutationFn = Apollo.MutationFunction<CreateMotorLiabilityInsuranceProductDocumentMutation, CreateMotorLiabilityInsuranceProductDocumentMutationVariables>;

/**
 * __useCreateMotorLiabilityInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateMotorLiabilityInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMotorLiabilityInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMotorLiabilityInsuranceProductDocumentMutation, { data, loading, error }] = useCreateMotorLiabilityInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateMotorLiabilityInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMotorLiabilityInsuranceProductDocumentMutation, CreateMotorLiabilityInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMotorLiabilityInsuranceProductDocumentMutation, CreateMotorLiabilityInsuranceProductDocumentMutationVariables>(CreateMotorLiabilityInsuranceProductDocumentDocument, options);
      }
export type CreateMotorLiabilityInsuranceProductDocumentMutationHookResult = ReturnType<typeof useCreateMotorLiabilityInsuranceProductDocumentMutation>;
export type CreateMotorLiabilityInsuranceProductDocumentMutationResult = Apollo.MutationResult<CreateMotorLiabilityInsuranceProductDocumentMutation>;
export type CreateMotorLiabilityInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateMotorLiabilityInsuranceProductDocumentMutation, CreateMotorLiabilityInsuranceProductDocumentMutationVariables>;
export const UpdateProductTypeDocument = gql`
    mutation UpdateProductType($id: ID!, $productType: FinancialProductType!, $newProductType: FinancialProductType!) {
  updateProductType(
    id: $id
    productType: $productType
    newProductType: $newProductType
  )
}
    `;
export type UpdateProductTypeMutationFn = Apollo.MutationFunction<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>;

/**
 * __useUpdateProductTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductTypeMutation, { data, loading, error }] = useUpdateProductTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productType: // value for 'productType'
 *      newProductType: // value for 'newProductType'
 *   },
 * });
 */
export function useUpdateProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>(UpdateProductTypeDocument, options);
      }
export type UpdateProductTypeMutationHookResult = ReturnType<typeof useUpdateProductTypeMutation>;
export type UpdateProductTypeMutationResult = Apollo.MutationResult<UpdateProductTypeMutation>;
export type UpdateProductTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProductTypeMutation, UpdateProductTypeMutationVariables>;
export const PropertyInsuranceProductsDocument = gql`
    query PropertyInsuranceProducts {
  products: getPropertyInsuranceProductsPage {
    items {
      id
      ...PropertyInsuranceProductListItem
    }
  }
}
    ${PropertyInsuranceProductListItemFragmentDoc}`;

/**
 * __usePropertyInsuranceProductsQuery__
 *
 * To run a query within a React component, call `usePropertyInsuranceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyInsuranceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyInsuranceProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyInsuranceProductsQuery(baseOptions?: Apollo.QueryHookOptions<PropertyInsuranceProductsQuery, PropertyInsuranceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyInsuranceProductsQuery, PropertyInsuranceProductsQueryVariables>(PropertyInsuranceProductsDocument, options);
      }
export function usePropertyInsuranceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyInsuranceProductsQuery, PropertyInsuranceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyInsuranceProductsQuery, PropertyInsuranceProductsQueryVariables>(PropertyInsuranceProductsDocument, options);
        }
export type PropertyInsuranceProductsQueryHookResult = ReturnType<typeof usePropertyInsuranceProductsQuery>;
export type PropertyInsuranceProductsLazyQueryHookResult = ReturnType<typeof usePropertyInsuranceProductsLazyQuery>;
export type PropertyInsuranceProductsQueryResult = Apollo.QueryResult<PropertyInsuranceProductsQuery, PropertyInsuranceProductsQueryVariables>;
export const PropertyInsuranceProductDocument = gql`
    query PropertyInsuranceProduct($id: ID!) {
  detail: getPropertyInsuranceProduct(id: $id) {
    id
    ...PropertyInsuranceProduct
  }
}
    ${PropertyInsuranceProductFragmentDoc}`;

/**
 * __usePropertyInsuranceProductQuery__
 *
 * To run a query within a React component, call `usePropertyInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyInsuranceProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<PropertyInsuranceProductQuery, PropertyInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyInsuranceProductQuery, PropertyInsuranceProductQueryVariables>(PropertyInsuranceProductDocument, options);
      }
export function usePropertyInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyInsuranceProductQuery, PropertyInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyInsuranceProductQuery, PropertyInsuranceProductQueryVariables>(PropertyInsuranceProductDocument, options);
        }
export type PropertyInsuranceProductQueryHookResult = ReturnType<typeof usePropertyInsuranceProductQuery>;
export type PropertyInsuranceProductLazyQueryHookResult = ReturnType<typeof usePropertyInsuranceProductLazyQuery>;
export type PropertyInsuranceProductQueryResult = Apollo.QueryResult<PropertyInsuranceProductQuery, PropertyInsuranceProductQueryVariables>;
export const UpdatePropertyInsuranceProductDocument = gql`
    mutation UpdatePropertyInsuranceProduct($id: ID!, $updatedProduct: PropertyInsuranceProductInput!) {
  updateProduct: updatePropertyInsuranceProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...PropertyInsuranceProduct
  }
}
    ${PropertyInsuranceProductFragmentDoc}`;
export type UpdatePropertyInsuranceProductMutationFn = Apollo.MutationFunction<UpdatePropertyInsuranceProductMutation, UpdatePropertyInsuranceProductMutationVariables>;

/**
 * __useUpdatePropertyInsuranceProductMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyInsuranceProductMutation, { data, loading, error }] = useUpdatePropertyInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdatePropertyInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyInsuranceProductMutation, UpdatePropertyInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyInsuranceProductMutation, UpdatePropertyInsuranceProductMutationVariables>(UpdatePropertyInsuranceProductDocument, options);
      }
export type UpdatePropertyInsuranceProductMutationHookResult = ReturnType<typeof useUpdatePropertyInsuranceProductMutation>;
export type UpdatePropertyInsuranceProductMutationResult = Apollo.MutationResult<UpdatePropertyInsuranceProductMutation>;
export type UpdatePropertyInsuranceProductMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyInsuranceProductMutation, UpdatePropertyInsuranceProductMutationVariables>;
export const CreatePropertyInsuranceProductDocument = gql`
    mutation CreatePropertyInsuranceProduct {
  createProduct: createPropertyInsuranceProduct {
    id
  }
}
    `;
export type CreatePropertyInsuranceProductMutationFn = Apollo.MutationFunction<CreatePropertyInsuranceProductMutation, CreatePropertyInsuranceProductMutationVariables>;

/**
 * __useCreatePropertyInsuranceProductMutation__
 *
 * To run a mutation, you first call `useCreatePropertyInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyInsuranceProductMutation, { data, loading, error }] = useCreatePropertyInsuranceProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePropertyInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyInsuranceProductMutation, CreatePropertyInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyInsuranceProductMutation, CreatePropertyInsuranceProductMutationVariables>(CreatePropertyInsuranceProductDocument, options);
      }
export type CreatePropertyInsuranceProductMutationHookResult = ReturnType<typeof useCreatePropertyInsuranceProductMutation>;
export type CreatePropertyInsuranceProductMutationResult = Apollo.MutationResult<CreatePropertyInsuranceProductMutation>;
export type CreatePropertyInsuranceProductMutationOptions = Apollo.BaseMutationOptions<CreatePropertyInsuranceProductMutation, CreatePropertyInsuranceProductMutationVariables>;
export const DeletePropertyInsuranceProductDocument = gql`
    mutation DeletePropertyInsuranceProduct($id: ID!) {
  deleteProduct: deletePropertyInsuranceProduct(id: $id)
}
    `;
export type DeletePropertyInsuranceProductMutationFn = Apollo.MutationFunction<DeletePropertyInsuranceProductMutation, DeletePropertyInsuranceProductMutationVariables>;

/**
 * __useDeletePropertyInsuranceProductMutation__
 *
 * To run a mutation, you first call `useDeletePropertyInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyInsuranceProductMutation, { data, loading, error }] = useDeletePropertyInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePropertyInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertyInsuranceProductMutation, DeletePropertyInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertyInsuranceProductMutation, DeletePropertyInsuranceProductMutationVariables>(DeletePropertyInsuranceProductDocument, options);
      }
export type DeletePropertyInsuranceProductMutationHookResult = ReturnType<typeof useDeletePropertyInsuranceProductMutation>;
export type DeletePropertyInsuranceProductMutationResult = Apollo.MutationResult<DeletePropertyInsuranceProductMutation>;
export type DeletePropertyInsuranceProductMutationOptions = Apollo.BaseMutationOptions<DeletePropertyInsuranceProductMutation, DeletePropertyInsuranceProductMutationVariables>;
export const CreatePropertyInsuranceProductDocumentDocument = gql`
    mutation CreatePropertyInsuranceProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createPropertyInsuranceProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreatePropertyInsuranceProductDocumentMutationFn = Apollo.MutationFunction<CreatePropertyInsuranceProductDocumentMutation, CreatePropertyInsuranceProductDocumentMutationVariables>;

/**
 * __useCreatePropertyInsuranceProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreatePropertyInsuranceProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyInsuranceProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyInsuranceProductDocumentMutation, { data, loading, error }] = useCreatePropertyInsuranceProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreatePropertyInsuranceProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyInsuranceProductDocumentMutation, CreatePropertyInsuranceProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyInsuranceProductDocumentMutation, CreatePropertyInsuranceProductDocumentMutationVariables>(CreatePropertyInsuranceProductDocumentDocument, options);
      }
export type CreatePropertyInsuranceProductDocumentMutationHookResult = ReturnType<typeof useCreatePropertyInsuranceProductDocumentMutation>;
export type CreatePropertyInsuranceProductDocumentMutationResult = Apollo.MutationResult<CreatePropertyInsuranceProductDocumentMutation>;
export type CreatePropertyInsuranceProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreatePropertyInsuranceProductDocumentMutation, CreatePropertyInsuranceProductDocumentMutationVariables>;
export const RetirementPensionSavingsProductsDocument = gql`
    query RetirementPensionSavingsProducts {
  products: getRetirementPensionSavingsProductsPage {
    items {
      id
      ...RetirementPensionSavingsProductListItem
    }
  }
}
    ${RetirementPensionSavingsProductListItemFragmentDoc}`;

/**
 * __useRetirementPensionSavingsProductsQuery__
 *
 * To run a query within a React component, call `useRetirementPensionSavingsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetirementPensionSavingsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetirementPensionSavingsProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetirementPensionSavingsProductsQuery(baseOptions?: Apollo.QueryHookOptions<RetirementPensionSavingsProductsQuery, RetirementPensionSavingsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetirementPensionSavingsProductsQuery, RetirementPensionSavingsProductsQueryVariables>(RetirementPensionSavingsProductsDocument, options);
      }
export function useRetirementPensionSavingsProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetirementPensionSavingsProductsQuery, RetirementPensionSavingsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetirementPensionSavingsProductsQuery, RetirementPensionSavingsProductsQueryVariables>(RetirementPensionSavingsProductsDocument, options);
        }
export type RetirementPensionSavingsProductsQueryHookResult = ReturnType<typeof useRetirementPensionSavingsProductsQuery>;
export type RetirementPensionSavingsProductsLazyQueryHookResult = ReturnType<typeof useRetirementPensionSavingsProductsLazyQuery>;
export type RetirementPensionSavingsProductsQueryResult = Apollo.QueryResult<RetirementPensionSavingsProductsQuery, RetirementPensionSavingsProductsQueryVariables>;
export const RetirementPensionSavingsProductDocument = gql`
    query RetirementPensionSavingsProduct($id: ID!) {
  detail: getRetirementPensionSavingsProduct(id: $id) {
    id
    ...RetirementPensionSavingsProduct
  }
}
    ${RetirementPensionSavingsProductFragmentDoc}`;

/**
 * __useRetirementPensionSavingsProductQuery__
 *
 * To run a query within a React component, call `useRetirementPensionSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetirementPensionSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetirementPensionSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetirementPensionSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<RetirementPensionSavingsProductQuery, RetirementPensionSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetirementPensionSavingsProductQuery, RetirementPensionSavingsProductQueryVariables>(RetirementPensionSavingsProductDocument, options);
      }
export function useRetirementPensionSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetirementPensionSavingsProductQuery, RetirementPensionSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetirementPensionSavingsProductQuery, RetirementPensionSavingsProductQueryVariables>(RetirementPensionSavingsProductDocument, options);
        }
export type RetirementPensionSavingsProductQueryHookResult = ReturnType<typeof useRetirementPensionSavingsProductQuery>;
export type RetirementPensionSavingsProductLazyQueryHookResult = ReturnType<typeof useRetirementPensionSavingsProductLazyQuery>;
export type RetirementPensionSavingsProductQueryResult = Apollo.QueryResult<RetirementPensionSavingsProductQuery, RetirementPensionSavingsProductQueryVariables>;
export const UpdateRetirementPensionSavingsProductDocument = gql`
    mutation UpdateRetirementPensionSavingsProduct($id: ID!, $updatedProduct: RetirementPensionSavingsProductInput!) {
  updateProduct: updateRetirementPensionSavingsProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...RetirementPensionSavingsProduct
  }
}
    ${RetirementPensionSavingsProductFragmentDoc}`;
export type UpdateRetirementPensionSavingsProductMutationFn = Apollo.MutationFunction<UpdateRetirementPensionSavingsProductMutation, UpdateRetirementPensionSavingsProductMutationVariables>;

/**
 * __useUpdateRetirementPensionSavingsProductMutation__
 *
 * To run a mutation, you first call `useUpdateRetirementPensionSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRetirementPensionSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRetirementPensionSavingsProductMutation, { data, loading, error }] = useUpdateRetirementPensionSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateRetirementPensionSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRetirementPensionSavingsProductMutation, UpdateRetirementPensionSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRetirementPensionSavingsProductMutation, UpdateRetirementPensionSavingsProductMutationVariables>(UpdateRetirementPensionSavingsProductDocument, options);
      }
export type UpdateRetirementPensionSavingsProductMutationHookResult = ReturnType<typeof useUpdateRetirementPensionSavingsProductMutation>;
export type UpdateRetirementPensionSavingsProductMutationResult = Apollo.MutationResult<UpdateRetirementPensionSavingsProductMutation>;
export type UpdateRetirementPensionSavingsProductMutationOptions = Apollo.BaseMutationOptions<UpdateRetirementPensionSavingsProductMutation, UpdateRetirementPensionSavingsProductMutationVariables>;
export const CreateRetirementPensionSavingsProductDocument = gql`
    mutation CreateRetirementPensionSavingsProduct {
  createProduct: createRetirementPensionSavingsProduct {
    id
  }
}
    `;
export type CreateRetirementPensionSavingsProductMutationFn = Apollo.MutationFunction<CreateRetirementPensionSavingsProductMutation, CreateRetirementPensionSavingsProductMutationVariables>;

/**
 * __useCreateRetirementPensionSavingsProductMutation__
 *
 * To run a mutation, you first call `useCreateRetirementPensionSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRetirementPensionSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRetirementPensionSavingsProductMutation, { data, loading, error }] = useCreateRetirementPensionSavingsProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateRetirementPensionSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateRetirementPensionSavingsProductMutation, CreateRetirementPensionSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRetirementPensionSavingsProductMutation, CreateRetirementPensionSavingsProductMutationVariables>(CreateRetirementPensionSavingsProductDocument, options);
      }
export type CreateRetirementPensionSavingsProductMutationHookResult = ReturnType<typeof useCreateRetirementPensionSavingsProductMutation>;
export type CreateRetirementPensionSavingsProductMutationResult = Apollo.MutationResult<CreateRetirementPensionSavingsProductMutation>;
export type CreateRetirementPensionSavingsProductMutationOptions = Apollo.BaseMutationOptions<CreateRetirementPensionSavingsProductMutation, CreateRetirementPensionSavingsProductMutationVariables>;
export const DeleteRetirementPensionSavingsProductDocument = gql`
    mutation DeleteRetirementPensionSavingsProduct($id: ID!) {
  deleteProduct: deleteRetirementPensionSavingsProduct(id: $id)
}
    `;
export type DeleteRetirementPensionSavingsProductMutationFn = Apollo.MutationFunction<DeleteRetirementPensionSavingsProductMutation, DeleteRetirementPensionSavingsProductMutationVariables>;

/**
 * __useDeleteRetirementPensionSavingsProductMutation__
 *
 * To run a mutation, you first call `useDeleteRetirementPensionSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRetirementPensionSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRetirementPensionSavingsProductMutation, { data, loading, error }] = useDeleteRetirementPensionSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRetirementPensionSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRetirementPensionSavingsProductMutation, DeleteRetirementPensionSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRetirementPensionSavingsProductMutation, DeleteRetirementPensionSavingsProductMutationVariables>(DeleteRetirementPensionSavingsProductDocument, options);
      }
export type DeleteRetirementPensionSavingsProductMutationHookResult = ReturnType<typeof useDeleteRetirementPensionSavingsProductMutation>;
export type DeleteRetirementPensionSavingsProductMutationResult = Apollo.MutationResult<DeleteRetirementPensionSavingsProductMutation>;
export type DeleteRetirementPensionSavingsProductMutationOptions = Apollo.BaseMutationOptions<DeleteRetirementPensionSavingsProductMutation, DeleteRetirementPensionSavingsProductMutationVariables>;
export const CreateRetirementPensionSavingsProductDocumentDocument = gql`
    mutation CreateRetirementPensionSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createRetirementPensionSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateRetirementPensionSavingsProductDocumentMutationFn = Apollo.MutationFunction<CreateRetirementPensionSavingsProductDocumentMutation, CreateRetirementPensionSavingsProductDocumentMutationVariables>;

/**
 * __useCreateRetirementPensionSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateRetirementPensionSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRetirementPensionSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRetirementPensionSavingsProductDocumentMutation, { data, loading, error }] = useCreateRetirementPensionSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateRetirementPensionSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRetirementPensionSavingsProductDocumentMutation, CreateRetirementPensionSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRetirementPensionSavingsProductDocumentMutation, CreateRetirementPensionSavingsProductDocumentMutationVariables>(CreateRetirementPensionSavingsProductDocumentDocument, options);
      }
export type CreateRetirementPensionSavingsProductDocumentMutationHookResult = ReturnType<typeof useCreateRetirementPensionSavingsProductDocumentMutation>;
export type CreateRetirementPensionSavingsProductDocumentMutationResult = Apollo.MutationResult<CreateRetirementPensionSavingsProductDocumentMutation>;
export type CreateRetirementPensionSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateRetirementPensionSavingsProductDocumentMutation, CreateRetirementPensionSavingsProductDocumentMutationVariables>;
export const SavingsProductsDocument = gql`
    query SavingsProducts {
  products: getSavingsProductsPage {
    items {
      id
      ...SavingsProductListItem
    }
  }
}
    ${SavingsProductListItemFragmentDoc}`;

/**
 * __useSavingsProductsQuery__
 *
 * To run a query within a React component, call `useSavingsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavingsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavingsProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavingsProductsQuery(baseOptions?: Apollo.QueryHookOptions<SavingsProductsQuery, SavingsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavingsProductsQuery, SavingsProductsQueryVariables>(SavingsProductsDocument, options);
      }
export function useSavingsProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavingsProductsQuery, SavingsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavingsProductsQuery, SavingsProductsQueryVariables>(SavingsProductsDocument, options);
        }
export type SavingsProductsQueryHookResult = ReturnType<typeof useSavingsProductsQuery>;
export type SavingsProductsLazyQueryHookResult = ReturnType<typeof useSavingsProductsLazyQuery>;
export type SavingsProductsQueryResult = Apollo.QueryResult<SavingsProductsQuery, SavingsProductsQueryVariables>;
export const SavingsProductDocument = gql`
    query SavingsProduct($id: ID!) {
  detail: getSavingsProduct(id: $id) {
    id
    ...SavingsProduct
  }
}
    ${SavingsProductFragmentDoc}`;

/**
 * __useSavingsProductQuery__
 *
 * To run a query within a React component, call `useSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<SavingsProductQuery, SavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavingsProductQuery, SavingsProductQueryVariables>(SavingsProductDocument, options);
      }
export function useSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavingsProductQuery, SavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavingsProductQuery, SavingsProductQueryVariables>(SavingsProductDocument, options);
        }
export type SavingsProductQueryHookResult = ReturnType<typeof useSavingsProductQuery>;
export type SavingsProductLazyQueryHookResult = ReturnType<typeof useSavingsProductLazyQuery>;
export type SavingsProductQueryResult = Apollo.QueryResult<SavingsProductQuery, SavingsProductQueryVariables>;
export const UpdateSavingsProductDocument = gql`
    mutation UpdateSavingsProduct($id: ID!, $updatedProduct: SavingsProductInput!) {
  updateProduct: updateSavingsProduct(id: $id, updatedProduct: $updatedProduct) {
    id
    ...SavingsProduct
  }
}
    ${SavingsProductFragmentDoc}`;
export type UpdateSavingsProductMutationFn = Apollo.MutationFunction<UpdateSavingsProductMutation, UpdateSavingsProductMutationVariables>;

/**
 * __useUpdateSavingsProductMutation__
 *
 * To run a mutation, you first call `useUpdateSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavingsProductMutation, { data, loading, error }] = useUpdateSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavingsProductMutation, UpdateSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavingsProductMutation, UpdateSavingsProductMutationVariables>(UpdateSavingsProductDocument, options);
      }
export type UpdateSavingsProductMutationHookResult = ReturnType<typeof useUpdateSavingsProductMutation>;
export type UpdateSavingsProductMutationResult = Apollo.MutationResult<UpdateSavingsProductMutation>;
export type UpdateSavingsProductMutationOptions = Apollo.BaseMutationOptions<UpdateSavingsProductMutation, UpdateSavingsProductMutationVariables>;
export const CreateSavingsProductDocument = gql`
    mutation CreateSavingsProduct {
  createProduct: createSavingsProduct {
    id
  }
}
    `;
export type CreateSavingsProductMutationFn = Apollo.MutationFunction<CreateSavingsProductMutation, CreateSavingsProductMutationVariables>;

/**
 * __useCreateSavingsProductMutation__
 *
 * To run a mutation, you first call `useCreateSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavingsProductMutation, { data, loading, error }] = useCreateSavingsProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavingsProductMutation, CreateSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavingsProductMutation, CreateSavingsProductMutationVariables>(CreateSavingsProductDocument, options);
      }
export type CreateSavingsProductMutationHookResult = ReturnType<typeof useCreateSavingsProductMutation>;
export type CreateSavingsProductMutationResult = Apollo.MutationResult<CreateSavingsProductMutation>;
export type CreateSavingsProductMutationOptions = Apollo.BaseMutationOptions<CreateSavingsProductMutation, CreateSavingsProductMutationVariables>;
export const DeleteSavingsProductDocument = gql`
    mutation DeleteSavingsProduct($id: ID!) {
  deleteProduct: deleteSavingsProduct(id: $id)
}
    `;
export type DeleteSavingsProductMutationFn = Apollo.MutationFunction<DeleteSavingsProductMutation, DeleteSavingsProductMutationVariables>;

/**
 * __useDeleteSavingsProductMutation__
 *
 * To run a mutation, you first call `useDeleteSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavingsProductMutation, { data, loading, error }] = useDeleteSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavingsProductMutation, DeleteSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavingsProductMutation, DeleteSavingsProductMutationVariables>(DeleteSavingsProductDocument, options);
      }
export type DeleteSavingsProductMutationHookResult = ReturnType<typeof useDeleteSavingsProductMutation>;
export type DeleteSavingsProductMutationResult = Apollo.MutationResult<DeleteSavingsProductMutation>;
export type DeleteSavingsProductMutationOptions = Apollo.BaseMutationOptions<DeleteSavingsProductMutation, DeleteSavingsProductMutationVariables>;
export const CreateSavingsProductDocumentDocument = gql`
    mutation CreateSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateSavingsProductDocumentMutationFn = Apollo.MutationFunction<CreateSavingsProductDocumentMutation, CreateSavingsProductDocumentMutationVariables>;

/**
 * __useCreateSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavingsProductDocumentMutation, { data, loading, error }] = useCreateSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavingsProductDocumentMutation, CreateSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavingsProductDocumentMutation, CreateSavingsProductDocumentMutationVariables>(CreateSavingsProductDocumentDocument, options);
      }
export type CreateSavingsProductDocumentMutationHookResult = ReturnType<typeof useCreateSavingsProductDocumentMutation>;
export type CreateSavingsProductDocumentMutationResult = Apollo.MutationResult<CreateSavingsProductDocumentMutation>;
export type CreateSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateSavingsProductDocumentMutation, CreateSavingsProductDocumentMutationVariables>;
export const SupplementaryPensionSavingsProductsDocument = gql`
    query SupplementaryPensionSavingsProducts {
  products: getSupplementaryPensionSavingsProductsPage {
    items {
      id
      ...SupplementaryPensionSavingsProductListItem
    }
  }
}
    ${SupplementaryPensionSavingsProductListItemFragmentDoc}`;

/**
 * __useSupplementaryPensionSavingsProductsQuery__
 *
 * To run a query within a React component, call `useSupplementaryPensionSavingsProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementaryPensionSavingsProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementaryPensionSavingsProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplementaryPensionSavingsProductsQuery(baseOptions?: Apollo.QueryHookOptions<SupplementaryPensionSavingsProductsQuery, SupplementaryPensionSavingsProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplementaryPensionSavingsProductsQuery, SupplementaryPensionSavingsProductsQueryVariables>(SupplementaryPensionSavingsProductsDocument, options);
      }
export function useSupplementaryPensionSavingsProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplementaryPensionSavingsProductsQuery, SupplementaryPensionSavingsProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplementaryPensionSavingsProductsQuery, SupplementaryPensionSavingsProductsQueryVariables>(SupplementaryPensionSavingsProductsDocument, options);
        }
export type SupplementaryPensionSavingsProductsQueryHookResult = ReturnType<typeof useSupplementaryPensionSavingsProductsQuery>;
export type SupplementaryPensionSavingsProductsLazyQueryHookResult = ReturnType<typeof useSupplementaryPensionSavingsProductsLazyQuery>;
export type SupplementaryPensionSavingsProductsQueryResult = Apollo.QueryResult<SupplementaryPensionSavingsProductsQuery, SupplementaryPensionSavingsProductsQueryVariables>;
export const SupplementaryPensionSavingsProductDocument = gql`
    query SupplementaryPensionSavingsProduct($id: ID!) {
  detail: getSupplementaryPensionSavingsProduct(id: $id) {
    id
    ...SupplementaryPensionSavingsProduct
  }
}
    ${SupplementaryPensionSavingsProductFragmentDoc}`;

/**
 * __useSupplementaryPensionSavingsProductQuery__
 *
 * To run a query within a React component, call `useSupplementaryPensionSavingsProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementaryPensionSavingsProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementaryPensionSavingsProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupplementaryPensionSavingsProductQuery(baseOptions: Apollo.QueryHookOptions<SupplementaryPensionSavingsProductQuery, SupplementaryPensionSavingsProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplementaryPensionSavingsProductQuery, SupplementaryPensionSavingsProductQueryVariables>(SupplementaryPensionSavingsProductDocument, options);
      }
export function useSupplementaryPensionSavingsProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplementaryPensionSavingsProductQuery, SupplementaryPensionSavingsProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplementaryPensionSavingsProductQuery, SupplementaryPensionSavingsProductQueryVariables>(SupplementaryPensionSavingsProductDocument, options);
        }
export type SupplementaryPensionSavingsProductQueryHookResult = ReturnType<typeof useSupplementaryPensionSavingsProductQuery>;
export type SupplementaryPensionSavingsProductLazyQueryHookResult = ReturnType<typeof useSupplementaryPensionSavingsProductLazyQuery>;
export type SupplementaryPensionSavingsProductQueryResult = Apollo.QueryResult<SupplementaryPensionSavingsProductQuery, SupplementaryPensionSavingsProductQueryVariables>;
export const UpdateSupplementaryPensionSavingsProductDocument = gql`
    mutation UpdateSupplementaryPensionSavingsProduct($id: ID!, $updatedProduct: SupplementaryPensionSavingsProductInput!) {
  updateProduct: updateSupplementaryPensionSavingsProduct(
    id: $id
    updatedProduct: $updatedProduct
  ) {
    id
    ...SupplementaryPensionSavingsProduct
  }
}
    ${SupplementaryPensionSavingsProductFragmentDoc}`;
export type UpdateSupplementaryPensionSavingsProductMutationFn = Apollo.MutationFunction<UpdateSupplementaryPensionSavingsProductMutation, UpdateSupplementaryPensionSavingsProductMutationVariables>;

/**
 * __useUpdateSupplementaryPensionSavingsProductMutation__
 *
 * To run a mutation, you first call `useUpdateSupplementaryPensionSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplementaryPensionSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplementaryPensionSavingsProductMutation, { data, loading, error }] = useUpdateSupplementaryPensionSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedProduct: // value for 'updatedProduct'
 *   },
 * });
 */
export function useUpdateSupplementaryPensionSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplementaryPensionSavingsProductMutation, UpdateSupplementaryPensionSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplementaryPensionSavingsProductMutation, UpdateSupplementaryPensionSavingsProductMutationVariables>(UpdateSupplementaryPensionSavingsProductDocument, options);
      }
export type UpdateSupplementaryPensionSavingsProductMutationHookResult = ReturnType<typeof useUpdateSupplementaryPensionSavingsProductMutation>;
export type UpdateSupplementaryPensionSavingsProductMutationResult = Apollo.MutationResult<UpdateSupplementaryPensionSavingsProductMutation>;
export type UpdateSupplementaryPensionSavingsProductMutationOptions = Apollo.BaseMutationOptions<UpdateSupplementaryPensionSavingsProductMutation, UpdateSupplementaryPensionSavingsProductMutationVariables>;
export const CreateSupplementaryPensionSavingsProductDocument = gql`
    mutation CreateSupplementaryPensionSavingsProduct {
  createProduct: createSupplementaryPensionSavingsProduct {
    id
  }
}
    `;
export type CreateSupplementaryPensionSavingsProductMutationFn = Apollo.MutationFunction<CreateSupplementaryPensionSavingsProductMutation, CreateSupplementaryPensionSavingsProductMutationVariables>;

/**
 * __useCreateSupplementaryPensionSavingsProductMutation__
 *
 * To run a mutation, you first call `useCreateSupplementaryPensionSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplementaryPensionSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplementaryPensionSavingsProductMutation, { data, loading, error }] = useCreateSupplementaryPensionSavingsProductMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateSupplementaryPensionSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplementaryPensionSavingsProductMutation, CreateSupplementaryPensionSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplementaryPensionSavingsProductMutation, CreateSupplementaryPensionSavingsProductMutationVariables>(CreateSupplementaryPensionSavingsProductDocument, options);
      }
export type CreateSupplementaryPensionSavingsProductMutationHookResult = ReturnType<typeof useCreateSupplementaryPensionSavingsProductMutation>;
export type CreateSupplementaryPensionSavingsProductMutationResult = Apollo.MutationResult<CreateSupplementaryPensionSavingsProductMutation>;
export type CreateSupplementaryPensionSavingsProductMutationOptions = Apollo.BaseMutationOptions<CreateSupplementaryPensionSavingsProductMutation, CreateSupplementaryPensionSavingsProductMutationVariables>;
export const DeleteSupplementaryPensionSavingsProductDocument = gql`
    mutation DeleteSupplementaryPensionSavingsProduct($id: ID!) {
  deleteProduct: deleteSupplementaryPensionSavingsProduct(id: $id)
}
    `;
export type DeleteSupplementaryPensionSavingsProductMutationFn = Apollo.MutationFunction<DeleteSupplementaryPensionSavingsProductMutation, DeleteSupplementaryPensionSavingsProductMutationVariables>;

/**
 * __useDeleteSupplementaryPensionSavingsProductMutation__
 *
 * To run a mutation, you first call `useDeleteSupplementaryPensionSavingsProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplementaryPensionSavingsProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplementaryPensionSavingsProductMutation, { data, loading, error }] = useDeleteSupplementaryPensionSavingsProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplementaryPensionSavingsProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplementaryPensionSavingsProductMutation, DeleteSupplementaryPensionSavingsProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupplementaryPensionSavingsProductMutation, DeleteSupplementaryPensionSavingsProductMutationVariables>(DeleteSupplementaryPensionSavingsProductDocument, options);
      }
export type DeleteSupplementaryPensionSavingsProductMutationHookResult = ReturnType<typeof useDeleteSupplementaryPensionSavingsProductMutation>;
export type DeleteSupplementaryPensionSavingsProductMutationResult = Apollo.MutationResult<DeleteSupplementaryPensionSavingsProductMutation>;
export type DeleteSupplementaryPensionSavingsProductMutationOptions = Apollo.BaseMutationOptions<DeleteSupplementaryPensionSavingsProductMutation, DeleteSupplementaryPensionSavingsProductMutationVariables>;
export const CreateSupplementaryPensionSavingsProductDocumentDocument = gql`
    mutation CreateSupplementaryPensionSavingsProductDocument($productId: ID!, $document: DocumentInput!) {
  createProductDocument: createSupplementaryPensionSavingsProductDocument(
    productId: $productId
    document: $document
  ) {
    id
  }
}
    `;
export type CreateSupplementaryPensionSavingsProductDocumentMutationFn = Apollo.MutationFunction<CreateSupplementaryPensionSavingsProductDocumentMutation, CreateSupplementaryPensionSavingsProductDocumentMutationVariables>;

/**
 * __useCreateSupplementaryPensionSavingsProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateSupplementaryPensionSavingsProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplementaryPensionSavingsProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplementaryPensionSavingsProductDocumentMutation, { data, loading, error }] = useCreateSupplementaryPensionSavingsProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateSupplementaryPensionSavingsProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplementaryPensionSavingsProductDocumentMutation, CreateSupplementaryPensionSavingsProductDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplementaryPensionSavingsProductDocumentMutation, CreateSupplementaryPensionSavingsProductDocumentMutationVariables>(CreateSupplementaryPensionSavingsProductDocumentDocument, options);
      }
export type CreateSupplementaryPensionSavingsProductDocumentMutationHookResult = ReturnType<typeof useCreateSupplementaryPensionSavingsProductDocumentMutation>;
export type CreateSupplementaryPensionSavingsProductDocumentMutationResult = Apollo.MutationResult<CreateSupplementaryPensionSavingsProductDocumentMutation>;
export type CreateSupplementaryPensionSavingsProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateSupplementaryPensionSavingsProductDocumentMutation, CreateSupplementaryPensionSavingsProductDocumentMutationVariables>;
export const MortgageRefinanceProcessDocument = gql`
    query MortgageRefinanceProcess($id: ID!) {
  process: getMortgageRefinanceProcessById(processId: $id) {
    id
    updateTimestamp
    inquiry {
      ...MortgageRefinanceInquiry
    }
    acceptedProposal {
      id
    }
  }
}
    ${MortgageRefinanceInquiryFragmentDoc}`;

/**
 * __useMortgageRefinanceProcessQuery__
 *
 * To run a query within a React component, call `useMortgageRefinanceProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageRefinanceProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageRefinanceProcessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMortgageRefinanceProcessQuery(baseOptions: Apollo.QueryHookOptions<MortgageRefinanceProcessQuery, MortgageRefinanceProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageRefinanceProcessQuery, MortgageRefinanceProcessQueryVariables>(MortgageRefinanceProcessDocument, options);
      }
export function useMortgageRefinanceProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageRefinanceProcessQuery, MortgageRefinanceProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageRefinanceProcessQuery, MortgageRefinanceProcessQueryVariables>(MortgageRefinanceProcessDocument, options);
        }
export type MortgageRefinanceProcessQueryHookResult = ReturnType<typeof useMortgageRefinanceProcessQuery>;
export type MortgageRefinanceProcessLazyQueryHookResult = ReturnType<typeof useMortgageRefinanceProcessLazyQuery>;
export type MortgageRefinanceProcessQueryResult = Apollo.QueryResult<MortgageRefinanceProcessQuery, MortgageRefinanceProcessQueryVariables>;
export const AllMortgageRefinanceProcessesDocument = gql`
    query AllMortgageRefinanceProcesses {
  processes: getMortgageRefinanceProcessesPage {
    items {
      id
      inquiry {
        ...MortgageRefinanceInquiry
      }
      acceptedProposal {
        id
      }
      updateTimestamp
      creationTimestamp
    }
  }
}
    ${MortgageRefinanceInquiryFragmentDoc}`;

/**
 * __useAllMortgageRefinanceProcessesQuery__
 *
 * To run a query within a React component, call `useAllMortgageRefinanceProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMortgageRefinanceProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMortgageRefinanceProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMortgageRefinanceProcessesQuery(baseOptions?: Apollo.QueryHookOptions<AllMortgageRefinanceProcessesQuery, AllMortgageRefinanceProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMortgageRefinanceProcessesQuery, AllMortgageRefinanceProcessesQueryVariables>(AllMortgageRefinanceProcessesDocument, options);
      }
export function useAllMortgageRefinanceProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMortgageRefinanceProcessesQuery, AllMortgageRefinanceProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMortgageRefinanceProcessesQuery, AllMortgageRefinanceProcessesQueryVariables>(AllMortgageRefinanceProcessesDocument, options);
        }
export type AllMortgageRefinanceProcessesQueryHookResult = ReturnType<typeof useAllMortgageRefinanceProcessesQuery>;
export type AllMortgageRefinanceProcessesLazyQueryHookResult = ReturnType<typeof useAllMortgageRefinanceProcessesLazyQuery>;
export type AllMortgageRefinanceProcessesQueryResult = Apollo.QueryResult<AllMortgageRefinanceProcessesQuery, AllMortgageRefinanceProcessesQueryVariables>;
export const CreateMortgageRefinanceProcessDocument = gql`
    mutation CreateMortgageRefinanceProcess {
  createMortgageRefinanceProcess {
    id
    updateTimestamp
  }
}
    `;
export type CreateMortgageRefinanceProcessMutationFn = Apollo.MutationFunction<CreateMortgageRefinanceProcessMutation, CreateMortgageRefinanceProcessMutationVariables>;

/**
 * __useCreateMortgageRefinanceProcessMutation__
 *
 * To run a mutation, you first call `useCreateMortgageRefinanceProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgageRefinanceProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgageRefinanceProcessMutation, { data, loading, error }] = useCreateMortgageRefinanceProcessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateMortgageRefinanceProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgageRefinanceProcessMutation, CreateMortgageRefinanceProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgageRefinanceProcessMutation, CreateMortgageRefinanceProcessMutationVariables>(CreateMortgageRefinanceProcessDocument, options);
      }
export type CreateMortgageRefinanceProcessMutationHookResult = ReturnType<typeof useCreateMortgageRefinanceProcessMutation>;
export type CreateMortgageRefinanceProcessMutationResult = Apollo.MutationResult<CreateMortgageRefinanceProcessMutation>;
export type CreateMortgageRefinanceProcessMutationOptions = Apollo.BaseMutationOptions<CreateMortgageRefinanceProcessMutation, CreateMortgageRefinanceProcessMutationVariables>;
export const UpdateMortgageRefinanceProcessDocument = gql`
    mutation UpdateMortgageRefinanceProcess($id: ID!, $inquiry: MortgageRefinanceInquiryInput!) {
  updateMortgageRefinanceProcess(processId: $id, inquiry: $inquiry) {
    id
    updateTimestamp
  }
}
    `;
export type UpdateMortgageRefinanceProcessMutationFn = Apollo.MutationFunction<UpdateMortgageRefinanceProcessMutation, UpdateMortgageRefinanceProcessMutationVariables>;

/**
 * __useUpdateMortgageRefinanceProcessMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageRefinanceProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageRefinanceProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageRefinanceProcessMutation, { data, loading, error }] = useUpdateMortgageRefinanceProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useUpdateMortgageRefinanceProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageRefinanceProcessMutation, UpdateMortgageRefinanceProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageRefinanceProcessMutation, UpdateMortgageRefinanceProcessMutationVariables>(UpdateMortgageRefinanceProcessDocument, options);
      }
export type UpdateMortgageRefinanceProcessMutationHookResult = ReturnType<typeof useUpdateMortgageRefinanceProcessMutation>;
export type UpdateMortgageRefinanceProcessMutationResult = Apollo.MutationResult<UpdateMortgageRefinanceProcessMutation>;
export type UpdateMortgageRefinanceProcessMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageRefinanceProcessMutation, UpdateMortgageRefinanceProcessMutationVariables>;
export const MortgageRefinanceTuningLimitsByProcessIdDocument = gql`
    query MortgageRefinanceTuningLimitsByProcessId($processId: ID!) {
  limits: calculateMortgageRefinanceTuningLimitsByProcessId(processId: $processId) {
    fixationDefault
    fixationOptions
    maturityInYearsDefault
    maturityInYearsRange {
      lower
      upper
    }
  }
}
    `;

/**
 * __useMortgageRefinanceTuningLimitsByProcessIdQuery__
 *
 * To run a query within a React component, call `useMortgageRefinanceTuningLimitsByProcessIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageRefinanceTuningLimitsByProcessIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageRefinanceTuningLimitsByProcessIdQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useMortgageRefinanceTuningLimitsByProcessIdQuery(baseOptions: Apollo.QueryHookOptions<MortgageRefinanceTuningLimitsByProcessIdQuery, MortgageRefinanceTuningLimitsByProcessIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageRefinanceTuningLimitsByProcessIdQuery, MortgageRefinanceTuningLimitsByProcessIdQueryVariables>(MortgageRefinanceTuningLimitsByProcessIdDocument, options);
      }
export function useMortgageRefinanceTuningLimitsByProcessIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageRefinanceTuningLimitsByProcessIdQuery, MortgageRefinanceTuningLimitsByProcessIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageRefinanceTuningLimitsByProcessIdQuery, MortgageRefinanceTuningLimitsByProcessIdQueryVariables>(MortgageRefinanceTuningLimitsByProcessIdDocument, options);
        }
export type MortgageRefinanceTuningLimitsByProcessIdQueryHookResult = ReturnType<typeof useMortgageRefinanceTuningLimitsByProcessIdQuery>;
export type MortgageRefinanceTuningLimitsByProcessIdLazyQueryHookResult = ReturnType<typeof useMortgageRefinanceTuningLimitsByProcessIdLazyQuery>;
export type MortgageRefinanceTuningLimitsByProcessIdQueryResult = Apollo.QueryResult<MortgageRefinanceTuningLimitsByProcessIdQuery, MortgageRefinanceTuningLimitsByProcessIdQueryVariables>;
export const MortgageRefinanceTuningLimitsByInquiryDocument = gql`
    query MortgageRefinanceTuningLimitsByInquiry($inquiry: MortgageRefinanceInquiryInput!) {
  limits: calculateMortgageRefinanceTuningLimitsByInquiry(inquiry: $inquiry) {
    fixationDefault
    fixationOptions
    maturityInYearsDefault
    maturityInYearsRange {
      lower
      upper
    }
  }
}
    `;

/**
 * __useMortgageRefinanceTuningLimitsByInquiryQuery__
 *
 * To run a query within a React component, call `useMortgageRefinanceTuningLimitsByInquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageRefinanceTuningLimitsByInquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageRefinanceTuningLimitsByInquiryQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useMortgageRefinanceTuningLimitsByInquiryQuery(baseOptions: Apollo.QueryHookOptions<MortgageRefinanceTuningLimitsByInquiryQuery, MortgageRefinanceTuningLimitsByInquiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageRefinanceTuningLimitsByInquiryQuery, MortgageRefinanceTuningLimitsByInquiryQueryVariables>(MortgageRefinanceTuningLimitsByInquiryDocument, options);
      }
export function useMortgageRefinanceTuningLimitsByInquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageRefinanceTuningLimitsByInquiryQuery, MortgageRefinanceTuningLimitsByInquiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageRefinanceTuningLimitsByInquiryQuery, MortgageRefinanceTuningLimitsByInquiryQueryVariables>(MortgageRefinanceTuningLimitsByInquiryDocument, options);
        }
export type MortgageRefinanceTuningLimitsByInquiryQueryHookResult = ReturnType<typeof useMortgageRefinanceTuningLimitsByInquiryQuery>;
export type MortgageRefinanceTuningLimitsByInquiryLazyQueryHookResult = ReturnType<typeof useMortgageRefinanceTuningLimitsByInquiryLazyQuery>;
export type MortgageRefinanceTuningLimitsByInquiryQueryResult = Apollo.QueryResult<MortgageRefinanceTuningLimitsByInquiryQuery, MortgageRefinanceTuningLimitsByInquiryQueryVariables>;
export const CalculateMortgageRefinanceResultByProcessIdDocument = gql`
    mutation CalculateMortgageRefinanceResultByProcessId($processId: ID!, $tuning: MortgageRefinanceTuningInput!) {
  proposals: calculateAndSaveMortgageRefinanceResultByProcessId(
    processId: $processId
    tuning: $tuning
  ) {
    id
    currentMortgageInFixationPeriod {
      ...MortgageRefinanceProposal
    }
    minimizingOverpaymentResult {
      ...MortgageRefinanceStrategyResult
    }
    customStrategyResult {
      ...MortgageRefinanceStrategyResult
    }
    preservingCurrentInstallmentResult {
      ...MortgageRefinanceStrategyResult
    }
  }
}
    ${MortgageRefinanceProposalFragmentDoc}
${MortgageRefinanceStrategyResultFragmentDoc}`;
export type CalculateMortgageRefinanceResultByProcessIdMutationFn = Apollo.MutationFunction<CalculateMortgageRefinanceResultByProcessIdMutation, CalculateMortgageRefinanceResultByProcessIdMutationVariables>;

/**
 * __useCalculateMortgageRefinanceResultByProcessIdMutation__
 *
 * To run a mutation, you first call `useCalculateMortgageRefinanceResultByProcessIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateMortgageRefinanceResultByProcessIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateMortgageRefinanceResultByProcessIdMutation, { data, loading, error }] = useCalculateMortgageRefinanceResultByProcessIdMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *      tuning: // value for 'tuning'
 *   },
 * });
 */
export function useCalculateMortgageRefinanceResultByProcessIdMutation(baseOptions?: Apollo.MutationHookOptions<CalculateMortgageRefinanceResultByProcessIdMutation, CalculateMortgageRefinanceResultByProcessIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateMortgageRefinanceResultByProcessIdMutation, CalculateMortgageRefinanceResultByProcessIdMutationVariables>(CalculateMortgageRefinanceResultByProcessIdDocument, options);
      }
export type CalculateMortgageRefinanceResultByProcessIdMutationHookResult = ReturnType<typeof useCalculateMortgageRefinanceResultByProcessIdMutation>;
export type CalculateMortgageRefinanceResultByProcessIdMutationResult = Apollo.MutationResult<CalculateMortgageRefinanceResultByProcessIdMutation>;
export type CalculateMortgageRefinanceResultByProcessIdMutationOptions = Apollo.BaseMutationOptions<CalculateMortgageRefinanceResultByProcessIdMutation, CalculateMortgageRefinanceResultByProcessIdMutationVariables>;
export const CalculateMortgageRefinanceResultByInquiryDocument = gql`
    query CalculateMortgageRefinanceResultByInquiry($inquiry: MortgageRefinanceInquiryInput!) {
  proposals: calculateMortgageRefinanceResultByInquiry(inquiry: $inquiry) {
    id
    currentMortgageInFixationPeriod {
      ...MortgageRefinanceProposal
    }
    minimizingOverpaymentResult {
      ...MortgageRefinanceStrategyResult
    }
    customStrategyResult {
      ...MortgageRefinanceStrategyResult
    }
    preservingCurrentInstallmentResult {
      ...MortgageRefinanceStrategyResult
    }
  }
}
    ${MortgageRefinanceProposalFragmentDoc}
${MortgageRefinanceStrategyResultFragmentDoc}`;

/**
 * __useCalculateMortgageRefinanceResultByInquiryQuery__
 *
 * To run a query within a React component, call `useCalculateMortgageRefinanceResultByInquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateMortgageRefinanceResultByInquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateMortgageRefinanceResultByInquiryQuery({
 *   variables: {
 *      inquiry: // value for 'inquiry'
 *   },
 * });
 */
export function useCalculateMortgageRefinanceResultByInquiryQuery(baseOptions: Apollo.QueryHookOptions<CalculateMortgageRefinanceResultByInquiryQuery, CalculateMortgageRefinanceResultByInquiryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateMortgageRefinanceResultByInquiryQuery, CalculateMortgageRefinanceResultByInquiryQueryVariables>(CalculateMortgageRefinanceResultByInquiryDocument, options);
      }
export function useCalculateMortgageRefinanceResultByInquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateMortgageRefinanceResultByInquiryQuery, CalculateMortgageRefinanceResultByInquiryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateMortgageRefinanceResultByInquiryQuery, CalculateMortgageRefinanceResultByInquiryQueryVariables>(CalculateMortgageRefinanceResultByInquiryDocument, options);
        }
export type CalculateMortgageRefinanceResultByInquiryQueryHookResult = ReturnType<typeof useCalculateMortgageRefinanceResultByInquiryQuery>;
export type CalculateMortgageRefinanceResultByInquiryLazyQueryHookResult = ReturnType<typeof useCalculateMortgageRefinanceResultByInquiryLazyQuery>;
export type CalculateMortgageRefinanceResultByInquiryQueryResult = Apollo.QueryResult<CalculateMortgageRefinanceResultByInquiryQuery, CalculateMortgageRefinanceResultByInquiryQueryVariables>;
export const MortgageRefinanceResultDocument = gql`
    query MortgageRefinanceResult($processId: ID!) {
  proposals: getMortgageRefinanceResultByProcessId(processId: $processId) {
    id
    currentMortgageInFixationPeriod {
      ...MortgageRefinanceProposal
    }
    minimizingOverpaymentResult {
      ...MortgageRefinanceStrategyResult
    }
    customStrategyResult {
      ...MortgageRefinanceStrategyResult
    }
    preservingCurrentInstallmentResult {
      ...MortgageRefinanceStrategyResult
    }
  }
}
    ${MortgageRefinanceProposalFragmentDoc}
${MortgageRefinanceStrategyResultFragmentDoc}`;

/**
 * __useMortgageRefinanceResultQuery__
 *
 * To run a query within a React component, call `useMortgageRefinanceResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useMortgageRefinanceResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMortgageRefinanceResultQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useMortgageRefinanceResultQuery(baseOptions: Apollo.QueryHookOptions<MortgageRefinanceResultQuery, MortgageRefinanceResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MortgageRefinanceResultQuery, MortgageRefinanceResultQueryVariables>(MortgageRefinanceResultDocument, options);
      }
export function useMortgageRefinanceResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MortgageRefinanceResultQuery, MortgageRefinanceResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MortgageRefinanceResultQuery, MortgageRefinanceResultQueryVariables>(MortgageRefinanceResultDocument, options);
        }
export type MortgageRefinanceResultQueryHookResult = ReturnType<typeof useMortgageRefinanceResultQuery>;
export type MortgageRefinanceResultLazyQueryHookResult = ReturnType<typeof useMortgageRefinanceResultLazyQuery>;
export type MortgageRefinanceResultQueryResult = Apollo.QueryResult<MortgageRefinanceResultQuery, MortgageRefinanceResultQueryVariables>;
export const SelectMortgageRefinanceProposalDocument = gql`
    mutation SelectMortgageRefinanceProposal($processId: ID!, $refinanceProposalId: ID!) {
  proposal: acceptMortgageRefinanceProposal(
    processId: $processId
    refinanceProposalId: $refinanceProposalId
  ) {
    id
    acceptedProposal {
      ...MortgageRefinanceProposal
    }
    acceptedTimestamp
    creationTimestamp
    updateTimestamp
    inquiry {
      ...MortgageRefinanceInquiry
    }
  }
}
    ${MortgageRefinanceProposalFragmentDoc}
${MortgageRefinanceInquiryFragmentDoc}`;
export type SelectMortgageRefinanceProposalMutationFn = Apollo.MutationFunction<SelectMortgageRefinanceProposalMutation, SelectMortgageRefinanceProposalMutationVariables>;

/**
 * __useSelectMortgageRefinanceProposalMutation__
 *
 * To run a mutation, you first call `useSelectMortgageRefinanceProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectMortgageRefinanceProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectMortgageRefinanceProposalMutation, { data, loading, error }] = useSelectMortgageRefinanceProposalMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *      refinanceProposalId: // value for 'refinanceProposalId'
 *   },
 * });
 */
export function useSelectMortgageRefinanceProposalMutation(baseOptions?: Apollo.MutationHookOptions<SelectMortgageRefinanceProposalMutation, SelectMortgageRefinanceProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectMortgageRefinanceProposalMutation, SelectMortgageRefinanceProposalMutationVariables>(SelectMortgageRefinanceProposalDocument, options);
      }
export type SelectMortgageRefinanceProposalMutationHookResult = ReturnType<typeof useSelectMortgageRefinanceProposalMutation>;
export type SelectMortgageRefinanceProposalMutationResult = Apollo.MutationResult<SelectMortgageRefinanceProposalMutation>;
export type SelectMortgageRefinanceProposalMutationOptions = Apollo.BaseMutationOptions<SelectMortgageRefinanceProposalMutation, SelectMortgageRefinanceProposalMutationVariables>;
export const AcceptedRefinanceProposalDocument = gql`
    query AcceptedRefinanceProposal($processId: ID!) {
  process: getMortgageRefinanceProcessById(processId: $processId) {
    id
    acceptedProposal {
      ...MortgageRefinanceProposal
    }
  }
}
    ${MortgageRefinanceProposalFragmentDoc}`;

/**
 * __useAcceptedRefinanceProposalQuery__
 *
 * To run a query within a React component, call `useAcceptedRefinanceProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcceptedRefinanceProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcceptedRefinanceProposalQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useAcceptedRefinanceProposalQuery(baseOptions: Apollo.QueryHookOptions<AcceptedRefinanceProposalQuery, AcceptedRefinanceProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcceptedRefinanceProposalQuery, AcceptedRefinanceProposalQueryVariables>(AcceptedRefinanceProposalDocument, options);
      }
export function useAcceptedRefinanceProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcceptedRefinanceProposalQuery, AcceptedRefinanceProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcceptedRefinanceProposalQuery, AcceptedRefinanceProposalQueryVariables>(AcceptedRefinanceProposalDocument, options);
        }
export type AcceptedRefinanceProposalQueryHookResult = ReturnType<typeof useAcceptedRefinanceProposalQuery>;
export type AcceptedRefinanceProposalLazyQueryHookResult = ReturnType<typeof useAcceptedRefinanceProposalLazyQuery>;
export type AcceptedRefinanceProposalQueryResult = Apollo.QueryResult<AcceptedRefinanceProposalQuery, AcceptedRefinanceProposalQueryVariables>;
export const SendMortgageRefinanceNotificationToSpecialistDocument = gql`
    mutation SendMortgageRefinanceNotificationToSpecialist($processId: ID!) {
  sendMortgageRefinanceNotificationEmailToSpecialist(processId: $processId)
}
    `;
export type SendMortgageRefinanceNotificationToSpecialistMutationFn = Apollo.MutationFunction<SendMortgageRefinanceNotificationToSpecialistMutation, SendMortgageRefinanceNotificationToSpecialistMutationVariables>;

/**
 * __useSendMortgageRefinanceNotificationToSpecialistMutation__
 *
 * To run a mutation, you first call `useSendMortgageRefinanceNotificationToSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMortgageRefinanceNotificationToSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMortgageRefinanceNotificationToSpecialistMutation, { data, loading, error }] = useSendMortgageRefinanceNotificationToSpecialistMutation({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useSendMortgageRefinanceNotificationToSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<SendMortgageRefinanceNotificationToSpecialistMutation, SendMortgageRefinanceNotificationToSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMortgageRefinanceNotificationToSpecialistMutation, SendMortgageRefinanceNotificationToSpecialistMutationVariables>(SendMortgageRefinanceNotificationToSpecialistDocument, options);
      }
export type SendMortgageRefinanceNotificationToSpecialistMutationHookResult = ReturnType<typeof useSendMortgageRefinanceNotificationToSpecialistMutation>;
export type SendMortgageRefinanceNotificationToSpecialistMutationResult = Apollo.MutationResult<SendMortgageRefinanceNotificationToSpecialistMutation>;
export type SendMortgageRefinanceNotificationToSpecialistMutationOptions = Apollo.BaseMutationOptions<SendMortgageRefinanceNotificationToSpecialistMutation, SendMortgageRefinanceNotificationToSpecialistMutationVariables>;
export const DeleteMortgageRefinanceProcessDocument = gql`
    mutation DeleteMortgageRefinanceProcess($id: ID!) {
  deleteMortgageRefinanceProcess(processId: $id)
}
    `;
export type DeleteMortgageRefinanceProcessMutationFn = Apollo.MutationFunction<DeleteMortgageRefinanceProcessMutation, DeleteMortgageRefinanceProcessMutationVariables>;

/**
 * __useDeleteMortgageRefinanceProcessMutation__
 *
 * To run a mutation, you first call `useDeleteMortgageRefinanceProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgageRefinanceProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgageRefinanceProcessMutation, { data, loading, error }] = useDeleteMortgageRefinanceProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMortgageRefinanceProcessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgageRefinanceProcessMutation, DeleteMortgageRefinanceProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgageRefinanceProcessMutation, DeleteMortgageRefinanceProcessMutationVariables>(DeleteMortgageRefinanceProcessDocument, options);
      }
export type DeleteMortgageRefinanceProcessMutationHookResult = ReturnType<typeof useDeleteMortgageRefinanceProcessMutation>;
export type DeleteMortgageRefinanceProcessMutationResult = Apollo.MutationResult<DeleteMortgageRefinanceProcessMutation>;
export type DeleteMortgageRefinanceProcessMutationOptions = Apollo.BaseMutationOptions<DeleteMortgageRefinanceProcessMutation, DeleteMortgageRefinanceProcessMutationVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($reportType: ReportType!) {
  createReport(reportType: $reportType) {
    id
    ...Report
  }
}
    ${ReportFragmentDoc}`;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const ReportsDocument = gql`
    query Reports($filterInput: FilterInput, $sortInput: SortInput) {
  reports: getReportsPage(filterInput: $filterInput, sortInput: $sortInput) {
    items {
      id
      ...Report
    }
    totalItems
  }
}
    ${ReportFragmentDoc}`;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      sortInput: // value for 'sortInput'
 *   },
 * });
 */
export function useReportsQuery(baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
      }
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const RequestContactDocument = gql`
    mutation RequestContact($userInfo: UserInfo!, $context: RequestContactContext!, $text: String!) {
  requestContact(userInfo: $userInfo, context: $context, text: $text)
}
    `;
export type RequestContactMutationFn = Apollo.MutationFunction<RequestContactMutation, RequestContactMutationVariables>;

/**
 * __useRequestContactMutation__
 *
 * To run a mutation, you first call `useRequestContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContactMutation, { data, loading, error }] = useRequestContactMutation({
 *   variables: {
 *      userInfo: // value for 'userInfo'
 *      context: // value for 'context'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useRequestContactMutation(baseOptions?: Apollo.MutationHookOptions<RequestContactMutation, RequestContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestContactMutation, RequestContactMutationVariables>(RequestContactDocument, options);
      }
export type RequestContactMutationHookResult = ReturnType<typeof useRequestContactMutation>;
export type RequestContactMutationResult = Apollo.MutationResult<RequestContactMutation>;
export type RequestContactMutationOptions = Apollo.BaseMutationOptions<RequestContactMutation, RequestContactMutationVariables>;
export const RequestContactAuthenticatedDocument = gql`
    mutation RequestContactAuthenticated($context: RequestContactContext!, $text: String!) {
  requestContactFromAuthenticatedUser(context: $context, text: $text)
}
    `;
export type RequestContactAuthenticatedMutationFn = Apollo.MutationFunction<RequestContactAuthenticatedMutation, RequestContactAuthenticatedMutationVariables>;

/**
 * __useRequestContactAuthenticatedMutation__
 *
 * To run a mutation, you first call `useRequestContactAuthenticatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContactAuthenticatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContactAuthenticatedMutation, { data, loading, error }] = useRequestContactAuthenticatedMutation({
 *   variables: {
 *      context: // value for 'context'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useRequestContactAuthenticatedMutation(baseOptions?: Apollo.MutationHookOptions<RequestContactAuthenticatedMutation, RequestContactAuthenticatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestContactAuthenticatedMutation, RequestContactAuthenticatedMutationVariables>(RequestContactAuthenticatedDocument, options);
      }
export type RequestContactAuthenticatedMutationHookResult = ReturnType<typeof useRequestContactAuthenticatedMutation>;
export type RequestContactAuthenticatedMutationResult = Apollo.MutationResult<RequestContactAuthenticatedMutation>;
export type RequestContactAuthenticatedMutationOptions = Apollo.BaseMutationOptions<RequestContactAuthenticatedMutation, RequestContactAuthenticatedMutationVariables>;
export const AggregateTransactionsDocument = gql`
    query AggregateTransactions($groupBy: [TransactionAttribute!], $filterInput: FilterInput) {
  aggregateTransactions(groupBy: $groupBy, filterInput: $filterInput) {
    baseCurrency
    resultData {
      ...TransactionAggregationValue
    }
  }
}
    ${TransactionAggregationValueFragmentDoc}`;

/**
 * __useAggregateTransactionsQuery__
 *
 * To run a query within a React component, call `useAggregateTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateTransactionsQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useAggregateTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<AggregateTransactionsQuery, AggregateTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregateTransactionsQuery, AggregateTransactionsQueryVariables>(AggregateTransactionsDocument, options);
      }
export function useAggregateTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregateTransactionsQuery, AggregateTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregateTransactionsQuery, AggregateTransactionsQueryVariables>(AggregateTransactionsDocument, options);
        }
export type AggregateTransactionsQueryHookResult = ReturnType<typeof useAggregateTransactionsQuery>;
export type AggregateTransactionsLazyQueryHookResult = ReturnType<typeof useAggregateTransactionsLazyQuery>;
export type AggregateTransactionsQueryResult = Apollo.QueryResult<AggregateTransactionsQuery, AggregateTransactionsQueryVariables>;
export const TransactionTagsDocument = gql`
    query TransactionTags {
  tags: getTransactionTagsPage {
    items {
      id
      ...TransactionTag
    }
  }
}
    ${TransactionTagFragmentDoc}`;

/**
 * __useTransactionTagsQuery__
 *
 * To run a query within a React component, call `useTransactionTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionTagsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionTagsQuery, TransactionTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionTagsQuery, TransactionTagsQueryVariables>(TransactionTagsDocument, options);
      }
export function useTransactionTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionTagsQuery, TransactionTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionTagsQuery, TransactionTagsQueryVariables>(TransactionTagsDocument, options);
        }
export type TransactionTagsQueryHookResult = ReturnType<typeof useTransactionTagsQuery>;
export type TransactionTagsLazyQueryHookResult = ReturnType<typeof useTransactionTagsLazyQuery>;
export type TransactionTagsQueryResult = Apollo.QueryResult<TransactionTagsQuery, TransactionTagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($tag: TransactionTagInput!) {
  createTransactionTag(tag: $tag) {
    id
    ...TransactionTag
  }
}
    ${TransactionTagFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($tagId: ID!) {
  deleteTransactionTag(tagId: $tagId)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const RenameTagDocument = gql`
    mutation RenameTag($tagId: ID!, $name: String!) {
  renameTransactionTag(tagId: $tagId, name: $name) {
    id
    ...TransactionTag
  }
}
    ${TransactionTagFragmentDoc}`;
export type RenameTagMutationFn = Apollo.MutationFunction<RenameTagMutation, RenameTagMutationVariables>;

/**
 * __useRenameTagMutation__
 *
 * To run a mutation, you first call `useRenameTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTagMutation, { data, loading, error }] = useRenameTagMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameTagMutation(baseOptions?: Apollo.MutationHookOptions<RenameTagMutation, RenameTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTagMutation, RenameTagMutationVariables>(RenameTagDocument, options);
      }
export type RenameTagMutationHookResult = ReturnType<typeof useRenameTagMutation>;
export type RenameTagMutationResult = Apollo.MutationResult<RenameTagMutation>;
export type RenameTagMutationOptions = Apollo.BaseMutationOptions<RenameTagMutation, RenameTagMutationVariables>;
export const AddTagsToTransactionsDocument = gql`
    mutation AddTagsToTransactions($transactionIds: [ID!]!, $tagIds: [ID!]!) {
  addTagsToTransactions(transactionIds: $transactionIds, tagIds: $tagIds) {
    id
    tags {
      id
      ...TransactionTag
    }
  }
}
    ${TransactionTagFragmentDoc}`;
export type AddTagsToTransactionsMutationFn = Apollo.MutationFunction<AddTagsToTransactionsMutation, AddTagsToTransactionsMutationVariables>;

/**
 * __useAddTagsToTransactionsMutation__
 *
 * To run a mutation, you first call `useAddTagsToTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToTransactionsMutation, { data, loading, error }] = useAddTagsToTransactionsMutation({
 *   variables: {
 *      transactionIds: // value for 'transactionIds'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAddTagsToTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<AddTagsToTransactionsMutation, AddTagsToTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagsToTransactionsMutation, AddTagsToTransactionsMutationVariables>(AddTagsToTransactionsDocument, options);
      }
export type AddTagsToTransactionsMutationHookResult = ReturnType<typeof useAddTagsToTransactionsMutation>;
export type AddTagsToTransactionsMutationResult = Apollo.MutationResult<AddTagsToTransactionsMutation>;
export type AddTagsToTransactionsMutationOptions = Apollo.BaseMutationOptions<AddTagsToTransactionsMutation, AddTagsToTransactionsMutationVariables>;
export const RemoveTagsFromTransactionsDocument = gql`
    mutation RemoveTagsFromTransactions($transactionIds: [ID!]!, $tagIds: [ID!]!) {
  removeTagsFromTransactions(transactionIds: $transactionIds, tagIds: $tagIds) {
    id
    tags {
      id
      ...TransactionTag
    }
  }
}
    ${TransactionTagFragmentDoc}`;
export type RemoveTagsFromTransactionsMutationFn = Apollo.MutationFunction<RemoveTagsFromTransactionsMutation, RemoveTagsFromTransactionsMutationVariables>;

/**
 * __useRemoveTagsFromTransactionsMutation__
 *
 * To run a mutation, you first call `useRemoveTagsFromTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagsFromTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagsFromTransactionsMutation, { data, loading, error }] = useRemoveTagsFromTransactionsMutation({
 *   variables: {
 *      transactionIds: // value for 'transactionIds'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useRemoveTagsFromTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagsFromTransactionsMutation, RemoveTagsFromTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagsFromTransactionsMutation, RemoveTagsFromTransactionsMutationVariables>(RemoveTagsFromTransactionsDocument, options);
      }
export type RemoveTagsFromTransactionsMutationHookResult = ReturnType<typeof useRemoveTagsFromTransactionsMutation>;
export type RemoveTagsFromTransactionsMutationResult = Apollo.MutationResult<RemoveTagsFromTransactionsMutation>;
export type RemoveTagsFromTransactionsMutationOptions = Apollo.BaseMutationOptions<RemoveTagsFromTransactionsMutation, RemoveTagsFromTransactionsMutationVariables>;
export const TransactionDetailDocument = gql`
    query TransactionDetail($id: ID!) {
  detail: getTransaction(transactionId: $id) {
    id
    ...TransactionDetail
  }
}
    ${TransactionDetailFragmentDoc}`;

/**
 * __useTransactionDetailQuery__
 *
 * To run a query within a React component, call `useTransactionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionDetailQuery(baseOptions: Apollo.QueryHookOptions<TransactionDetailQuery, TransactionDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionDetailQuery, TransactionDetailQueryVariables>(TransactionDetailDocument, options);
      }
export function useTransactionDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionDetailQuery, TransactionDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionDetailQuery, TransactionDetailQueryVariables>(TransactionDetailDocument, options);
        }
export type TransactionDetailQueryHookResult = ReturnType<typeof useTransactionDetailQuery>;
export type TransactionDetailLazyQueryHookResult = ReturnType<typeof useTransactionDetailLazyQuery>;
export type TransactionDetailQueryResult = Apollo.QueryResult<TransactionDetailQuery, TransactionDetailQueryVariables>;
export const TransactionCategoryGroupsDocument = gql`
    query TransactionCategoryGroups {
  page: getTransactionCategoryGroupsPage {
    items {
      id
      ...TransactionCategoryGroup
    }
  }
}
    ${TransactionCategoryGroupFragmentDoc}`;

/**
 * __useTransactionCategoryGroupsQuery__
 *
 * To run a query within a React component, call `useTransactionCategoryGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionCategoryGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionCategoryGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionCategoryGroupsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionCategoryGroupsQuery, TransactionCategoryGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionCategoryGroupsQuery, TransactionCategoryGroupsQueryVariables>(TransactionCategoryGroupsDocument, options);
      }
export function useTransactionCategoryGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionCategoryGroupsQuery, TransactionCategoryGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionCategoryGroupsQuery, TransactionCategoryGroupsQueryVariables>(TransactionCategoryGroupsDocument, options);
        }
export type TransactionCategoryGroupsQueryHookResult = ReturnType<typeof useTransactionCategoryGroupsQuery>;
export type TransactionCategoryGroupsLazyQueryHookResult = ReturnType<typeof useTransactionCategoryGroupsLazyQuery>;
export type TransactionCategoryGroupsQueryResult = Apollo.QueryResult<TransactionCategoryGroupsQuery, TransactionCategoryGroupsQueryVariables>;
export const TransactionCategoriesDocument = gql`
    query TransactionCategories($filterInput: FilterInput, $pageInput: PageInput) {
  page: getTransactionCategoriesPage(
    filterInput: $filterInput
    pageInput: $pageInput
  ) {
    items {
      id
      ...TransactionCategory
    }
  }
}
    ${TransactionCategoryFragmentDoc}`;

/**
 * __useTransactionCategoriesQuery__
 *
 * To run a query within a React component, call `useTransactionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionCategoriesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useTransactionCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<TransactionCategoriesQuery, TransactionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionCategoriesQuery, TransactionCategoriesQueryVariables>(TransactionCategoriesDocument, options);
      }
export function useTransactionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionCategoriesQuery, TransactionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionCategoriesQuery, TransactionCategoriesQueryVariables>(TransactionCategoriesDocument, options);
        }
export type TransactionCategoriesQueryHookResult = ReturnType<typeof useTransactionCategoriesQuery>;
export type TransactionCategoriesLazyQueryHookResult = ReturnType<typeof useTransactionCategoriesLazyQuery>;
export type TransactionCategoriesQueryResult = Apollo.QueryResult<TransactionCategoriesQuery, TransactionCategoriesQueryVariables>;
export const TransactionCounterpartiesDocument = gql`
    query TransactionCounterparties($filterInput: FilterInput, $pageInput: PageInput) {
  page: getTransactionCounterpartiesPage(
    filterInput: $filterInput
    pageInput: $pageInput
  ) {
    items {
      id
      ...TransactionCounterparty
    }
  }
}
    ${TransactionCounterpartyFragmentDoc}`;

/**
 * __useTransactionCounterpartiesQuery__
 *
 * To run a query within a React component, call `useTransactionCounterpartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionCounterpartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionCounterpartiesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useTransactionCounterpartiesQuery(baseOptions?: Apollo.QueryHookOptions<TransactionCounterpartiesQuery, TransactionCounterpartiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionCounterpartiesQuery, TransactionCounterpartiesQueryVariables>(TransactionCounterpartiesDocument, options);
      }
export function useTransactionCounterpartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionCounterpartiesQuery, TransactionCounterpartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionCounterpartiesQuery, TransactionCounterpartiesQueryVariables>(TransactionCounterpartiesDocument, options);
        }
export type TransactionCounterpartiesQueryHookResult = ReturnType<typeof useTransactionCounterpartiesQuery>;
export type TransactionCounterpartiesLazyQueryHookResult = ReturnType<typeof useTransactionCounterpartiesLazyQuery>;
export type TransactionCounterpartiesQueryResult = Apollo.QueryResult<TransactionCounterpartiesQuery, TransactionCounterpartiesQueryVariables>;
export const TransactionsDocument = gql`
    query Transactions($pageInput: PageInput, $sortInput: SortInput, $filterInput: FilterInput) {
  transactionsList: getTransactionsPage(
    pageInput: $pageInput
    sortInput: $sortInput
    filterInput: $filterInput
  ) {
    totalItems
    pageIndex
    pageSize
    items {
      id
      ...TransactionListItem
    }
  }
}
    ${TransactionListItemFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      sortInput: // value for 'sortInput'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const UpdateTransactionsDocument = gql`
    mutation UpdateTransactions($categoryId: ID, $transactionIds: [ID!]!, $tagIds: [ID!], $note: String, $excludeFromAnalytics: Boolean) {
  updateTransactions(
    transactionIds: $transactionIds
    categoryId: $categoryId
    note: $note
    tagIds: $tagIds
    excludeFromAnalytics: $excludeFromAnalytics
  ) {
    id
    ...TransactionDetail
  }
}
    ${TransactionDetailFragmentDoc}`;
export type UpdateTransactionsMutationFn = Apollo.MutationFunction<UpdateTransactionsMutation, UpdateTransactionsMutationVariables>;

/**
 * __useUpdateTransactionsMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionsMutation, { data, loading, error }] = useUpdateTransactionsMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      transactionIds: // value for 'transactionIds'
 *      tagIds: // value for 'tagIds'
 *      note: // value for 'note'
 *      excludeFromAnalytics: // value for 'excludeFromAnalytics'
 *   },
 * });
 */
export function useUpdateTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionsMutation, UpdateTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionsMutation, UpdateTransactionsMutationVariables>(UpdateTransactionsDocument, options);
      }
export type UpdateTransactionsMutationHookResult = ReturnType<typeof useUpdateTransactionsMutation>;
export type UpdateTransactionsMutationResult = Apollo.MutationResult<UpdateTransactionsMutation>;
export type UpdateTransactionsMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionsMutation, UpdateTransactionsMutationVariables>;
export const UpdateTransactionGroupDocument = gql`
    mutation UpdateTransactionGroup($groupId: ID!, $categoryId: ID, $tagIds: [ID!], $note: String, $excludeFromAnalytics: Boolean) {
  updateTransactionGroup(
    groupId: $groupId
    categoryId: $categoryId
    note: $note
    tagIds: $tagIds
    excludeFromAnalytics: $excludeFromAnalytics
  ) {
    id
    ...TransactionGroup
  }
}
    ${TransactionGroupFragmentDoc}`;
export type UpdateTransactionGroupMutationFn = Apollo.MutationFunction<UpdateTransactionGroupMutation, UpdateTransactionGroupMutationVariables>;

/**
 * __useUpdateTransactionGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionGroupMutation, { data, loading, error }] = useUpdateTransactionGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      categoryId: // value for 'categoryId'
 *      tagIds: // value for 'tagIds'
 *      note: // value for 'note'
 *      excludeFromAnalytics: // value for 'excludeFromAnalytics'
 *   },
 * });
 */
export function useUpdateTransactionGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionGroupMutation, UpdateTransactionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionGroupMutation, UpdateTransactionGroupMutationVariables>(UpdateTransactionGroupDocument, options);
      }
export type UpdateTransactionGroupMutationHookResult = ReturnType<typeof useUpdateTransactionGroupMutation>;
export type UpdateTransactionGroupMutationResult = Apollo.MutationResult<UpdateTransactionGroupMutation>;
export type UpdateTransactionGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionGroupMutation, UpdateTransactionGroupMutationVariables>;
export const RemovePeriodFromTransactionGroupDocument = gql`
    mutation RemovePeriodFromTransactionGroup($groupId: ID!) {
  removePeriodFromTransactionGroup(groupId: $groupId) {
    id
    ...TransactionGroup
  }
}
    ${TransactionGroupFragmentDoc}`;
export type RemovePeriodFromTransactionGroupMutationFn = Apollo.MutationFunction<RemovePeriodFromTransactionGroupMutation, RemovePeriodFromTransactionGroupMutationVariables>;

/**
 * __useRemovePeriodFromTransactionGroupMutation__
 *
 * To run a mutation, you first call `useRemovePeriodFromTransactionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePeriodFromTransactionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePeriodFromTransactionGroupMutation, { data, loading, error }] = useRemovePeriodFromTransactionGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRemovePeriodFromTransactionGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemovePeriodFromTransactionGroupMutation, RemovePeriodFromTransactionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePeriodFromTransactionGroupMutation, RemovePeriodFromTransactionGroupMutationVariables>(RemovePeriodFromTransactionGroupDocument, options);
      }
export type RemovePeriodFromTransactionGroupMutationHookResult = ReturnType<typeof useRemovePeriodFromTransactionGroupMutation>;
export type RemovePeriodFromTransactionGroupMutationResult = Apollo.MutationResult<RemovePeriodFromTransactionGroupMutation>;
export type RemovePeriodFromTransactionGroupMutationOptions = Apollo.BaseMutationOptions<RemovePeriodFromTransactionGroupMutation, RemovePeriodFromTransactionGroupMutationVariables>;
export const UpdatePeriodOfTransactionGroupDocument = gql`
    mutation UpdatePeriodOfTransactionGroup($groupId: ID!, $period: TransactionPeriodInput!) {
  updatePeriodOfTransactionGroup: updatePeriodOfTransactionGroupNew(
    groupId: $groupId
    period: $period
  ) {
    id
    ...TransactionGroup
  }
}
    ${TransactionGroupFragmentDoc}`;
export type UpdatePeriodOfTransactionGroupMutationFn = Apollo.MutationFunction<UpdatePeriodOfTransactionGroupMutation, UpdatePeriodOfTransactionGroupMutationVariables>;

/**
 * __useUpdatePeriodOfTransactionGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePeriodOfTransactionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeriodOfTransactionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeriodOfTransactionGroupMutation, { data, loading, error }] = useUpdatePeriodOfTransactionGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useUpdatePeriodOfTransactionGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePeriodOfTransactionGroupMutation, UpdatePeriodOfTransactionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePeriodOfTransactionGroupMutation, UpdatePeriodOfTransactionGroupMutationVariables>(UpdatePeriodOfTransactionGroupDocument, options);
      }
export type UpdatePeriodOfTransactionGroupMutationHookResult = ReturnType<typeof useUpdatePeriodOfTransactionGroupMutation>;
export type UpdatePeriodOfTransactionGroupMutationResult = Apollo.MutationResult<UpdatePeriodOfTransactionGroupMutation>;
export type UpdatePeriodOfTransactionGroupMutationOptions = Apollo.BaseMutationOptions<UpdatePeriodOfTransactionGroupMutation, UpdatePeriodOfTransactionGroupMutationVariables>;
export const RenameTransactionCounterpartyDocument = gql`
    mutation RenameTransactionCounterparty($counterpartyId: ID!, $name: String!) {
  renameTransactionCounterparty(counterpartyId: $counterpartyId, name: $name) {
    id
    ...TransactionCounterparty
  }
}
    ${TransactionCounterpartyFragmentDoc}`;
export type RenameTransactionCounterpartyMutationFn = Apollo.MutationFunction<RenameTransactionCounterpartyMutation, RenameTransactionCounterpartyMutationVariables>;

/**
 * __useRenameTransactionCounterpartyMutation__
 *
 * To run a mutation, you first call `useRenameTransactionCounterpartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTransactionCounterpartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTransactionCounterpartyMutation, { data, loading, error }] = useRenameTransactionCounterpartyMutation({
 *   variables: {
 *      counterpartyId: // value for 'counterpartyId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameTransactionCounterpartyMutation(baseOptions?: Apollo.MutationHookOptions<RenameTransactionCounterpartyMutation, RenameTransactionCounterpartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTransactionCounterpartyMutation, RenameTransactionCounterpartyMutationVariables>(RenameTransactionCounterpartyDocument, options);
      }
export type RenameTransactionCounterpartyMutationHookResult = ReturnType<typeof useRenameTransactionCounterpartyMutation>;
export type RenameTransactionCounterpartyMutationResult = Apollo.MutationResult<RenameTransactionCounterpartyMutation>;
export type RenameTransactionCounterpartyMutationOptions = Apollo.BaseMutationOptions<RenameTransactionCounterpartyMutation, RenameTransactionCounterpartyMutationVariables>;
export const SynchronizeUserDocument = gql`
    mutation SynchronizeUser {
  synchronizeUser
}
    `;
export type SynchronizeUserMutationFn = Apollo.MutationFunction<SynchronizeUserMutation, SynchronizeUserMutationVariables>;

/**
 * __useSynchronizeUserMutation__
 *
 * To run a mutation, you first call `useSynchronizeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynchronizeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synchronizeUserMutation, { data, loading, error }] = useSynchronizeUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useSynchronizeUserMutation(baseOptions?: Apollo.MutationHookOptions<SynchronizeUserMutation, SynchronizeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynchronizeUserMutation, SynchronizeUserMutationVariables>(SynchronizeUserDocument, options);
      }
export type SynchronizeUserMutationHookResult = ReturnType<typeof useSynchronizeUserMutation>;
export type SynchronizeUserMutationResult = Apollo.MutationResult<SynchronizeUserMutation>;
export type SynchronizeUserMutationOptions = Apollo.BaseMutationOptions<SynchronizeUserMutation, SynchronizeUserMutationVariables>;
export const CreateUnregisteredUserDocument = gql`
    mutation CreateUnregisteredUser($user: UserInput!) {
  createUnregisteredUser(input: $user)
}
    `;
export type CreateUnregisteredUserMutationFn = Apollo.MutationFunction<CreateUnregisteredUserMutation, CreateUnregisteredUserMutationVariables>;

/**
 * __useCreateUnregisteredUserMutation__
 *
 * To run a mutation, you first call `useCreateUnregisteredUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnregisteredUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnregisteredUserMutation, { data, loading, error }] = useCreateUnregisteredUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUnregisteredUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnregisteredUserMutation, CreateUnregisteredUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnregisteredUserMutation, CreateUnregisteredUserMutationVariables>(CreateUnregisteredUserDocument, options);
      }
export type CreateUnregisteredUserMutationHookResult = ReturnType<typeof useCreateUnregisteredUserMutation>;
export type CreateUnregisteredUserMutationResult = Apollo.MutationResult<CreateUnregisteredUserMutation>;
export type CreateUnregisteredUserMutationOptions = Apollo.BaseMutationOptions<CreateUnregisteredUserMutation, CreateUnregisteredUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UserInput!) {
  updateUserPersonalInformation(input: $input) {
    displayName
    email
    subject
    phoneNumber
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RemoveUserDocument = gql`
    mutation RemoveUser {
  removeUser
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  user: getCurrentUser {
    email
    subject
    displayName
    roles
    phoneNumber
    avatar {
      ...Avatar
    }
    clientId
    staffId
  }
}
    ${AvatarFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const ContactUserRelationDocument = gql`
    query ContactUserRelation {
  userRelation: getContactUserRelation {
    ...UserRelation
  }
}
    ${UserRelationFragmentDoc}`;

/**
 * __useContactUserRelationQuery__
 *
 * To run a query within a React component, call `useContactUserRelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactUserRelationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactUserRelationQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactUserRelationQuery(baseOptions?: Apollo.QueryHookOptions<ContactUserRelationQuery, ContactUserRelationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactUserRelationQuery, ContactUserRelationQueryVariables>(ContactUserRelationDocument, options);
      }
export function useContactUserRelationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactUserRelationQuery, ContactUserRelationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactUserRelationQuery, ContactUserRelationQueryVariables>(ContactUserRelationDocument, options);
        }
export type ContactUserRelationQueryHookResult = ReturnType<typeof useContactUserRelationQuery>;
export type ContactUserRelationLazyQueryHookResult = ReturnType<typeof useContactUserRelationLazyQuery>;
export type ContactUserRelationQueryResult = Apollo.QueryResult<ContactUserRelationQuery, ContactUserRelationQueryVariables>;
export const CreateLeadDocument = gql`
    mutation CreateLead($context: LeadContext!, $userInfo: UserInfo!) {
  createOrUpdateLead(context: $context, userInfo: $userInfo)
}
    `;
export type CreateLeadMutationFn = Apollo.MutationFunction<CreateLeadMutation, CreateLeadMutationVariables>;

/**
 * __useCreateLeadMutation__
 *
 * To run a mutation, you first call `useCreateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadMutation, { data, loading, error }] = useCreateLeadMutation({
 *   variables: {
 *      context: // value for 'context'
 *      userInfo: // value for 'userInfo'
 *   },
 * });
 */
export function useCreateLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadMutation, CreateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument, options);
      }
export type CreateLeadMutationHookResult = ReturnType<typeof useCreateLeadMutation>;
export type CreateLeadMutationResult = Apollo.MutationResult<CreateLeadMutation>;
export type CreateLeadMutationOptions = Apollo.BaseMutationOptions<CreateLeadMutation, CreateLeadMutationVariables>;
export const UpdateUserAvatarDocument = gql`
    mutation UpdateUserAvatar($fileId: ID) {
  updateUserAvatar(fileId: $fileId) {
    id
    subject
  }
}
    `;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>(UpdateUserAvatarDocument, options);
      }
export type UpdateUserAvatarMutationHookResult = ReturnType<typeof useUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationResult = Apollo.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;
export const SaveUtmParametersDocument = gql`
    mutation SaveUtmParameters($utmParameters: UtmParametersInput!) {
  saveUtmParameters(utmParameters: $utmParameters)
}
    `;
export type SaveUtmParametersMutationFn = Apollo.MutationFunction<SaveUtmParametersMutation, SaveUtmParametersMutationVariables>;

/**
 * __useSaveUtmParametersMutation__
 *
 * To run a mutation, you first call `useSaveUtmParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUtmParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUtmParametersMutation, { data, loading, error }] = useSaveUtmParametersMutation({
 *   variables: {
 *      utmParameters: // value for 'utmParameters'
 *   },
 * });
 */
export function useSaveUtmParametersMutation(baseOptions?: Apollo.MutationHookOptions<SaveUtmParametersMutation, SaveUtmParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUtmParametersMutation, SaveUtmParametersMutationVariables>(SaveUtmParametersDocument, options);
      }
export type SaveUtmParametersMutationHookResult = ReturnType<typeof useSaveUtmParametersMutation>;
export type SaveUtmParametersMutationResult = Apollo.MutationResult<SaveUtmParametersMutation>;
export type SaveUtmParametersMutationOptions = Apollo.BaseMutationOptions<SaveUtmParametersMutation, SaveUtmParametersMutationVariables>;